
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("inFIz", function(module, exports) {

$parcel$export(module.exports, "spotByPath", () => spotByPath);
$parcel$export(module.exports, "lookup", () => lookup);
$parcel$export(module.exports, "lookdown", () => lookdown);
$parcel$export(module.exports, "lookdownAll", () => lookdownAll);
$parcel$export(module.exports, "setNodeStyles", () => setNodeStyles);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "setProps", () => setProps);
$parcel$export(module.exports, "getRef", () => getRef);
$parcel$export(module.exports, "getPath", () => getPath);
$parcel$export(module.exports, "keys", () => keys);
$parcel$export(module.exports, "parse", () => parse);
$parcel$export(module.exports, "parseDeep", () => parseDeep);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
$parcel$export(module.exports, "nextElement", () => nextElement);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "previousElement", () => previousElement);
$parcel$export(module.exports, "variables", () => variables);
$parcel$export(module.exports, "call", () => call);
$parcel$export(module.exports, "isMethod", () => isMethod);
parcelRequire("3uN8v");
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $fMhOg = parcelRequire("fMhOg");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");
var $hSU9O = parcelRequire("hSU9O");

var $b18jb = parcelRequire("b18jb");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");

var $cKpeW = parcelRequire("cKpeW");
'use strict';
function spotByPath(path) {
    const element = this;
    const arr = [].concat(path);
    let active = (0, $b18jb.TREE)[arr[0]];
    if (!arr || !arr.length) return console.log(arr, 'on', element.key, 'is undefined');
    while(active.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        active = active[arr[0]];
        if (!active) return;
    }
    return active;
}
function lookup(param) {
    const el = this;
    let { parent } = el;
    if ((0, $EqHTq.isFunction)(param)) {
        if (parent.state && param(parent, parent.state, parent.context)) return parent;
        else if (parent.parent) return parent.lookup(param);
        else return;
    }
    if (el[param]) return el[param];
    while(parent.param !== param){
        if (parent[param]) return parent[param];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
}
function lookdown(param) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (!childElem) return this.warn('Element found in children array but it does not exist in parent');
        if (v === param) return childElem;
        else if ((0, $EqHTq.isFunction)(param)) {
            if (!childElem) {
                this.error(`"${v}" found in element __children, but content is not defined`);
                continue;
            }
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) return childElem;
        }
        const lookdown = childElem?.lookdown?.(param);
        if (lookdown) return lookdown;
    }
}
function lookdownAll(param, results = []) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) results.push(childElem);
        else if ((0, $EqHTq.isFunction)(param)) {
            if (!childElem) {
                this.error(`"${v}" found in element __children, but content is not defined`);
                continue;
            }
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) results.push(childElem);
        }
        childElem?.lookdownAll?.(param, results);
    }
    return results.length ? results : undefined;
}
function setNodeStyles(params = {}) {
    const el = this;
    if (!el.node?.style) return;
    for(const param in params){
        const value = params[param];
        const childElem = el[param];
        if ((0, $EqHTq.isObject)(value) && childElem) setNodeStyles.call(childElem, value);
        else el.node.style[param] = value;
    }
    return el;
}
async function remove(opts = {}) {
    const element = this;
    const beforeRemoveReturns = (0, $4qxjt.triggerEventOn)('beforeRemove', element, opts);
    if (beforeRemoveReturns === false) return element;
    if ((0, $EqHTq.isFunction)(element.node.remove)) element.node.remove();
    else if (element.node?.parentNode) element.node.parentNode.removeChild(element.node);
    else if (!(0, $jOLBF.isProduction)()) {
        console.warn('This item cant be removed');
        element.log();
    }
    delete element.parent[element.key];
    if (element.parent.__ref) element.parent.__ref.__children = (0, $hSU9O.removeValueFromArray)(element.parent.__ref.__children, element.key);
    await (0, $4qxjt.triggerEventOn)('remove', element, opts);
}
function get(param) {
    const element = this;
    return element[param];
}
function setProps(param, opts = {}) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, opts);
    return element;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children.map((k)=>this[k]);
}
function getPath() {
    return this.getRef().path;
}
const defineSetter = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
function keys() {
    const element = this;
    const keys = [];
    for(const param in element){
        if ((0, $ajGUj.REGISTRY)[param] && !(0, $ajGUj.parseFilters).elementKeys.includes(param) || !Object.hasOwnProperty.call(element, param)) continue;
        keys.push(param);
    }
    return keys;
}
function parse(excl = []) {
    const element = this;
    const obj = {};
    const keyList = keys.call(element);
    keyList.forEach((v)=>{
        if (excl.includes(v)) return;
        const val = element[v];
        if (v === 'state') {
            if (element.__ref && !element.__ref.__hasRootState) return;
            const parsedVal = (0, $EqHTq.isFunction)(val && val.parse) ? val.parse() : val;
            obj[v] = (0, $EqHTq.isFunction)(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
        } else if (v === 'scope') {
            if (element.__ref && !element.__ref.__hasRootScope) return;
            obj[v] = JSON.parse(JSON.stringify(val || {}));
        } else if (v === 'props') {
            const { __element, update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $EqHTq.isDefined)(val) && Object.hasOwnProperty.call(element, v)) obj[v] = val;
    });
    return obj;
}
function parseDeep(excl = []) {
    const element = this;
    const obj = parse.call(element, excl);
    for(const v in obj){
        if (excl.includes(v)) return;
        if ((0, $EqHTq.isObjectLike)(obj[v])) obj[v] = parseDeep.call(obj[v], excl);
    }
    return obj;
}
function verbose(element, ...args) {
    if ((0, $jOLBF.isProduction)()) return;
    const parent = this;
    const { __ref: ref } = parent;
    console.groupCollapsed(parent.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', parent[v]));
    else {
        console.log(ref.path);
        const keys = parent.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', parent[v]));
    }
    console.log(parent);
    console.groupEnd(parent.key);
    return parent;
}
function groupLog(...params) {
    // if (isNotProduction()) {
    console.group(...params);
// }
}
function groupLogEnd(...params) {
    // if (isNotProduction()) {
    console.groupEnd(...params);
// }
}
function log(...params) {
    // if (isNotProduction()) {
    console.log(...params);
// }
}
function warn(...params) {
    // if (isNotProduction()) {
    console.warn(...params, this);
// }
}
function error(...params) {
    // if (isNotProduction()) {
    if (params[params.length - 1]?.debugger) debugger; // eslint-disable-line
    if (params[params.length - 1]?.verbose) verbose.call(this, ...params);
    if ((0, $EqHTq.isFunction)(params[params.length - 1]?.onError)) params[params.length - 1]?.onError.call(this, ...params);
    console.error(...params, this);
// }
}
function nextElement() {
    const element = this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
}
async function append(el, key, opts) {
    return await (0, $cKpeW.create)(el, this, key, opts);
}
function previousElement(el) {
    const element = el || this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
}
function variables(obj = {}) {
    const element = this;
    if (!element.data) element.data = {};
    if (!element.data.varCaches) element.data.varCaches = {};
    const varCaches = element.data.varCaches;
    const changes = {};
    let changed;
    for(const key in obj)if (obj[key] !== varCaches[key]) {
        changed = true;
        changes[key] = obj[key];
    }
    return {
        changed: (cb)=>{
            if (!changed || !varCaches) return;
            const returns = cb(changes, (0, $8wu6n.clone)(varCaches));
            for(const key in changes)varCaches[key] = changes[key];
            return returns;
        },
        timeout: (cb, timeout)=>{
            if (!changed) return;
            const t = setTimeout(()=>{
                cb(changes);
                clearTimeout(t);
            }, timeout);
        }
    };
}
function call(fnKey, ...args) {
    const fn = (0, $fMhOg.getContextFunction).call(this, fnKey);
    if (!fn) return undefined;
    try {
        // Call the function
        const result = fn.call(this, ...args);
        // Handle promises
        if (result && typeof result.then === 'function') // This magic allows the function to be awaited if called with await
        // but still work reasonably when called without await
        return result;
        // Return synchronous results directly
        return result;
    } catch (error) {
        console.error(`Error calling function: '${fnKey}'\n`, error);
        throw new Error(error);
    }
}
const METHODS = [
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getChildren',
    'getPath',
    'getRootState',
    'getRoot',
    'getRootData',
    'getRootContext',
    'getContext',
    'setNodeStyles',
    'spotByPath',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'verbose',
    'groupLog',
    'groupLogEnd',
    'warn',
    'error',
    'call',
    'nextElement',
    'append',
    'previousElement'
];
function isMethod(param, element) {
    return METHODS.includes(param) || element?.context?.methods?.[param];
}

});
parcelRegister("3uN8v", function(module, exports) {

$parcel$export(module.exports, "getRootState", () => getRootState);
$parcel$export(module.exports, "getRoot", () => getRoot);
$parcel$export(module.exports, "getRootData", () => getRootData);
$parcel$export(module.exports, "getRootContext", () => getRootContext);
$parcel$export(module.exports, "getContext", () => getContext);
function getRootState(param) {
    let state = null;
    const hasRootState = (obj)=>obj.__element && obj.root?.isRootState;
    if (!this) state = window.platformState || window.smblsApp?.state;
    else if (hasRootState(this)) state = this.root;
    else if (this.__ref && this.__ref.path) {
        const hasPlatformState = this.state && hasRootState(this.state);
        const hasPlatformStateOnParent = this.call('isFunction', this.state) && this.parent.state && hasRootState(this.parent.state);
        if (hasPlatformState || hasPlatformStateOnParent) state = this.state.root || this.parent.state.root;
    }
    if (!state) state = window.platformState || window.smblsApp?.state;
    return param ? state[param] : state;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children?.map((k)=>this[k]);
}
function getRoot(key) {
    const rootElem = this.getRootState()?.__element;
    return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
}
function getRootData(key) {
    return this.getRoot('data') && Object.keys(this.getRoot('data')).length > 0 && key ? this.getRoot('data')[key] : this.getRoot('data');
}
function getRootContext(key) {
    const ctx = this.getRoot()?.context;
    return key ? ctx[key] : ctx;
}
function getContext(key) {
    const ctx = this.context;
    return key ? ctx[key] : ctx;
}

});

parcelRegister("60dnU", function(module, exports) {
$parcel$export(module.exports, "applyEvent", () => (parcelRequire("4qxjt")).applyEvent);
$parcel$export(module.exports, "applyEventsOnNode", () => (parcelRequire("4qxjt")).applyEventsOnNode);
$parcel$export(module.exports, "triggerEventOn", () => (parcelRequire("4qxjt")).triggerEventOn);
$parcel$export(module.exports, "triggerEventOnUpdate", () => (parcelRequire("4qxjt")).triggerEventOnUpdate);
$parcel$export(module.exports, "canRenderTag", () => (parcelRequire("eoYQa")).canRenderTag);
$parcel$export(module.exports, "applyAnimationFrame", () => (parcelRequire("btZia")).applyAnimationFrame);
$parcel$export(module.exports, "initAnimationFrame", () => (parcelRequire("btZia")).initAnimationFrame);
parcelRequire("4qxjt");
parcelRequire("eoYQa");
parcelRequire("btZia");
'use strict';

});
parcelRegister("4qxjt", function(module, exports) {

$parcel$export(module.exports, "applyEvent", () => $33936e69aa63c9cd$export$27ca81ea148fa005);
$parcel$export(module.exports, "triggerEventOn", () => $33936e69aa63c9cd$export$1bc010482b845252);
$parcel$export(module.exports, "triggerEventOnUpdate", () => $33936e69aa63c9cd$export$8fe90418b8a0fc1e);
$parcel$export(module.exports, "applyEventsOnNode", () => $33936e69aa63c9cd$export$1f7cb486ba1f8a10);
parcelRequire("cBUNY");
var $fMhOg = parcelRequire("fMhOg");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $33936e69aa63c9cd$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    const onPropEvent = element.props?.['on' + param.slice(0, 1).toUpperCase() + param.slice(1)];
    return onEvent || onPropEvent;
};
const $33936e69aa63c9cd$export$27ca81ea148fa005 = (fnValue, element, state, context, options)=>{
    if ((0, $EqHTq.isString)(fnValue)) fnValue = (0, $fMhOg.getContextFunction).call(element, fnValue);
    if (!fnValue.call) element.warn(`Event is not executable: ${fnValue}`);
    return fnValue.call(element, element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$1bc010482b845252 = async (param, element, options)=>{
    const appliedFunction = $33936e69aa63c9cd$var$getOnOrPropsEvent(param, element);
    // prevent update storm
    const ref = element.__ref;
    if (ref.__stormAbortion) return;
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return await $33936e69aa63c9cd$export$27ca81ea148fa005(appliedFunction, element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$906113ec468a9c43 = (fnValue, updatedObj, element, state, context, options)=>{
    if ((0, $EqHTq.isString)(fnValue)) fnValue = (0, $fMhOg.getContextFunction).call(element, fnValue);
    if (!fnValue.call) element.warn(`Event is not executable: ${fnValue}`);
    return fnValue.call(element, updatedObj, element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$8fe90418b8a0fc1e = async (param, updatedObj, element, options)=>{
    const appliedFunction = $33936e69aa63c9cd$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return await $33936e69aa63c9cd$export$906113ec468a9c43(appliedFunction, updatedObj, element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on } = element;
    for(const param in on){
        if (param === 'init' || param === 'beforeClassAssign' || param === 'render' || param === 'renderRouter' || param === 'attachNode' || param === 'stateInit' || param === 'stateCreated' || param === 'beforeStateUpdate' || param === 'stateUpdate' || param === 'beforeUpdate' || param === 'done' || param === 'create' || param === 'complete' || param === 'frame' || param === 'update') continue;
        let fnValue = $33936e69aa63c9cd$var$getOnOrPropsEvent(param, element);
        if ((0, $EqHTq.isString)(fnValue)) fnValue = (0, $fMhOg.getContextFunction).call(element, fnValue);
        if ((0, $EqHTq.isFunction)(fnValue)) node.addEventListener(param, async (event)=>{
            const { state: state, context: context } = element;
            await fnValue.call(element, event, element, state, context, options);
        });
    }
};

});
parcelRegister("cBUNY", function(module, exports) {

var $NWrSd = parcelRequire("NWrSd");

var $jOLBF = parcelRequire("jOLBF");

var $EqHTq = parcelRequire("EqHTq");

var $8wu6n = parcelRequire("8wu6n");

var $fMhOg = parcelRequire("fMhOg");

var $hSU9O = parcelRequire("hSU9O");

var $cPMIO = parcelRequire("cPMIO");

var $cQ6eY = parcelRequire("cQ6eY");

var $5WrxC = parcelRequire("5WrxC");

var $jvD5p = parcelRequire("jvD5p");

var $57Gb5 = parcelRequire("57Gb5");

var $glQML = parcelRequire("glQML");

var $bGXur = parcelRequire("bGXur");
'use strict';
$parcel$exportWildcard(module.exports, $NWrSd);
$parcel$exportWildcard(module.exports, $jOLBF);
$parcel$exportWildcard(module.exports, $EqHTq);
$parcel$exportWildcard(module.exports, $8wu6n);
$parcel$exportWildcard(module.exports, $fMhOg);
$parcel$exportWildcard(module.exports, $hSU9O);
$parcel$exportWildcard(module.exports, $cPMIO);
$parcel$exportWildcard(module.exports, $cQ6eY);
$parcel$exportWildcard(module.exports, $5WrxC);
$parcel$exportWildcard(module.exports, $jvD5p);
$parcel$exportWildcard(module.exports, $57Gb5);
$parcel$exportWildcard(module.exports, $glQML);
$parcel$exportWildcard(module.exports, $bGXur);

});
parcelRegister("NWrSd", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $0961ea6318004278$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $0961ea6318004278$export$6f8fb29fbb5b5b63);
'use strict';
const $0961ea6318004278$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $0961ea6318004278$export$6f8fb29fbb5b5b63 = $0961ea6318004278$export$3a7728e868aa3ebd;

});

parcelRegister("jOLBF", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "ENV", () => $e6d79d7b0d7b5fe1$export$83401e34d5e11bf4);
$parcel$export(module.exports, "isProduction", () => $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isTesting", () => $e6d79d7b0d7b5fe1$export$9592e006a670b581);
$parcel$export(module.exports, "isStaging", () => $e6d79d7b0d7b5fe1$export$23da1d24a38b0bde);
$parcel$export(module.exports, "isLocal", () => $e6d79d7b0d7b5fe1$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDevelopment", () => $e6d79d7b0d7b5fe1$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $e6d79d7b0d7b5fe1$export$d84272657cb7c466);
$parcel$export(module.exports, "isNotProduction", () => $e6d79d7b0d7b5fe1$export$eda5083784a7e709);
'use strict';
const $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4 = "production";
const $e6d79d7b0d7b5fe1$export$83401e34d5e11bf4 = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4;
const $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'production';
const $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'testing' || env === 'test';
const $e6d79d7b0d7b5fe1$export$9592e006a670b581 = $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5;
const $e6d79d7b0d7b5fe1$export$23da1d24a38b0bde = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'staging';
const $e6d79d7b0d7b5fe1$export$6dd1bbd39f571125 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'local';
const $e6d79d7b0d7b5fe1$export$df77466336fe5355 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === 'development' || env === 'dev' || env === 'local';
const $e6d79d7b0d7b5fe1$export$d84272657cb7c466 = (key, env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env[key];
const $e6d79d7b0d7b5fe1$export$eda5083784a7e709 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>!$e6d79d7b0d7b5fe1$export$f15d00aa73aafac4(env);

});

parcelRegister("EqHTq", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $079873fc3f2b5f81$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $079873fc3f2b5f81$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $079873fc3f2b5f81$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $079873fc3f2b5f81$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $079873fc3f2b5f81$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $079873fc3f2b5f81$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $079873fc3f2b5f81$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $079873fc3f2b5f81$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $079873fc3f2b5f81$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $079873fc3f2b5f81$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $079873fc3f2b5f81$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $079873fc3f2b5f81$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $079873fc3f2b5f81$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $079873fc3f2b5f81$export$612ae635ef713eeb);

var $cPMIO = parcelRequire("cPMIO");
'use strict';
const $079873fc3f2b5f81$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === 'object' && arg.constructor === Object;
};
const $079873fc3f2b5f81$export$844ec244b1367d54 = (arg)=>typeof arg === 'string';
const $079873fc3f2b5f81$export$7e4aa119212bc614 = (arg)=>typeof arg === 'number';
const $079873fc3f2b5f81$export$f6e2535fb5126e54 = (arg)=>typeof arg === 'function';
const $079873fc3f2b5f81$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $079873fc3f2b5f81$export$630801d484da15df = (arg)=>arg === null;
const $079873fc3f2b5f81$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $079873fc3f2b5f81$export$871608497c498473 = (d)=>d instanceof Date;
const $079873fc3f2b5f81$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === 'object';
};
const $079873fc3f2b5f81$export$4e62c701997796c1 = (arg)=>{
    return $079873fc3f2b5f81$export$a6cdc56e425d0d0a(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$844ec244b1367d54(arg) || $079873fc3f2b5f81$export$7e4aa119212bc614(arg) || $079873fc3f2b5f81$export$f6e2535fb5126e54(arg) || $079873fc3f2b5f81$export$43bee75e5e14138e(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$f9ce7b637dfbe238(arg) || $079873fc3f2b5f81$export$871608497c498473(arg) || $079873fc3f2b5f81$export$630801d484da15df(arg);
};
const $079873fc3f2b5f81$export$fce6876652108ab = (arg)=>{
    return arg === undefined;
};
const $079873fc3f2b5f81$export$426db7a6155b7a80 = {
    boolean: $079873fc3f2b5f81$export$f9ce7b637dfbe238,
    array: $079873fc3f2b5f81$export$43bee75e5e14138e,
    object: $079873fc3f2b5f81$export$a6cdc56e425d0d0a,
    string: $079873fc3f2b5f81$export$844ec244b1367d54,
    date: $079873fc3f2b5f81$export$871608497c498473,
    number: $079873fc3f2b5f81$export$7e4aa119212bc614,
    null: $079873fc3f2b5f81$export$630801d484da15df,
    function: $079873fc3f2b5f81$export$f6e2535fb5126e54,
    objectLike: $079873fc3f2b5f81$export$c10d0b04eaa80a43,
    node: (0, $cPMIO.isNode),
    htmlElement: (0, $cPMIO.isHtmlElement),
    defined: $079873fc3f2b5f81$export$4e62c701997796c1
};
const $079873fc3f2b5f81$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length > 0;
    };
};
const $079873fc3f2b5f81$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length === 0;
    };
};

});
parcelRegister("cPMIO", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $95800a96be489797$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $95800a96be489797$export$211442cb55fb93);
$parcel$export(module.exports, "isDOMNode", () => $95800a96be489797$export$b8eb4d3b76e486c2);

var $jvD5p = parcelRequire("jvD5p");
'use strict';
const $95800a96be489797$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === 'object' ? obj instanceof (0, $jvD5p.window).Node : obj && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string') || false;
};
const $95800a96be489797$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === 'object' ? obj instanceof (0, $jvD5p.window).HTMLElement // DOM2
     : obj && typeof obj === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string') || false;
};
const $95800a96be489797$export$b8eb4d3b76e486c2 = (obj)=>{
    return typeof (0, $jvD5p.window) !== 'undefined' && (obj instanceof (0, $jvD5p.window).Node || obj instanceof (0, $jvD5p.window).Window || obj === (0, $jvD5p.window) || obj === document);
};

});
parcelRegister("jvD5p", function(module, exports) {

$parcel$export(module.exports, "global", () => $e33f3b456b841cc9$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $e33f3b456b841cc9$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $e33f3b456b841cc9$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $e33f3b456b841cc9$export$5a7bfc01df82fcd1);
'use strict';
const $e33f3b456b841cc9$export$90b4d2ff6acb88af = globalThis;
const $e33f3b456b841cc9$export$82c2e460fb230c2a = globalThis;
const $e33f3b456b841cc9$export$8291e5b88f90ce4 = globalThis;
const $e33f3b456b841cc9$export$5a7bfc01df82fcd1 = (undefined || $e33f3b456b841cc9$export$8291e5b88f90ce4).document // eslint-disable-line
;

});



parcelRegister("8wu6n", function(module, exports) {

$parcel$export(module.exports, "exec", () => $6348a97baa20d8d9$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $6348a97baa20d8d9$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $6348a97baa20d8d9$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $6348a97baa20d8d9$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $6348a97baa20d8d9$export$9cd59f9826255e47);
$parcel$export(module.exports, "mergeArrayExclude", () => $6348a97baa20d8d9$export$1c8d6f44648a0c27);
$parcel$export(module.exports, "deepClone", () => $6348a97baa20d8d9$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepStringifyFunctions", () => $6348a97baa20d8d9$export$a1b87aa71164cd70);
$parcel$export(module.exports, "deepStringifyFunctionsWithMaxDepth", () => $6348a97baa20d8d9$export$c72adb7caaf75717);
$parcel$export(module.exports, "objectToString", () => $6348a97baa20d8d9$export$830c053460e5ddf6);
$parcel$export(module.exports, "detachFunctionsFromObject", () => $6348a97baa20d8d9$export$43ffbb9d42fee1c4);
$parcel$export(module.exports, "hasFunction", () => $6348a97baa20d8d9$export$6b15be743c368efa);
$parcel$export(module.exports, "deepDestringifyFunctions", () => $6348a97baa20d8d9$export$4db1ad98392a09bb);
$parcel$export(module.exports, "evalStringToObject", () => $6348a97baa20d8d9$export$f6c7e74fe3cf5fd9);
$parcel$export(module.exports, "diffObjects", () => $6348a97baa20d8d9$export$fcd7b39b3d1c2c1);
$parcel$export(module.exports, "diff", () => $6348a97baa20d8d9$export$a37e3c603d7117e5);
$parcel$export(module.exports, "hasOwnProperty", () => $6348a97baa20d8d9$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $6348a97baa20d8d9$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $6348a97baa20d8d9$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $6348a97baa20d8d9$export$d6d64087a1bd2d);
$parcel$export(module.exports, "deepDiff", () => $6348a97baa20d8d9$export$f00d38dfe38936c3);
$parcel$export(module.exports, "overwrite", () => $6348a97baa20d8d9$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $6348a97baa20d8d9$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $6348a97baa20d8d9$export$f0b277b530b4fffd);
$parcel$export(module.exports, "mergeIfExisted", () => $6348a97baa20d8d9$export$7bde6dffa6d2dd59);
$parcel$export(module.exports, "flattenRecursive", () => $6348a97baa20d8d9$export$d53c2c5b09d0676f);
$parcel$export(module.exports, "isEqualDeep", () => $6348a97baa20d8d9$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $6348a97baa20d8d9$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $6348a97baa20d8d9$export$bdd7fc6cf95d63b);
$parcel$export(module.exports, "createObjectWithoutPrototype", () => $6348a97baa20d8d9$export$c2a75c92f46bb782);
$parcel$export(module.exports, "createNestedObject", () => $6348a97baa20d8d9$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeNestedKeyByPath", () => $6348a97baa20d8d9$export$33f72cab96f733af);
$parcel$export(module.exports, "setInObjectByPath", () => $6348a97baa20d8d9$export$9c3074cc3d55a00f);
$parcel$export(module.exports, "getInObjectByPath", () => $6348a97baa20d8d9$export$12bc5d09cd221028);
$parcel$export(module.exports, "detectInfiniteLoop", () => $6348a97baa20d8d9$export$ad59efee0c629be2);
$parcel$export(module.exports, "isCyclic", () => $6348a97baa20d8d9$export$831fcc412582ee80);
$parcel$export(module.exports, "excludeKeysFromObject", () => $6348a97baa20d8d9$export$efc42697dda340d9);

var $jvD5p = parcelRequire("jvD5p");

var $EqHTq = parcelRequire("EqHTq");

var $hSU9O = parcelRequire("hSU9O");

var $5WrxC = parcelRequire("5WrxC");

var $cPMIO = parcelRequire("cPMIO");

var $jOLBF = parcelRequire("jOLBF");
'use strict';
function $6348a97baa20d8d9$export$78e3044358792147(param, element, state, context, opts = {}) {
    if (!element) element = this;
    if ((0, $EqHTq.isFunction)(param)) try {
        // Call the function with the specified context and parameters
        const result = param.call(element, element, state || element.state, context || element.context);
        // Handle promises
        if (result && typeof result.then === 'function') // This magic allows the function to be awaited if called with await
        // but still work reasonably when called without await
        return result;
        return result;
    } catch (e) {
        element.log(param);
        element.warn('Error executing function', e, opts);
    }
    return param;
}
const $6348a97baa20d8d9$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $6348a97baa20d8d9$export$78e3044358792147(extention[e], element);
};
const $6348a97baa20d8d9$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith('__')) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === undefined) element[e] = objProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$6969335ea1e4e77c = (element, extend, excludeFrom = [], level = Infinity)=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith('__')) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObjectLike)(extendProp)) {
            // shallow merge when deepness level is reached
            if (level > 0) $6348a97baa20d8d9$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom, level - 1);
            else for(const k in extendProp){
                if (excludeFrom.includes(k) || elementProp[k] !== undefined) continue;
                elementProp[k] = extendProp[k];
            }
        } else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const o = {};
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith('__')) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $6348a97baa20d8d9$export$1c8d6f44648a0c27 = (arr, exclude = [])=>{
    return arr.reduce((acc, curr)=>$6348a97baa20d8d9$export$6969335ea1e4e77c(acc, $6348a97baa20d8d9$export$b7d58db314e0ac27(curr, {
            exclude: exclude
        })), {});
};
const $6348a97baa20d8d9$export$b7d58db314e0ac27 = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = new WeakMap(), handleExtend: handleExtend = false } = options;
    const contentWindow = targetWindow || (0, $jvD5p.window) || globalThis;
    // Handle non-object types and special cases
    if (!(0, $EqHTq.isObjectLike)(obj) || (0, $cPMIO.isDOMNode)(obj)) return obj;
    // Handle circular references
    if (visited.has(obj)) return visited.get(obj);
    // Create appropriate container based on type and window context
    const clone = contentWindow ? (0, $EqHTq.isArray)(obj) ? new contentWindow.Array() : new contentWindow.Object() : (0, $EqHTq.isArray)(obj) ? [] : {};
    // Store the clone to handle circular references
    visited.set(obj, clone);
    // Clone properties
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        // Skip excluded properties
        if (exclude.includes(key) || key.startsWith('__') || key === '__proto__') continue;
        let value = obj[key];
        // Skip based on cleanup options
        if (cleanUndefined && (0, $EqHTq.isUndefined)(value) || cleanNull && (0, $EqHTq.isNull)(value)) continue;
        // Handle special cases
        if ((0, $cPMIO.isDOMNode)(value)) {
            clone[key] = value;
            continue;
        }
        // Handle 'extend' array if enabled
        if (handleExtend && key === 'extend' && (0, $EqHTq.isArray)(value)) {
            clone[key] = (0, $hSU9O.mergeArray)(value, exclude);
            continue;
        }
        // Handle functions in cross-frame scenario
        if ((0, $EqHTq.isFunction)(value) && options.window) {
            clone[key] = contentWindow.eval('(' + value.toString() + ')');
            continue;
        }
        // Handle special cases
        if (value?.__ref && value?.node) value = value.parseDeep();
        if (value?.__element) value = value.parse();
        // Recursively clone objects
        if ((0, $EqHTq.isObjectLike)(value)) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            clone[key] = $6348a97baa20d8d9$export$b7d58db314e0ac27(value, {
                ...options,
                visited: visited
            });
        } else clone[key] = value;
    }
    return clone;
};
const $6348a97baa20d8d9$export$a1b87aa71164cd70 = (obj, stringified = {})=>{
    if (!obj) return;
    if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
        (obj.__element || obj.parent?.__element).warn('Trying to clone element or state at', obj);
        obj = obj.parse?.();
    }
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $EqHTq.isObject)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$a1b87aa71164cd70(objProp, stringified[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isObject)(v)) {
                    stringified[prop][i] = {};
                    $6348a97baa20d8d9$export$a1b87aa71164cd70(v, stringified[prop][i]);
                } else if ((0, $EqHTq.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$var$MAX_DEPTH = 100 // Adjust this value as needed
;
const $6348a97baa20d8d9$export$c72adb7caaf75717 = (obj, stringified = {}, depth = 0, path = '')=>{
    if (depth > $6348a97baa20d8d9$var$MAX_DEPTH) {
        console.warn(`Maximum depth exceeded at path: ${path}. Possible circular reference.`);
        return '[MAX_DEPTH_EXCEEDED]';
    }
    for(const prop in obj){
        const currentPath = path ? `${path}.${prop}` : prop;
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $EqHTq.isObject)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$c72adb7caaf75717(objProp, stringified[prop], depth + 1, currentPath);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                const itemPath = `${currentPath}[${i}]`;
                if ((0, $EqHTq.isObject)(v)) {
                    stringified[prop][i] = {};
                    $6348a97baa20d8d9$export$c72adb7caaf75717(v, stringified[prop][i], depth + 1, itemPath);
                } else if ((0, $EqHTq.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$export$830c053460e5ddf6 = (obj = {}, indent = 0)=>{
    // Handle null or primitive case
    if (obj === null || typeof obj !== 'object') return String(obj);
    const spaces = '  '.repeat(indent);
    // Handle array case
    if (Array.isArray(obj)) {
        if (obj.length === 0) return '[]';
        let str = '[\n';
        for (const element of obj){
            if ((0, $EqHTq.isObjectLike)(element)) str += `${spaces}  ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 1)},\n`;
            else if ((0, $EqHTq.isString)(element)) str += `${spaces}  '${element}',\n`;
            else str += `${spaces}  ${element},\n`;
        }
        str += `${spaces}]`;
        return str;
    }
    // Handle empty object case
    if (Object.keys(obj).length === 0) return '{}';
    let str = '{\n';
    for (const [key, value] of Object.entries(obj)){
        const keyNotAllowdChars = (0, $5WrxC.stringIncludesAny)(key, [
            '&',
            '*',
            '-',
            ':',
            '%',
            '{',
            '}',
            '>',
            '<',
            '@',
            '.',
            '/',
            '!',
            ' '
        ]);
        const stringedKey = keyNotAllowdChars ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $EqHTq.isArray)(value)) {
            str += '[\n';
            for (const element of value){
                if ((0, $EqHTq.isObjectLike)(element) && element !== null) str += `${spaces}    ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $EqHTq.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $EqHTq.isObjectLike)(value)) str += $6348a97baa20d8d9$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $EqHTq.isString)(value)) str += (0, $5WrxC.stringIncludesAny)(value, [
            '\n',
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ',\n';
    }
    str += `${spaces}}`;
    return str;
};
const $6348a97baa20d8d9$export$43ffbb9d42fee1c4 = (obj, detached = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) continue;
        else if ((0, $EqHTq.isObject)(objProp)) {
            detached[prop] = {};
            $6348a97baa20d8d9$export$a1b87aa71164cd70(objProp, detached[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            detached[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isFunction)(v)) return;
                if ((0, $EqHTq.isObject)(v)) {
                    detached[prop][i] = {};
                    $6348a97baa20d8d9$export$43ffbb9d42fee1c4(v, detached[prop][i]);
                } else detached[prop][i] = v;
            });
        } else detached[prop] = objProp;
    }
    return detached;
};
const $6348a97baa20d8d9$export$6b15be743c368efa = (str)=>{
    if (!str) return false;
    const trimmed = str.trim().replace(/\n\s*/g, ' ').trim();
    if (trimmed === '') return false;
    if (trimmed === '{}') return false;
    if (trimmed === '[]') return false;
    const patterns = [
        /^\(\s*\{[^}]*\}\s*\)\s*=>/,
        /^(\([^)]*\)|[^=]*)\s*=>/,
        /^function[\s(]/,
        /^async\s+/,
        /^\(\s*function/,
        /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
    ];
    const isClass = str.startsWith('class');
    const isFunction = patterns.some((pattern)=>pattern.test(trimmed));
    const isObjectLiteral = trimmed.startsWith('{') && !trimmed.includes('=>');
    const isArrayLiteral = trimmed.startsWith('[');
    const isJSONLike = /^["[{]/.test(trimmed) && !trimmed.includes('=>');
    return (isFunction || isClass) && !isObjectLiteral && !isArrayLiteral && !isJSONLike;
};
const $6348a97baa20d8d9$export$4db1ad98392a09bb = (obj, destringified = {})=>{
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isString)(objProp)) {
            if ($6348a97baa20d8d9$export$6b15be743c368efa(objProp)) try {
                const evalProp = (0, $jvD5p.window).eval(`(${objProp})`);
                destringified[prop] = evalProp;
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $EqHTq.isArray)(objProp)) {
            destringified[prop] = [];
            objProp.forEach((arrProp)=>{
                if ((0, $EqHTq.isString)(arrProp)) {
                    if ($6348a97baa20d8d9$export$6b15be743c368efa(arrProp)) try {
                        const evalProp = (0, $jvD5p.window).eval(`(${arrProp})`);
                        destringified[prop].push(evalProp);
                    } catch (e) {
                        if (e) destringified[prop].push(arrProp);
                    }
                    else destringified[prop].push(arrProp);
                } else if ((0, $EqHTq.isObject)(arrProp)) destringified[prop].push($6348a97baa20d8d9$export$4db1ad98392a09bb(arrProp));
                else destringified[prop].push(arrProp);
            });
        } else if ((0, $EqHTq.isObject)(objProp)) destringified[prop] = $6348a97baa20d8d9$export$4db1ad98392a09bb(objProp, destringified[prop]);
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $6348a97baa20d8d9$export$f6c7e74fe3cf5fd9 = (str, opts = {
    verbose: true
})=>{
    try {
        return str ? (opts.window || (0, $jvD5p.window)).eval('(' + str + ')') : {} // eslint-disable-line
        ;
    } catch (e) {
        if (opts.verbose) console.warn(e);
        if (opts.onError) return opts.onError(e);
    }
};
const $6348a97baa20d8d9$export$fcd7b39b3d1c2c1 = (original, objToDiff, cache, opts)=>{
    let hasDiff = false;
    // Use union of keys maintaining original order where possible
    const originalKeys = Object.keys(original);
    const diffKeys = Object.keys(objToDiff);
    const allKeys = [
        ...new Set([
            ...originalKeys,
            ...diffKeys
        ])
    ];
    // Check if key order has changed
    const originalKeyOrder = originalKeys.join(',');
    const diffKeyOrder = diffKeys.filter((k)=>originalKeys.includes(k)).join(',');
    if (originalKeyOrder !== diffKeyOrder) hasDiff = true;
    for (const key of allKeys){
        if (key === 'ref') continue;
        const originalProp = original[key];
        const objToDiffProp = objToDiff[key];
        // Handle deleted keys (missing in objToDiff)
        if (!(key in objToDiff)) {
            cache[key] = undefined;
            hasDiff = true;
            continue;
        }
        if ((0, $EqHTq.isObject)(originalProp) && (0, $EqHTq.isObject)(objToDiffProp)) {
            const nestedDiff = $6348a97baa20d8d9$export$a37e3c603d7117e5(originalProp, objToDiffProp, {}, opts);
            if (nestedDiff && Object.keys(nestedDiff).length > 0) {
                cache[key] = nestedDiff;
                hasDiff = true;
            }
        } else if ((0, $EqHTq.isArray)(originalProp) && (0, $EqHTq.isArray)(objToDiffProp)) {
            const nestedDiff = $6348a97baa20d8d9$var$diffArrays(originalProp, objToDiffProp, [], opts);
            if (nestedDiff && nestedDiff.length > 0) {
                cache[key] = nestedDiff;
                hasDiff = true;
            }
        } else if (objToDiffProp !== originalProp) {
            cache[key] = objToDiffProp;
            hasDiff = true;
        }
    }
    return hasDiff ? cache : undefined;
};
const $6348a97baa20d8d9$var$diffArrays = (original, objToDiff, cache, opts)=>{
    // Different lengths means arrays are different
    if (original.length !== objToDiff.length) return objToDiff;
    let hasDiff = false;
    // First check if any elements have changed position
    // by doing a shallow comparison of elements
    const originalStringified = original.map((item)=>JSON.stringify(item));
    const diffStringified = objToDiff.map((item)=>JSON.stringify(item));
    if (originalStringified.join(',') !== diffStringified.join(',')) hasDiff = true;
    // Then do deep comparison of each element
    for(let i = 0; i < original.length; i++){
        const diffObj = $6348a97baa20d8d9$export$a37e3c603d7117e5(original[i], objToDiff[i], {}, opts);
        if (diffObj && ((0, $EqHTq.isObject)(diffObj) ? Object.keys(diffObj).length > 0 : true)) {
            cache[i] = diffObj;
            hasDiff = true;
        }
    }
    return hasDiff ? objToDiff : undefined;
};
const $6348a97baa20d8d9$export$a37e3c603d7117e5 = (original, objToDiff, cache = {}, opts = {})=>{
    if (opts.cloneInstances) {
        original = $6348a97baa20d8d9$export$b7d58db314e0ac27(original);
        objToDiff = $6348a97baa20d8d9$export$b7d58db314e0ac27(objToDiff);
    }
    original = $6348a97baa20d8d9$export$a1b87aa71164cd70(original);
    objToDiff = $6348a97baa20d8d9$export$a1b87aa71164cd70(objToDiff);
    if ((0, $EqHTq.isArray)(original) && (0, $EqHTq.isArray)(objToDiff)) {
        const result = $6348a97baa20d8d9$var$diffArrays(original, objToDiff, [], opts);
        return result === undefined ? {} : result;
    }
    if ((0, $EqHTq.isObject)(original) && (0, $EqHTq.isObject)(objToDiff)) {
        const result = $6348a97baa20d8d9$export$fcd7b39b3d1c2c1(original, objToDiff, {}, opts);
        return result === undefined ? {} : result;
    }
    // fallback for primitives or differing types
    if (original !== objToDiff) return objToDiff;
    return {};
};
const $6348a97baa20d8d9$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $6348a97baa20d8d9$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $6348a97baa20d8d9$export$83b788b1a3698c03 = (o)=>(0, $EqHTq.isObject)(o) && $6348a97baa20d8d9$export$dd1bc94b04021eeb(o);
const $6348a97baa20d8d9$export$d6d64087a1bd2d = ()=>Object.create(null);
const $6348a97baa20d8d9$export$f00d38dfe38936c3 = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $EqHTq.isObjectLike)(lhs) || !(0, $EqHTq.isObjectLike)(rhs)) return rhs;
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(rhs, key)) acc[key] = undefined;
        return acc;
    }, $6348a97baa20d8d9$export$d6d64087a1bd2d());
    if ((0, $EqHTq.isDate)(lhs) || (0, $EqHTq.isDate)(rhs)) {
        if (lhs.valueOf() === rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(lhs, key)) {
            acc[key] = rhs[key];
            return acc;
        }
        const difference = $6348a97baa20d8d9$export$a37e3c603d7117e5(lhs[key], rhs[key]);
        if ($6348a97baa20d8d9$export$83b788b1a3698c03(difference) && !(0, $EqHTq.isDate)(difference) && ($6348a97baa20d8d9$export$83b788b1a3698c03(lhs[key]) || !$6348a97baa20d8d9$export$83b788b1a3698c03(rhs[key]))) return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
};
const $6348a97baa20d8d9$export$d3305692eb3e9a81 = (element, params, opts = {})=>{
    const { __ref: ref } = element;
    const excl = opts.exclude || [];
    const allowUnderscore = opts.preventUnderscore;
    const preventCaching = opts.preventCaching;
    for(const e in params){
        if (excl.includes(e) || !allowUnderscore && e.startsWith('__')) continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            element[e] = paramsProp;
            if (ref && !preventCaching) ref.__cache[e] = elementProp;
            if ((0, $EqHTq.isObject)(opts.diff)) $6348a97baa20d8d9$export$a37e3c603d7117e5[e] = elementProp;
        }
    }
    return element;
};
const $6348a97baa20d8d9$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith('__')) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $6348a97baa20d8d9$export$f0b277b530b4fffd = (obj, params, opts = {}, visited = new WeakMap())=>{
    const excl = opts.exclude || [];
    const forcedExclude = opts.preventForce ? [] : [
        'node',
        'window'
    ];
    if (!(0, $EqHTq.isObjectLike)(obj) || !(0, $EqHTq.isObjectLike)(params) || (0, $cPMIO.isDOMNode)(obj) || (0, $cPMIO.isDOMNode)(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    for(const e in params){
        if (!Object.hasOwnProperty.call(params, e)) continue;
        if (excl.includes(e) || forcedExclude && e.startsWith('__')) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $cPMIO.isDOMNode)(paramsProp)) obj[e] = paramsProp;
        else if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) obj[e] = $6348a97baa20d8d9$export$f0b277b530b4fffd(objProp, paramsProp, opts, visited);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $6348a97baa20d8d9$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $6348a97baa20d8d9$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $6348a97baa20d8d9$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = (0, $hSU9O.mergeAndCloneIfArray)(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $6348a97baa20d8d9$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};
const $6348a97baa20d8d9$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    // Check if both values are non-null objects
    if (typeof param !== 'object' || typeof element !== 'object' || param === null || element === null) return param === element // Compare non-object values directly
    ;
    // Check for circular references
    if (visited.has(param) || visited.has(element)) return true // Assume equality to break the circular reference
    ;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    // Check if both objects have the same number of properties
    if (keysParam.length !== keysElement.length) return false;
    // Check if all properties in param also exist in element
    for (const key of keysParam){
        if (!keysElement.includes(key)) return false;
        const paramProp = param[key];
        const elementProp = element[key];
        // Recursively check property values
        if (!$6348a97baa20d8d9$export$683c7d6569f339f4(paramProp, elementProp, visited)) return false;
    }
    return true;
};
const $6348a97baa20d8d9$export$273cb3019e2f952c = (obj1, obj2, ignoredKeys = [
    'node',
    '__ref'
])=>{
    if (obj1 === obj2) return true;
    if (!(0, $EqHTq.isObjectLike)(obj1) || !(0, $EqHTq.isObjectLike)(obj2)) return false;
    if ((0, $cPMIO.isDOMNode)(obj1) || (0, $cPMIO.isDOMNode)(obj2)) return obj1 === obj2;
    const stack = [
        [
            obj1,
            obj2
        ]
    ];
    const visited = new WeakSet();
    while(stack.length > 0){
        const [current1, current2] = stack.pop();
        if (visited.has(current1)) continue;
        visited.add(current1);
        const keys1 = Object.keys(current1).filter((key)=>!ignoredKeys.includes(key));
        const keys2 = Object.keys(current2).filter((key)=>!ignoredKeys.includes(key));
        if (keys1.length !== keys2.length) return false;
        for (const key of keys1){
            if (!Object.prototype.hasOwnProperty.call(current2, key)) return false;
            const value1 = current1[key];
            const value2 = current2[key];
            if ((0, $cPMIO.isDOMNode)(value1) || (0, $cPMIO.isDOMNode)(value2)) {
                if (value1 !== value2) return false;
            } else if ((0, $EqHTq.isObjectLike)(value1) && (0, $EqHTq.isObjectLike)(value2)) {
                if (value1 !== value2) stack.push([
                    value1,
                    value2
                ]);
            } else if (value1 !== value2) return false;
        }
    }
    return true;
};
const $6348a97baa20d8d9$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $EqHTq.is)(props)('string', 'number')) delete obj[props];
    else if ((0, $EqHTq.isArray)(props)) props.forEach((prop)=>delete obj[prop]);
    else throw new Error('Invalid input: props must be a string or an array of strings');
    return obj;
};
const $6348a97baa20d8d9$export$c2a75c92f46bb782 = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj // Return the value if obj is not an object
    ;
    const newObj = Object.create(null) // Create an object without prototype
    ;
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $6348a97baa20d8d9$export$c2a75c92f46bb782(obj[key]) // Recursively copy each property
    ;
    return newObj;
};
const $6348a97baa20d8d9$export$a9706fb8026b394a = (arr, lastValue)=>{
    const nestedObject = {};
    if (arr.length === 0) return lastValue;
    arr.reduce((obj, value, index)=>{
        if (!obj[value]) obj[value] = {};
        if (index === arr.length - 1 && lastValue !== undefined) obj[value] = lastValue;
        return obj[value];
    }, nestedObject);
    return nestedObject;
};
const $6348a97baa20d8d9$export$33f72cab96f733af = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (current[path[i]] === undefined) return; // Path does not exist, so nothing to remove.
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    if (current && Object.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
};
const $6348a97baa20d8d9$export$9c3074cc3d55a00f = (obj, path, value)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        // If the current path segment doesn't exist or isn't an object, create it
        if (!current[path[i]] || typeof current[path[i]] !== 'object') current[path[i]] = {};
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    current[lastKey] = value;
    return obj;
};
const $6348a97baa20d8d9$export$12bc5d09cd221028 = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length; i++){
        if (current === undefined || current === null) return undefined;
        current = current[path[i]];
    }
    return current;
};
const $6348a97baa20d8d9$export$ad59efee0c629be2 = (arr)=>{
    const maxRepeats = 3 // Maximum allowed repetitions
    ;
    let pattern = [];
    let repeatCount = 0;
    for(let i = 0; i < arr.length; i++)if (pattern.length < 2) // Build the initial pattern with two consecutive elements
    pattern.push(arr[i]);
    else {
        // Check if the current element follows the repeating pattern
        if (arr[i] === pattern[i % 2]) repeatCount++;
        else {
            // If there's a mismatch, reset the pattern and repeat counter
            pattern = [
                arr[i - 1],
                arr[i]
            ];
            repeatCount = 1 // Reset to 1 because we start a new potential pattern
            ;
        }
        // If the pattern repeats more than `maxRepeats`, throw a warning
        if (repeatCount >= maxRepeats * 2) {
            if ((0, $jOLBF.isNotProduction)()) console.warn('Warning: Potential infinite loop detected due to repeated sequence:', pattern);
            return true;
        }
    }
};
const $6348a97baa20d8d9$export$831fcc412582ee80 = (obj)=>{
    const seenObjects = [];
    function detect(obj) {
        if (obj && typeof obj === 'object') {
            if (seenObjects.indexOf(obj) !== -1) return true;
            seenObjects.push(obj);
            for(const key in obj)if (Object.hasOwnProperty.call(obj, key) && detect(obj[key])) {
                console.log(obj, 'cycle at ' + key);
                return true;
            }
        }
        return false;
    }
    return detect(obj);
};
const $6348a97baa20d8d9$export$efc42697dda340d9 = (obj, excludedKeys)=>{
    const result = {
        ...obj
    };
    excludedKeys.forEach((key)=>delete result[key]);
    return result;
};

});
parcelRegister("hSU9O", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $d0530a7c3063b815$export$de875babef361e5d);
$parcel$export(module.exports, "getFrequencyInArray", () => $d0530a7c3063b815$export$2b3f138fefbb2e97);
$parcel$export(module.exports, "removeFromArray", () => $d0530a7c3063b815$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $d0530a7c3063b815$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $d0530a7c3063b815$export$fc359ae9633f7296);
$parcel$export(module.exports, "mergeArray", () => $d0530a7c3063b815$export$fd2fbaf2367ef824);
$parcel$export(module.exports, "mergeAndCloneIfArray", () => $d0530a7c3063b815$export$803a4c6bdde5cd1d);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $d0530a7c3063b815$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $d0530a7c3063b815$export$e9b4b966d876219d);
$parcel$export(module.exports, "removeValueFromArray", () => $d0530a7c3063b815$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $d0530a7c3063b815$export$91b305d65813a3f8);
$parcel$export(module.exports, "addItemAfterEveryElement", () => $d0530a7c3063b815$export$aefdd0c3cb403b10);
$parcel$export(module.exports, "reorderArrayByValues", () => $d0530a7c3063b815$export$402525ce1e0ae04f);
$parcel$export(module.exports, "arraysEqual", () => $d0530a7c3063b815$export$234180f8206db11b);
$parcel$export(module.exports, "filterArrays", () => $d0530a7c3063b815$export$e43a5cd3407a4eed);
$parcel$export(module.exports, "filterArraysFast", () => $d0530a7c3063b815$export$34fca6752b16443b);
$parcel$export(module.exports, "checkIfStringIsInArray", () => $d0530a7c3063b815$export$8a158988a0fbe64f);

var $8wu6n = parcelRequire("8wu6n");

var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $d0530a7c3063b815$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $d0530a7c3063b815$export$2b3f138fefbb2e97 = (arr, value)=>{
    return arr.reduce((count, currentValue)=>{
        return currentValue === value ? count + 1 : count;
    }, 0);
};
const $d0530a7c3063b815$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $EqHTq.isString)(index)) index = parseInt(index);
    if ((0, $EqHTq.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error('Invalid index');
        arr.splice(index, 1);
    } else if ((0, $EqHTq.isArray)(index)) index.forEach((idx)=>$d0530a7c3063b815$export$8af121ae7401c4(arr, idx));
    else throw new Error('Invalid index');
    return arr;
};
const $d0530a7c3063b815$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $d0530a7c3063b815$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $d0530a7c3063b815$export$fd2fbaf2367ef824 = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>(0, $8wu6n.deepMerge)(a, (0, $8wu6n.deepClone)(c, {
            exclude: exclude
        }), exclude), {});
};
const $d0530a7c3063b815$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $d0530a7c3063b815$export$fd2fbaf2367ef824(obj) : (0, $8wu6n.deepClone)(obj);
};
const $d0530a7c3063b815$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $d0530a7c3063b815$export$e9b4b966d876219d = (arr, value)=>{
    if (!(0, $EqHTq.isArray)(arr)) return;
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $d0530a7c3063b815$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr;
};
const $d0530a7c3063b815$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};
const $d0530a7c3063b815$export$aefdd0c3cb403b10 = (array, item)=>{
    // Create a new array to hold the result
    const result = [];
    // Loop through the input array
    for(let i = 0; i < array.length; i++){
        // Add the current element to the result array
        result.push(array[i]);
        // If it's not the last element, add the item
        if (i < array.length - 1) result.push(item);
    }
    return result;
};
const $d0530a7c3063b815$export$402525ce1e0ae04f = (array, valueToMove, insertBeforeValue)=>{
    const newArray = [
        ...array
    ] // Create a copy of the original array
    ;
    const indexToMove = newArray.indexOf(valueToMove) // Find the index of the value to move
    ;
    const indexToInsertBefore = newArray.indexOf(insertBeforeValue) // Find the index to insert before
    ;
    if (indexToMove !== -1 && indexToInsertBefore !== -1) {
        const removedItem = newArray.splice(indexToMove, 1)[0] // Remove the item to move
        ;
        const insertIndex = indexToInsertBefore < indexToMove ? indexToInsertBefore : indexToInsertBefore + 1 // Adjust insert index
        ;
        newArray.splice(insertIndex, 0, removedItem) // Insert the removed item before the specified value
        ;
    }
    return newArray;
};
const $d0530a7c3063b815$export$234180f8206db11b = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $d0530a7c3063b815$export$e43a5cd3407a4eed = (sourceArr, excludeArr)=>{
    return sourceArr.filter((item)=>!excludeArr.includes(item));
};
const $d0530a7c3063b815$export$34fca6752b16443b = (sourceArr, excludeArr)=>{
    const excludeSet = new Set(excludeArr);
    return sourceArr.filter((item)=>!excludeSet.has(item));
};
const $d0530a7c3063b815$export$8a158988a0fbe64f = (string, arr)=>{
    if (!string) return;
    return arr.filter((v)=>string.includes(v)).length;
};

});

parcelRegister("5WrxC", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $4537bba2bd33729a$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $4537bba2bd33729a$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $4537bba2bd33729a$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $4537bba2bd33729a$export$f08459d87829d2ee);
$parcel$export(module.exports, "findKeyPosition", () => $4537bba2bd33729a$export$e03c69ff1d8102d5);
$parcel$export(module.exports, "replaceOctalEscapeSequences", () => $4537bba2bd33729a$export$ed5844ba7edb0ac0);
$parcel$export(module.exports, "encodeNewlines", () => $4537bba2bd33729a$export$56079d9b77cc851c);
$parcel$export(module.exports, "decodeNewlines", () => $4537bba2bd33729a$export$d5a58d286266e59c);
$parcel$export(module.exports, "customEncodeURIComponent", () => $4537bba2bd33729a$export$afdf0655b23d957b);
$parcel$export(module.exports, "customDecodeURIComponent", () => $4537bba2bd33729a$export$f0dfcf6020c0b258);
'use strict';
const $4537bba2bd33729a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $4537bba2bd33729a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join('\\')}]`, 'g');
    // Replace matched symbols with an empty string
    return str.replace(pattern, '');
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $4537bba2bd33729a$var$brackRegex = {
    2: /\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}/g,
    3: /\{\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}\}/g
};
function $4537bba2bd33729a$export$7cb52b7decbd2220(str, options = {}, forcedState) {
    if (!str.includes(options.bracketsLength === 3 ? '{{{' : '{{')) return str;
    const reg = $4537bba2bd33729a$var$brackRegex[options.bracketsLength || 2];
    const obj = forcedState || this?.state || {};
    return str.replace(reg, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = parentPath.match(options.bracketsLength === 3 ? /\.\.\.\//g : /\.\.\//g).length;
            let parentState = obj;
            for(let i = 0; i < parentLevels; i++){
                parentState = parentState.parent;
                if (!parentState) return '' // Return an empty string if the parent level doesn't exist
                ;
            }
            const value = parentState[variable.trim()];
            return value !== undefined ? `${value}` : '';
        } else {
            const value = obj[variable.trim()];
            return value !== undefined ? `${value}` : '';
        }
    });
}
const $4537bba2bd33729a$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};
const $4537bba2bd33729a$export$e03c69ff1d8102d5 = (str, key)=>{
    const lines = str.split('\n');
    let startLineNumber = -1;
    let endLineNumber = -1;
    let startColumn = -1;
    let endColumn = -1;
    const keyPattern = new RegExp(`\\b${key}\\b\\s*:\\s*`);
    let braceCount = 0;
    let foundKey = false;
    for(let i = 0; i < lines.length; i++){
        if (keyPattern.test(lines[i]) && !foundKey) {
            foundKey = true;
            startLineNumber = i + 1;
            startColumn = lines[i].indexOf(key) + 1;
            // Check if the value is an empty object
            if (lines[i].includes('{}')) {
                endLineNumber = startLineNumber;
                endColumn = lines[i].indexOf('{}') + 3;
                break;
            }
            // Check if the value starts with '{' (object) or '[' (array)
            const line = lines[i].slice(startColumn + key.length);
            if (line.includes('{') || line.includes('[')) braceCount = 1;
            else {
                endLineNumber = i + 1;
                endColumn = lines[i].length + 1;
                break;
            }
        } else if (foundKey) {
            braceCount += (lines[i].match(/{/g) || []).length;
            braceCount += (lines[i].match(/\[/g) || []).length;
            braceCount -= (lines[i].match(/}/g) || []).length;
            braceCount -= (lines[i].match(/]/g) || []).length;
            // If braceCount is 0 and we find the end of the object/array
            if (braceCount === 0) {
                endLineNumber = i + 1;
                endColumn = lines[i].lastIndexOf('}') !== -1 ? lines[i].lastIndexOf('}') + 2 : lines[i].length + 1;
                break;
            }
        }
    }
    return {
        startColumn: startColumn,
        endColumn: endColumn,
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber
    };
};
const $4537bba2bd33729a$export$ed5844ba7edb0ac0 = (str)=>{
    // Regex to match octal escape sequences
    const octalRegex = /\\([0-7]{1,3})/g;
    // Replace each match with the corresponding character
    return str.replace(octalRegex, (match, p1)=>{
        // Convert the octal value to a decimal integer
        const octalValue = parseInt(p1, 8);
        // Convert the decimal value to the corresponding character
        const char = String.fromCharCode(octalValue);
        return char;
    });
};
const $4537bba2bd33729a$export$56079d9b77cc851c = (str)=>{
    return str.split('\n').join('/////n').split('`').join('/////tilde').split('$').join('/////dlrsgn');
};
const $4537bba2bd33729a$export$d5a58d286266e59c = (encodedStr)=>{
    return encodedStr.split('/////n').join('\n').split('/////tilde').join('`').split('/////dlrsgn').join('$');
};
const $4537bba2bd33729a$export$afdf0655b23d957b = (str)=>{
    return str.split('').map((char)=>{
        if (/[^a-zA-Z0-9\s]/.test(char)) return '%' + char.charCodeAt(0).toString(16).toUpperCase();
        return char;
    }).join('');
};
const $4537bba2bd33729a$export$f0dfcf6020c0b258 = (encodedStr)=>{
    return encodedStr.replace(/%[0-9A-Fa-f]{2}/g, (match)=>String.fromCharCode(parseInt(match.slice(1), 16)));
};

});


parcelRegister("fMhOg", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $b7c9275e9e0262d0$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $b7c9275e9e0262d0$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $b7c9275e9e0262d0$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $b7c9275e9e0262d0$export$6f017d9966fe4675);
$parcel$export(module.exports, "cloneFunction", () => $b7c9275e9e0262d0$export$5c7d787bf6cea16b);
$parcel$export(module.exports, "getContextFunction", () => $b7c9275e9e0262d0$export$1b6cefb841a4280);
'use strict';
function $b7c9275e9e0262d0$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $b7c9275e9e0262d0$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $b7c9275e9e0262d0$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $b7c9275e9e0262d0$export$6f017d9966fe4675 = (inputString)=>{
    // Regular expression to match both regular and arrow function declarations
    const functionRegex = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
    // Use the regex to test if the inputString matches the function pattern
    return functionRegex.test(inputString);
};
function $b7c9275e9e0262d0$export$5c7d787bf6cea16b(fn, win = window) {
    const temp = function() {
        return fn.apply(win, arguments);
    };
    // Copy properties from original function
    for(const key in fn)if (Object.hasOwnProperty.call(fn, key)) temp[key] = fn[key];
    return temp;
}
function $b7c9275e9e0262d0$export$1b6cefb841a4280(fnKey) {
    return this.context.utils?.[fnKey] || this.context.functions?.[fnKey] || this.context.methods?.[fnKey] || this.context.snippets?.[fnKey];
}

});

parcelRegister("cQ6eY", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $958f2e9ae228360b$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $958f2e9ae228360b$export$7cea94b68a0c230b);
'use strict';
const $958f2e9ae228360b$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $958f2e9ae228360b$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("57Gb5", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $3bae52d896fdaae9$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $3bae52d896fdaae9$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $3bae52d896fdaae9$export$4be65e66cfa2648a);
$parcel$export(module.exports, "removeCookie", () => $3bae52d896fdaae9$export$6a874b7a74007875);
$parcel$export(module.exports, "getLocalStorage", () => $3bae52d896fdaae9$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $3bae52d896fdaae9$export$1f73f60bdb811cb1);

var $EqHTq = parcelRequire("EqHTq");

var $jvD5p = parcelRequire("jvD5p");
'use strict';
const $3bae52d896fdaae9$export$d0a8044dce8ff2fc = (()=>typeof navigator === 'undefined' ? false : /Mobi/.test(navigator.userAgent))();
const $3bae52d896fdaae9$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $EqHTq.isUndefined)((0, $jvD5p.document)) || (0, $EqHTq.isUndefined)((0, $jvD5p.document).cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    (0, $jvD5p.document).cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $3bae52d896fdaae9$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $EqHTq.isUndefined)((0, $jvD5p.document)) || (0, $EqHTq.isUndefined)((0, $jvD5p.document).cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent((0, $jvD5p.document).cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
};
const $3bae52d896fdaae9$export$6a874b7a74007875 = (cname)=>{
    if ((0, $EqHTq.isUndefined)((0, $jvD5p.document)) || (0, $EqHTq.isUndefined)((0, $jvD5p.document).cookie)) return;
    (0, $jvD5p.document).cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
function $3bae52d896fdaae9$export$d3720feff416e85b(key) {
    let savedJSON;
    if (window.localStorage) try {
        savedJSON = JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
        console.error(e);
    }
    if (typeof savedJSON !== 'undefined') return savedJSON;
}
function $3bae52d896fdaae9$export$1f73f60bdb811cb1(key, data) {
    if (data && window.localStorage) {
        if (typeof data === 'object') window.localStorage.setItem(key, JSON.stringify(data));
        else window.localStorage.setItem(key, data);
    }
}

});

parcelRegister("glQML", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $be778da0f6744ca3$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "isValidHtmlTag", () => $be778da0f6744ca3$export$52675ca41d41c093);
'use strict';
const $be778da0f6744ca3$export$4c3fa92ca590c71f = {
    root: [
        'body',
        'html'
    ],
    head: [
        'title',
        'base',
        'meta',
        'style',
        'noscript',
        'script'
    ],
    body: [
        'string',
        'style',
        'fragment',
        'a',
        'abbr',
        'acronym',
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'basefont',
        'bdi',
        'bdo',
        'big',
        'blockquote',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'search',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hr',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'meter',
        'nav',
        'noframes',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'param',
        'picture',
        'pre',
        'progress',
        'hgroup',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strike',
        'strong',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'hgroup',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr',
        // SVG
        'svg',
        'path'
    ]
};
const $be778da0f6744ca3$export$52675ca41d41c093 = (arg)=>$be778da0f6744ca3$export$4c3fa92ca590c71f.body.includes(arg);

});

parcelRegister("bGXur", function(module, exports) {

$parcel$export(module.exports, "checkIfKeyIsComponent", () => $8831c36ff812ea2a$export$b791484194c5fc38);
$parcel$export(module.exports, "checkIfKeyIsProperty", () => $8831c36ff812ea2a$export$69dfe88127d1d0de);
$parcel$export(module.exports, "addAdditionalExtend", () => $8831c36ff812ea2a$export$356ecc5e07374be5);
$parcel$export(module.exports, "checkIfSugar", () => $8831c36ff812ea2a$export$998af2411f6c25b6);
$parcel$export(module.exports, "extractComponentKeyFromKey", () => $8831c36ff812ea2a$export$4683a1d5b4c03da1);
$parcel$export(module.exports, "extendizeByKey", () => $8831c36ff812ea2a$export$c786485ace8eb69b);
$parcel$export(module.exports, "getCapitalCaseKeys", () => $8831c36ff812ea2a$export$ef62ecae187000fa);
$parcel$export(module.exports, "addChildrenIfNotInOriginal", () => $8831c36ff812ea2a$export$5f700329e3bf6352);
$parcel$export(module.exports, "applyKeyComponentAsExtend", () => $8831c36ff812ea2a$export$2279e5e6b0817ddc);
$parcel$export(module.exports, "applyComponentFromContext", () => $8831c36ff812ea2a$export$fd6b2f481ffc7974);
$parcel$export(module.exports, "isVariant", () => $8831c36ff812ea2a$export$53cd1a145c393044);
$parcel$export(module.exports, "hasVariantProp", () => $8831c36ff812ea2a$export$c66af1c05bf7bb06);
$parcel$export(module.exports, "getChildrenComponentsByKey", () => $8831c36ff812ea2a$export$ca8981c294eb4d67);
$parcel$export(module.exports, "getExtendsInElement", () => $8831c36ff812ea2a$export$a23334bdec459c3a);
$parcel$export(module.exports, "setContentKey", () => $8831c36ff812ea2a$export$c99c504ad1135f20);

var $jOLBF = parcelRequire("jOLBF");

var $hSU9O = parcelRequire("hSU9O");

var $8wu6n = parcelRequire("8wu6n");

var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $8831c36ff812ea2a$export$b791484194c5fc38 = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $8831c36ff812ea2a$export$69dfe88127d1d0de = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[a-z]*$/.test(firstCharKey);
};
const $8831c36ff812ea2a$export$356ecc5e07374be5 = (newExtend, element)=>{
    if (!newExtend) return element;
    const { extend: elementExtend } = element;
    const originalArray = (0, $EqHTq.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $EqHTq.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    const extend = (0, $hSU9O.joinArrays)(receivedArray, originalArray);
    return {
        ...element,
        extend: extend
    };
};
const $8831c36ff812ea2a$export$998af2411f6c25b6 = (element, parent, key)=>{
    const { extend: extend, props: props, childExtend: childExtend, extends: extendProps, childExtends: childExtends, childProps: childProps, children: children, on: on, $collection: $collection, $stateCollection: $stateCollection, $propsCollection: $propsCollection } = element;
    const hasComponentAttrs = extend || childExtend || props || on || $collection || $stateCollection || $propsCollection;
    if (hasComponentAttrs && (childProps || extendProps || children || childExtends)) {
        const logErr = (parent || element)?.error;
        if (logErr) logErr.call(parent, element, 'Sugar component includes params for builtin components', {
            verbose: true
        });
    }
    return !hasComponentAttrs || childProps || extendProps || children || childExtends;
};
const $8831c36ff812ea2a$export$4683a1d5b4c03da1 = (key)=>{
    return key.includes('+') ? key.split('+') // get array of componentKeys
     : key.includes('_') ? [
        key.split('_')[0]
    ] // get component key split _
     : key.includes('.') && !$8831c36ff812ea2a$export$b791484194c5fc38(key.split('.')[1]) ? [
        key.split('.')[0]
    ] // get component key split .
     : [
        key
    ];
};
const $8831c36ff812ea2a$export$c786485ace8eb69b = (element, parent, key)=>{
    const { context: context } = parent;
    const { tag: tag, extend: extend, childExtends: childExtends } = element;
    const isSugar = $8831c36ff812ea2a$export$998af2411f6c25b6(element, parent, key);
    const extendFromKey = $8831c36ff812ea2a$export$4683a1d5b4c03da1(key);
    const isExtendKeyComponent = context && context.components[extendFromKey];
    if (element === isExtendKeyComponent) return element;
    else if (isSugar) {
        const newElem = $8831c36ff812ea2a$export$356ecc5e07374be5(element.extends, {
            extend: extendFromKey,
            tag: tag,
            props: {
                ...element
            }
        });
        if (newElem.props.data) {
            newElem.data = newElem.props.data;
            delete newElem.props.data;
        }
        if (newElem.props.state) {
            newElem.state = newElem.props.state;
            delete newElem.props.state;
        }
        if (newElem.props.attr) {
            newElem.attr = newElem.props.attr;
            delete newElem.props.attr;
        }
        if (newElem.props.if) {
            newElem.if = newElem.props.if;
            delete newElem.props.if;
        }
        if (childExtends) newElem.childExtend = childExtends;
        return newElem;
    } else if (!extend || extend === true) return {
        ...element,
        tag: tag,
        extend: extendFromKey
    };
    else if (extend) return $8831c36ff812ea2a$export$356ecc5e07374be5(extendFromKey, element);
    else if ((0, $EqHTq.isFunction)(element)) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...(0, $8wu6n.exec)(element, parent)
        }
    };
};
function $8831c36ff812ea2a$export$ef62ecae187000fa(obj) {
    return Object.keys(obj).filter((key)=>/^[A-Z]/.test(key));
}
const $8831c36ff812ea2a$export$5f700329e3bf6352 = (element, parent, key)=>{
    const childElems = $8831c36ff812ea2a$export$ef62ecae187000fa(element.props);
    if (!childElems.length) return element;
    for(const i in childElems){
        const childKey = childElems[i];
        const childElem = element[childKey];
        const newChild = element.props[childKey];
        const assignChild = (val)=>{
            element[childKey] = val;
            delete element.props[childKey];
        };
        if (newChild?.ignoreExtend) continue;
        if (newChild === null) assignChild(null);
        else if (!childElem) assignChild((0, $8wu6n.deepClone)(newChild));
        else {
            const isSugarChildElem = $8831c36ff812ea2a$export$998af2411f6c25b6(childElem, parent, key);
            if (isSugarChildElem) continue;
            assignChild({
                extend: element[childKey],
                props: newChild
            });
        }
    }
};
const $8831c36ff812ea2a$export$2279e5e6b0817ddc = (element, parent, key)=>{
    return $8831c36ff812ea2a$export$c786485ace8eb69b(element, parent, key) || element;
};
const $8831c36ff812ea2a$export$fd6b2f481ffc7974 = (element, parent, options)=>{
    const { context: context } = element;
    if (!context || !context.components) return;
    const { components: components } = context;
    const { extend: extend } = element;
    const execExtend = (0, $8wu6n.exec)(extend, element);
    if ((0, $EqHTq.isString)(execExtend)) {
        const componentExists = components[execExtend] || components['smbls.' + execExtend];
        if (componentExists) element.extend = componentExists;
        else {
            if ((0, $jOLBF.isNotProduction)() && options.verbose) {
                console.warn(execExtend, 'is not in library', components, element);
                console.warn('replacing with ', {});
            }
            element.extend = {};
        }
    }
};
const $8831c36ff812ea2a$export$53cd1a145c393044 = (param)=>{
    if (!(0, $EqHTq.isString)(param)) return;
    const firstCharKey = param.slice(0, 1);
    // return (firstCharKey === '.' || firstCharKey === '$')
    return firstCharKey === '.';
};
const $8831c36ff812ea2a$export$c66af1c05bf7bb06 = (element)=>{
    const { props: props } = element;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.variant)) return true;
};
function $8831c36ff812ea2a$export$ca8981c294eb4d67(key) {
    if (key === this.key || this.__ref?.__componentKey === key) return this;
    // Check if the prop is "extend" and it's either a string or an array
    if (this.extend) {
        // Add the value of the extend key to the result array
        const foundString = (0, $EqHTq.isString)(this.extend) && this.extend === key;
        const foundInArray = (0, $EqHTq.isArray)(this.extend) && this.extend.filter((v)=>v === key).length;
        if (foundString || foundInArray) return this;
    }
    if (this.parent && this.parent.childExtend) {
        // Add the value of the extend key to the result array
        const foundString = (0, $EqHTq.isString)(this.parent.childExtend) && this.parent.childExtend === key;
        const foundInArray = (0, $EqHTq.isArray)(this.parent.childExtend) && this.parent.childExtend.filter((v)=>v === key).length;
        if (foundString || foundInArray) return this;
    }
}
const $8831c36ff812ea2a$export$a23334bdec459c3a = (obj)=>{
    let result = [];
    function traverse(o) {
        for(const key in o)if (Object.hasOwnProperty.call(o, key)) {
            // Check if the key starts with a capital letter and exclude keys like @mobileL, $propsCollection
            if ($8831c36ff812ea2a$export$b791484194c5fc38(key)) result.push(key);
            // Check if the key is "extend" and it's either a string or an array
            if (key === 'extend' || key === 'extends' || key === 'childExtend' || key === 'childExtends') {
                // Add the value of the extend key to the result array
                if (typeof o[key] === 'string') result.push(o[key]);
                else if (Array.isArray(o[key])) result = result.concat(o[key]);
            }
            // If the property is an object, traverse it
            if (typeof o[key] === 'object' && o[key] !== null) traverse(o[key]);
        }
    }
    traverse(obj);
    return result;
};
const $8831c36ff812ea2a$export$c99c504ad1135f20 = (el, opts = {})=>{
    const { __ref: ref } = el;
    const contentElementKey = opts.contentElementKey;
    if (contentElementKey !== 'content' && contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = contentElementKey || 'content';
    else ref.contentElementKey = 'content';
    if (contentElementKey !== 'content') opts.contentElementKey = 'content';
    return ref.contentElementKey;
};

});



parcelRegister("eoYQa", function(module, exports) {

$parcel$export(module.exports, "canRenderTag", () => $a7c2803c7e7b293f$export$342a7615681b7118);

var $yWtDc = parcelRequire("yWtDc");
parcelRequire("cBUNY");
var $glQML = parcelRequire("glQML");
'use strict';
const $a7c2803c7e7b293f$export$342a7615681b7118 = (tag)=>{
    return (0, $glQML.isValidHtmlTag)(tag || 'div') || (0, $yWtDc.report)('HTMLInvalidTag');
};

});
parcelRegister("yWtDc", function(module, exports) {

$parcel$export(module.exports, "ERRORS_REGISTRY", () => $06908963bda72849$export$fc4da02de2c0bd43);
$parcel$export(module.exports, "report", () => $06908963bda72849$export$f18d5b0af29128b7);
'use strict';
const $06908963bda72849$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: 'Document is undefined',
            description: 'To tweak with DOM, you should use browser.'
        },
        OverwriteToBuiltin: {
            title: 'Overwriting to builtin method',
            description: 'Overwriting a builtin method in the window define is not possible, please choose different name'
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: 'Environment should be browser application, that can run Javascript'
        },
        SetQuickPreferancesIsNotObject: {
            title: 'Quick preferances object is required',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: 'Params are invalid',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: 'You must provide node',
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: 'Element tag name (or DOM nodeName) is invalid',
            description: 'To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/'
        },
        HTMLInvalidAttr: {
            title: 'Attibutes object is invalid',
            description: 'Please pass a valid plain object to apply as an attributes for a DOM node'
        },
        HTMLInvalidData: {
            title: 'Data object is invalid',
            description: 'Please pass a valid plain object to apply as an dataset for a DOM node'
        },
        HTMLInvalidStyles: {
            title: 'Styles object is invalid',
            description: 'Please pass a valid plain object to apply as an style for a DOM node'
        },
        HTMLInvalidText: {
            title: 'Text string is invalid',
            description: 'Please pass a valid string to apply text to DOM node'
        },
        ElementOnStateIsNotDefined: {
            title: 'Element on state is not defined',
            description: 'Please check the element object'
        }
    }
};
const $06908963bda72849$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = 'en';
    let errObj;
    if (err && typeof err === 'string') errObj = $06908963bda72849$export$fc4da02de2c0bd43[currentLang][err];
    return new Error(`"${err}", "${arg}"\n\n`, `${errObj.description}`, element ? `\n\n${element}` : '');
};

});


parcelRegister("btZia", function(module, exports) {

$parcel$export(module.exports, "applyAnimationFrame", () => $85c1f279f2dd84cb$export$cef3c08d5491509f);
$parcel$export(module.exports, "initAnimationFrame", () => $85c1f279f2dd84cb$export$e1d20e1514750bad);
'use strict';
const $85c1f279f2dd84cb$export$a9e0446239e28a61 = (el)=>{
    const { __ref: ref } = el;
    const { frameListeners: frameListeners } = ref.root.data;
    // Check if frameListeners exists and the element is not already in the Set
    if (frameListeners && !frameListeners.has(el)) frameListeners.add(el) // Add the element to the Set
    ;
};
const $85c1f279f2dd84cb$export$cef3c08d5491509f = (element, options)=>{
    const { props: props, on: on, __ref: ref } = element;
    const { frameListeners: frameListeners } = ref.root.data;
    if (frameListeners && (on?.frame || props?.onFrame)) $85c1f279f2dd84cb$export$a9e0446239e28a61(element);
};
const $85c1f279f2dd84cb$export$e1d20e1514750bad = (ctx)=>{
    const frameListeners = new Set();
    function requestFrame() {
        // Iterate over frameListeners
        for (const element of frameListeners){
            const parentNode = element.parent.tag === 'fragment' ? element.parent.parent : element.parent;
            if (!parentNode.node.contains(element.node)) frameListeners.delete(element) // Remove if node has no parent
            ;
            else try {
                (element.on.frame || element.props.onFrame)(element, element.state, element.context);
            } catch (e) {
                console.warn(e);
            }
        }
        window.requestAnimationFrame(requestFrame);
    }
    requestFrame();
    return frameListeners;
};

});


parcelRegister("b18jb", function(module, exports) {

$parcel$export(module.exports, "ROOT", () => $80563b8eaf6ba844$export$fbea82a1c0574ef4);
$parcel$export(module.exports, "TREE", () => $80563b8eaf6ba844$export$33ecaa422889cd80);
parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");

var $yWtDc = parcelRequire("yWtDc");
'use strict';
const $80563b8eaf6ba844$export$fbea82a1c0574ef4 = {
    key: ':root',
    node: (0, $jvD5p.document) ? (0, $jvD5p.document).body : (0, $yWtDc.report)('DocumentNotDefined', (0, $jvD5p.document))
};
const $80563b8eaf6ba844$export$33ecaa422889cd80 = $80563b8eaf6ba844$export$fbea82a1c0574ef4;

});

parcelRegister("lI5Kt", function(module, exports) {
$parcel$export(module.exports, "parseFilters", () => (parcelRequire("ajGUj")).parseFilters);
$parcel$export(module.exports, "REGISTRY", () => (parcelRequire("ajGUj")).REGISTRY);

$parcel$export(module.exports, "registry", () => (parcelRequire("ajGUj")).REGISTRY);

var $ajkzz = parcelRequire("ajkzz");

var $97DJ4 = parcelRequire("97DJ4");

var $TGTEZ = parcelRequire("TGTEZ");

var $jDgNO = parcelRequire("jDgNO");

var $1QNO8 = parcelRequire("1QNO8");

var $699eL = parcelRequire("699eL");

var $2ea4y = parcelRequire("2ea4y");

var $6nUV8 = parcelRequire("6nUV8");

var $i0pxI = parcelRequire("i0pxI");

var $ajGUj = parcelRequire("ajGUj");
'use strict';

});
parcelRegister("ajkzz", function(module, exports) {

$parcel$export(module.exports, "attr", () => $781ba30c522cf3e7$export$7aabe8b3a840d2fd);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $yWtDc = parcelRequire("yWtDc");
parcelRequire("6LaO6");
var $dxF2a = parcelRequire("dxF2a");
'use strict';
function $781ba30c522cf3e7$export$7aabe8b3a840d2fd(params, element, node, opts) {
    const { __ref: ref, props: props } = element;
    const { __attr: __attr } = ref;
    if ((0, $EqHTq.isNot)('object')) (0, $yWtDc.report)('HTMLInvalidAttr', params);
    if (params) {
        if (props.attr) (0, $dxF2a.deepMerge)(params, props.attr);
        for(const attr in params){
            const val = (0, $8wu6n.exec)(params[attr], element, element.state, element.context, opts);
            // if (__attr[attr] === val) return
            if (val !== false && !(0, $EqHTq.isUndefined)(val) && !(0, $EqHTq.isNull)(val) && node.setAttribute) node.setAttribute(attr, (0, $8wu6n.exec)(val, element, element.state, element.context, opts));
            else if (node.removeAttribute) node.removeAttribute(attr);
            __attr[attr] = val;
        }
    }
}
var $781ba30c522cf3e7$export$2e2bcd8739ae039 = $781ba30c522cf3e7$export$7aabe8b3a840d2fd;

});
parcelRegister("6LaO6", function(module, exports) {
$parcel$export(module.exports, "deepMerge", () => (parcelRequire("dxF2a")).deepMerge);
$parcel$export(module.exports, "METHODS_EXL", () => (parcelRequire("dxF2a")).METHODS_EXL);
$parcel$export(module.exports, "overwrite", () => (parcelRequire("dxF2a")).overwrite);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => (parcelRequire("hHA4r")).cloneAndMergeArrayExtend);
$parcel$export(module.exports, "deepMergeExtend", () => (parcelRequire("hHA4r")).deepMergeExtend);
$parcel$export(module.exports, "fallbackStringExtend", () => (parcelRequire("hHA4r")).fallbackStringExtend);
$parcel$export(module.exports, "getExtendStack", () => (parcelRequire("hHA4r")).getExtendStack);
$parcel$export(module.exports, "jointStacks", () => (parcelRequire("hHA4r")).jointStacks);
parcelRequire("dxF2a");
parcelRequire("hHA4r");
parcelRequire("ejBiG");
'use strict';

});
parcelRegister("dxF2a", function(module, exports) {

$parcel$export(module.exports, "METHODS_EXL", () => $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d);
$parcel$export(module.exports, "deepMerge", () => $9dbe2fe74e93fc61$export$6969335ea1e4e77c);
$parcel$export(module.exports, "overwrite", () => $9dbe2fe74e93fc61$export$d3305692eb3e9a81);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");
parcelRequire("dAG9v");
var $h0ZsQ = parcelRequire("h0ZsQ");
'use strict';
// breaks server build
// import { IGNORE_STATE_PARAMS } from '@domql/state'
// import { METHODS } from '../methods'
const $9dbe2fe74e93fc61$var$IGNORE_STATE_PARAMS = [
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
];
const $9dbe2fe74e93fc61$export$f0748ddc99f937c7 = [
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getPath',
    'setNodeStyles',
    'spotByPath',
    'append',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'nextElement',
    'previousElement'
];
const $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d = (0, $hSU9O.joinArrays)([
    'node',
    'state',
    'context',
    'extend',
    '__element'
], $9dbe2fe74e93fc61$export$f0748ddc99f937c7, $9dbe2fe74e93fc61$var$IGNORE_STATE_PARAMS, (0, $h0ZsQ.IGNORE_PROPS_PARAMS));
const $9dbe2fe74e93fc61$export$6969335ea1e4e77c = (element, extend, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in extend){
        if (exclude.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $9dbe2fe74e93fc61$export$6969335ea1e4e77c(elementProp, extendProp);
    }
    return element;
};
const $9dbe2fe74e93fc61$export$9cd59f9826255e47 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        o[e] = obj[e];
    }
    return o;
};
const $9dbe2fe74e93fc61$export$d3305692eb3e9a81 = (element, params, options)=>{
    const changes = {};
    const { __ref: __ref } = element;
    const { __exec: __exec, __cached: __cached } = __ref;
    for(const e in params){
        if (e === 'props' || e === 'state' || e === '__ref') continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            __cached[e] = changes[e] = elementProp;
            element[e] = paramsProp;
        }
        if (options.cleanExec) delete __exec[e];
    }
    return changes;
};
const $9dbe2fe74e93fc61$export$1c07155dfdd98f41 = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$f0b277b530b4fffd = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) $9dbe2fe74e93fc61$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $9dbe2fe74e93fc61$export$fd2fbaf2367ef824 = (arr, exclude = [
    'parent',
    'node',
    '__element',
    'state',
    'context',
    '__ref'
])=>{
    return arr.reduce((a, c)=>$9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, (0, $8wu6n.deepClone)(c, {
            exclude: exclude
        })), {});
};
const $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(obj) : (0, $8wu6n.deepClone)(obj);
};
const $9dbe2fe74e93fc61$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $9dbe2fe74e93fc61$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};

});
parcelRegister("dAG9v", function(module, exports) {
$parcel$export(module.exports, "IGNORE_PROPS_PARAMS", () => (parcelRequire("h0ZsQ")).IGNORE_PROPS_PARAMS);
$parcel$export(module.exports, "createProps", () => (parcelRequire("jVrQR")).createProps);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("cnttI")).updateProps);
parcelRequire("h0ZsQ");
parcelRequire("jVrQR");
parcelRequire("nd8mW");
parcelRequire("cnttI");
'use strict';

});
parcelRegister("h0ZsQ", function(module, exports) {

$parcel$export(module.exports, "IGNORE_PROPS_PARAMS", () => $c6321d44fd66ade0$export$431871e52735632b);
'use strict';
const $c6321d44fd66ade0$export$431871e52735632b = [
    'update',
    '__element'
];

});

parcelRegister("jVrQR", function(module, exports) {

$parcel$export(module.exports, "syncProps", () => $e818f1ed291a38e8$export$b23ca50362483f82);
$parcel$export(module.exports, "createProps", () => $e818f1ed291a38e8$export$c94ea207b45fef3a);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $h0ZsQ = parcelRequire("h0ZsQ");

var $nd8mW = parcelRequire("nd8mW");
'use strict';
const $e818f1ed291a38e8$var$createPropsStack = (element, parent)=>{
    const { props: props, __ref: ref } = element;
    const propsStack = ref.__props = (0, $nd8mW.inheritParentProps)(element, parent);
    if ((0, $EqHTq.isObject)(props)) propsStack.push(props);
    else if (props === 'inherit' && parent.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $EqHTq.isArray)(ref.__extend)) ref.__extend.forEach((extend)=>{
        if (extend.props && extend.props !== props) propsStack.push(extend.props);
    });
    ref.__props = propsStack;
    return propsStack;
};
const $e818f1ed291a38e8$export$b23ca50362483f82 = async (props, element, opts)=>{
    element.props = {};
    const mergedProps = {};
    props.forEach((v)=>{
        if ((0, $h0ZsQ.IGNORE_PROPS_PARAMS).includes(v)) return;
        let execProps;
        try {
            execProps = (0, $8wu6n.exec)(v, element, element.state, element.context, opts);
        } catch (e) {
            element.error(e, opts);
        }
        // TODO: check if this failing the function props merge
        // if (isObject(execProps) && execProps.__element) return
        // it was causing infinite loop at early days
        element.props = (0, $8wu6n.deepMerge)(mergedProps, (0, $8wu6n.deepClone)(execProps, {
            ignore: (0, $h0ZsQ.IGNORE_PROPS_PARAMS)
        }), (0, $h0ZsQ.IGNORE_PROPS_PARAMS));
    });
    element.props = mergedProps;
    const methods = {
        update: await $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element.props;
};
const $e818f1ed291a38e8$export$c94ea207b45fef3a = function(element, parent, options) {
    const { __ref: ref } = element;
    const applyProps = ()=>{
        const propsStack = options.cachedProps || $e818f1ed291a38e8$var$createPropsStack(element, parent);
        if (propsStack.length) {
            ref.__props = propsStack;
            $e818f1ed291a38e8$export$b23ca50362483f82(propsStack, element, options);
        } else {
            ref.__props = options.cachedProps || [];
            element.props = {};
        }
    };
    if (ref.__if) applyProps();
    else try {
        applyProps();
    } catch (e) {
        element.props = {};
        ref.__props = options.cachedProps || [];
        element.error('Error applying props', e, options);
    }
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element;
};
async function $e818f1ed291a38e8$var$update(props, options) {
    const element = this.__element;
    await element.update({
        props: props
    }, options);
}

});
parcelRegister("nd8mW", function(module, exports) {

$parcel$export(module.exports, "inheritParentProps", () => $045c563bb4b0b2eb$export$d25057a75c14aff7);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $045c563bb4b0b2eb$var$objectizeStringProperty = (propValue)=>{
    if ((0, $EqHTq.is)(propValue)('string', 'number')) return {
        inheritedString: propValue
    };
    return propValue;
};
const $045c563bb4b0b2eb$export$d25057a75c14aff7 = (element, parent)=>{
    let propsStack = [];
    const parentProps = (0, $8wu6n.exec)(parent, parent.state).props;
    const matchParent = parent.props && parentProps[element.key];
    const matchParentIsString = (0, $EqHTq.isString)(matchParent);
    const matchParentChildProps = parentProps && parentProps.childProps;
    if (matchParent) {
        if (matchParentIsString) {
            const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
            if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
            else propsStack = [].concat($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent), propsStack);
        } else propsStack.push($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent));
    }
    if (matchParentChildProps && !element?.props?.ignoreChildProps) propsStack.push(matchParentChildProps);
    return propsStack;
};

});


parcelRegister("cnttI", function(module, exports) {

$parcel$export(module.exports, "updateProps", () => $902e7fcbfa0a2596$export$c8dce3c08436e91e);

var $jVrQR = parcelRequire("jVrQR");

var $nd8mW = parcelRequire("nd8mW");
'use strict';
const $902e7fcbfa0a2596$export$c8dce3c08436e91e = (newProps, element, parent, opts)=>{
    const { __ref: __ref } = element;
    let propsStack = __ref.__props;
    const parentProps = (0, $nd8mW.inheritParentProps)(element, parent);
    if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
    if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
    if (propsStack) (0, $jVrQR.syncProps)(propsStack, element, opts);
    return element;
};

});



parcelRegister("hHA4r", function(module, exports) {

$parcel$export(module.exports, "fallbackStringExtend", () => $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315);
$parcel$export(module.exports, "deepMergeExtend", () => $ce326eb5cdcc3ce9$export$d20ceec222df68ed);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => $ce326eb5cdcc3ce9$export$e2e460d82983fb19);
$parcel$export(module.exports, "jointStacks", () => $ce326eb5cdcc3ce9$export$f9f936cf352c3af2);
$parcel$export(module.exports, "getExtendStack", () => $ce326eb5cdcc3ce9$export$a0203ee23029af7e);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");
'use strict';
const $ce326eb5cdcc3ce9$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d = {};
const $ce326eb5cdcc3ce9$export$bc442b6cc8c83971 = {};
const $ce326eb5cdcc3ce9$export$46ce3405574370c6 = (extend)=>{
    return $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[extend.__hash];
};
const $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $ce326eb5cdcc3ce9$export$daf4c137c5f56404();
    if (!(0, $EqHTq.isString)(extend)) extend.__hash = hash;
    $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $ce326eb5cdcc3ce9$export$6ef9dd655b57622a = (extend, stack)=>{
    if (extend.__hash) return stack.concat($ce326eb5cdcc3ce9$export$46ce3405574370c6(extend));
    return $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $ce326eb5cdcc3ce9$export$2c118161a655606a = (extend, stack, context)=>{
    extend.forEach((each)=>$ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(each, stack, context));
    return stack;
};
const $ce326eb5cdcc3ce9$export$54e9fb29908872fa = (extend, stack, context)=>{
    const extendOflattenExtend = extend.extend;
    if (extendOflattenExtend) $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2 = (extend, stack, context)=>{
    if (!extend) return stack;
    if ((0, $EqHTq.isArray)(extend)) return $ce326eb5cdcc3ce9$export$2c118161a655606a(extend, stack, context);
    if ((0, $EqHTq.isString)(extend)) extend = $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315(extend, context);
    stack.push(extend);
    if (extend.extend) $ce326eb5cdcc3ce9$export$54e9fb29908872fa(extend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$d20ceec222df68ed = (element, extend)=>{
    for(const e in extend){
        if ([
            'parent',
            'node',
            '__element'
        ].indexOf(e) > -1) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObject)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $ce326eb5cdcc3ce9$export$d20ceec222df68ed(elementProp, extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isObject)(extendProp)) {
            const obj = $ce326eb5cdcc3ce9$export$d20ceec222df68ed({}, elementProp);
            element[e] = $ce326eb5cdcc3ce9$export$d20ceec222df68ed(obj, extendProp);
        } else if (elementProp === undefined && (0, $EqHTq.isFunction)(extendProp)) element[e] = extendProp;
    }
    return element;
};
const $ce326eb5cdcc3ce9$export$e2e460d82983fb19 = (stack)=>{
    return stack.reduce((a, c)=>{
        return $ce326eb5cdcc3ce9$export$d20ceec222df68ed(a, (0, $8wu6n.deepClone)(c));
    }, {});
};
const $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315 = (extend, context, options = {}, variant)=>{
    const COMPONENTS = context && context.components || options.components;
    const PAGES = context && context.pages || options.pages;
    if ((0, $EqHTq.isString)(extend)) {
        const componentExists = COMPONENTS && (COMPONENTS[extend + '.' + variant] || COMPONENTS[extend] || COMPONENTS['smbls.' + extend]);
        const pageExists = PAGES && extend.startsWith('/') && PAGES[extend];
        if (componentExists) return componentExists;
        else if (pageExists) return pageExists;
        else {
            if (options.verbose && (0, $jOLBF.isNotProduction)()) console.warn('Extend is string but component was not found:', extend);
            return {};
        }
    }
    return extend;
};
const $ce326eb5cdcc3ce9$export$f9f936cf352c3af2 = (extendStack, childExtendStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
};
const $ce326eb5cdcc3ce9$export$a0203ee23029af7e = (extend, context)=>{
    if (!extend) return [];
    if (extend.__hash) return $ce326eb5cdcc3ce9$export$46ce3405574370c6(extend) || [];
    const stack = $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extend, [], context);
    return $ce326eb5cdcc3ce9$export$6ef9dd655b57622a(extend, stack);
};
const $ce326eb5cdcc3ce9$export$52f1fe7126b651a = (extend)=>{
    const stack = $ce326eb5cdcc3ce9$export$a0203ee23029af7e(extend);
    return $ce326eb5cdcc3ce9$export$e2e460d82983fb19(stack);
} // export const replaceStringsWithComponents = (stack, context, options) => {
 //   const COMPONENTS = (context && context.components) || options.components
 //   return stack.map(v => {
 //     if (isString(v)) {
 //       const component = COMPONENTS[v]
 //       return component
 //     }
 //     if (isString(v.extend)) {
 //       v.extend = getExtendMerged(COMPONENTS[v.extend])
 //     }
 //     return v
 //   })
 // }
;

});

parcelRegister("ejBiG", function(module, exports) {

$parcel$export(module.exports, "createValidDomqlObjectFromSugar", () => $a6bfc6202982ac85$export$2cbc234431a4ef8);
$parcel$export(module.exports, "applyVariant", () => $a6bfc6202982ac85$export$f1439fc936ef702f);
parcelRequire("cBUNY");
var $bGXur = parcelRequire("bGXur");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");

var $59mkj = parcelRequire("59mkj");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");
'use strict';
const $a6bfc6202982ac85$export$2cbc234431a4ef8 = (el, parent, key, options)=>{
    const newElem = {
        props: {},
        define: {}
    };
    const allowedKeys = [
        'data',
        'state',
        'attr',
        'if'
    ];
    for(const k in el){
        const value = el[k];
        const isComponent = (0, $bGXur.checkIfKeyIsComponent)(k);
        const isRegistry = (0, $ajGUj.REGISTRY)[k];
        if (isComponent || isRegistry || allowedKeys.includes(k)) newElem[k] = value;
        else newElem.props[k] = value;
    }
    return newElem;
};
const $a6bfc6202982ac85$export$a9aa73f3ae416cbd = (element, variant, variantProps)=>{
    let variantElement = element[variant];
    if (!variantElement) return;
    const props = (0, $EqHTq.isObject)(variantProps) ? variantProps : {};
    if ((0, $EqHTq.isString)(variantElement)) variantElement = {
        extend: [
            {
                props: props
            },
            variantElement
        ]
    };
    else if (variantElement.extend) variantElement = (0, $bGXur.addAdditionalExtend)({
        props: props
    }, variantElement);
    const extendedVariant = (0, $59mkj.applyExtend)(variantElement, element.parent);
    const { parent: parent, ...rest } = extendedVariant;
    return (0, $8wu6n.overwriteDeep)(element, rest) // TODO: check why string is not working
    ;
// return overwriteDeep(element, applyExtend(variantElement, element.parent)) // TODO: check why string is not working
};
const $a6bfc6202982ac85$export$f1439fc936ef702f = (element)=>{
    const { props: props } = element;
    if (!(0, $bGXur.hasVariantProp)(element)) return element;
    const { variant: variant } = props;
    $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, `.${variant}`);
    const elKeys = Object.keys(element).filter((key)=>(0, $bGXur.isVariant)(key));
    elKeys.forEach((variant)=>{
        const slicedVariantElementKey = variant.slice(1);
        const variantElementProps = props[slicedVariantElementKey];
        if (variantElementProps) $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, variant, variantElementProps);
    });
    return element;
};

});
parcelRegister("59mkj", function(module, exports) {

$parcel$export(module.exports, "applyExtend", () => $3bff1c984b824aeb$export$f20941eae6723bcc);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("6LaO6");
var $hHA4r = parcelRequire("hHA4r");
'use strict';
let $3bff1c984b824aeb$var$mainExtend;
const $3bff1c984b824aeb$export$f20941eae6723bcc = (element, parent, options = {})=>{
    if ((0, $EqHTq.isFunction)(element)) element = (0, $8wu6n.exec)(element, parent);
    const { props: props, __ref: __ref } = element;
    let extend = props?.extends || element.extends || element.extend;
    const variant = props?.variant;
    const context = element.context || parent.context;
    extend = (0, $hHA4r.fallbackStringExtend)(extend, context, options, variant);
    const extendStack = (0, $hHA4r.getExtendStack)(extend, context);
    // if (isProduction()) delete element.extend
    delete element.extend;
    let childExtendStack = [];
    if (parent) {
        element.parent = parent;
        // Assign parent attr to the element
        if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
            childExtendStack = (0, $hHA4r.getExtendStack)(parent.childExtend, context);
            // if (!options.ignoreChildExtend && !(props && exec(props, element).ignoreChildExtend)) {
            //   const ignoreChildExtendRecursive = props && exec(props, element).ignoreChildExtendRecursive
            const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
            if (parent.childExtendsRecursive && !ignoreChildExtendRecursive) {
                const canExtendRecursive = element.key !== '__text';
                if (canExtendRecursive) {
                    const childExtendsRecursiveStack = (0, $hHA4r.getExtendStack)(parent.childExtendsRecursive, context);
                    // add error if childExtendsRecursive contains element which goes to infinite loop
                    childExtendStack = childExtendStack.concat(childExtendsRecursiveStack);
                    element.childExtendsRecursive = parent.childExtendsRecursive;
                }
            }
        }
    }
    const extendLength = extendStack.length;
    const childExtendLength = childExtendStack.length;
    let stack = [];
    if (extendLength && childExtendLength) stack = (0, $hHA4r.jointStacks)(extendStack, childExtendStack);
    else if (extendLength) stack = extendStack;
    else if (childExtendLength) stack = childExtendStack;
    else if (!context.defaultExtends) return element;
    if (context.defaultExtends) {
        if (!$3bff1c984b824aeb$var$mainExtend) {
            const defaultOptionsExtend = (0, $hHA4r.getExtendStack)(context.defaultExtends, context);
            $3bff1c984b824aeb$var$mainExtend = (0, $hHA4r.cloneAndMergeArrayExtend)(defaultOptionsExtend);
            delete $3bff1c984b824aeb$var$mainExtend.extend;
        }
        stack = [].concat(stack, $3bff1c984b824aeb$var$mainExtend);
    }
    if (__ref) __ref.__extend = stack;
    let mergedExtend = (0, $hHA4r.cloneAndMergeArrayExtend)(stack);
    const COMPONENTS = context && context.components || options.components;
    const component = (0, $8wu6n.exec)(element.component || mergedExtend.component, element);
    if (component && COMPONENTS && COMPONENTS[component]) {
        const componentExtend = (0, $hHA4r.cloneAndMergeArrayExtend)((0, $hHA4r.getExtendStack)(COMPONENTS[component]));
        mergedExtend = (0, $hHA4r.deepMergeExtend)(componentExtend, mergedExtend);
    }
    const merged = (0, $hHA4r.deepMergeExtend)(element, mergedExtend);
    return merged;
};

});




parcelRegister("97DJ4", function(module, exports) {

$parcel$export(module.exports, "assignKeyAsClassname", () => $6a43953e96d89b45$export$d559e9a3b71405f6);
$parcel$export(module.exports, "classList", () => $6a43953e96d89b45$export$11c615ce16f87241);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $6a43953e96d89b45$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === 'string' && key.charAt(0) === '_' && key.charAt(1) !== '_') element.class = key.slice(1);
};
const $6a43953e96d89b45$export$b04d9b8d414ba5e8 = (obj, element, opts)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $8wu6n.exec)(param, element, element.state, element.context, opts)}`;
    }
    return className;
};
const $6a43953e96d89b45$export$11c615ce16f87241 = (params, element, opts)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $6a43953e96d89b45$export$b04d9b8d414ba5e8(params, element, opts);
    // TODO: fails on string
    const className = params.replace(/\s+/g, ' ').trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $6a43953e96d89b45$export$e8f750c9f10c0a7b = (params, element, node, opts)=>{
    const className = $6a43953e96d89b45$export$11c615ce16f87241(params, element, opts);
    node.classList = className;
    return className;
};
function $6a43953e96d89b45$export$f1a8a7f322d4587c(params, element, node, opts) {
    $6a43953e96d89b45$export$e8f750c9f10c0a7b(params, element, node, opts);
}
var $6a43953e96d89b45$export$2e2bcd8739ae039 = $6a43953e96d89b45$export$f1a8a7f322d4587c;

});

parcelRegister("TGTEZ", function(module, exports) {

$parcel$export(module.exports, "updateContent", () => $0a7669919424e35c$export$5143cc956eb9d8f6);
$parcel$export(module.exports, "removeContent", () => $0a7669919424e35c$export$6e1d9b0d0e1e1def);
$parcel$export(module.exports, "setContent", () => $0a7669919424e35c$export$431313f2afd011e2);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $bGXur = parcelRequire("bGXur");

var $grKOq = parcelRequire("grKOq");
'use strict';
const $0a7669919424e35c$export$5143cc956eb9d8f6 = async function(params, options) {
    const element = this;
    const ref = element.__ref;
    const contentKey = ref.contentElementKey;
    if (!element[contentKey]) return;
    if (element[contentKey].update) await element[contentKey].update(params, options);
};
const $0a7669919424e35c$export$6e1d9b0d0e1e1def = function(el, opts = {}) {
    const element = el || this;
    const { __ref: ref } = element;
    // console.warn('removing content', ref.path)
    const contentElementKey = (0, $bGXur.setContentKey)(element, opts);
    if (opts.contentElementKey !== 'content') opts.contentElementKey = 'content';
    const contentElement = element[contentElementKey];
    if (contentElement) {
        if (contentElement.node && element.node) {
            if (contentElement.tag === 'fragment') element.node.innerHTML = '' // TODO: deep check to only remove `content` children and not other children
            ;
            else {
                const contentNode = contentElement.node;
                if (contentNode.parentNode === element.node) element.node.removeChild(contentElement.node);
            }
        }
        const { __cachedContent: __cachedContent } = ref;
        if (__cachedContent) {
            if (__cachedContent.tag === 'fragment') __cachedContent.parent.node.innerHTML = '';
            else if (__cachedContent && (0, $EqHTq.isFunction)(__cachedContent.remove)) __cachedContent.remove();
            delete ref.__cachedContent;
        }
        ref.__children.splice(ref.__children.indexOf(contentElementKey), 1);
        delete element[contentElementKey];
    }
};
async function $0a7669919424e35c$export$431313f2afd011e2(param, element, node, opts) {
    const contentElementKey = (0, $bGXur.setContentKey)(element, opts);
    if (!element) this.warn('No element to set content on');
    if (param) {
        if (element[contentElementKey]?.update) await element[contentElementKey].update({}, opts);
        else await (0, $grKOq.set).call(element, param, opts);
    } else $0a7669919424e35c$export$6e1d9b0d0e1e1def(element, opts);
}
var $0a7669919424e35c$export$2e2bcd8739ae039 = $0a7669919424e35c$export$431313f2afd011e2;

});
parcelRegister("grKOq", function(module, exports) {

$parcel$export(module.exports, "reset", () => $bf937aebc888d68f$export$aad8462122ac592b);
$parcel$export(module.exports, "set", () => $bf937aebc888d68f$export$adaa4cf7ef1b65be);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $bGXur = parcelRequire("bGXur");

var $eS9bk = parcelRequire("eS9bk");

var $cKpeW = parcelRequire("cKpeW");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");

var $TGTEZ = parcelRequire("TGTEZ");
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");
'use strict';
const $bf937aebc888d68f$export$9329d8eaaf41ac4f = async (params, element, options)=>{
    if (!options.preventRemove) (0, $TGTEZ.removeContent)(element, options);
    const { __ref: ref } = element;
    const newContent = await (0, $cKpeW.create)(params, element, ref.contentElementKey || 'content', {
        ignoreChildExtend: true,
        ...(0, $ajGUj.REGISTRY).defaultOptions,
        ...(0, $eS9bk.OPTIONS).create,
        ...options
    });
    ref.__cachedContent = newContent;
};
const $bf937aebc888d68f$export$aad8462122ac592b = async (options)=>{
    const element = undefined;
    await (0, $cKpeW.create)(element, element.parent, undefined, {
        ignoreChildExtend: true,
        ...(0, $ajGUj.REGISTRY).defaultOptions,
        ...(0, $eS9bk.OPTIONS).create,
        ...options
    });
};
const $bf937aebc888d68f$export$adaa4cf7ef1b65be = async function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref } = element;
    // console.warn(params)
    if (options.preventContentUpdate || options.preventUpdate && options.preventUpdate.includes?.('content')) return;
    if (options.routerContentElement && options.lastElement) {
        if (options.routerContentElement !== options.lastElement.content) return;
    }
    const contentKey = (0, $bGXur.setContentKey)(element, options);
    const content = element[contentKey];
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection || element.props?.children;
    if (options.preventContentUpdate === true && !hasCollection) return;
    // console.log(deepClone(params), deepClone(content))
    // console.log(deepContains(params, content))
    if (options.forceUpdate && !options.forceReset && (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && (0, $8wu6n.deepContains)(params, content))) {
        if (!options.preventBeforeUpdateListener && !options.preventListeners) {
            const beforeUpdateReturns = await (0, $4qxjt.triggerEventOnUpdate)('beforeUpdate', params, element, options);
            if (beforeUpdateReturns === false) return element;
        }
        if (content?.update) await content.update({}, options);
        if (!options.preventUpdateListener) await (0, $4qxjt.triggerEventOn)('update', element, options);
        return;
    }
    if (params) {
        let { childExtend: childExtend, childExtendRecursive: childExtendRecursive, props: props } = params;
        if (!props) props = params.props = {};
        if (!childExtend && element.childExtend) {
            params.childExtend = element.childExtend;
            props.ignoreChildExtend = true;
        }
        if (!childExtendRecursive && element.childExtendRecursive) {
            params.childExtendRecursive = element.childExtendRecursive;
            props.ignoreChildExtendRecursive = true;
        }
        if (!props?.childProps && element.props?.childProps) {
            props.childProps = element.props.childProps;
            props.ignoreChildProps = true;
        }
        // TODO: check for fragment and ignore if these attrs ^
        // console.warn('setting content', ref.path)
        if (lazyLoad) window.requestAnimationFrame(async ()=>{
            await $bf937aebc888d68f$export$9329d8eaaf41ac4f(params, element, options);
            // handle lazy load
            if (!options.preventUpdateListener) await (0, $4qxjt.triggerEventOn)('lazyLoad', element, options);
        });
        else await $bf937aebc888d68f$export$9329d8eaaf41ac4f(params, element, options);
    } else if (!options.preventRemove) (0, $TGTEZ.removeContent)(element, options);
    return element;
};
var $bf937aebc888d68f$export$2e2bcd8739ae039 = $bf937aebc888d68f$export$adaa4cf7ef1b65be;

});
parcelRegister("eS9bk", function(module, exports) {

$parcel$export(module.exports, "OPTIONS", () => $ad3d3b247d47f3a2$export$8eb3892b442747bd);
'use strict';
const $ad3d3b247d47f3a2$export$8eb3892b442747bd = {};
var $ad3d3b247d47f3a2$export$2e2bcd8739ae039 = $ad3d3b247d47f3a2$export$8eb3892b442747bd;

});

parcelRegister("cKpeW", function(module, exports) {

$parcel$export(module.exports, "create", () => $947d5c063e68e91c$export$185802fd694ee1f5);
$parcel$export(module.exports, "default", () => $947d5c063e68e91c$export$2e2bcd8739ae039);

var $6HSQm = parcelRequire("6HSQm");

var $b18jb = parcelRequire("b18jb");
parcelRequire("cBUNY");
var $bGXur = parcelRequire("bGXur");
var $8wu6n = parcelRequire("8wu6n");
var $NWrSd = parcelRequire("NWrSd");
var $glQML = parcelRequire("glQML");
var $EqHTq = parcelRequire("EqHTq");
var $cPMIO = parcelRequire("cPMIO");
parcelRequire("60dnU");
var $btZia = parcelRequire("btZia");
var $4qxjt = parcelRequire("4qxjt");
parcelRequire("9OxNG");
var $d5LmL = parcelRequire("d5LmL");
parcelRequire("fmM4W");
var $af4TA = parcelRequire("af4TA");

var $inFIz = parcelRequire("inFIz");
parcelRequire("dAG9v");
var $jVrQR = parcelRequire("jVrQR");

var $59mkj = parcelRequire("59mkj");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");

var $8IrBA = parcelRequire("8IrBA");

var $97DJ4 = parcelRequire("97DJ4");

var $r1wpG = parcelRequire("r1wpG");

var $eS9bk = parcelRequire("eS9bk");

var $ejBiG = parcelRequire("ejBiG");

var $jOLBF = parcelRequire("jOLBF");
'use strict';
const $947d5c063e68e91c$export$185802fd694ee1f5 = async (element, parent1, key, options = (0, $eS9bk.OPTIONS).create || {}, attachOptions)=>{
    const isValid = $947d5c063e68e91c$var$validateElement(element, options);
    if (!isValid) {
        (0, $inFIz.error).call(element, 'Error while creating element: Not valid type', element, options);
        return;
    }
    $947d5c063e68e91c$var$cacheOptions(element, options);
    // if element is STRING
    if ($947d5c063e68e91c$var$checkIfPrimitive(element)) element = $947d5c063e68e91c$var$applyValueAsText(element, parent1, key);
    element = $947d5c063e68e91c$var$redefineElement(element, parent1, key, options);
    parent1 = $947d5c063e68e91c$var$redefineParent(element, parent1, key);
    key = $947d5c063e68e91c$var$createKey(element, parent1, key);
    const ref = $947d5c063e68e91c$var$addRef(element, parent1, key);
    ref.__initialProps = (0, $8wu6n.deepClone)(element.props);
    $947d5c063e68e91c$var$applyContext(element, parent1, options);
    (0, $bGXur.applyComponentFromContext)(element, parent1, options);
    if (!ref.__skipCreate) (0, $59mkj.applyExtend)(element, parent1, options);
    element.key = key;
    if (options.onlyResolveExtends) return await $947d5c063e68e91c$var$onlyResolveExtends(element, parent1, key, options);
    await (0, $4qxjt.triggerEventOn)('eventStart', element, options);
    await (0, $4qxjt.triggerEventOn)('start', element, options);
    $947d5c063e68e91c$var$switchDefaultOptions(element, parent1, options);
    $947d5c063e68e91c$var$addCaching(element, parent1, options);
    (0, $8IrBA.addMethods)(element, parent1, options);
    $947d5c063e68e91c$var$createScope(element, parent1, options);
    await (0, $af4TA.createState)(element, parent1, options);
    if (element.scope === 'state') element.scope = element.state;
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent1);
    // apply props settings
    (0, $jVrQR.createProps)(element, parent1, options);
    if (element.scope === 'props' || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent1);
    // if it already HAS a NODE
    if (element.node && ref.__if) return (0, $d5LmL.assignNode)(element, parent1, key, attachOptions);
    // apply variants
    (0, $ejBiG.applyVariant)(element, parent1);
    (0, $bGXur.addChildrenIfNotInOriginal)(element, parent1, key);
    const onInit = await (0, $4qxjt.triggerEventOn)('init', element, options);
    if (onInit === false) return element;
    const onEventInit = await (0, $4qxjt.triggerEventOn)('eventInit', element, options);
    if (onEventInit === false) return element;
    await (0, $4qxjt.triggerEventOn)('beforeClassAssign', element, options);
    // generate a CLASS name
    (0, $97DJ4.assignKeyAsClassname)(element);
    await $947d5c063e68e91c$var$renderElement(element, parent1, options, attachOptions);
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent1);
    await (0, $4qxjt.triggerEventOn)('complete', element, options);
    await (0, $4qxjt.triggerEventOn)('eventComplete', element, options);
    return element;
};
const $947d5c063e68e91c$var$createBasedOnType = (element, parent1, key, options)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ((0, $jOLBF.isNotProduction)()) console.warn(key, 'element is undefined in', parent1 && parent1.__ref && parent1.__ref.path);
        return {};
    }
    if ((0, $EqHTq.isString)(key) && key.slice(0, false)) {
        if ((0, $jOLBF.isNotProduction)()) console.warn(key, 'seems like to be in __ref');
    }
    if (element === null) return;
    if (element === true) return {
        text: true
    };
    // if element is extend
    if (element.__hash) return {
        extend: element
    };
    // Check if element was passed as node, reassign it to element.node
    if (typeof Node !== 'undefined' && element instanceof Node || typeof DocumentFragment !== 'undefined' && element instanceof DocumentFragment) return {
        node: element
    };
    return element;
};
const $947d5c063e68e91c$var$redefineElement = (element, parent1, key, options)=>{
    const elementWrapper = $947d5c063e68e91c$var$createBasedOnType(element, parent1, key, options);
    if (options.syntaxv3 || element.props && element.props.syntaxv3 || parent1 && parent1.props && parent1.props.syntaxv3) {
        if (element.props) element.props.syntaxv3 = true;
        else element.syntaxv3 = true;
        return (0, $ejBiG.createValidDomqlObjectFromSugar)(element, parent1, key, options);
    } else if ((0, $bGXur.checkIfKeyIsComponent)(key)) return (0, $bGXur.applyKeyComponentAsExtend)(elementWrapper, parent1, key);
    // TODO: move as define plugins
    // Responsive rendering
    if ($947d5c063e68e91c$var$checkIfMedia(key)) return $947d5c063e68e91c$var$applyMediaProps(elementWrapper, parent1, key);
    return elementWrapper;
};
const $947d5c063e68e91c$var$redefineParent = (element, parent1, key, options)=>{
    if (!parent1) return 0, $b18jb.ROOT;
    if ((0, $cPMIO.isNode)(parent1)) {
        const parentNodeWrapper = {
            key: ':root',
            node: parent1
        };
        (0, $b18jb.ROOT)[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent1;
};
const $947d5c063e68e91c$var$validateElement = (value, options)=>{
    if (value == null) return false // null or undefined are not valid elements
    ;
    // --- 1. Invalid primitive types
    const t = typeof value;
    if (t === 'function' || t === 'symbol' || t === 'bigint') return false;
    if (Number.isNaN(value) || value === Infinity || value === -Infinity) return false;
    // --- 2. Global / host objects
    const unsafeGlobals = [
        typeof window !== 'undefined' && window,
        typeof document !== 'undefined' && document,
        typeof globalThis !== 'undefined' && globalThis,
        typeof navigator !== 'undefined' && navigator,
        typeof location !== 'undefined' && location,
        typeof history !== 'undefined' && history,
        typeof screen !== 'undefined' && screen,
        typeof frames !== 'undefined' && frames,
        typeof parent !== 'undefined' && parent,
        typeof self !== 'undefined' && self,
        typeof top !== 'undefined' && top,
        typeof performance !== 'undefined' && performance,
        typeof console !== 'undefined' && console,
        typeof indexedDB !== 'undefined' && indexedDB,
        typeof caches !== 'undefined' && caches,
        typeof localStorage !== 'undefined' && localStorage,
        typeof sessionStorage !== 'undefined' && sessionStorage,
        typeof crypto !== 'undefined' && crypto,
        typeof visualViewport !== 'undefined' && visualViewport,
        typeof customElements !== 'undefined' && customElements
    ].filter(Boolean);
    if (unsafeGlobals.includes(value)) return false;
    // --- 3. DOM node instances
    // allow nodes in order to assign it in element.node
    // if (typeof Node !== 'undefined' && value instanceof Node) return false
    // if (typeof DocumentFragment !== 'undefined' && value instanceof DocumentFragment) return false
    if (typeof EventTarget !== 'undefined' && value instanceof EventTarget) return false;
    if (typeof Event !== 'undefined' && value instanceof Event) return false;
    // --- 4. Prototype / built-in objects
    if (value === Object.prototype || value === Array.prototype || value === Function.prototype || value === Map.prototype || value === Set.prototype || value === WeakMap.prototype || value === WeakSet.prototype || value === Promise.prototype || value === Symbol.prototype) return false;
    // --- 5. Platform API instances
    const unsafeConstructors = [
        typeof Worker !== 'undefined' && Worker,
        typeof SharedWorker !== 'undefined' && SharedWorker,
        typeof MessagePort !== 'undefined' && MessagePort,
        typeof BroadcastChannel !== 'undefined' && BroadcastChannel,
        typeof ReadableStream !== 'undefined' && ReadableStream,
        typeof WritableStream !== 'undefined' && WritableStream,
        typeof TransformStream !== 'undefined' && TransformStream,
        typeof File !== 'undefined' && File,
        typeof Blob !== 'undefined' && Blob,
        typeof FormData !== 'undefined' && FormData,
        typeof XMLHttpRequest !== 'undefined' && XMLHttpRequest,
        typeof AbortController !== 'undefined' && AbortController,
        typeof AbortSignal !== 'undefined' && AbortSignal
    ].filter(Boolean);
    for (const Ctor of unsafeConstructors){
        if (value instanceof Ctor) return false;
    }
    return true;
};
const $947d5c063e68e91c$var$cacheOptions = (element, options)=>{
    if (options && !(0, $eS9bk.OPTIONS).create) {
        (0, $eS9bk.OPTIONS).create = options;
        (0, $eS9bk.OPTIONS).create.context = element.context || options.context;
    }
};
const $947d5c063e68e91c$var$createKey = (element, parent1, key)=>{
    return ((0, $8wu6n.exec)(key, element) || key || element.key || (0, $NWrSd.generateKey)()).toString();
};
const $947d5c063e68e91c$var$addRef = (element, parent1)=>{
    if (element.__ref) element.__ref.origin = element;
    else element.__ref = {
        origin: element
    };
    return element.__ref;
};
const $947d5c063e68e91c$var$switchDefaultOptions = (element, parent1, options)=>{
    if (Object.keys(options).length) {
        (0, $ajGUj.REGISTRY).defaultOptions = options;
        if (options.ignoreChildExtend) delete options.ignoreChildExtend;
    }
};
const $947d5c063e68e91c$var$addElementIntoParentChildren = (element, parent1)=>{
    if (parent1.__ref && parent1.__ref.__children) parent1.__ref.__children.push(element.key);
};
const $947d5c063e68e91c$var$visitedElements = new WeakMap();
const $947d5c063e68e91c$var$renderElement = async (element, parent1, options, attachOptions)=>{
    if ($947d5c063e68e91c$var$visitedElements.has(element)) {
        if ((0, $jOLBF.isNotProduction)()) console.warn('Cyclic rendering detected:', element.__ref.path);
    }
    $947d5c063e68e91c$var$visitedElements.set(element, true);
    const { __ref: ref, key: key } = element;
    const createNestedChild = async ()=>{
        const isInfiniteLoopDetected = (0, $8wu6n.detectInfiniteLoop)(ref.path);
        if (ref.__uniqId || isInfiniteLoopDetected) return;
        await (0, $6HSQm.createNode)(element, options);
        ref.__uniqId = Math.random();
    };
    // CREATE a real NODE
    if ((0, $jOLBF.isNotProduction)()) await createNestedChild();
    else try {
        await createNestedChild();
    } catch (e) {
        const path = ref.path;
        if (path.includes('ComponentsGrid')) path.splice(0, path.indexOf('ComponentsGrid') + 2);
        if (path.includes('demoComponent')) path.splice(0, path.indexOf('demoComponent') + 1);
        const isDemoComponent = element.lookup((el)=>el.state.key)?.state?.key;
        element.warn('Error happened in:', isDemoComponent ? isDemoComponent + ' ' : '' + path.join('.'));
        element.verbose();
        element.error(e, options);
        if (element.on?.error) element.on.error(e, element, element.state, element.context, options);
        if (element.props?.onError) element.props.onError(e, element, element.state, element.context, options);
    }
    if (!ref.__if) {
        parent1[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $d5LmL.assignNode)(element, parent1, key, attachOptions);
    // apply events
    (0, $btZia.applyAnimationFrame)(element, options);
    // run `on.render`
    await (0, $4qxjt.triggerEventOn)('render', element, options);
    // triggerEventOn('render', element, options).then(() => {})
    // run `on.renderRouter`
    await (0, $4qxjt.triggerEventOn)('renderRouter', element, options);
    // run `on.done`
    await (0, $4qxjt.triggerEventOn)('done', element, options);
    // run `on.done`
    await (0, $4qxjt.triggerEventOn)('create', element, options);
};
const $947d5c063e68e91c$var$checkIfPrimitive = (element)=>(0, $EqHTq.is)(element)('string', 'number');
const $947d5c063e68e91c$var$applyValueAsText = (element, parent1, key)=>{
    const extendTag = element.extend && element.extend.tag;
    const childExtendTag = parent1.childExtend && parent1.childExtend.tag;
    const childPropsTag = parent1.props.childProps && parent1.props.childProps.tag;
    const isKeyValidHTMLTag = (0, $glQML.HTML_TAGS).body.indexOf(key) > -1 && key;
    return {
        text: element,
        tag: extendTag || childExtendTag || childPropsTag || isKeyValidHTMLTag || 'string'
    };
};
const $947d5c063e68e91c$var$applyContext = (element, parent1, options)=>{
    const forcedOptionsContext = options.context && !(0, $b18jb.ROOT).context && !element.context;
    if (forcedOptionsContext) (0, $b18jb.ROOT).context = options.context;
    // inherit from parent or root
    if (!element.context) element.context = parent1.context || options.context || (0, $b18jb.ROOT).context;
};
// Create scope - shared object across the elements to the own or the nearest parent
const $947d5c063e68e91c$var$createScope = (element, parent1)=>{
    const { __ref: ref } = element;
    // If the element doesn't have a scope, initialize it using the parent's scope or the root's scope.
    if (!element.scope) element.scope = parent1.scope || ref.root.scope || {};
};
const $947d5c063e68e91c$var$createIfConditionFlag = (element, parent1)=>{
    const { __ref: ref } = element;
    const ifFn = element.props?.if || element.if;
    if ((0, $EqHTq.isFunction)(ifFn) && !ifFn(element, element.state, element.context)) delete ref.__if;
    else ref.__if = true;
};
const $947d5c063e68e91c$var$addCaching = (element, parent1)=>{
    const { __ref: ref, key: key } = element;
    let { __ref: parentRef } = parent1;
    // enable TRANSFORM in data
    if (!element.transform) element.transform = {};
    // enable CACHING
    if (!ref.__cached) ref.__cached = {};
    if (!ref.__cachedContent) ref.__cachedContent = null;
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    if (!ref.__execProps) ref.__execProps = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    if ((0, $bGXur.checkIfKeyIsComponent)(key)) ref.__componentKey = key.split('_')[0].split('.')[0].split('+')[0];
    // Add _root element property
    const hasRoot = parent1 && parent1.key === ':root';
    if (!ref.root) ref.root = hasRoot ? element : parentRef.root;
    // set the PATH array
    // if (isNotProduction()) {
    if (!parentRef) parentRef = parent1.ref = {};
    if (!parentRef.path) parentRef.path = [];
    ref.path = parentRef.path.concat(element.key);
// }
};
const $947d5c063e68e91c$var$onlyResolveExtends = async (element, parent1, key, options)=>{
    const { __ref: ref } = element;
    if (!ref.__skipCreate) {
        $947d5c063e68e91c$var$addCaching(element, parent1);
        (0, $8IrBA.addMethods)(element, parent1, options);
        $947d5c063e68e91c$var$createScope(element, parent1);
        (0, $af4TA.createState)(element, parent1, options);
        if (element.scope === 'state') element.scope = element.state;
        $947d5c063e68e91c$var$createIfConditionFlag(element, parent1);
        // apply props settings
        (0, $jVrQR.createProps)(element, parent1, options);
        if (element.scope === 'props' || element.scope === true) element.scope = element.props;
        if (element.node && ref.__if) parent1[key || element.key] = element;
         // Borrowed from assignNode()
        if (!element.props) element.props = {};
        (0, $ejBiG.applyVariant)(element, parent1);
        $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent1);
    }
    if (element.tag !== 'string' && element.tag !== 'fragment') {
        await (0, $r1wpG.throughInitialDefine)(element);
        await (0, $r1wpG.throughInitialExec)(element);
        for(const k in element){
            if ((0, $EqHTq.isUndefined)(element[k]) || (0, $inFIz.isMethod)(k, element) || (0, $EqHTq.isObject)(((0, $ajGUj.REGISTRY).default || (0, $ajGUj.REGISTRY))[k]) || (0, $bGXur.isVariant)(k)) continue;
            const hasDefine = element.define && element.define[k];
            const contextHasDefine = element.context && element.context.define && element.context.define[k];
            const optionsHasDefine = options.define && options.define[k];
            if (!ref.__skipCreate && (0, $ajGUj.REGISTRY)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $947d5c063e68e91c$export$185802fd694ee1f5((0, $8wu6n.exec)(element[k], element), element, k, options);
        }
    }
    parent1[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by createProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
const $947d5c063e68e91c$var$checkIfMedia = (key)=>key.slice(0, 1) === '@';
const $947d5c063e68e91c$var$applyMediaProps = (element, parent1, key)=>{
    const { props: props } = element;
    if (props) {
        props.display = 'none';
        if (props[key]) props[key].display = props.display;
        else props[key] = {
            display: props.display || 'block'
        };
        return element;
    } else return {
        ...element,
        props: {
            display: 'none',
            [key]: {
                display: 'block'
            }
        }
    };
};
var $947d5c063e68e91c$export$2e2bcd8739ae039 = $947d5c063e68e91c$export$185802fd694ee1f5;

});
parcelRegister("6HSQm", function(module, exports) {

$parcel$export(module.exports, "createNode", () => $4e214d02be0ddce7$export$270e7ba5936d3c48);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $bGXur = parcelRequire("bGXur");
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");
parcelRequire("9OxNG");
var $aiDgO = parcelRequire("aiDgO");

var $inFIz = parcelRequire("inFIz");

var $cKpeW = parcelRequire("cKpeW");

var $r1wpG = parcelRequire("r1wpG");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");

var $bKCm2 = parcelRequire("bKCm2");

var $1vZTM = parcelRequire("1vZTM");
'use strict';
const $4e214d02be0ddce7$export$270e7ba5936d3c48 = async (element, options)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    let isNewNode;
    // handle content duplication bug with delayed rendering
    if (options.routerContentElement && options.lastElement) {
        if (options.routerContentElement !== options.lastElement.content) return;
    }
    if (!node) {
        isNewNode = true;
        if (!ref.__if) return element;
        if (tag === 'shadow') node = element.node = element.parent.node.attachShadow({
            mode: 'open'
        });
        else node = element.node = (0, $aiDgO.cacheNode)(element);
        // trigger `on.attachNode`
        await (0, $4qxjt.triggerEventOn)('attachNode', element, options);
    }
    // node.dataset // .key = element.key
    // if (isNotProduction() || options.alowRefReference) {
    node.ref = element;
    if ((0, $EqHTq.isFunction)(node.setAttribute)) node.setAttribute('key', element.key);
    // }
    // iterate through exec props
    (0, $r1wpG.throughExecProps)(element, options);
    // iterate through define
    await (0, $r1wpG.throughInitialDefine)(element, options);
    // iterate through exec
    await (0, $r1wpG.throughInitialExec)(element);
    if (element.tag !== 'string' && element.tag !== 'fragment') {
        (0, $1vZTM.propagateEventsFromProps)(element);
        if (isNewNode && (0, $EqHTq.isObject)(element.on)) (0, $4qxjt.applyEventsOnNode)(element, options);
    }
    const keys = Object.keys(element);
    for (const param of keys){
        const value = element[param];
        if (!Object.hasOwnProperty.call(element, param)) continue;
        if ((0, $EqHTq.isUndefined)(value) || (0, $inFIz.isMethod)(param, element) || (0, $bGXur.isVariant)(param) || (0, $EqHTq.isObject)((0, $ajGUj.REGISTRY)[param])) continue;
        if (param === 'onClick') debugger;
        const isElement = await (0, $bKCm2.applyParam)(param, element, options);
        if (!isElement) continue;
        const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
        if (value && isElement && !hasDefine && !hasContextDefine) {
            const createAsync = async ()=>{
                try {
                    const val = await (0, $8wu6n.exec)(value, element);
                    await (0, $cKpeW.create)(val, element, param, options);
                } catch (error) {
                    // Handle other potential errors
                    element.error('An unexpected error occurred:', error);
                }
            };
            if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(async ()=>{
                await createAsync();
                // handle lazy load
                if (!options.preventUpdateListener) await (0, $4qxjt.triggerEventOn)('lazyLoad', element, options);
            });
            else await createAsync();
        }
    }
    // node.dataset.key = key
    return element;
};
var $4e214d02be0ddce7$export$2e2bcd8739ae039 = $4e214d02be0ddce7$export$270e7ba5936d3c48;

});
parcelRegister("9OxNG", function(module, exports) {
$parcel$export(module.exports, "cacheNode", () => (parcelRequire("aiDgO")).cacheNode);
$parcel$export(module.exports, "assignNode", () => (parcelRequire("d5LmL")).assignNode);
parcelRequire("bVzuX");
parcelRequire("aiDgO");
parcelRequire("d5LmL");
'use strict';

});
parcelRegister("bVzuX", function(module, exports) {
'use strict';
const $8af08dc9e7559b54$export$270e7ba5936d3c48 = (element)=>{};

});

parcelRegister("aiDgO", function(module, exports) {

$parcel$export(module.exports, "cacheNode", () => $01ef634a92434650$export$257247f9c0329159);

var $yWtDc = parcelRequire("yWtDc");
parcelRequire("60dnU");
var $eoYQa = parcelRequire("eoYQa");
parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $glQML = parcelRequire("glQML");
'use strict';
const $01ef634a92434650$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag, context: context } = element;
    const doc = context.document || (0, $jvD5p.document);
    if (tag) {
        if (tag === 'string') return doc.createTextNode(element.text);
        else if (tag === 'fragment') return doc.createDocumentFragment();
        else if (tag === 'svg' || tag === 'path') return doc.createElementNS('http://www.w3.org/2000/svg', tag);
        else return doc.createElement(tag) // TODO: allow strict mode to check validity
        ;
    } else return doc.createElement('div');
};
const $01ef634a92434650$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $8wu6n.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.tag)) {
        const tagExists = (0, $glQML.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $EqHTq.isString)(tag)) {
        if ((0, $glQML.isValidHtmlTag)(tag)) return tag;
    } else {
        let keyAsTag = key.toLowerCase();
        if (keyAsTag.includes('.')) keyAsTag = keyAsTag.split('.')[0];
        if (keyAsTag.includes('_')) keyAsTag = keyAsTag.split('_')[0];
        if ((0, $glQML.isValidHtmlTag)(keyAsTag)) return keyAsTag;
    }
    return 'div';
};
const $01ef634a92434650$export$257247f9c0329159 = (element)=>{
    const { context: context } = element;
    const win = context.window || window;
    const tag = element.tag = $01ef634a92434650$export$5075bd4eae016d2c(element);
    if (!(0, $eoYQa.canRenderTag)(tag)) return (0, $yWtDc.report)('HTMLInvalidTag', element.tag, element);
    if (!win.nodeCaches) win.nodeCaches = {};
    let cachedTag = win.nodeCaches[tag];
    if (!cachedTag) cachedTag = win.nodeCaches[tag] = $01ef634a92434650$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === 'string') clonedNode.nodeValue = element.text;
    return clonedNode;
};

});

parcelRegister("d5LmL", function(module, exports) {

$parcel$export(module.exports, "assignNode", () => $98807bf18bc93fb3$export$4f2a718cb234b42f);
'use strict';
const $98807bf18bc93fb3$export$13970129ca912f06 = (node, parentNode, el)=>{
    const win = el?.context?.window || window;
    try {
        if (parentNode && typeof parentNode.appendChild === 'function') {
            if (parentNode instanceof win.Node && typeof parentNode.appendChild === 'function') parentNode.appendChild(node);
            else throw new Error('Invalid parentNode: appendChild is not supported on this node type.');
        } else throw new Error('Invalid parentNode: appendChild is not supported on this node type.');
    } catch (e) {
        // Fallback for older browsers
        if (node && node.parentNode) node.parentNode.removeChild(node);
        if (node && parentNode && parentNode instanceof win.Element) parentNode.appendChild(node);
    }
    return node;
};
const $98807bf18bc93fb3$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    if (siblingNode.nextSibling) parent && parent.insertBefore(node, siblingNode.nextSibling);
    else if (siblingNode?.insertAdjacentElement) siblingNode.insertAdjacentElement('afterend', node);
    else parent.insertBefore(node, siblingNode);
};
const $98807bf18bc93fb3$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    parent && parent.insertBefore(node, siblingNode);
};
const $98807bf18bc93fb3$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    parent[key || element.key] = element;
    if (element.tag !== 'shadow') {
        if (attachOptions && attachOptions.position) (attachOptions.position === 'before' ? $98807bf18bc93fb3$export$3a727f1d0007fe49 : $98807bf18bc93fb3$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $98807bf18bc93fb3$export$13970129ca912f06(element.node, parent.node, element);
    }
    return element;
};

});


parcelRegister("r1wpG", function(module, exports) {

$parcel$export(module.exports, "throughInitialExec", () => $0513b3ed7d5404ec$export$3223a9877c540db8);
$parcel$export(module.exports, "throughUpdatedExec", () => $0513b3ed7d5404ec$export$2ad800d85590910f);
$parcel$export(module.exports, "throughExecProps", () => $0513b3ed7d5404ec$export$23077649cd9ebd4b);
$parcel$export(module.exports, "throughInitialDefine", () => $0513b3ed7d5404ec$export$b4c781127351659b);
$parcel$export(module.exports, "throughUpdatedDefine", () => $0513b3ed7d5404ec$export$88eda8a7eb5c5eff);
parcelRequire("cBUNY");
var $bGXur = parcelRequire("bGXur");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("6LaO6");
var $dxF2a = parcelRequire("dxF2a");

var $inFIz = parcelRequire("inFIz");
'use strict';
const $0513b3ed7d5404ec$export$3223a9877c540db8 = async (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $EqHTq.isFunction)(prop) && !(0, $inFIz.isMethod)(param, element) && !(0, $bGXur.isVariant)(param)) {
            ref.__exec[param] = prop;
            element[param] = await prop(element, element.state, element.context);
        // if (isComponent)
        }
    }
};
const $0513b3ed7d5404ec$export$2ad800d85590910f = async (element, options = {
    excludes: (0, $dxF2a.METHODS_EXL)
})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = await ref.__exec[param](element, element.state, element.context);
        const execReturnsString = (0, $EqHTq.isString)(newExec) || (0, $EqHTq.isNumber)(newExec);
        // if (prop && prop.node && execReturnsString) {
        if (prop && prop.node && execReturnsString) (0, $dxF2a.overwrite)(prop, {
            text: newExec
        }, options);
        else if (newExec !== prop) {
            if ((0, $bGXur.checkIfKeyIsComponent)(param)) {
                const { extend: extend, ...newElem } = (0, $bGXur.extendizeByKey)(newExec, element, param);
                (0, $dxF2a.overwrite)(prop, newElem, options);
            // } else {
            //   overwrite(prop, newExec, options)
            } else {
                ref.__cached[param] = changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $0513b3ed7d5404ec$export$23077649cd9ebd4b = (element, opts)=>{
    const { __ref: ref } = element;
    const { props: props } = element;
    for(const k in props){
        const isDefine = k.startsWith('is') || k.startsWith('has') || k.startsWith('use');
        if (!ref.__execProps) return (0, $inFIz.warn).call(element, 'Element was not initiated to execute props');
        const cachedExecProp = ref.__execProps[k];
        if ((0, $EqHTq.isFunction)(cachedExecProp)) props[k] = (0, $8wu6n.exec)(cachedExecProp, element, element.state, element.context, opts);
        else if (isDefine && (0, $EqHTq.isFunction)(props[k])) {
            ref.__execProps[k] = props[k];
            props[k] = (0, $8wu6n.exec)(props[k], element, element.state, element.context, opts);
        }
    }
};
const $0513b3ed7d5404ec$export$b4c781127351659b = async (element, opts)=>{
    const { define: define, context: context, __ref: ref } = element;
    let defineObj = {};
    const hasGlobalDefine = context && (0, $EqHTq.isObject)(context.define);
    if ((0, $EqHTq.isObject)(define)) defineObj = {
        ...define
    };
    if (hasGlobalDefine) defineObj = {
        ...defineObj,
        ...context.define
    };
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $EqHTq.isFunction)(elementProp) && !(0, $inFIz.isMethod)(param, element) && !(0, $bGXur.isVariant)(param)) {
            ref.__exec[param] = elementProp;
            const execParam = elementProp = await (0, $8wu6n.exec)(elementProp, element, element.state, element.context, opts);
            if (execParam) {
                elementProp = element[param] = execParam.parse ? execParam.parse() : execParam;
                ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = await defineObj[param](elementProp, element, element.state, element.context);
        if (execParam) element[param] = execParam;
    }
    return element;
};
const $0513b3ed7d5404ec$export$88eda8a7eb5c5eff = async (element, opts)=>{
    const { context: context, define: define, __ref: ref } = element;
    const changes = {};
    let obj = {};
    if ((0, $EqHTq.isObject)(define)) obj = {
        ...define
    };
    if ((0, $EqHTq.isObject)(context && context.define)) obj = {
        ...obj,
        ...context.define
    };
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) ref.__defineCache[param] = await execParam(element, element.state, element.context);
        const cached = await (0, $8wu6n.exec)(ref.__defineCache[param], element, element.state, element.context, opts);
        const newExecParam = await obj[param](cached, element, element.state, element.context);
        if (newExecParam) element[param] = newExecParam;
    }
    return changes;
};

});

parcelRegister("bKCm2", function(module, exports) {

$parcel$export(module.exports, "applyParam", () => $88e1be01eff6bc07$export$535107f3c159da5d);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");
'use strict';
const $88e1be01eff6bc07$export$535107f3c159da5d = async (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = await (0, $8wu6n.exec)(element[param], element, element.state, element.context, options);
    const { onlyUpdate: onlyUpdate } = options;
    const DOMQLProperty = (0, $ajGUj.REGISTRY)[param];
    const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define && element.define[param];
    const hasContextDefine = context && context.define && context.define[param];
    if (!ref.__if) return;
    const hasOnlyUpdate = onlyUpdate ? onlyUpdate === param || element.lookup(onlyUpdate) : true;
    if (isGlobalTransformer && !hasContextDefine && hasOnlyUpdate) {
        if ((0, $EqHTq.isFunction)(isGlobalTransformer)) await isGlobalTransformer(prop, element, node, options);
        return;
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};

});

parcelRegister("1vZTM", function(module, exports) {

$parcel$export(module.exports, "propagateEventsFromProps", () => $11a8b378b730acc1$export$e43138af17da316d);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
'use strict';
const $11a8b378b730acc1$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    const eventKeysFromProps = Object.keys(props).filter((key)=>key.startsWith('on'));
    eventKeysFromProps.forEach((v)=>{
        const eventName = (0, $5WrxC.lowercaseFirstLetter)(v.split('on')[1]);
        const origEvent = on[eventName];
        const funcFromProps = props[v];
        if ((0, $EqHTq.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const originalEventRetunrs = origEvent(...args);
            if (originalEventRetunrs !== false) return funcFromProps(...args);
        };
        else on[eventName] = funcFromProps;
    });
};

});


parcelRegister("fmM4W", function(module, exports) {
$parcel$export(module.exports, "IGNORE_STATE_PARAMS", () => (parcelRequire("gsrkA")).IGNORE_STATE_PARAMS);
$parcel$export(module.exports, "createState", () => (parcelRequire("af4TA")).createState);
$parcel$export(module.exports, "findInheritedState", () => (parcelRequire("8dU3Q")).findInheritedState);
$parcel$export(module.exports, "getChildStateInKey", () => (parcelRequire("8dU3Q")).getChildStateInKey);
$parcel$export(module.exports, "isState", () => (parcelRequire("8dU3Q")).isState);
parcelRequire("gsrkA");
parcelRequire("af4TA");
parcelRequire("bXI75");
parcelRequire("aF4Ar");
parcelRequire("8dU3Q");
'use strict';

});
parcelRegister("gsrkA", function(module, exports) {

$parcel$export(module.exports, "IGNORE_STATE_PARAMS", () => $bfb47641e396194b$export$5100524046ce8de6);
'use strict';
const $bfb47641e396194b$export$5100524046ce8de6 = [
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'keys',
    'values',
    'ref',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
];

});

parcelRegister("af4TA", function(module, exports) {

$parcel$export(module.exports, "createState", () => $774f1a3b2fe82710$export$e6a0daad8304de);
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $gsrkA = parcelRequire("gsrkA");

var $aF4Ar = parcelRequire("aF4Ar");

var $bXI75 = parcelRequire("bXI75");

var $8dU3Q = parcelRequire("8dU3Q");
'use strict';
const $774f1a3b2fe82710$export$e6a0daad8304de = async function(element, parent, options) {
    element.state = await $774f1a3b2fe82710$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $774f1a3b2fe82710$export$6e8a0938c76079c7 = async function(element, parent, options) {
    const objectizeState = await $774f1a3b2fe82710$var$checkForTypes(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = objectizeState;
    const whatInitReturns = await (0, $4qxjt.triggerEventOn)('stateInit', element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $8dU3Q.checkIfInherits)(element)) {
        const inheritedState = (0, $8dU3Q.createInheritedState)(element, parent);
        element.state = (0, $EqHTq.isUndefined)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = $774f1a3b2fe82710$var$applyDependentState(element, element.state || parent.state || {});
    if (dependentState) element.state = dependentState;
    $774f1a3b2fe82710$var$applyMethods(element);
    // trigger `on.stateCreated`
    await (0, $4qxjt.triggerEventOn)('stateCreated', element, options);
    return element.state;
};
const $774f1a3b2fe82710$var$applyDependentState = (element, state)=>{
    const { __ref: __ref, ref: ref, __element: __element } = state //
    ;
    const origState = (0, $8wu6n.exec)(__ref || ref || __element?.state, element);
    if (!origState) return;
    const dependentState = (0, $8wu6n.deepClone)(origState, (0, $gsrkA.IGNORE_STATE_PARAMS));
    const newDepends = {
        [element.key + Math.random()]: dependentState
    };
    const __depends = (0, $EqHTq.isObject)(origState.__depends) ? {
        ...origState.__depends,
        ...newDepends
    } : newDepends;
    if (Array.isArray(origState)) $774f1a3b2fe82710$var$addProtoToArray(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    else Object.setPrototypeOf(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    return dependentState;
};
const $774f1a3b2fe82710$var$checkForTypes = async (element)=>{
    const { state: orig, props: props, __ref: ref } = element;
    const state = props?.state || orig;
    if ((0, $EqHTq.isFunction)(state)) {
        ref.__state = state;
        return await (0, $8wu6n.exec)(state, element);
    } else if ((0, $EqHTq.is)(state)('string', 'number')) {
        ref.__state = state;
        return {
            value: state
        };
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $774f1a3b2fe82710$var$addProtoToArray = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};
const $774f1a3b2fe82710$var$applyMethods = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: (0, $aF4Ar.clean).bind(state),
        parse: (0, $aF4Ar.parse).bind(state),
        destroy: (0, $aF4Ar.destroy).bind(state),
        update: (0, $bXI75.updateState).bind(state),
        rootUpdate: (0, $aF4Ar.rootUpdate).bind(state),
        parentUpdate: (0, $aF4Ar.parentUpdate).bind(state),
        create: $774f1a3b2fe82710$export$e6a0daad8304de.bind(state),
        add: (0, $aF4Ar.add).bind(state),
        toggle: (0, $aF4Ar.toggle).bind(state),
        remove: (0, $aF4Ar.remove).bind(state),
        apply: (0, $aF4Ar.apply).bind(state),
        applyReplace: (0, $aF4Ar.applyReplace).bind(state),
        applyFunction: (0, $aF4Ar.applyFunction).bind(state),
        set: (0, $aF4Ar.set).bind(state),
        quietUpdate: (0, $aF4Ar.quietUpdate).bind(state),
        replace: (0, $aF4Ar.replace).bind(state),
        quietReplace: (0, $aF4Ar.quietReplace).bind(state),
        reset: (0, $aF4Ar.reset).bind(state),
        parent: element.parent.state || state,
        setByPath: (0, $aF4Ar.setByPath).bind(state),
        setPathCollection: (0, $aF4Ar.setPathCollection).bind(state),
        removeByPath: (0, $aF4Ar.removeByPath).bind(state),
        removePathCollection: (0, $aF4Ar.removePathCollection).bind(state),
        getByPath: (0, $aF4Ar.getByPath).bind(state),
        keys: (0, $aF4Ar.keys).bind(state),
        values: (0, $aF4Ar.values).bind(state),
        __element: element,
        __children: {},
        root: ref.root ? ref.root.state : state
    };
    if ((0, $EqHTq.isArray)(state)) $774f1a3b2fe82710$var$addProtoToArray(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};

});
parcelRegister("aF4Ar", function(module, exports) {

$parcel$export(module.exports, "parse", () => $7c314a91da5c12c3$export$98e6a39c04603d36);
$parcel$export(module.exports, "clean", () => $7c314a91da5c12c3$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "destroy", () => $7c314a91da5c12c3$export$b1fb4cac938035f7);
$parcel$export(module.exports, "parentUpdate", () => $7c314a91da5c12c3$export$e45af8832c6abf26);
$parcel$export(module.exports, "rootUpdate", () => $7c314a91da5c12c3$export$c2f300c8c094e900);
$parcel$export(module.exports, "add", () => $7c314a91da5c12c3$export$e16d8520af44a096);
$parcel$export(module.exports, "toggle", () => $7c314a91da5c12c3$export$e03c1c3201ee8bb7);
$parcel$export(module.exports, "remove", () => $7c314a91da5c12c3$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "set", () => $7c314a91da5c12c3$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "setByPath", () => $7c314a91da5c12c3$export$f65a19d15516795e);
$parcel$export(module.exports, "setPathCollection", () => $7c314a91da5c12c3$export$d340c517393b84c7);
$parcel$export(module.exports, "removeByPath", () => $7c314a91da5c12c3$export$ceab6855354994b2);
$parcel$export(module.exports, "removePathCollection", () => $7c314a91da5c12c3$export$20d12daede3a0bb7);
$parcel$export(module.exports, "getByPath", () => $7c314a91da5c12c3$export$44b5bed83342a92f);
$parcel$export(module.exports, "reset", () => $7c314a91da5c12c3$export$aad8462122ac592b);
$parcel$export(module.exports, "apply", () => $7c314a91da5c12c3$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "applyReplace", () => $7c314a91da5c12c3$export$a820c59bcfe11369);
$parcel$export(module.exports, "applyFunction", () => $7c314a91da5c12c3$export$bd130d4161841808);
$parcel$export(module.exports, "quietUpdate", () => $7c314a91da5c12c3$export$8e1d54bd5cf63ec5);
$parcel$export(module.exports, "replace", () => $7c314a91da5c12c3$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "quietReplace", () => $7c314a91da5c12c3$export$b2ed1c8afe947b7d);
$parcel$export(module.exports, "keys", () => $7c314a91da5c12c3$export$ed97f33186d4b816);
$parcel$export(module.exports, "values", () => $7c314a91da5c12c3$export$68c286be0e7e55b7);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");

var $gsrkA = parcelRequire("gsrkA");
'use strict';
const $7c314a91da5c12c3$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $EqHTq.isObject)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $gsrkA.IGNORE_STATE_PARAMS).includes(param)) obj[param] = state[param];
        return obj;
    }
};
const $7c314a91da5c12c3$export$cf0b2a6c63f9e656 = async function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $gsrkA.IGNORE_STATE_PARAMS).includes(param) && Object.hasOwnProperty.call(state, param)) delete state[param];
    if (!options.preventStateUpdate) await state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $7c314a91da5c12c3$export$b1fb4cac938035f7 = async function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $EqHTq.isString)(stateKey)) {
        await element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $EqHTq.isArray)(child.state)) Object.defineProperty(child.state, 'parent', {
                value: state.parent,
                enumerable: false,
                configurable: true,
                writable: true // Set this to true if you want to allow changing the function later
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    await element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $7c314a91da5c12c3$export$e45af8832c6abf26 = async function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return await state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$c2f300c8c094e900 = async function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.root.state;
    return await rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $7c314a91da5c12c3$export$e16d8520af44a096 = async function(value, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) {
        await state.push(value);
        return await state.update(state.parse(), {
            overwrite: true,
            ...options
        });
    } else if ((0, $EqHTq.isObject)(state)) {
        const key = Object.keys(state).length;
        return await state.update({
            [key]: value
        }, options);
    }
};
const $7c314a91da5c12c3$export$e03c1c3201ee8bb7 = async function(key, options = {}) {
    const state = this;
    return await state.update({
        [key]: !Boolean(state[key])
    }, options);
};
const $7c314a91da5c12c3$export$cd7f480d6b8286c3 = async function(key, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) (0, $hSU9O.removeFromArray)(state, key);
    if ((0, $EqHTq.isObject)(state)) (0, $8wu6n.removeFromObject)(state, key);
    if (options.applyReset) return await state.set(state.parse(), {
        replace: true,
        ...options
    });
    return await state.update();
};
const $7c314a91da5c12c3$export$adaa4cf7ef1b65be = async function(val, options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepClone)(val);
    await state.clean({
        preventStateUpdate: true,
        ...options
    });
    await state.replace(value, options);
    return state;
};
const $7c314a91da5c12c3$export$f65a19d15516795e = async function(path, val, options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepClone)(val);
    if (!options.preventReplace) (0, $8wu6n.setInObjectByPath)(state, path, val);
    const update = (0, $8wu6n.createNestedObject)(path, value);
    if (options.preventStateUpdate) return update;
    return await state.update(update, options);
};
const $7c314a91da5c12c3$export$d340c517393b84c7 = async function(changes, options = {}) {
    const state = this;
    const update = await changes.reduce(async (promacc, change)=>{
        const acc = await promacc;
        if (change[0] === 'update') {
            const result = await $7c314a91da5c12c3$export$f65a19d15516795e.call(state, change[1], change[2], {
                ...options,
                preventStateUpdate: true
            });
            return (0, $8wu6n.overwriteDeep)(acc, result);
        } else if (change[0] === 'delete') {
            await $7c314a91da5c12c3$export$ceab6855354994b2.call(state, change[1], options);
            // we are doing this to create empty nested
            // by removed path to show as changed property
            const removedFromPath = change[1].slice(0, -1);
            const removedFromValue = (0, $8wu6n.getInObjectByPath)(state, removedFromPath);
            const result = (0, $8wu6n.createNestedObject)(removedFromPath, (0, $EqHTq.isObject)(removedFromValue) ? {} : []);
            return (0, $8wu6n.deepMerge)(acc, result);
        }
        return acc;
    }, {});
    return await state.update(update, options);
};
const $7c314a91da5c12c3$export$ceab6855354994b2 = async function(path, options = {}) {
    const state = this;
    (0, $8wu6n.removeNestedKeyByPath)(state, path);
    if (options.preventUpdate) return path;
    return await state.update({}, options);
};
const $7c314a91da5c12c3$export$20d12daede3a0bb7 = async function(changes, options = {}) {
    const state = this;
    changes.forEach(async (item)=>{
        await $7c314a91da5c12c3$export$ceab6855354994b2(item, {
            preventUpdate: true
        });
    });
    return await state.update({}, options);
};
const $7c314a91da5c12c3$export$44b5bed83342a92f = function(path, options = {}) {
    const state = this;
    return (0, $8wu6n.getInObjectByPath)(state, path);
};
const $7c314a91da5c12c3$export$aad8462122ac592b = async function(options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepClone)(state.parse());
    return await state.set(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$5635d7ef4b8fee1c = async function(func, options = {}) {
    const state = this;
    if ((0, $EqHTq.isFunction)(func)) {
        const value = func(state);
        return await state.update(value, {
            replace: true,
            ...options
        });
    }
};
const $7c314a91da5c12c3$export$a820c59bcfe11369 = async function(func, options = {}) {
    const state = this;
    if ((0, $EqHTq.isFunction)(func)) {
        const value = func(state);
        return await state.replace(value, options);
    }
};
const $7c314a91da5c12c3$export$bd130d4161841808 = async function(func, options = {}) {
    const state = this;
    if ((0, $EqHTq.isFunction)(func)) {
        const result = func(state);
        if (result instanceof Promise) await result;
        else result;
        return await state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};
const $7c314a91da5c12c3$export$8e1d54bd5cf63ec5 = async function(obj, options = {}) {
    const state = this;
    return await state.update(obj, {
        preventUpdate: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$77ad94ebf1c2b9ed = async function(obj, options = {}) {
    const state = this;
    for(const param in obj)state[param] = obj[param];
    return await state.update(obj, options);
};
const $7c314a91da5c12c3$export$b2ed1c8afe947b7d = async function(obj, options = {}) {
    const state = this;
    return await state.replace(obj, {
        preventUpdate: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$ed97f33186d4b816 = function(obj, options = {}) {
    const state = this;
    return Object.keys(state);
};
const $7c314a91da5c12c3$export$68c286be0e7e55b7 = function(obj, options = {}) {
    const state = this;
    return Object.values(state);
};

});

parcelRegister("bXI75", function(module, exports) {

$parcel$export(module.exports, "updateState", () => $8b576c5d9c1d0c84$export$4971331372cec95a);

var $yWtDc = parcelRequire("yWtDc");
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");

var $gsrkA = parcelRequire("gsrkA");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

var $8dU3Q = parcelRequire("8dU3Q");
'use strict';
const $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true
};
const $8b576c5d9c1d0c84$export$4971331372cec95a = async function(obj, options = $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (options.onEach) options.onEach(element, state, element.context, options);
    if (!options.updateByState) (0, $8wu6n.merge)(options, $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $yWtDc.report)('ElementOnStateIsNotDefined');
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventBeforeStateUpdateListener) {
        const beforeStateUpdateReturns = await (0, $4qxjt.triggerEventOnUpdate)('beforeStateUpdate', obj, element, options);
        if (beforeStateUpdateReturns === false) return element;
    }
    $8b576c5d9c1d0c84$var$applyOverwrite(state, obj, options);
    const updateIsHoisted = await $8b576c5d9c1d0c84$var$hoistStateUpdate(state, obj, options);
    if (updateIsHoisted) return state;
    await $8b576c5d9c1d0c84$var$updateDependentState(state, obj, options);
    const updated = await $8b576c5d9c1d0c84$var$applyElementUpdate(state, obj, options);
    if (updated === false) return false;
    if (!options.preventStateUpdateListener) await (0, $4qxjt.triggerEventOnUpdate)('stateUpdate', obj, element, options);
    return state;
};
const $8b576c5d9c1d0c84$var$applyOverwrite = (state, obj, options)=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === 'shallow' || overwrite === 'shallow-once';
    const merge = overwrite === 'merge';
    if (merge) {
        (0, $8wu6n.deepMerge)(state, obj, (0, $gsrkA.IGNORE_STATE_PARAMS));
        return;
    }
    const overwriteFunc = shallow ? (0, $8wu6n.overwriteShallow) : (0, $8wu6n.overwriteDeep);
    if (options.overwrite === 'shallow-once') options.overwrite = true;
    overwriteFunc(state, obj, (0, $gsrkA.IGNORE_STATE_PARAMS));
};
const $8b576c5d9c1d0c84$var$hoistStateUpdate = async (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref?.__state;
    const stateType = ref?.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $8dU3Q.checkIfInherits)(element);
    const inheritedState = (0, $8dU3Q.findInheritedState)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === 'string' || stateType === 'number' || stateType === 'boolean';
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findRootState = (0, $8dU3Q.getRootStateInKey)(stateKey, parent.state);
    const findGrandParentState = (0, $8dU3Q.getParentStateInKey)(stateKey, parent.state);
    const changesValue = (0, $8dU3Q.createNestedObjectByKeyPath)(stateKey, passedValue);
    const targetParent = findRootState || findGrandParentState || parent.state;
    if (options.replace) (0, $8wu6n.overwriteDeep)(targetParent, changesValue || value) // check with createNestedObjectByKeyPath
    ;
    await targetParent.update(changesValue, {
        isHoisted: true,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace,
        ...options
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) await (0, $4qxjt.triggerEventOnUpdate)('stateUpdate', obj, element, options);
    return true;
};
const $8b576c5d9c1d0c84$var$updateDependentState = async (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        await dependentState.set(state.parse(), options);
    }
};
const $8b576c5d9c1d0c84$var$applyElementUpdate = async (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) return await element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === 'recursive') return await element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};

});
parcelRegister("8dU3Q", function(module, exports) {

$parcel$export(module.exports, "getRootStateInKey", () => $5fcb062e9eb35754$export$c138e045c9d99c0);
$parcel$export(module.exports, "getParentStateInKey", () => $5fcb062e9eb35754$export$f7dd4f6f6830b29d);
$parcel$export(module.exports, "getChildStateInKey", () => $5fcb062e9eb35754$export$e6d108f71cc7e736);
$parcel$export(module.exports, "findInheritedState", () => $5fcb062e9eb35754$export$487549069bb5d2a9);
$parcel$export(module.exports, "checkIfInherits", () => $5fcb062e9eb35754$export$e187d7e20e9fd8fa);
$parcel$export(module.exports, "createInheritedState", () => $5fcb062e9eb35754$export$c546cc738d4564ba);
$parcel$export(module.exports, "isState", () => $5fcb062e9eb35754$export$e5d60a6bbabd36f);
$parcel$export(module.exports, "createNestedObjectByKeyPath", () => $5fcb062e9eb35754$export$a1831dd7b6191ba4);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $gsrkA = parcelRequire("gsrkA");
'use strict';
const $5fcb062e9eb35754$export$c138e045c9d99c0 = (stateKey, parentState)=>{
    if (!stateKey.includes('~/')) return;
    const arr = stateKey.split('~/');
    if (arr.length > 1) return parentState.root;
};
const $5fcb062e9eb35754$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes('../')) return;
    const arr = stateKey.split('../');
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $5fcb062e9eb35754$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = stateKey.split('/');
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === '__proto__' || grandChildKey === '__proto__') return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $5fcb062e9eb35754$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$5fcb062e9eb35754$export$e187d7e20e9fd8fa(element)) return;
    const rootState = $5fcb062e9eb35754$export$c138e045c9d99c0(stateKey, parent.state);
    let parentState = parent.state;
    if (rootState) {
        parentState = rootState;
        stateKey = stateKey.replaceAll('~/', '');
    } else {
        const findGrandParentState = $5fcb062e9eb35754$export$f7dd4f6f6830b29d(stateKey, parent.state);
        if (findGrandParentState) {
            parentState = findGrandParentState;
            stateKey = stateKey.replaceAll('../', '');
        }
    }
    if (!parentState) return;
    return $5fcb062e9eb35754$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $5fcb062e9eb35754$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $5fcb062e9eb35754$export$487549069bb5d2a9(element, parent);
    if ((0, $EqHTq.isUndefined)(inheritedState)) return element.state;
    if ((0, $EqHTq.is)(inheritedState)('object', 'array')) return (0, $8wu6n.deepClone)(inheritedState, {
        exclude: (0, $gsrkA.IGNORE_STATE_PARAMS)
    });
    else if ((0, $EqHTq.is)(inheritedState)('string', 'number', 'boolean')) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, 'is not present. Replacing with', {});
};
const $5fcb062e9eb35754$export$e187d7e20e9fd8fa = (element)=>{
    const ref = element.__ref;
    const stateKey = ref.__state;
    if (stateKey && (0, $EqHTq.is)(stateKey)('number', 'string', 'boolean')) return true;
    return false;
};
const $5fcb062e9eb35754$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $EqHTq.isObjectLike)(state)) return false;
    return state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.keys && state.values && state.toggle && state.replace && state.quietUpdate && state.quietReplace && state.add && state.apply && state.applyReplace && state.setByPath && state.setPathCollection && state.removeByPath && state.removePathCollection && state.getByPath && state.applyFunction && state.__element && state.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
};
const $5fcb062e9eb35754$export$a1831dd7b6191ba4 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split('/');
    const obj = {};
    let ref = obj;
    keys.forEach((key, index)=>{
        ref[key] = index === keys.length - 1 ? value || {} : {};
        ref = ref[key];
    });
    return obj;
};

});




parcelRegister("8IrBA", function(module, exports) {

$parcel$export(module.exports, "addMethods", () => $6587d89a5cc3b917$export$626ce79af72fc3d3);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

var $grKOq = parcelRequire("grKOq");

var $2bilB = parcelRequire("2bilB");

var $TGTEZ = parcelRequire("TGTEZ");

var $inFIz = parcelRequire("inFIz");

var $3uN8v = parcelRequire("3uN8v");
'use strict';
const $6587d89a5cc3b917$export$626ce79af72fc3d3 = (element, parent, options = {})=>{
    const proto = {
        set: $grKOq.set,
        reset: $grKOq.reset,
        update: $2bilB.update,
        variables: $inFIz.variables,
        remove: $inFIz.remove,
        updateContent: $TGTEZ.updateContent,
        removeContent: $TGTEZ.removeContent,
        setProps: $inFIz.setProps,
        lookup: $inFIz.lookup,
        lookdown: $inFIz.lookdown,
        lookdownAll: $inFIz.lookdownAll,
        getRef: $inFIz.getRef,
        getRootState: $3uN8v.getRootState,
        getRoot: $3uN8v.getRoot,
        getRootData: $3uN8v.getRootData,
        getRootContext: $3uN8v.getRootContext,
        getContext: $3uN8v.getContext,
        getPath: $inFIz.getPath,
        setNodeStyles: $inFIz.setNodeStyles,
        spotByPath: $inFIz.spotByPath,
        parse: $inFIz.parse,
        parseDeep: $inFIz.parseDeep,
        keys: $inFIz.keys,
        nextElement: $inFIz.nextElement,
        previousElement: $inFIz.previousElement,
        log: $inFIz.log,
        verbose: $inFIz.verbose,
        warn: $inFIz.warn,
        error: $inFIz.error,
        append: $inFIz.append,
        call: $inFIz.call
    };
    if (element.context.methods) (options.strict ? (0, $8wu6n.merge) : (0, $8wu6n.overwrite))(proto, element.context.methods);
    Object.setPrototypeOf(element, proto);
};

});
parcelRegister("2bilB", function(module, exports) {

$parcel$export(module.exports, "update", () => $196ad7400dcaf39e$export$722fbec263ad908a);
parcelRequire("cBUNY");
var $NWrSd = parcelRequire("NWrSd");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $bGXur = parcelRequire("bGXur");
var $jvD5p = parcelRequire("jvD5p");
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");

var $inFIz = parcelRequire("inFIz");
parcelRequire("dAG9v");
var $cnttI = parcelRequire("cnttI");
parcelRequire("fmM4W");
var $af4TA = parcelRequire("af4TA");
var $8dU3Q = parcelRequire("8dU3Q");

var $cKpeW = parcelRequire("cKpeW");

var $r1wpG = parcelRequire("r1wpG");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");

var $bKCm2 = parcelRequire("bKCm2");

var $eS9bk = parcelRequire("eS9bk");
parcelRequire("6LaO6");
var $dxF2a = parcelRequire("dxF2a");
'use strict';
const $196ad7400dcaf39e$var$snapshot = {
    snapshotId: (0, $NWrSd.createSnapshotId)
};
const $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    excludes: (0, $dxF2a.METHODS_EXL)
};
const $196ad7400dcaf39e$export$722fbec263ad908a = async function(params = {}, opts) {
    const calleeElementCache = opts?.calleeElement;
    const options = (0, $8wu6n.deepClone)(typeof opts === 'object' // dont use isObject as it does not check objects from cross frames
     ? (0, $dxF2a.deepMerge)(opts, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS) : $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS, {
        exclude: [
            'calleeElement',
            'updatingCalleeElement'
        ]
    });
    const element = this;
    options.calleeElement = calleeElementCache;
    const { parent: parent, node: node, key: key } = element;
    const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = $196ad7400dcaf39e$var$captureSnapshot(element, options);
    if (snapshotHasUpdated) return false;
    if ($196ad7400dcaf39e$var$checkIfStorm(element, options)) return false;
    if (!options.preventListeners) await (0, $4qxjt.triggerEventOn)('eventStart', element, options);
    if (!options.preventListeners) await (0, $4qxjt.triggerEventOnUpdate)('startUpdate', params, element, options);
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return false;
    if (!excludes) (0, $8wu6n.merge)(options, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS);
    if ((0, $EqHTq.isString)(params) || (0, $EqHTq.isNumber)(params)) params = {
        text: params
    };
    const inheritState = await $196ad7400dcaf39e$var$inheritStateUpdates(element, options);
    if (inheritState === false) return false;
    const ifFails = $196ad7400dcaf39e$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return false;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__props.filter((v)=>(0, $EqHTq.isFunction)(v));
        const props = params.props || hasParentProps || hasFunctionInProps.length;
        if (props) (0, $cnttI.updateProps)(props, element, parent, options);
    }
    if (!options.preventBeforeUpdateListener && !options.preventListeners) {
        const beforeUpdateReturns = await (0, $4qxjt.triggerEventOnUpdate)('beforeUpdate', params, element, options);
        if (beforeUpdateReturns === false) return element;
    }
    // apply new updates
    (0, $8wu6n.overwriteDeep)(element, params, {
        exclude: (0, $dxF2a.METHODS_EXL)
    });
    // exec updates
    (0, $r1wpG.throughExecProps)(element, options);
    await (0, $r1wpG.throughUpdatedExec)(element, {
        ignore: $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    });
    await (0, $r1wpG.throughUpdatedDefine)(element, options);
    if (!options.isForced && !options.preventListeners) await (0, $4qxjt.triggerEventOn)('beforeClassAssign', element, options);
    if (!ref.__if) return false;
    if (!node) // if (!node || !document.body.contains(node)) {
    // return createNode(element, options)
    return false;
    element.tag !== 'fragment' && document.body.contains(node);
    const { preventUpdate: preventUpdate, preventDefineUpdate: preventDefineUpdate, preventContentUpdate: preventContentUpdate, preventStateUpdate: preventStateUpdate, preventRecursive: preventRecursive, preventUpdateListener: preventUpdateListener, preventUpdateAfter: preventUpdateAfter, preventUpdateAfterCount: preventUpdateAfterCount } = options;
    if (preventUpdateAfter) {
        if ((0, $EqHTq.isNumber)(preventUpdateAfterCount) && preventUpdateAfter <= preventUpdateAfterCount) return;
        else if (options.preventUpdateAfterCount === undefined) options.preventUpdateAfterCount = 1;
        else options.preventUpdateAfterCount++;
    }
    const keys = Object.keys(element);
    for (const param of keys){
        const prop = element[param];
        if (!Object.hasOwnProperty.call(element, param)) continue;
        const isInPreventUpdate = (0, $EqHTq.isArray)(preventUpdate) && preventUpdate.includes(param);
        const isInPreventDefineUpdate = (0, $EqHTq.isArray)(preventDefineUpdate) && preventDefineUpdate.includes(param);
        const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
        if ((0, $EqHTq.isUndefined)(prop) || isInPreventUpdate || isInPreventDefineUpdate || preventDefineUpdate === true || preventDefineUpdate === param || preventContentUpdate && param === 'content' && !hasCollection || (preventStateUpdate && param) === 'state' || (0, $inFIz.isMethod)(param, element) || (0, $EqHTq.isObject)((0, $ajGUj.REGISTRY)[param]) || (0, $bGXur.isVariant)(param)) continue;
        if (preventStateUpdate === 'once') options.preventStateUpdate = false;
        const isElement = await (0, $bKCm2.applyParam)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $EqHTq.isObject)(prop) && !hasDefine && !hasContextDefine && !preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            if (options.onEachUpdate) options.onEachUpdate(param, element, element.state, element.context);
            const childUpdateCall = async ()=>await $196ad7400dcaf39e$export$722fbec263ad908a.call(prop, params[prop], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            lazyLoad ? (0, $jvD5p.window).requestAnimationFrame(async ()=>{
                // eslint-disable-line
                await childUpdateCall();
                // handle lazy load
                if (!options.preventUpdateListener) await (0, $4qxjt.triggerEventOn)('lazyLoad', element, options);
            }) : await childUpdateCall();
        }
    }
    if (!options.preventListeners) {
        if (!preventUpdateListener) await (0, $4qxjt.triggerEventOn)('update', element, options);
        await (0, $4qxjt.triggerEventOn)('eventComplete', element, options);
    }
};
const $196ad7400dcaf39e$var$checkIfStorm = (element, options)=>{
    let ref = element.__ref;
    if (!options.updatingCalleeElement) options.updatingCalleeElement = element;
    if (ref.__stormAbortion && !options.allowStorm) {
        // make storm abourtion time based
        const stormAbortion = setTimeout(()=>{
            delete ref.__stormAbortion;
            clearTimeout(stormAbortion);
        }, 1000);
        element.error('Potential storm update detected', options);
        return true;
    }
    // self calling is detected
    if (element === options.updatingCalleeElement && !options.allowStorm) {
        if (ref.__selfCallIteration === undefined) ref.__selfCallIteration = 0;
        else ref.__selfCallIteration++;
        // prevent storm
        if (ref.__selfCallIteration > 100) {
            ref.__selfCallIteration = 0;
            ref.__stormAbortion = true;
            element.error('Potential self calling loop in update detected', options);
            return true;
        }
        // make storm detection time based
        const stormTimeout = setTimeout(()=>{
            ref.__selfCallIteration = 0;
            clearTimeout(stormTimeout);
        }, 350);
    }
};
const $196ad7400dcaf39e$var$captureSnapshot = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $196ad7400dcaf39e$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = calleeElement.__ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};
const $196ad7400dcaf39e$var$checkIfOnUpdate = (element, parent, options)=>{
    const ifFn = element.props?.if || element.if;
    if (!(0, $EqHTq.isFunction)(ifFn) || !parent) return;
    const ref = element.__ref;
    const ifPassed = ifFn(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.__text;
            delete element.extend;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            if (element.node) {
                element.node.remove();
                delete element.node;
            }
            const contentKey = ref.contentElementKey;
            if (element.$collection || element.$stateCollection || element.$propsCollection) element.removeContent();
            else if (element[contentKey]?.parseDeep) element[contentKey] = element[contentKey].parseDeep();
            const previousElement = element.previousElement();
            const previousNode = previousElement?.node // document.body.contains(previousElement.node)
            ;
            const hasPrevious = previousNode?.parentNode // document.body.contains(previousElement.node)
            ;
            const nextElement = element.nextElement();
            const nextNode = nextElement?.node // document.body.contains(previousElement.node)
            ;
            const hasNext = nextNode?.parentNode // && document.body.contains(nextElement.node)
            ;
            // const hasNext = nextElement && document.body.contains(nextElement.node)
            const attachOptions = (hasPrevious || hasNext) && {
                position: hasPrevious ? 'after' : hasNext ? 'before' : null,
                node: hasPrevious && previousNode || hasNext && nextNode
            };
            delete element.__ref;
            delete element.parent;
            const createdElement = (0, $cKpeW.create)(element, parent, element.key, (0, $eS9bk.OPTIONS).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $EqHTq.isFunction)(element.on.update)) (0, $4qxjt.applyEvent)(element.on.update, createdElement, createdElement.state);
            return createdElement;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element based on the specified options.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventBeforeStateUpdateListener] - If true, prevent the 'beforeStateUpdate' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdate' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $196ad7400dcaf39e$var$inheritStateUpdates = async (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent && parent.state || {};
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $8dU3Q.findInheritedState)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.beforeStateUpdate event
    if (!options.preventBeforeStateUpdateListener && !options.preventListeners) {
        const initStateReturns = await (0, $4qxjt.triggerEventOnUpdate)('beforeStateUpdate', keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = await $196ad7400dcaf39e$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdate event
    if (!options.preventStateUpdateListener && !options.preventListeners) await (0, $4qxjt.triggerEventOnUpdate)('stateUpdate', newState.parse(), element, options);
};
const $196ad7400dcaf39e$var$createStateUpdate = async (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = await (0, $af4TA.createState)(element, parent, options);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        // __stateChildren[child].parent = newState
        Object.getPrototypeOf(__stateChildren[child]).parent = newState;
    }
    return newState;
};
var $196ad7400dcaf39e$export$2e2bcd8739ae039 // save updates history
 // const overwriteChanges = overwriteDeep(element, params, { exclude: METHODS_EXL })
 // // const overwriteChanges = overwriteDeep(element, params)
 // const propsChanges = throughExecProps(element)
 // const execChanges = throughUpdatedExec(element, { ignore: UPDATE_DEFAULT_OPTIONS })
 // const definedChanges = throughUpdatedDefine(element)
 // if (options.stackChanges && ref.__stackChanges) {
 //   const stackChanges = merge(definedChanges, merge(execChanges, overwriteChanges))
 //   ref.__stackChanges.push(stackChanges)
 // }
 = $196ad7400dcaf39e$export$722fbec263ad908a;

});





parcelRegister("jDgNO", function(module, exports) {

$parcel$export(module.exports, "data", () => $e4aeb17327021212$export$4051a07651545597);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $yWtDc = parcelRequire("yWtDc");
'use strict';
function $e4aeb17327021212$export$4051a07651545597(params, element, node) {
    if (params) {
        if (element.props.data) (0, $8wu6n.deepMerge)(params, element.props.data);
        if (params.showOnNode) {
            if (!(0, $EqHTq.isObject)(params)) (0, $yWtDc.report)('HTMLInvalidData', params);
            // Apply data params on node
            for(const dataset in params)if (dataset !== 'showOnNode') node.dataset[dataset] = (0, $8wu6n.exec)(params[dataset], element);
        }
    }
}
var $e4aeb17327021212$export$2e2bcd8739ae039 = $e4aeb17327021212$export$4051a07651545597;

});

parcelRegister("1QNO8", function(module, exports) {

$parcel$export(module.exports, "html", () => $1591488d379f80a7$export$c0bb0b647f701bb5);
'use strict';
function $1591488d379f80a7$export$c0bb0b647f701bb5(param, element, node, opts) {
    const prop = element.call('exec', param, element, element.state, element.context, opts) || element.call('exec', element?.props?.html, element, element.state, element.context, opts);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        // const parser = new window.DOMParser()
        // param = parser.parseFromString(param, 'text/html')
        if (node.nodeName === 'SVG') node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
}
var $1591488d379f80a7$export$2e2bcd8739ae039 = $1591488d379f80a7$export$c0bb0b647f701bb5;

});

parcelRegister("699eL", function(module, exports) {

$parcel$export(module.exports, "style", () => $479abf9e8c0e6739$export$1d567c320f4763bc);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");

var $yWtDc = parcelRequire("yWtDc");
'use strict';
function $479abf9e8c0e6739$export$1d567c320f4763bc(params, element, node) {
    if (params) {
        if ((0, $EqHTq.isObject)(params)) (0, $8wu6n.map)(node.style, params, element);
        else (0, $yWtDc.report)('HTMLInvalidStyles', params);
    }
}
var $479abf9e8c0e6739$export$2e2bcd8739ae039 = $479abf9e8c0e6739$export$1d567c320f4763bc;

});

parcelRegister("2ea4y", function(module, exports) {

$parcel$export(module.exports, "text", () => $19f4b3c5f241581d$export$6f093cfa640b7166);

var $cKpeW = parcelRequire("cKpeW");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
function $19f4b3c5f241581d$export$6f093cfa640b7166(param, element, node, opts) {
    let prop = (0, $8wu6n.exec)(param, element, element.state, element.context, opts);
    if ((0, $EqHTq.isString)(prop) && prop.includes('{{')) prop = element.call('replaceLiteralsWithObjectFields', prop);
    if (element.tag === 'string') node.nodeValue = prop;
    else if (param !== undefined || param !== null) {
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $cKpeW.create)({
            tag: 'string',
            text: prop
        }, element, '__text');
    }
}
var $19f4b3c5f241581d$export$2e2bcd8739ae039 = $19f4b3c5f241581d$export$6f093cfa640b7166;

});

parcelRegister("6nUV8", function(module, exports) {

$parcel$export(module.exports, "state", () => $4a610b4ab9f6f506$export$ca000e230c0caa3e);
parcelRequire("fmM4W");
var $gsrkA = parcelRequire("gsrkA");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
async function $4a610b4ab9f6f506$export$ca000e230c0caa3e(params, element, node, opts) {
    const state = (0, $8wu6n.exec)(params, element, element.state, element.context, opts);
    if ((0, $EqHTq.isObject)(state)) {
        const keys = Object.keys(state);
        for (const param of keys){
            if ((0, $gsrkA.IGNORE_STATE_PARAMS).includes(param)) continue;
            if (!Object.hasOwnProperty.call(state, param)) continue;
        // element.state[param] = exec(state[param], element)
        }
    }
    return element;
}
var $4a610b4ab9f6f506$export$2e2bcd8739ae039 = $4a610b4ab9f6f506$export$ca000e230c0caa3e;

});

parcelRegister("i0pxI", function(module, exports) {

$parcel$export(module.exports, "scope", () => $d1bc0a58271a837c$export$5cff813ca8e50db9);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
function $d1bc0a58271a837c$export$5cff813ca8e50db9(params, element, node) {
    if (!(0, $EqHTq.isObject)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $EqHTq.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
}
var $d1bc0a58271a837c$export$2e2bcd8739ae039 = $d1bc0a58271a837c$export$5cff813ca8e50db9;

});

parcelRegister("ajGUj", function(module, exports) {

$parcel$export(module.exports, "REGISTRY", () => $782cf63e523d0885$export$21cc2ed387caee94);
$parcel$export(module.exports, "parseFilters", () => $782cf63e523d0885$export$2f387f690230eab4);

var $ajkzz = parcelRequire("ajkzz");

var $97DJ4 = parcelRequire("97DJ4");

var $TGTEZ = parcelRequire("TGTEZ");

var $jDgNO = parcelRequire("jDgNO");

var $1QNO8 = parcelRequire("1QNO8");

var $i0pxI = parcelRequire("i0pxI");

var $6nUV8 = parcelRequire("6nUV8");

var $699eL = parcelRequire("699eL");

var $2ea4y = parcelRequire("2ea4y");
'use strict';
const $782cf63e523d0885$export$21cc2ed387caee94 = {
    attr: $ajkzz.attr,
    style: $699eL.style,
    text: $2ea4y.text,
    html: $1QNO8.html,
    content: (0, $TGTEZ.setContent),
    data: $jDgNO.data,
    class: (0, $97DJ4.classList),
    state: $6nUV8.state,
    scope: $i0pxI.scope,
    deps: (param, el)=>param || el.parent.deps,
    extend: {},
    extends: {},
    childExtend: {},
    childExtends: {},
    childExtendsRecursive: {},
    helmet: {},
    metadata: {},
    props: {},
    path: {},
    if: {},
    define: {},
    transform: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    nextElement: {},
    previousElement: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    set: {},
    reset: {},
    update: {},
    error: {},
    warn: {},
    call: {},
    setProps: {},
    remove: {},
    updateContent: {},
    removeContent: {},
    variables: {},
    lookup: {},
    lookdown: {},
    getRef: {},
    getPath: {},
    lookdownAll: {},
    setNodeStyles: {},
    spotByPath: {},
    append: {},
    routes: {},
    keys: {},
    log: {},
    parse: {},
    parseDeep: {},
    on: {},
    component: {},
    context: {},
    $collection: {},
    $stateCollection: {},
    $propsCollection: {},
    $setCollection: {},
    $setStateCollection: {},
    $setPropsCollection: {}
};
var $782cf63e523d0885$export$2e2bcd8739ae039 = $782cf63e523d0885$export$21cc2ed387caee94;
const $782cf63e523d0885$export$2f387f690230eab4 = {
    elementKeys: [
        'tag',
        'text',
        'style',
        'attr',
        'class',
        'state',
        'props',
        'data',
        'content',
        'html',
        'on',
        'key',
        'extend',
        'childExtend',
        'childExtendsRecursive',
        'scope',
        'query',
        '$collection',
        '$stateCollection',
        '$propsCollection'
    ],
    propsKeys: [
        '__element',
        'update'
    ],
    stateKeys: []
};
const $782cf63e523d0885$export$9e7e3c1608cc7f28 = [
    '$collection',
    '$stateCollection',
    '$propsCollection'
];

});



parcelRegister("cVSYW", function(module, exports) {

$parcel$export(module.exports, "send", () => send);

var $cBUNY = parcelRequire("cBUNY");

var $73MNt = parcelRequire("73MNt");
const { window, isFunction, isArray } = $cBUNY.default || $cBUNY;
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const getIsDev = (options)=>options.development || window && window.location && window.location.host.includes('local') || $cBUNY.isNotProduction();
const getSocketUrl = (options, isDev)=>{
    const SOCKET_BACKEND_URL = isDev ? 'http://localhost:8080/' : 'https://api.symbols.app/';
    const socketUrls = isArray(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || 'api.symbols.app';
    return {
        primaryUrl: primaryUrl || SOCKET_BACKEND_URL,
        secondaryUrl: secondaryUrl
    };
};
const connect = (key, options = {})=>{
    const isDev = getIsDev(options);
    const { primaryUrl, secondaryUrl } = getSocketUrl(options, isDev);
    const socket = (0, $73MNt.default)(primaryUrl || secondaryUrl, {
    });
    socket.on('connect', ()=>{
        if (isDev) console.warn(`Connected to %c${primaryUrl} %c${key} %c${socket.id}`, 'font-weight: bold; color: green;', 'font-weight: bold;', '');
        socket.emit('initConnect', {
            key: key,
            ...options
        });
        try {
            if (isFunction(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('connect_error', (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if (isFunction(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if ($cBUNY.isNotProduction()) console.log(`Could not connect to %c${primaryUrl}%c, reconnecting to %c${secondaryUrl}`, 'font-weight: bold; color: red;', '', 'font-weight: bold; color: green;');
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('disconnect', (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if (isFunction(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === 'connect') return;
        try {
            if (isFunction(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = 'change', changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});
parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "io", () => $523eaa49d3f99bf8$export$841407ceb083bd74);
$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
parcelRequire("1XKMK");
var $i3KZp = parcelRequire("i3KZp");
var $3W81j = parcelRequire("3W81j");
var $dhyBt = parcelRequire("dhyBt");
var $hJTtX = parcelRequire("hJTtX");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("bN72v")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $bN72v = parcelRequire("bN72v");

var $i3KZp = parcelRequire("i3KZp");

var $3W81j = parcelRequire("3W81j");

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $5hHAH = parcelRequire("5hHAH");

var $CnWUo = parcelRequire("CnWUo");

var $bN72v = parcelRequire("bN72v");
const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $5hHAH.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $bN72v.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $l7wSz.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $bN72v.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $bN72v.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $CnWUo.protocol);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $gEtm1.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $3W81j = parcelRequire("3W81j");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $3W81j.XHR)
};

});
parcelRegister("3W81j", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $2ddd02863faa1587$export$a2d42eb087c10497);

var $7pvuz = parcelRequire("7pvuz");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $bN72v = parcelRequire("bN72v");

var $kxvpX = parcelRequire("kxvpX");
function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $7pvuz.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $5hHAH.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $bN72v.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $bN72v.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");

var $CnWUo = parcelRequire("CnWUo");
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $5hHAH = parcelRequire("5hHAH");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $5hHAH.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("5hHAH", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $3d905a8ca243a015$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);
$parcel$export(module.exports, "randomString", () => $4028d5a20a4526d1$export$7fa8378418b4411e);

var $bN72v = parcelRequire("bN72v");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $bN72v.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $bN72v.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $bN72v.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $bN72v.globalThisShim).setTimeout.bind((0, $bN72v.globalThisShim));
        obj.clearTimeoutFn = (0, $bN72v.globalThisShim).clearTimeout.bind((0, $bN72v.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("bN72v", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $8959bb304e43f43f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "globalThisShim", () => $8959bb304e43f43f$export$394f9358f6231289);
$parcel$export(module.exports, "defaultBinaryType", () => $8959bb304e43f43f$export$790dcbc41e2d75d5);
$parcel$export(module.exports, "createCookieJar", () => $8959bb304e43f43f$export$19413efcf2fac759);
const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});


parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $5vwdc = parcelRequire("5vwdc");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $bN72v = parcelRequire("bN72v");
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $6opKi.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $5vwdc.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $bN72v.globalThisShim).WebSocket || (0, $bN72v.globalThisShim).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $bN72v = parcelRequire("bN72v");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $bN72v.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("i3KZp", function(module, exports) {

var $7pvuz = parcelRequire("7pvuz");
class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $7pvuz.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $bN72v = parcelRequire("bN72v");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $5hHAH = parcelRequire("5hHAH");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $5hHAH.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $bN72v.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5hHAH = parcelRequire("5hHAH");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $5hHAH.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);
$parcel$export(module.exports, "isPacketValid", () => $1e4e6e6cc3958162$export$1a38ed17dcb5458e);

var $5hHAH = parcelRequire("5hHAH");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $5hHAH.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $1e4e6e6cc3958162$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $1e4e6e6cc3958162$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $1e4e6e6cc3958162$var$isAckIdValid(id) {
    return id === undefined || $1e4e6e6cc3958162$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $1e4e6e6cc3958162$var$isDataValid(type, payload) {
    switch(type){
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $1e4e6e6cc3958162$var$isObject(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
        default:
            return false;
    }
}
function $1e4e6e6cc3958162$export$1a38ed17dcb5458e(packet) {
    return $1e4e6e6cc3958162$var$isNamespaceValid(packet.nsp) && $1e4e6e6cc3958162$var$isAckIdValid(packet.id) && $1e4e6e6cc3958162$var$isDataValid(packet.type, packet.data);
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




var $5f26bd3c2a16a4d1$exports = {};
$parcel$export($5f26bd3c2a16a4d1$exports, "create", () => $22cae8e82746fd5e$export$185802fd694ee1f5);

var $cBUNY = parcelRequire("cBUNY");
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $d6212e11970c8083$export$147ca7d289c2f7de = [
    'alert',
    'alertdialog',
    'application',
    'article',
    'banner',
    'button',
    'cell',
    'checkbox',
    'columnheader',
    'combobox',
    'complementary',
    'contentinfo',
    'definition',
    'dialog',
    'directory',
    'document',
    'feed',
    'figure',
    'form',
    'grid',
    'gridcell',
    'group',
    'heading',
    'img',
    'link',
    'list',
    'listbox',
    'listitem',
    'log',
    'main',
    'marquee',
    'math',
    'menu',
    'menubar',
    'menuitem',
    'menuitemcheckbox',
    'menuitemradio',
    'navigation',
    'none',
    'note',
    'option',
    'presentation',
    'progressbar',
    'radio',
    'radiogroup',
    'region',
    'row',
    'rowgroup',
    'rowheader',
    'scrollbar',
    'search',
    'searchbox',
    'separator',
    'slider',
    'spinbutton',
    'status',
    'switch',
    'tab',
    'table',
    'tablist',
    'tabpanel',
    'term',
    'textbox',
    'timer',
    'toolbar',
    'tooltip',
    'tree',
    'treegrid',
    'treeitem'
];
const $d6212e11970c8083$export$a073516cf3506ae6 = {
    default: [
        'accesskey',
        'autofocus',
        'class',
        'contenteditable',
        'contextmenu',
        'dir',
        'draggable',
        'hidden',
        'id',
        'lang',
        'part',
        'placeholder',
        'slot',
        'spellcheck',
        'style',
        'tabindex',
        'title',
        'translate',
        'inert',
        'radiogroup',
        'role',
        'about',
        'datatype',
        'inlist',
        'prefix',
        'property',
        'resource',
        'typeof',
        'vocab',
        'autocapitalize',
        'autocorrect',
        'autosave',
        'color',
        'itemprop',
        'itemscope',
        'itemtype',
        'itemid',
        'itemref',
        'results',
        'security',
        'unselectable',
        'is'
    ],
    a: [
        'accesskey',
        'charset',
        'coords',
        'download',
        'href',
        'hreflang',
        'name',
        'rel',
        'rev',
        'shape',
        'target',
        'type'
    ],
    aria: [
        'aria-activedescendant',
        'aria-atomic',
        'aria-autocomplete',
        'aria-checked',
        'aria-colcount',
        'aria-colindex',
        'aria-colspan',
        'aria-controls',
        'aria-current',
        'aria-describedby',
        'aria-details',
        'aria-dropeffect',
        'aria-errormessage',
        'aria-expanded',
        'aria-flowto',
        'aria-grabbed',
        'aria-haspopup',
        'aria-hidden',
        'aria-invalid',
        'aria-keyshortcuts',
        'aria-label',
        'aria-labelledby',
        'aria-level',
        'aria-live',
        'aria-modal',
        'aria-multiline',
        'aria-multiselectable',
        'aria-orientation',
        'aria-owns',
        'aria-placeholder',
        'aria-posinset',
        'aria-pressed',
        'aria-readonly',
        'aria-relevant',
        'aria-required',
        'aria-roledescription',
        'aria-rowcount',
        'aria-rowindex',
        'aria-rowspan',
        'aria-selected',
        'aria-setsize',
        'aria-sort',
        'aria-valuemax',
        'aria-valuemin',
        'aria-valuenow',
        'aria-valuetext'
    ],
    anchor: [
        'download',
        'href',
        'hreflang',
        'media',
        'ping',
        'rel',
        'target',
        'type',
        'referrerpolicy'
    ],
    audio: [],
    area: [
        'alt',
        'coords',
        'download',
        'href',
        'hreflang',
        'media',
        'referrerpolicy',
        'rel',
        'shape',
        'target',
        'ping'
    ],
    base: [
        'href',
        'target'
    ],
    blockquote: [
        'cite'
    ],
    button: [
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'name',
        'type',
        'value'
    ],
    canvas: [
        'height',
        'width'
    ],
    col: [
        'span',
        'width'
    ],
    colgroup: [
        'span'
    ],
    data: [
        'value'
    ],
    details: [
        'open'
    ],
    del: [
        'cite',
        'datetime'
    ],
    dialog: [
        'open'
    ],
    embed: [
        'height',
        'src',
        'type',
        'width'
    ],
    fieldset: [
        'disabled',
        'form',
        'name'
    ],
    form: [
        'acceptcharset',
        'action',
        'autocomplete',
        'enctype',
        'method',
        'name',
        'novalidate',
        'target',
        'rel'
    ],
    html: [
        'manifest'
    ],
    iframe: [
        'allow',
        'allowfullscreen',
        'allowtransparency',
        'frameborder',
        'height',
        'loading',
        'marginheight',
        'marginwidth',
        'name',
        'referrerpolicy',
        'sandbox',
        'scrolling',
        'seamless',
        'src',
        'srcdoc',
        'width'
    ],
    img: [
        'alt',
        'crossorigin',
        'decoding',
        'height',
        'ismap',
        'loading',
        'referrerpolicy',
        'sizes',
        'src',
        'srcset',
        'usemap',
        'width'
    ],
    ins: [
        'cite',
        'datetime'
    ],
    input: [
        'accept',
        'alt',
        'autocomplete',
        'capture',
        'checked',
        'crossorigin',
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'height',
        'indeterminate',
        'list',
        'max',
        'maxlength',
        'min',
        'minlength',
        'multiple',
        'name',
        'pattern',
        'placeholder',
        'readonly',
        'required',
        'size',
        'src',
        'step',
        'type',
        'value',
        'width'
    ],
    keygen: [
        'challenge',
        'disabled',
        'form',
        'keytype',
        'keyparams',
        'name'
    ],
    label: [
        'form',
        'for'
    ],
    li: [
        'value'
    ],
    link: [
        'as',
        'crossorigin',
        'href',
        'hreflang',
        'integrity',
        'media',
        'imagesrcset',
        'imagesizes',
        'referrerpolicy',
        'rel',
        'sizes',
        'type',
        'charset'
    ],
    map: [
        'name'
    ],
    menu: [
        'type'
    ],
    media: [
        'autoplay',
        'controls',
        'currenttime',
        'defaultmuted',
        'defaultplaybackrate',
        'loop',
        'mediagroup',
        'muted',
        'playsinline',
        'preload',
        'src',
        'volume'
    ],
    meta: [
        'charset',
        'content',
        'http-equiv',
        'name',
        'media'
    ],
    meter: [
        'form',
        'high',
        'low',
        'max',
        'min',
        'optimum',
        'value'
    ],
    quote: [
        'cite'
    ],
    object: [
        'classid',
        'data',
        'form',
        'height',
        'name',
        'type',
        'usemap',
        'width',
        'wmode'
    ],
    ol: [
        'reversed',
        'start',
        'type'
    ],
    optgroup: [
        'disabled',
        'label'
    ],
    option: [
        'disabled',
        'label',
        'selected',
        'value'
    ],
    output: [
        'form',
        'for',
        'name'
    ],
    param: [
        'name',
        'value'
    ],
    progress: [
        'max',
        'value'
    ],
    slot: [
        'name'
    ],
    script: [
        'async',
        'charset',
        'crossorigin',
        'defer',
        'integrity',
        'nomodule',
        'nonce',
        'referrerpolicy',
        'src',
        'type'
    ],
    select: [
        'autocomplete',
        'disabled',
        'form',
        'multiple',
        'name',
        'required',
        'size',
        'value',
        'onchange'
    ],
    source: [
        'height',
        'media',
        'sizes',
        'src',
        'srcset',
        'type',
        'width'
    ],
    style: [
        'media',
        'nonce',
        'scoped',
        'type'
    ],
    table: [
        'align',
        'bgcolor',
        'border',
        'cellpadding',
        'cellspacing',
        'frame',
        'rules',
        'summary',
        'width'
    ],
    textarea: [
        'autocomplete',
        'cols',
        'dirname',
        'disabled',
        'form',
        'maxlength',
        'minlength',
        'name',
        'placeholder',
        'readonly',
        'required',
        'rows',
        'value',
        'wrap'
    ],
    td: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr',
        'height',
        'width',
        'valign'
    ],
    th: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr'
    ],
    time: [
        'datetime'
    ],
    track: [
        'default',
        'kind',
        'label',
        'src',
        'srclang'
    ],
    video: [
        'height',
        'playsinline',
        'poster',
        'width',
        'disablepictureinpicture',
        'disableremoteplayback'
    ],
    svg: [
        'className',
        'class',
        'color',
        'height',
        'id',
        'lang',
        'max',
        'media',
        'method',
        'min',
        'name',
        'style',
        'target',
        'type',
        'width',
        // Other HTML properties supported by SVG elements in browsers
        'role',
        'tabindex',
        'crossorigin',
        // SVG Specific attributes
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'allowReorder',
        'alphabetic',
        'amplitude',
        'arabic-form',
        'ascent',
        'attributeName',
        'attributeType',
        'autoReverse',
        'azimuth',
        'baseFrequency',
        'baseline-shift',
        'baseProfile',
        'bbox',
        'begin',
        'bias',
        'by',
        'calcMode',
        'cap-height',
        'clip',
        'clip-path',
        'clipPathUnits',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'contentScriptType',
        'contentStyleType',
        'cursor',
        'cx',
        'cy',
        'd',
        'decelerate',
        'descent',
        'diffuseConstant',
        'direction',
        'display',
        'divisor',
        'dominant-baseline',
        'dur',
        'dx',
        'dy',
        'edgeMode',
        'elevation',
        'enable-background',
        'end',
        'exponent',
        'externalResourcesRequired',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterRes',
        'filterUnits',
        'flood-color',
        'flood-opacity',
        'focusable',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'format',
        'from',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'glyphRef',
        'gradientTransform',
        'gradientUnits',
        'hanging',
        'href',
        'horiz-adv-x',
        'horiz-origin-x',
        'ideographic',
        'image-rendering',
        'in2',
        'in',
        'intercept',
        'k1',
        'k2',
        'k3',
        'k4',
        'k',
        'kernelMatrix',
        'kernelUnitLength',
        'kerning',
        'keyPoints',
        'keySplines',
        'keyTimes',
        'lengthAdjust',
        'letter-spacing',
        'lighting-color',
        'limitingConeAngle',
        'local',
        'marker-end',
        'markerHeight',
        'marker-mid',
        'marker-start',
        'markerUnits',
        'markerWidth',
        'mask',
        'maskContentUnits',
        'maskUnits',
        'mathematical',
        'mode',
        'numOctaves',
        'offset',
        'opacity',
        'operator',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'path',
        'pathLength',
        'patternContentUnits',
        'patternTransform',
        'patternUnits',
        'pointer-events',
        'points',
        'pointsAtX',
        'pointsAtY',
        'pointsAtZ',
        'preserveAlpha',
        'preserveAspectRatio',
        'primitiveUnits',
        'r',
        'radius',
        'refX',
        'refY',
        'rendering-intent',
        'repeatCount',
        'repeatDur',
        'requiredExtensions',
        'requiredFeatures',
        'restart',
        'result',
        'rotate',
        'rx',
        'ry',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'spacing',
        'specularConstant',
        'specularExponent',
        'speed',
        'spreadMethod',
        'startOffset',
        'stdDeviation',
        'stemh',
        'stemv',
        'stitchTiles',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'string',
        'stroke',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'surfaceScale',
        'systemLanguage',
        'tableValues',
        'targetX',
        'targetY',
        'text-anchor',
        'text-decoration',
        'textLength',
        'text-rendering',
        'to',
        'transform',
        'u1',
        'u2',
        'underline-position',
        'underline-thickness',
        'unicode',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'values',
        'vector-effect',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'v-hanging',
        'v-ideographic',
        'viewBox',
        'viewTarget',
        'visibility',
        'v-mathematical',
        'widths',
        'word-spacing',
        'writing-mode',
        'x1',
        'x2',
        'x',
        'xChannelSelector',
        'x-height',
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:href',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type',
        'xml:base',
        'xml:lang',
        'xmlns',
        'xmlns:xlink',
        'xml:space',
        'y1',
        'y2',
        'y',
        'yChannelSelector',
        'z',
        'zoomAndPan'
    ]
};
const $d6212e11970c8083$export$f552dbb36ef6b3dd = [
    // Clipboard Events
    'oncopy',
    'oncut',
    'onpaste',
    // Composition Events
    'oncompositionend',
    'oncompositionstart',
    'oncompositionupdate',
    // Focus Events
    'onfocus',
    'onfocusin',
    'onfocusout',
    'onblur',
    // Form Events
    'onchange',
    'onbeforeinput',
    'oninput',
    'onreset',
    'onsubmit',
    'oninvalid',
    'onformdata',
    // Image Events
    'onload',
    'onerror',
    // Detail Events
    'ontoggle',
    // Keyboard Events
    'onkeydown',
    'onkeypress',
    'onkeyup',
    // Media Events
    'onabort',
    'oncanplay',
    'oncanplaythrough',
    'oncuechange',
    'ondurationchange',
    'onemptied',
    'onencrypted',
    'onended',
    'onloadeddata',
    'onloadedmetadata',
    'onloadstart',
    'onpause',
    'onplay',
    'onplaying',
    'onprogress',
    'onratechange',
    'onseeked',
    'onseeking',
    'onstalled',
    'onsuspend',
    'ontimeupdate',
    'onvolumechange',
    'onwaiting',
    // MouseEvents
    'onauxclick',
    'onclick',
    'oncontextmenu',
    'ondblclick',
    'ondrag',
    'ondragend',
    'ondragenter',
    'ondragexit',
    'ondragleave',
    'ondragover',
    'ondragstart',
    'ondrop',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup',
    // Selection Events
    'onselect',
    'onselectionchange',
    'onselectstart',
    // Touch Events
    'ontouchcancel',
    'ontouchend',
    'ontouchmove',
    'ontouchstart',
    // Pointer Events
    'ongotpointercapture',
    'onpointercancel',
    'onpointerdown',
    'onpointerenter',
    'onpointerleave',
    'onpointermove',
    'onpointerout',
    'onpointerover',
    'onpointerup',
    'onlostpointercapture',
    // UI Events
    'onscroll',
    'onresize',
    // Wheel Events
    'onwheel',
    // Animation Events
    'onanimationstart',
    'onanimationend',
    'onanimationiteration',
    // Transition Events
    'ontransitionstart',
    'ontransitionrun',
    'ontransitionend',
    'ontransitioncancel',
    // Svelte Transition Events
    'onoutrostart',
    'onoutroend',
    'onintrostart',
    'onintroend',
    // Message Events
    'onmessage',
    'onmessageerror',
    // Document Events
    'onvisibilitychange',
    // Global Events
    'oncancel',
    'onclose',
    'onfullscreenchange',
    'onfullscreenerror'
];
const $d6212e11970c8083$export$3c670b34323f5417 = (tag, attribute)=>{
    if (Object.prototype.hasOwnProperty.call($d6212e11970c8083$export$a073516cf3506ae6, tag)) {
        const attributes = $d6212e11970c8083$export$a073516cf3506ae6[tag];
        return attributes.includes(attribute) || attributes.includes('default');
    } else {
        const defaultAttributes = $d6212e11970c8083$export$a073516cf3506ae6.default;
        return defaultAttributes.includes(attribute);
    }
};
const $d6212e11970c8083$export$12ab4f1a89970119 = (key)=>{
    if (!(0, $EqHTq.isString)(key)) return false;
    const normalizedKey = key.toLowerCase();
    return $d6212e11970c8083$export$f552dbb36ef6b3dd.includes(normalizedKey);
};
const $d6212e11970c8083$export$a3d5d5e1a17535c6 = (tag, props)=>{
    const filteredObject = {};
    for(const key in props)if (Object.prototype.hasOwnProperty.call(props, key)) {
        const isAttribute = $d6212e11970c8083$export$3c670b34323f5417(tag, key);
        const isEvent = $d6212e11970c8083$export$12ab4f1a89970119(key);
        if ((0, $EqHTq.isDefined)(props[key]) && (isAttribute || isEvent)) filteredObject[key] = props[key];
    }
    return filteredObject;
};
const $d6212e11970c8083$export$a420285f97b772db = (elem, element)=>{
    const attrObj = {};
    if (elem.attr) for(const attrProp in elem.attr)attrObj[attrProp] = elem.attr[attrProp](element, element.state, element.context);
    return attrObj;
};


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $2a60ce89a661a6b2$exports = {};

$parcel$export($2a60ce89a661a6b2$exports, "scratchUtils", () => $16baa215ff216ac9$exports.scratchUtils);
$parcel$export($2a60ce89a661a6b2$exports, "scratchSystem", () => $16baa215ff216ac9$exports.scratchSystem);
$parcel$export($2a60ce89a661a6b2$exports, "set", () => $16baa215ff216ac9$exports.set);
$parcel$export($2a60ce89a661a6b2$exports, "init", () => $31242768b5023c84$export$2cd8252107eb640b);
$parcel$export($2a60ce89a661a6b2$exports, "reinit", () => $31242768b5023c84$export$b545ad0f2df0be16);
$parcel$export($2a60ce89a661a6b2$exports, "applyCSS", () => $31242768b5023c84$export$3a26aa64e59aeaff);
var $16baa215ff216ac9$exports = {};
"use strict";
var $16baa215ff216ac9$var$__create = Object.create;
var $16baa215ff216ac9$var$__defProp = Object.defineProperty;
var $16baa215ff216ac9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $16baa215ff216ac9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $16baa215ff216ac9$var$__getProtoOf = Object.getPrototypeOf;
var $16baa215ff216ac9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $16baa215ff216ac9$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$16baa215ff216ac9$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $16baa215ff216ac9$var$__export = (target, all)=>{
    for(var name in all)$16baa215ff216ac9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $16baa215ff216ac9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $16baa215ff216ac9$var$__getOwnPropNames(from))if (!$16baa215ff216ac9$var$__hasOwnProp.call(to, key) && key !== except) $16baa215ff216ac9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $16baa215ff216ac9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $16baa215ff216ac9$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $16baa215ff216ac9$var$__create($16baa215ff216ac9$var$__getProtoOf(mod)) : {}, $16baa215ff216ac9$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $16baa215ff216ac9$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $16baa215ff216ac9$var$__toCommonJS = (mod)=>$16baa215ff216ac9$var$__copyProps($16baa215ff216ac9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// ../utils/dist/cjs/index.js
var $16baa215ff216ac9$var$require_cjs = $16baa215ff216ac9$var$__commonJS({
    "../utils/dist/cjs/index.js" (exports, module2) {
        "use strict";
        var __defProp2 = Object.defineProperty;
        var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames2 = Object.getOwnPropertyNames;
        var __hasOwnProp2 = Object.prototype.hasOwnProperty;
        var __export2 = (target, all)=>{
            for(var name in all)__defProp2(target, name, {
                get: all[name],
                enumerable: true
            });
        };
        var __copyProps2 = (to, from, except, desc)=>{
            if (from && typeof from === "object" || typeof from === "function") {
                for (let key of __getOwnPropNames2(from))if (!__hasOwnProp2.call(to, key) && key !== except) __defProp2(to, key, {
                    get: ()=>from[key],
                    enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable
                });
            }
            return to;
        };
        var __toCommonJS2 = (mod)=>__copyProps2(__defProp2({}, "__esModule", {
                value: true
            }), mod);
        var index_exports2 = {};
        __export2(index_exports2, {
            arrayzeValue: ()=>arrayzeValue3,
            copyJavaScriptToClipboard: ()=>copyJavaScriptToClipboard,
            copyStringToClipboard: ()=>copyStringToClipboard,
            fibonacciNumberByIndex: ()=>fibonacciNumberByIndex,
            findClosestNumber: ()=>findClosestNumber,
            findClosestNumberInFactory: ()=>findClosestNumberInFactory,
            formatDate: ()=>formatDate,
            isPhoto: ()=>isPhoto,
            loadCssFile: ()=>loadCssFile,
            loadJavascript: ()=>loadJavascript,
            loadJavascriptFile: ()=>loadJavascriptFile,
            loadJavascriptFileEmbedSync: ()=>loadJavascriptFileEmbedSync,
            loadJavascriptFileSync: ()=>loadJavascriptFileSync,
            loadRemoteCSS: ()=>loadRemoteCSS,
            loadRemoteScript: ()=>loadRemoteScript,
            removeChars: ()=>removeChars,
            temporaryDomqlHack: ()=>temporaryDomqlHack,
            temporaryDomqlHackReverse: ()=>temporaryDomqlHackReverse,
            toCamelCase: ()=>toCamelCase2,
            toDashCase: ()=>toDashCase2,
            toDescriptionCase: ()=>toDescriptionCase,
            toTitleCase: ()=>toTitleCase,
            toggleFullscreen: ()=>toggleFullscreen
        });
        module2.exports = __toCommonJS2(index_exports2);
        var generateKey = /* @__PURE__ */ function() {
            let index = 0;
            function newId() {
                index++;
                return index;
            }
            return newId;
        }();
        var createSnapshotId = generateKey;
        var NODE_ENV2 = "development";
        var isProduction2 = (env = NODE_ENV2)=>env === "production";
        var isNotProduction2 = (env = NODE_ENV2)=>!isProduction2(env);
        var window22 = globalThis;
        var document22 = window22.document;
        var isNode2 = (obj)=>{
            return (typeof Node === "object" ? obj instanceof window22.Node : obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string") || false;
        };
        var isHtmlElement2 = (obj)=>{
            return (typeof HTMLElement === "object" ? obj instanceof window22.HTMLElement : obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string") || false;
        };
        var isDOMNode2 = (obj)=>{
            return typeof window22 !== "undefined" && (obj instanceof window22.Node || obj instanceof window22.Window || obj === window22 || obj === document);
        };
        var isObject2 = (arg)=>{
            if (arg === null) return false;
            return typeof arg === "object" && arg.constructor === Object;
        };
        var isString2 = (arg)=>typeof arg === "string";
        var isNumber2 = (arg)=>typeof arg === "number";
        var isFunction2 = (arg)=>typeof arg === "function";
        var isBoolean2 = (arg)=>arg === true || arg === false;
        var isNull2 = (arg)=>arg === null;
        var isArray2 = (arg)=>Array.isArray(arg);
        var isDate2 = (d)=>d instanceof Date;
        var isObjectLike2 = (arg)=>{
            if (arg === null) return false;
            return typeof arg === "object";
        };
        var isDefined2 = (arg)=>{
            return isObject2(arg) || isObjectLike2(arg) || isString2(arg) || isNumber2(arg) || isFunction2(arg) || isArray2(arg) || isObjectLike2(arg) || isBoolean2(arg) || isDate2(arg) || isNull2(arg);
        };
        var isUndefined2 = (arg)=>{
            return arg === void 0;
        };
        var TYPES = {
            boolean: isBoolean2,
            array: isArray2,
            object: isObject2,
            string: isString2,
            date: isDate2,
            number: isNumber2,
            null: isNull2,
            function: isFunction2,
            objectLike: isObjectLike2,
            node: isNode2,
            htmlElement: isHtmlElement2,
            defined: isDefined2
        };
        var is2 = (arg)=>{
            return (...args)=>{
                return args.map((val)=>TYPES[val](arg)).filter((v)=>v).length > 0;
            };
        };
        var isNot = (arg)=>{
            return (...args)=>{
                return args.map((val)=>TYPES[val](arg)).filter((v)=>v).length === 0;
            };
        };
        var removeFromArray = (arr, index)=>{
            if (isString2(index)) index = parseInt(index);
            if (isNumber2(index)) {
                if (index < 0 || index >= arr.length || isNaN(index)) throw new Error("Invalid index");
                arr.splice(index, 1);
            } else if (isArray2(index)) index.forEach((idx)=>removeFromArray(arr, idx));
            else throw new Error("Invalid index");
            return arr;
        };
        var joinArrays2 = (...arrays)=>{
            return [].concat(...arrays);
        };
        var mergeArray2 = (arr, exclude = [])=>{
            return arr.reduce((a, c)=>deepMerge2(a, deepClone2(c, {
                    exclude: exclude
                }), exclude), {});
        };
        var removeValueFromArray = (arr, value)=>{
            const index = arr.indexOf(value);
            if (index > -1) {
                const newArray = [
                    ...arr
                ];
                newArray.splice(index, 1);
                return newArray;
            }
            return arr;
        };
        var lowercaseFirstLetter = (inputString)=>{
            return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
        };
        function exec2(param, element, state2, context, opts = {}) {
            if (!element) element = this;
            if (isFunction2(param)) try {
                const result = param.call(element, element, state2 || element.state, context || element.context);
                if (result && typeof result.then === "function") return result;
                return result;
            } catch (e) {
                element.log(param);
                element.warn("Error executing function", e, opts);
            }
            return param;
        }
        var map = (obj, extention, element)=>{
            for(const e in extention)obj[e] = exec2(extention[e], element);
        };
        var merge2 = (element, obj, excludeFrom = [])=>{
            for(const e in obj){
                const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
                if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
                const elementProp = element[e];
                const objProp = obj[e];
                if (elementProp === void 0) element[e] = objProp;
            }
            return element;
        };
        var deepMerge2 = (element, extend, excludeFrom = [], level = Infinity)=>{
            for(const e in extend){
                const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
                if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
                const elementProp = element[e];
                const extendProp = extend[e];
                if (isObjectLike2(elementProp) && isObjectLike2(extendProp)) {
                    if (level > 0) deepMerge2(elementProp, extendProp, excludeFrom, level - 1);
                    else for(const k in extendProp){
                        if (excludeFrom.includes(k) || elementProp[k] !== void 0) continue;
                        elementProp[k] = extendProp[k];
                    }
                } else if (elementProp === void 0) element[e] = extendProp;
            }
            return element;
        };
        var clone = (obj, excludeFrom = [])=>{
            const o = {};
            for(const prop in obj){
                const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
                if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith("__")) continue;
                o[prop] = obj[prop];
            }
            return o;
        };
        var deepClone2 = (obj, options = {})=>{
            const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = /* @__PURE__ */ new WeakMap(), handleExtend: handleExtend = false } = options;
            const contentWindow = targetWindow || window22 || globalThis;
            if (!isObjectLike2(obj) || isDOMNode2(obj)) return obj;
            if (visited.has(obj)) return visited.get(obj);
            const clone2 = contentWindow ? isArray2(obj) ? new contentWindow.Array() : new contentWindow.Object() : isArray2(obj) ? [] : {};
            visited.set(obj, clone2);
            for(const key in obj){
                if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
                if (exclude.includes(key) || key.startsWith("__") || key === "__proto__") continue;
                let value = obj[key];
                if (cleanUndefined && isUndefined2(value) || cleanNull && isNull2(value)) continue;
                if (isDOMNode2(value)) {
                    clone2[key] = value;
                    continue;
                }
                if (handleExtend && key === "extend" && isArray2(value)) {
                    clone2[key] = mergeArray2(value, exclude);
                    continue;
                }
                if (isFunction2(value) && options.window) {
                    clone2[key] = contentWindow.eval("(" + value.toString() + ")");
                    continue;
                }
                if ((value == null ? void 0 : value.__ref) && (value == null ? void 0 : value.node)) value = value.parseDeep();
                if (value == null ? void 0 : value.__element) value = value.parse();
                if (isObjectLike2(value)) {
                    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
                    clone2[key] = deepClone2(value, {
                        ...options,
                        visited: visited
                    });
                } else clone2[key] = value;
            }
            return clone2;
        };
        var deepStringifyFunctions = (obj, stringified = {})=>{
            var _a, _b;
            if (!obj) return;
            if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
                (obj.__element || ((_a = obj.parent) == null ? void 0 : _a.__element)).warn("Trying to clone element or state at", obj);
                obj = (_b = obj.parse) == null ? void 0 : _b.call(obj);
            }
            for(const prop in obj){
                const objProp = obj[prop];
                if (isFunction2(objProp)) stringified[prop] = objProp.toString();
                else if (isObject2(objProp)) {
                    stringified[prop] = {};
                    deepStringifyFunctions(objProp, stringified[prop]);
                } else if (isArray2(objProp)) {
                    stringified[prop] = [];
                    objProp.forEach((v, i)=>{
                        if (isObject2(v)) {
                            stringified[prop][i] = {};
                            deepStringifyFunctions(v, stringified[prop][i]);
                        } else if (isFunction2(v)) stringified[prop][i] = v.toString();
                        else stringified[prop][i] = v;
                    });
                } else stringified[prop] = objProp;
            }
            return stringified;
        };
        var diffObjects = (original, objToDiff, cache, opts)=>{
            let hasDiff = false;
            const originalKeys = Object.keys(original);
            const diffKeys = Object.keys(objToDiff);
            const allKeys = [
                .../* @__PURE__ */ new Set([
                    ...originalKeys,
                    ...diffKeys
                ])
            ];
            const originalKeyOrder = originalKeys.join(",");
            const diffKeyOrder = diffKeys.filter((k)=>originalKeys.includes(k)).join(",");
            if (originalKeyOrder !== diffKeyOrder) hasDiff = true;
            for (const key of allKeys){
                if (key === "ref") continue;
                const originalProp = original[key];
                const objToDiffProp = objToDiff[key];
                if (!(key in objToDiff)) {
                    cache[key] = void 0;
                    hasDiff = true;
                    continue;
                }
                if (isObject2(originalProp) && isObject2(objToDiffProp)) {
                    const nestedDiff = diff(originalProp, objToDiffProp, {}, opts);
                    if (nestedDiff && Object.keys(nestedDiff).length > 0) {
                        cache[key] = nestedDiff;
                        hasDiff = true;
                    }
                } else if (isArray2(originalProp) && isArray2(objToDiffProp)) {
                    const nestedDiff = diffArrays(originalProp, objToDiffProp, [], opts);
                    if (nestedDiff && nestedDiff.length > 0) {
                        cache[key] = nestedDiff;
                        hasDiff = true;
                    }
                } else if (objToDiffProp !== originalProp) {
                    cache[key] = objToDiffProp;
                    hasDiff = true;
                }
            }
            return hasDiff ? cache : void 0;
        };
        var diffArrays = (original, objToDiff, cache, opts)=>{
            if (original.length !== objToDiff.length) return objToDiff;
            let hasDiff = false;
            const originalStringified = original.map((item)=>JSON.stringify(item));
            const diffStringified = objToDiff.map((item)=>JSON.stringify(item));
            if (originalStringified.join(",") !== diffStringified.join(",")) hasDiff = true;
            for(let i = 0; i < original.length; i++){
                const diffObj = diff(original[i], objToDiff[i], {}, opts);
                if (diffObj && (isObject2(diffObj) ? Object.keys(diffObj).length > 0 : true)) {
                    cache[i] = diffObj;
                    hasDiff = true;
                }
            }
            return hasDiff ? objToDiff : void 0;
        };
        var diff = (original, objToDiff, cache = {}, opts = {})=>{
            if (opts.cloneInstances) {
                original = deepClone2(original);
                objToDiff = deepClone2(objToDiff);
            }
            original = deepStringifyFunctions(original);
            objToDiff = deepStringifyFunctions(objToDiff);
            if (isArray2(original) && isArray2(objToDiff)) {
                const result = diffArrays(original, objToDiff, [], opts);
                return result === void 0 ? {} : result;
            }
            if (isObject2(original) && isObject2(objToDiff)) {
                const result = diffObjects(original, objToDiff, {}, opts);
                return result === void 0 ? {} : result;
            }
            if (original !== objToDiff) return objToDiff;
            return {};
        };
        var overwrite = (element, params, opts = {})=>{
            const { __ref: ref } = element;
            const excl = opts.exclude || [];
            const allowUnderscore = opts.preventUnderscore;
            const preventCaching = opts.preventCaching;
            for(const e in params){
                if (excl.includes(e) || !allowUnderscore && e.startsWith("__")) continue;
                const elementProp = element[e];
                const paramsProp = params[e];
                if (paramsProp !== void 0) {
                    element[e] = paramsProp;
                    if (ref && !preventCaching) ref.__cache[e] = elementProp;
                    if (isObject2(opts.diff)) diff[e] = elementProp;
                }
            }
            return element;
        };
        var overwriteShallow = (obj, params, excludeFrom = [])=>{
            for(const e in params){
                if (excludeFrom.includes(e) || e.startsWith("__")) continue;
                obj[e] = params[e];
            }
            return obj;
        };
        var overwriteDeep2 = (obj, params, opts = {}, visited = /* @__PURE__ */ new WeakMap())=>{
            const excl = opts.exclude || [];
            const forcedExclude = opts.preventForce ? [] : [
                "node",
                "window"
            ];
            if (!isObjectLike2(obj) || !isObjectLike2(params) || isDOMNode2(obj) || isDOMNode2(params)) return params;
            if (visited.has(obj)) return visited.get(obj);
            visited.set(obj, obj);
            for(const e in params){
                if (!Object.hasOwnProperty.call(params, e)) continue;
                if (excl.includes(e) || forcedExclude && e.startsWith("__")) continue;
                const objProp = obj[e];
                const paramsProp = params[e];
                if (isDOMNode2(paramsProp)) obj[e] = paramsProp;
                else if (isObjectLike2(objProp) && isObjectLike2(paramsProp)) obj[e] = overwriteDeep2(objProp, paramsProp, opts, visited);
                else if (paramsProp !== void 0) obj[e] = paramsProp;
            }
            return obj;
        };
        var deepContains = (obj1, obj2, ignoredKeys = [
            "node",
            "__ref"
        ])=>{
            if (obj1 === obj2) return true;
            if (!isObjectLike2(obj1) || !isObjectLike2(obj2)) return false;
            if (isDOMNode2(obj1) || isDOMNode2(obj2)) return obj1 === obj2;
            const stack = [
                [
                    obj1,
                    obj2
                ]
            ];
            const visited = /* @__PURE__ */ new WeakSet();
            while(stack.length > 0){
                const [current1, current2] = stack.pop();
                if (visited.has(current1)) continue;
                visited.add(current1);
                const keys1 = Object.keys(current1).filter((key)=>!ignoredKeys.includes(key));
                const keys22 = Object.keys(current2).filter((key)=>!ignoredKeys.includes(key));
                if (keys1.length !== keys22.length) return false;
                for (const key of keys1){
                    if (!Object.prototype.hasOwnProperty.call(current2, key)) return false;
                    const value1 = current1[key];
                    const value2 = current2[key];
                    if (isDOMNode2(value1) || isDOMNode2(value2)) {
                        if (value1 !== value2) return false;
                    } else if (isObjectLike2(value1) && isObjectLike2(value2)) {
                        if (value1 !== value2) stack.push([
                            value1,
                            value2
                        ]);
                    } else if (value1 !== value2) return false;
                }
            }
            return true;
        };
        var removeFromObject = (obj, props)=>{
            if (props === void 0 || props === null) return obj;
            if (is2(props)("string", "number")) delete obj[props];
            else if (isArray2(props)) props.forEach((prop)=>delete obj[prop]);
            else throw new Error("Invalid input: props must be a string or an array of strings");
            return obj;
        };
        var createNestedObject = (arr, lastValue)=>{
            const nestedObject = {};
            if (arr.length === 0) return lastValue;
            arr.reduce((obj, value, index)=>{
                if (!obj[value]) obj[value] = {};
                if (index === arr.length - 1 && lastValue !== void 0) obj[value] = lastValue;
                return obj[value];
            }, nestedObject);
            return nestedObject;
        };
        var removeNestedKeyByPath = (obj, path)=>{
            if (!Array.isArray(path)) throw new Error("Path must be an array.");
            let current = obj;
            for(let i = 0; i < path.length - 1; i++){
                if (current[path[i]] === void 0) return;
                current = current[path[i]];
            }
            const lastKey = path[path.length - 1];
            if (current && Object.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
        };
        var setInObjectByPath = (obj, path, value)=>{
            if (!Array.isArray(path)) throw new Error("Path must be an array.");
            let current = obj;
            for(let i = 0; i < path.length - 1; i++){
                if (!current[path[i]] || typeof current[path[i]] !== "object") current[path[i]] = {};
                current = current[path[i]];
            }
            const lastKey = path[path.length - 1];
            current[lastKey] = value;
            return obj;
        };
        var getInObjectByPath = (obj, path)=>{
            if (!Array.isArray(path)) throw new Error("Path must be an array.");
            let current = obj;
            for(let i = 0; i < path.length; i++){
                if (current === void 0 || current === null) return void 0;
                current = current[path[i]];
            }
            return current;
        };
        var detectInfiniteLoop = (arr)=>{
            const maxRepeats = 3;
            let pattern = [];
            let repeatCount = 0;
            for(let i = 0; i < arr.length; i++)if (pattern.length < 2) pattern.push(arr[i]);
            else {
                if (arr[i] === pattern[i % 2]) repeatCount++;
                else {
                    pattern = [
                        arr[i - 1],
                        arr[i]
                    ];
                    repeatCount = 1;
                }
                if (repeatCount >= maxRepeats * 2) {
                    if (isNotProduction2()) console.warn("Warning: Potential infinite loop detected due to repeated sequence:", pattern);
                    return true;
                }
            }
        };
        function getContextFunction(fnKey) {
            var _a, _b, _c, _d;
            return ((_a = this.context.utils) == null ? void 0 : _a[fnKey]) || ((_b = this.context.functions) == null ? void 0 : _b[fnKey]) || ((_c = this.context.methods) == null ? void 0 : _c[fnKey]) || ((_d = this.context.snippets) == null ? void 0 : _d[fnKey]);
        }
        var isMobile2 = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
        var HTML_TAGS = {
            root: [
                "body",
                "html"
            ],
            head: [
                "title",
                "base",
                "meta",
                "style",
                "noscript",
                "script"
            ],
            body: [
                "string",
                "style",
                "fragment",
                "a",
                "abbr",
                "acronym",
                "address",
                "applet",
                "area",
                "article",
                "aside",
                "audio",
                "b",
                "basefont",
                "bdi",
                "bdo",
                "big",
                "blockquote",
                "br",
                "button",
                "canvas",
                "caption",
                "center",
                "cite",
                "code",
                "search",
                "col",
                "colgroup",
                "data",
                "datalist",
                "dd",
                "del",
                "details",
                "dfn",
                "dialog",
                "dir",
                "div",
                "dl",
                "dt",
                "em",
                "embed",
                "fieldset",
                "figcaption",
                "figure",
                "font",
                "footer",
                "form",
                "frame",
                "frameset",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "head",
                "header",
                "hr",
                "i",
                "iframe",
                "img",
                "input",
                "ins",
                "kbd",
                "label",
                "legend",
                "li",
                "link",
                "main",
                "map",
                "mark",
                "meter",
                "nav",
                "noframes",
                "noscript",
                "object",
                "ol",
                "optgroup",
                "option",
                "output",
                "p",
                "param",
                "picture",
                "pre",
                "progress",
                "hgroup",
                "q",
                "rp",
                "rt",
                "ruby",
                "s",
                "samp",
                "script",
                "section",
                "select",
                "small",
                "source",
                "span",
                "strike",
                "strong",
                "sub",
                "summary",
                "sup",
                "table",
                "tbody",
                "td",
                "template",
                "hgroup",
                "textarea",
                "tfoot",
                "th",
                "thead",
                "time",
                "tr",
                "track",
                "tt",
                "u",
                "ul",
                "var",
                "video",
                "wbr",
                // SVG
                "svg",
                "path"
            ]
        };
        var isValidHtmlTag = (arg)=>HTML_TAGS.body.includes(arg);
        var checkIfKeyIsComponent = (key)=>{
            const isFirstKeyString = isString2(key);
            if (!isFirstKeyString) return;
            const firstCharKey = key.slice(0, 1);
            return /^[A-Z]*$/.test(firstCharKey);
        };
        var addAdditionalExtend = (newExtend, element)=>{
            if (!newExtend) return element;
            const { extend: elementExtend } = element;
            const originalArray = isArray2(elementExtend) ? elementExtend : [
                elementExtend
            ];
            const receivedArray = isArray2(newExtend) ? newExtend : [
                newExtend
            ];
            const extend = joinArrays2(receivedArray, originalArray);
            return {
                ...element,
                extend: extend
            };
        };
        var checkIfSugar = (element, parent2, key)=>{
            var _a;
            const { extend: extend, props: props, childExtend: childExtend, extends: extendProps, childExtends: childExtends, childProps: childProps, children: children, on: on, $collection: $collection, $stateCollection: $stateCollection, $propsCollection: $propsCollection } = element;
            const hasComponentAttrs = extend || childExtend || props || on || $collection || $stateCollection || $propsCollection;
            if (hasComponentAttrs && (childProps || extendProps || children || childExtends)) {
                const logErr = (_a = parent2 || element) == null ? void 0 : _a.error;
                if (logErr) logErr.call(parent2, element, "Sugar component includes params for builtin components", {
                    verbose: true
                });
            }
            return !hasComponentAttrs || childProps || extendProps || children || childExtends;
        };
        var extractComponentKeyFromKey = (key)=>{
            return key.includes("+") ? key.split("+") : key.includes("_") ? [
                key.split("_")[0]
            ] : key.includes(".") && !checkIfKeyIsComponent(key.split(".")[1]) ? [
                key.split(".")[0]
            ] : [
                key
            ];
        };
        var extendizeByKey = (element, parent2, key)=>{
            const { context: context } = parent2;
            const { tag: tag, extend: extend, childExtends: childExtends } = element;
            const isSugar = checkIfSugar(element, parent2, key);
            const extendFromKey = extractComponentKeyFromKey(key);
            const isExtendKeyComponent = context && context.components[extendFromKey];
            if (element === isExtendKeyComponent) return element;
            else if (isSugar) {
                const newElem = addAdditionalExtend(element.extends, {
                    extend: extendFromKey,
                    tag: tag,
                    props: {
                        ...element
                    }
                });
                if (newElem.props.data) {
                    newElem.data = newElem.props.data;
                    delete newElem.props.data;
                }
                if (newElem.props.state) {
                    newElem.state = newElem.props.state;
                    delete newElem.props.state;
                }
                if (newElem.props.attr) {
                    newElem.attr = newElem.props.attr;
                    delete newElem.props.attr;
                }
                if (newElem.props.if) {
                    newElem.if = newElem.props.if;
                    delete newElem.props.if;
                }
                if (childExtends) newElem.childExtend = childExtends;
                return newElem;
            } else if (!extend || extend === true) return {
                ...element,
                tag: tag,
                extend: extendFromKey
            };
            else if (extend) return addAdditionalExtend(extendFromKey, element);
            else if (isFunction2(element)) return {
                extend: extendFromKey,
                tag: tag,
                props: {
                    ...exec2(element, parent2)
                }
            };
        };
        function getCapitalCaseKeys(obj) {
            return Object.keys(obj).filter((key)=>/^[A-Z]/.test(key));
        }
        var addChildrenIfNotInOriginal = (element, parent2, key)=>{
            const childElems = getCapitalCaseKeys(element.props);
            if (!childElems.length) return element;
            for(const i in childElems){
                const childKey = childElems[i];
                const childElem = element[childKey];
                const newChild = element.props[childKey];
                const assignChild = (val)=>{
                    element[childKey] = val;
                    delete element.props[childKey];
                };
                if (newChild == null ? void 0 : newChild.ignoreExtend) continue;
                if (newChild === null) assignChild(null);
                else if (!childElem) assignChild(deepClone2(newChild));
                else {
                    const isSugarChildElem = checkIfSugar(childElem, parent2, key);
                    if (isSugarChildElem) continue;
                    assignChild({
                        extend: element[childKey],
                        props: newChild
                    });
                }
            }
        };
        var applyKeyComponentAsExtend = (element, parent2, key)=>{
            return extendizeByKey(element, parent2, key) || element;
        };
        var applyComponentFromContext = (element, parent2, options)=>{
            const { context: context } = element;
            if (!context || !context.components) return;
            const { components: components } = context;
            const { extend: extend } = element;
            const execExtend = exec2(extend, element);
            if (isString2(execExtend)) {
                const componentExists = components[execExtend] || components["smbls." + execExtend];
                if (componentExists) element.extend = componentExists;
                else {
                    if (isNotProduction2() && options.verbose) {
                        console.warn(execExtend, "is not in library", components, element);
                        console.warn("replacing with ", {});
                    }
                    element.extend = {};
                }
            }
        };
        var isVariant = (param)=>{
            if (!isString2(param)) return;
            const firstCharKey = param.slice(0, 1);
            return firstCharKey === ".";
        };
        var hasVariantProp = (element)=>{
            const { props: props } = element;
            if (isObject2(props) && isString2(props.variant)) return true;
        };
        var setContentKey = (el, opts = {})=>{
            const { __ref: ref } = el;
            const contentElementKey = opts.contentElementKey;
            if (contentElementKey !== "content" && contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = contentElementKey || "content";
            else ref.contentElementKey = "content";
            if (contentElementKey !== "content") opts.contentElementKey = "content";
            return ref.contentElementKey;
        };
        async function toggleFullscreen(opts) {
            if (!document.fullscreenElement) try {
                await (this.node || document).requestFullscreen();
            } catch (err) {
                console.warn(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
            }
            else await document.exitFullscreen();
        }
        var findClosestNumber = (number, arr)=>{
            return (isArray2(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
                return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
            });
        };
        var findClosestNumberInFactory = (val, factory)=>{
            val = parseFloat(val);
            if (isObject2(factory)) factory = Object.values(factory);
            return findClosestNumber(val, factory);
        };
        var formatDate = (timestamp)=>{
            if (!timestamp) return "";
            const d = new Date(timestamp);
            const ye = new Intl.DateTimeFormat("en", {
                year: "numeric"
            }).format(d);
            const mo = new Intl.DateTimeFormat("en", {
                month: "short"
            }).format(d);
            const da = new Intl.DateTimeFormat("en", {
                day: "2-digit"
            }).format(d);
            return `${da} ${mo}, ${ye}`;
        };
        var fibonacciNumberByIndex = function fibonacciNumberByIndex2(n) {
            const fib = [
                0,
                1
            ];
            for(let i = 2; i <= n; i++)fib[i] = fib[i - 1] + fib[i - 2];
            return fib[n];
        };
        var loadJavascriptFile = (FILE_URL, async = false, doc = document, type = "text/javascript")=>{
            return new Promise((resolve, reject)=>{
                try {
                    const scriptEle = doc.createElement("script");
                    scriptEle.type = type;
                    scriptEle.async = async;
                    scriptEle.src = FILE_URL;
                    scriptEle.addEventListener("load", (ev)=>{
                        resolve({
                            status: true
                        });
                    });
                    scriptEle.addEventListener("error", (ev)=>{
                        reject(new Error({
                            status: false,
                            message: `Failed to load the script ${FILE_URL}`
                        }));
                    });
                    doc.body.appendChild(scriptEle);
                } catch (error2) {
                    reject(error2);
                }
            });
        };
        var loadJavascriptFileSync = (fileUrl, doc = document, type = "text/javascript")=>{
            return new Promise((resolve, reject)=>{
                const scriptEle = doc.createElement("script");
                scriptEle.type = type;
                scriptEle.src = fileUrl;
                const blocker = doc.createElement("div");
                blocker.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;";
                doc.body.appendChild(blocker);
                scriptEle.onload = ()=>{
                    console.log(`Successfully loaded: ${fileUrl}`);
                    doc.body.removeChild(blocker);
                    resolve();
                };
                scriptEle.onerror = ()=>{
                    doc.body.removeChild(blocker);
                    reject(new Error(`Failed to load: ${fileUrl}`));
                };
                doc.body.appendChild(scriptEle);
            });
        };
        var loadJavascriptFileEmbedSync = (FILE_URL, doc = document, fallback, type = "text/javascript")=>{
            const xhr = new window.XMLHttpRequest();
            xhr.open("GET", FILE_URL, false);
            xhr.send();
            if (xhr.status === 200) {
                const scriptEle = doc.createElement("script");
                scriptEle.type = type;
                scriptEle.text = xhr.responseText;
                doc.body.appendChild(scriptEle);
                if (typeof fallback === "function") fallback();
            } else throw new Error(`Failed to load the script ${FILE_URL}`);
        };
        var loadCssFile = (FILE_URL, async = false, doc = document, type = "text/javascript")=>{
            return new Promise((resolve, reject)=>{
                try {
                    const linkElem = doc.createElement("link");
                    linkElem.rel = "stylesheet";
                    linkElem.href = FILE_URL;
                    linkElem.addEventListener("load", (ev)=>{
                        resolve({
                            status: true
                        });
                    });
                    doc.head.appendChild(linkElem);
                } catch (error2) {
                    reject(error2);
                }
            });
        };
        var loadJavascript = (body, async = false, doc = document, type = "text/javascript", id = "smbls-script")=>{
            try {
                const scriptEle = doc.createElement("script");
                scriptEle.type = type;
                scriptEle.async = async;
                scriptEle.id = id;
                scriptEle.innerHTML = body;
                doc.body.appendChild(scriptEle);
            } catch (error2) {
                console.warn(error2);
            }
        };
        function loadRemoteScript(url, options = {}) {
            const { window: window3 = globalThis } = options;
            const { document: document3 = window3.document } = options;
            return new Promise((resolve, reject)=>{
                const existingScript = document3.querySelector(`script[src="${url}"]`);
                if (existingScript) return resolve(existingScript);
                const script = document3.createElement("script");
                script.src = url;
                script.async = options.async === true;
                script.type = options.type || "text/javascript";
                if (options.id) script.id = options.id;
                if (options.integrity) script.integrity = options.integrity;
                if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
                script.onload = ()=>{
                    script.onerror = script.onload = null;
                    resolve(script);
                };
                script.onerror = ()=>{
                    script.onerror = script.onload = null;
                    reject(new Error(`Failed to load script: ${url}`));
                };
                document3.head.appendChild(script);
            });
        }
        async function loadRemoteCSS(url, options = {}) {
            const { window: window3 = globalThis } = options;
            const { document: document3 = window3.document } = options;
            return new Promise((resolve, reject)=>{
                const existingLink = document3.querySelector(`link[href="${url}"]`);
                if (existingLink) return resolve(existingLink);
                const link = document3.createElement("link");
                link.href = url;
                link.rel = options.rel || "stylesheet";
                link.type = "text/css";
                link.media = options.media || "all";
                if (options.id) link.id = options.id;
                if (options.integrity) link.integrity = options.integrity;
                if (options.crossOrigin) link.crossOrigin = options.crossOrigin;
                link.onload = ()=>{
                    link.onerror = link.onload = null;
                    resolve(link);
                };
                link.onerror = ()=>{
                    link.onerror = link.onload = null;
                    reject(new Error(`Failed to load stylesheet: ${url}`));
                };
                document3.head.appendChild(link);
            });
        }
        var isPhoto = (format)=>[
                "jpeg",
                "gif",
                "jpg",
                "png",
                "tiff",
                "woff"
            ].includes(format);
        var ERRORS_REGISTRY = {
            en: {
                DocumentNotDefined: {
                    title: "Document is undefined",
                    description: "To tweak with DOM, you should use browser."
                },
                OverwriteToBuiltin: {
                    title: "Overwriting to builtin method",
                    description: "Overwriting a builtin method in the window define is not possible, please choose different name"
                },
                BrowserNotDefined: {
                    title: "Can't recognize environment",
                    description: "Environment should be browser application, that can run Javascript"
                },
                SetQuickPreferancesIsNotObject: {
                    title: "Quick preferances object is required",
                    description: 'Please pass a plain object with "lang", "culture" and "area" properties'
                },
                InvalidParams: {
                    title: "Params are invalid",
                    description: 'Please pass a plain object with "lang", "culture" and "area" properties'
                },
                CantCreateWithoutNode: {
                    title: "You must provide node",
                    description: "Can't create DOM element without setting node or text"
                },
                HTMLInvalidTag: {
                    title: "Element tag name (or DOM nodeName) is invalid",
                    description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
                },
                HTMLInvalidAttr: {
                    title: "Attibutes object is invalid",
                    description: "Please pass a valid plain object to apply as an attributes for a DOM node"
                },
                HTMLInvalidData: {
                    title: "Data object is invalid",
                    description: "Please pass a valid plain object to apply as an dataset for a DOM node"
                },
                HTMLInvalidStyles: {
                    title: "Styles object is invalid",
                    description: "Please pass a valid plain object to apply as an style for a DOM node"
                },
                HTMLInvalidText: {
                    title: "Text string is invalid",
                    description: "Please pass a valid string to apply text to DOM node"
                },
                ElementOnStateIsNotDefined: {
                    title: "Element on state is not defined",
                    description: "Please check the element object"
                }
            }
        };
        var report = (err, arg, element)=>{
            const currentLang = "en";
            let errObj;
            if (err && typeof err === "string") errObj = ERRORS_REGISTRY[currentLang][err];
            return new Error(`"${err}", "${arg}"

`, `${errObj.description}`, element ? `

${element}` : "");
        };
        var IGNORE_PROPS_PARAMS = [
            "update",
            "__element"
        ];
        var objectizeStringProperty = (propValue)=>{
            if (is2(propValue)("string", "number")) return {
                inheritedString: propValue
            };
            return propValue;
        };
        var inheritParentProps = (element, parent2)=>{
            var _a;
            let propsStack = [];
            const parentProps = exec2(parent2, parent2.state).props;
            const matchParent = parent2.props && parentProps[element.key];
            const matchParentIsString = isString2(matchParent);
            const matchParentChildProps = parentProps && parentProps.childProps;
            if (matchParent) {
                if (matchParentIsString) {
                    const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
                    if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
                    else propsStack = [].concat(objectizeStringProperty(matchParent), propsStack);
                } else propsStack.push(objectizeStringProperty(matchParent));
            }
            if (matchParentChildProps && !((_a = element == null ? void 0 : element.props) == null ? void 0 : _a.ignoreChildProps)) propsStack.push(matchParentChildProps);
            return propsStack;
        };
        var createPropsStack = (element, parent2)=>{
            const { props: props, __ref: ref } = element;
            const propsStack = ref.__props = inheritParentProps(element, parent2);
            if (isObject2(props)) propsStack.push(props);
            else if (props === "inherit" && parent2.props) propsStack.push(parent2.props);
            else if (props) propsStack.push(props);
            if (isArray2(ref.__extend)) ref.__extend.forEach((extend)=>{
                if (extend.props && extend.props !== props) propsStack.push(extend.props);
            });
            ref.__props = propsStack;
            return propsStack;
        };
        var syncProps = async (props, element, opts)=>{
            element.props = {};
            const mergedProps = {};
            props.forEach((v)=>{
                if (IGNORE_PROPS_PARAMS.includes(v)) return;
                let execProps;
                try {
                    execProps = exec2(v, element, element.state, element.context, opts);
                } catch (e) {
                    element.error(e, opts);
                }
                element.props = deepMerge2(mergedProps, deepClone2(execProps, {
                    ignore: IGNORE_PROPS_PARAMS
                }), IGNORE_PROPS_PARAMS);
            });
            element.props = mergedProps;
            const methods = {
                update: await update.bind(element.props),
                __element: element
            };
            Object.setPrototypeOf(element.props, methods);
            return element.props;
        };
        var createProps = function(element, parent2, options) {
            const { __ref: ref } = element;
            const applyProps = ()=>{
                const propsStack = options.cachedProps || createPropsStack(element, parent2);
                if (propsStack.length) {
                    ref.__props = propsStack;
                    syncProps(propsStack, element, options);
                } else {
                    ref.__props = options.cachedProps || [];
                    element.props = {};
                }
            };
            if (ref.__if) applyProps();
            else try {
                applyProps();
            } catch (e) {
                element.props = {};
                ref.__props = options.cachedProps || [];
                element.error("Error applying props", e, options);
            }
            const methods = {
                update: update.bind(element.props),
                __element: element
            };
            Object.setPrototypeOf(element.props, methods);
            return element;
        };
        async function update(props, options) {
            const element = this.__element;
            await element.update({
                props: props
            }, options);
        }
        var updateProps = (newProps, element, parent2, opts)=>{
            const { __ref: __ref } = element;
            let propsStack = __ref.__props;
            const parentProps = inheritParentProps(element, parent2);
            if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
            if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
            if (propsStack) syncProps(propsStack, element, opts);
            return element;
        };
        var IGNORE_STATE_PARAMS = [
            "update",
            "parse",
            "clean",
            "create",
            "destroy",
            "add",
            "toggle",
            "remove",
            "apply",
            "set",
            "reset",
            "replace",
            "quietReplace",
            "quietUpdate",
            "applyReplace",
            "applyFunction",
            "rootUpdate",
            "parentUpdate",
            "parent",
            "__element",
            "__depends",
            "__ref",
            "__children",
            "root",
            "setByPath",
            "setPathCollection",
            "removeByPath",
            "removePathCollection",
            "getByPath"
        ];
        var METHODS = [
            "set",
            "reset",
            "update",
            "remove",
            "updateContent",
            "removeContent",
            "lookup",
            "lookdown",
            "lookdownAll",
            "getRef",
            "getPath",
            "setNodeStyles",
            "spotByPath",
            "append",
            "keys",
            "parse",
            "setProps",
            "parseDeep",
            "variables",
            "if",
            "log",
            "nextElement",
            "previousElement"
        ];
        var METHODS_EXL = joinArrays2([
            "node",
            "state",
            "context",
            "extend",
            "__element"
        ], METHODS, IGNORE_STATE_PARAMS, IGNORE_PROPS_PARAMS);
        var deepMerge22 = (element, extend, exclude = METHODS_EXL)=>{
            for(const e in extend){
                if (exclude.includes(e)) continue;
                const elementProp = element[e];
                const extendProp = extend[e];
                if (elementProp === void 0) element[e] = extendProp;
                else if (isObjectLike2(elementProp) && isObject2(extendProp)) deepMerge22(elementProp, extendProp);
            }
            return element;
        };
        var overwrite2 = (element, params, options)=>{
            const changes = {};
            const { __ref: __ref } = element;
            const { __exec: __exec, __cached: __cached } = __ref;
            for(const e in params){
                if (e === "props" || e === "state" || e === "__ref") continue;
                const elementProp = element[e];
                const paramsProp = params[e];
                if (paramsProp !== void 0) {
                    __cached[e] = changes[e] = elementProp;
                    element[e] = paramsProp;
                }
                if (options.cleanExec) delete __exec[e];
            }
            return changes;
        };
        var generateHash = ()=>Math.random().toString(36).substring(2);
        var extendStackRegistry = {};
        var getHashedExtend = (extend)=>{
            return extendStackRegistry[extend.__hash];
        };
        var setHashedExtend = (extend, stack)=>{
            const hash = generateHash();
            if (!isString2(extend)) extend.__hash = hash;
            extendStackRegistry[hash] = stack;
            return stack;
        };
        var getExtendStackRegistry = (extend, stack)=>{
            if (extend.__hash) return stack.concat(getHashedExtend(extend));
            return setHashedExtend(extend, stack);
        };
        var extractArrayExtend = (extend, stack, context)=>{
            extend.forEach((each)=>flattenExtend(each, stack, context));
            return stack;
        };
        var deepExtend = (extend, stack, context)=>{
            const extendOflattenExtend = extend.extend;
            if (extendOflattenExtend) flattenExtend(extendOflattenExtend, stack, context);
            return stack;
        };
        var flattenExtend = (extend, stack, context)=>{
            if (!extend) return stack;
            if (isArray2(extend)) return extractArrayExtend(extend, stack, context);
            if (isString2(extend)) extend = fallbackStringExtend(extend, context);
            stack.push(extend);
            if (extend.extend) deepExtend(extend, stack, context);
            return stack;
        };
        var deepMergeExtend = (element, extend)=>{
            for(const e in extend){
                if ([
                    "parent",
                    "node",
                    "__element"
                ].indexOf(e) > -1) continue;
                const elementProp = element[e];
                const extendProp = extend[e];
                if (elementProp === void 0) element[e] = extendProp;
                else if (isObject2(elementProp) && isObject2(extendProp)) deepMergeExtend(elementProp, extendProp);
                else if (isArray2(elementProp) && isArray2(extendProp)) element[e] = elementProp.concat(extendProp);
                else if (isArray2(elementProp) && isObject2(extendProp)) {
                    const obj = deepMergeExtend({}, elementProp);
                    element[e] = deepMergeExtend(obj, extendProp);
                } else if (elementProp === void 0 && isFunction2(extendProp)) element[e] = extendProp;
            }
            return element;
        };
        var cloneAndMergeArrayExtend = (stack)=>{
            return stack.reduce((a, c)=>{
                return deepMergeExtend(a, deepClone2(c));
            }, {});
        };
        var fallbackStringExtend = (extend, context, options = {}, variant)=>{
            const COMPONENTS = context && context.components || options.components;
            const PAGES = context && context.pages || options.pages;
            if (isString2(extend)) {
                const componentExists = COMPONENTS && (COMPONENTS[extend + "." + variant] || COMPONENTS[extend] || COMPONENTS["smbls." + extend]);
                const pageExists = PAGES && extend.startsWith("/") && PAGES[extend];
                if (componentExists) return componentExists;
                else if (pageExists) return pageExists;
                else {
                    if (options.verbose && isNotProduction2()) console.warn("Extend is string but component was not found:", extend);
                    return {};
                }
            }
            return extend;
        };
        var jointStacks = (extendStack, childExtendStack)=>{
            return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
        };
        var getExtendStack = (extend, context)=>{
            if (!extend) return [];
            if (extend.__hash) return getHashedExtend(extend) || [];
            const stack = flattenExtend(extend, [], context);
            return getExtendStackRegistry(extend, stack);
        };
        var mainExtend;
        var applyExtend = (element, parent2, options = {})=>{
            if (isFunction2(element)) element = exec2(element, parent2);
            const { props: props, __ref: __ref } = element;
            let extend = (props == null ? void 0 : props.extends) || element.extends || element.extend;
            const variant = props == null ? void 0 : props.variant;
            const context = element.context || parent2.context;
            extend = fallbackStringExtend(extend, context, options, variant);
            const extendStack = getExtendStack(extend, context);
            delete element.extend;
            let childExtendStack = [];
            if (parent2) {
                element.parent = parent2;
                if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
                    childExtendStack = getExtendStack(parent2.childExtend, context);
                    const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
                    if (parent2.childExtendsRecursive && !ignoreChildExtendRecursive) {
                        const canExtendRecursive = element.key !== "__text";
                        if (canExtendRecursive) {
                            const childExtendsRecursiveStack = getExtendStack(parent2.childExtendsRecursive, context);
                            childExtendStack = childExtendStack.concat(childExtendsRecursiveStack);
                            element.childExtendsRecursive = parent2.childExtendsRecursive;
                        }
                    }
                }
            }
            const extendLength = extendStack.length;
            const childExtendLength = childExtendStack.length;
            let stack = [];
            if (extendLength && childExtendLength) stack = jointStacks(extendStack, childExtendStack);
            else if (extendLength) stack = extendStack;
            else if (childExtendLength) stack = childExtendStack;
            else if (!context.defaultExtends) return element;
            if (context.defaultExtends) {
                if (!mainExtend) {
                    const defaultOptionsExtend = getExtendStack(context.defaultExtends, context);
                    mainExtend = cloneAndMergeArrayExtend(defaultOptionsExtend);
                    delete mainExtend.extend;
                }
                stack = [].concat(stack, mainExtend);
            }
            if (__ref) __ref.__extend = stack;
            let mergedExtend = cloneAndMergeArrayExtend(stack);
            const COMPONENTS = context && context.components || options.components;
            const component = exec2(element.component || mergedExtend.component, element);
            if (component && COMPONENTS && COMPONENTS[component]) {
                const componentExtend = cloneAndMergeArrayExtend(getExtendStack(COMPONENTS[component]));
                mergedExtend = deepMergeExtend(componentExtend, mergedExtend);
            }
            const merged = deepMergeExtend(element, mergedExtend);
            return merged;
        };
        var assignKeyAsClassname = (element)=>{
            const { key: key } = element;
            if (element.class === true) element.class = key;
            else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
        };
        var classify = (obj, element, opts)=>{
            let className = "";
            for(const item in obj){
                const param = obj[item];
                if (typeof param === "boolean" && param) className += ` ${item}`;
                else if (typeof param === "string") className += ` ${param}`;
                else if (typeof param === "function") className += ` ${exec2(param, element, element.state, element.context, opts)}`;
            }
            return className;
        };
        var classList = (params, element, opts)=>{
            if (!params) return;
            const { key: key } = element;
            if (params === true) params = element.class = {
                key: key
            };
            if (isString2(params)) params = element.class = {
                default: params
            };
            if (isObject2(params)) params = classify(params, element, opts);
            const className = params.replace(/\s+/g, " ").trim();
            if (element.ref) element.ref.class = className;
            return className;
        };
        var OPTIONS = {};
        var getOnOrPropsEvent = (param, element)=>{
            var _a, _b;
            const onEvent = (_a = element.on) == null ? void 0 : _a[param];
            const onPropEvent = (_b = element.props) == null ? void 0 : _b["on" + param.slice(0, 1).toUpperCase() + param.slice(1)];
            return onEvent || onPropEvent;
        };
        var applyEvent = (fnValue, element, state2, context, options)=>{
            if (isString2(fnValue)) fnValue = getContextFunction.call(element, fnValue);
            if (!fnValue.call) element.warn(`Event is not executable: ${fnValue}`);
            return fnValue.call(element, element, state2 || element.state, context || element.context, options);
        };
        var triggerEventOn = async (param, element, options)=>{
            const appliedFunction = getOnOrPropsEvent(param, element);
            const ref = element.__ref;
            if (ref.__stormAbortion) return;
            if (appliedFunction) {
                const { state: state2, context: context } = element;
                return await applyEvent(appliedFunction, element, state2, context, options);
            }
        };
        var applyEventUpdate = (fnValue, updatedObj, element, state2, context, options)=>{
            if (isString2(fnValue)) fnValue = getContextFunction.call(element, fnValue);
            if (!fnValue.call) element.warn(`Event is not executable: ${fnValue}`);
            return fnValue.call(element, updatedObj, element, state2 || element.state, context || element.context, options);
        };
        var triggerEventOnUpdate = async (param, updatedObj, element, options)=>{
            const appliedFunction = getOnOrPropsEvent(param, element);
            if (appliedFunction) {
                const { state: state2, context: context } = element;
                return await applyEventUpdate(appliedFunction, updatedObj, element, state2, context, options);
            }
        };
        var applyEventsOnNode = (element, options)=>{
            const { node: node, on: on } = element;
            for(const param in on){
                if (param === "init" || param === "beforeClassAssign" || param === "render" || param === "renderRouter" || param === "attachNode" || param === "stateInit" || param === "stateCreated" || param === "beforeStateUpdate" || param === "stateUpdate" || param === "beforeUpdate" || param === "done" || param === "create" || param === "complete" || param === "frame" || param === "update") continue;
                let fnValue = getOnOrPropsEvent(param, element);
                if (isString2(fnValue)) fnValue = getContextFunction.call(element, fnValue);
                if (isFunction2(fnValue)) node.addEventListener(param, async (event)=>{
                    const { state: state2, context: context } = element;
                    await fnValue.call(element, event, element, state2, context, options);
                });
            }
        };
        var canRenderTag = (tag)=>{
            return isValidHtmlTag(tag || "div") || report("HTMLInvalidTag");
        };
        var registerFrameListener = (el)=>{
            const { __ref: ref } = el;
            const { frameListeners: frameListeners } = ref.root.data;
            if (frameListeners && !frameListeners.has(el)) frameListeners.add(el);
        };
        var applyAnimationFrame = (element, options)=>{
            const { props: props, on: on, __ref: ref } = element;
            const { frameListeners: frameListeners } = ref.root.data;
            if (frameListeners && ((on == null ? void 0 : on.frame) || (props == null ? void 0 : props.onFrame))) registerFrameListener(element);
        };
        var createHTMLNode = (element)=>{
            const { tag: tag, context: context } = element;
            const doc = context.document || document22;
            if (tag) {
                if (tag === "string") return doc.createTextNode(element.text);
                else if (tag === "fragment") return doc.createDocumentFragment();
                else if (tag === "svg" || tag === "path") return doc.createElementNS("http://www.w3.org/2000/svg", tag);
                else return doc.createElement(tag);
            } else return doc.createElement("div");
        };
        var detectTag = (element)=>{
            let { tag: tag, key: key, props: props } = element;
            tag = exec2(tag, element);
            if (tag === true) tag = key;
            if (isObject2(props) && isString2(props.tag)) {
                const tagExists = isValidHtmlTag(props.tag);
                if (tagExists) return props.tag;
            }
            if (isString2(tag)) {
                if (isValidHtmlTag(tag)) return tag;
            } else {
                let keyAsTag = key.toLowerCase();
                if (keyAsTag.includes(".")) keyAsTag = keyAsTag.split(".")[0];
                if (keyAsTag.includes("_")) keyAsTag = keyAsTag.split("_")[0];
                if (isValidHtmlTag(keyAsTag)) return keyAsTag;
            }
            return "div";
        };
        var cacheNode = (element)=>{
            const { context: context } = element;
            const win = context.window || window;
            const tag = element.tag = detectTag(element);
            if (!canRenderTag(tag)) return report("HTMLInvalidTag", element.tag, element);
            if (!win.nodeCaches) win.nodeCaches = {};
            let cachedTag = win.nodeCaches[tag];
            if (!cachedTag) cachedTag = win.nodeCaches[tag] = createHTMLNode(element);
            const clonedNode = cachedTag.cloneNode(true);
            if (tag === "string") clonedNode.nodeValue = element.text;
            return clonedNode;
        };
        var appendNode = (node, parentNode, el)=>{
            var _a;
            const win = ((_a = el == null ? void 0 : el.context) == null ? void 0 : _a.window) || window;
            try {
                if (parentNode && typeof parentNode.appendChild === "function") {
                    if (parentNode instanceof win.Node && typeof parentNode.appendChild === "function") parentNode.appendChild(node);
                    else throw new Error("Invalid parentNode: appendChild is not supported on this node type.");
                } else throw new Error("Invalid parentNode: appendChild is not supported on this node type.");
            } catch (e) {
                if (node && node.parentNode) node.parentNode.removeChild(node);
                if (node && parentNode && parentNode instanceof win.Element) parentNode.appendChild(node);
            }
            return node;
        };
        var insertNodeAfter = (node, siblingNode, parentNode)=>{
            const parent2 = parentNode || siblingNode.parentNode;
            if (siblingNode.nextSibling) parent2 && parent2.insertBefore(node, siblingNode.nextSibling);
            else if (siblingNode == null ? void 0 : siblingNode.insertAdjacentElement) siblingNode.insertAdjacentElement("afterend", node);
            else parent2.insertBefore(node, siblingNode);
        };
        var insertNodeBefore = (node, siblingNode, parentNode)=>{
            const parent2 = parentNode || siblingNode.parentNode;
            parent2 && parent2.insertBefore(node, siblingNode);
        };
        var assignNode = (element, parent2, key, attachOptions)=>{
            parent2[key || element.key] = element;
            if (element.tag !== "shadow") {
                if (attachOptions && attachOptions.position) (attachOptions.position === "before" ? insertNodeBefore : insertNodeAfter)(element.node, attachOptions.node || parent2.node);
                else appendNode(element.node, parent2.node, element);
            }
            return element;
        };
        function getRootState(param) {
            var _a, _b;
            let state2 = null;
            const hasRootState = (obj)=>{
                var _a2;
                return obj.__element && ((_a2 = obj.root) == null ? void 0 : _a2.isRootState);
            };
            if (!this) state2 = window.platformState || ((_a = window.smblsApp) == null ? void 0 : _a.state);
            else if (hasRootState(this)) state2 = this.root;
            else if (this.__ref && this.__ref.path) {
                const hasPlatformState = this.state && hasRootState(this.state);
                const hasPlatformStateOnParent = this.call("isFunction", this.state) && this.parent.state && hasRootState(this.parent.state);
                if (hasPlatformState || hasPlatformStateOnParent) state2 = this.state.root || this.parent.state.root;
            }
            if (!state2) state2 = window.platformState || ((_b = window.smblsApp) == null ? void 0 : _b.state);
            return param ? state2[param] : state2;
        }
        function getRoot(key) {
            var _a;
            const rootElem = (_a = this.getRootState()) == null ? void 0 : _a.__element;
            return rootElem && Object.keys(rootElem).length > 0 && key ? rootElem[key] : rootElem;
        }
        function getRootData(key) {
            return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && key ? this.getRoot("data")[key] : this.getRoot("data");
        }
        function getRootContext(key) {
            var _a;
            const ctx = (_a = this.getRoot()) == null ? void 0 : _a.context;
            return key ? ctx[key] : ctx;
        }
        function getContext(key) {
            const ctx = this.context;
            return key ? ctx[key] : ctx;
        }
        var ROOT = {
            key: ":root",
            node: document22 ? document22.body : report("DocumentNotDefined", document22)
        };
        var TREE = ROOT;
        function spotByPath(path) {
            const element = this;
            const arr = [].concat(path);
            let active = TREE[arr[0]];
            if (!arr || !arr.length) return console.log(arr, "on", element.key, "is undefined");
            while(active.key === arr[0]){
                arr.shift();
                if (!arr.length) break;
                active = active[arr[0]];
                if (!active) return;
            }
            return active;
        }
        function lookup(param) {
            const el = this;
            let { parent: parent2 } = el;
            if (isFunction2(param)) {
                if (parent2.state && param(parent2, parent2.state, parent2.context)) return parent2;
                else if (parent2.parent) return parent2.lookup(param);
                else return;
            }
            if (el[param]) return el[param];
            while(parent2.param !== param){
                if (parent2[param]) return parent2[param];
                parent2 = parent2.parent;
                if (!parent2) return;
            }
            return parent2;
        }
        function lookdown(param) {
            var _a;
            const el = this;
            const { __ref: ref } = el;
            const children = ref == null ? void 0 : ref.__children;
            if (!children) return;
            for(let i = 0; i < children.length; i++){
                const v = children[i];
                const childElem = el[v];
                if (!childElem) return this.warn("Element found in children array but it does not exist in parent");
                if (v === param) return childElem;
                else if (isFunction2(param)) {
                    if (!childElem) {
                        this.error(`"${v}" found in element __children, but content is not defined`);
                        continue;
                    }
                    const exec22 = param(childElem, childElem.state, childElem.context);
                    if (childElem.state && exec22) return childElem;
                }
                const lookdown2 = (_a = childElem == null ? void 0 : childElem.lookdown) == null ? void 0 : _a.call(childElem, param);
                if (lookdown2) return lookdown2;
            }
        }
        function lookdownAll(param, results = []) {
            var _a;
            const el = this;
            const { __ref: ref } = el;
            const children = ref == null ? void 0 : ref.__children;
            if (!children) return;
            for(let i = 0; i < children.length; i++){
                const v = children[i];
                const childElem = el[v];
                if (v === param) results.push(childElem);
                else if (isFunction2(param)) {
                    if (!childElem) {
                        this.error(`"${v}" found in element __children, but content is not defined`);
                        continue;
                    }
                    const exec22 = param(childElem, childElem.state, childElem.context);
                    if (childElem.state && exec22) results.push(childElem);
                }
                (_a = childElem == null ? void 0 : childElem.lookdownAll) == null || _a.call(childElem, param, results);
            }
            return results.length ? results : void 0;
        }
        function setNodeStyles(params = {}) {
            var _a;
            const el = this;
            if (!((_a = el.node) == null ? void 0 : _a.style)) return;
            for(const param in params){
                const value = params[param];
                const childElem = el[param];
                if (isObject2(value) && childElem) setNodeStyles.call(childElem, value);
                else el.node.style[param] = value;
            }
            return el;
        }
        async function remove(opts = {}) {
            var _a;
            const element = this;
            const beforeRemoveReturns = triggerEventOn("beforeRemove", element, opts);
            if (beforeRemoveReturns === false) return element;
            if (isFunction2(element.node.remove)) element.node.remove();
            else if ((_a = element.node) == null ? void 0 : _a.parentNode) element.node.parentNode.removeChild(element.node);
            else if (!isProduction2()) {
                console.warn("This item cant be removed");
                element.log();
            }
            delete element.parent[element.key];
            if (element.parent.__ref) element.parent.__ref.__children = removeValueFromArray(element.parent.__ref.__children, element.key);
            await triggerEventOn("remove", element, opts);
        }
        function setProps(param, opts = {}) {
            const element = this;
            if (!param || !element.props) return;
            element.update({
                props: param
            }, opts);
            return element;
        }
        function getRef(key) {
            if (key) return this.__ref && this.__ref[key];
            return this.__ref;
        }
        function getPath() {
            return this.getRef().path;
        }
        function keys() {
            const element = this;
            const keys3 = [];
            for(const param in element){
                if (REGISTRY[param] && !parseFilters.elementKeys.includes(param) || !Object.hasOwnProperty.call(element, param)) continue;
                keys3.push(param);
            }
            return keys3;
        }
        function parse(excl = []) {
            const element = this;
            const obj = {};
            const keyList = keys.call(element);
            keyList.forEach((v)=>{
                if (excl.includes(v)) return;
                const val = element[v];
                if (v === "state") {
                    if (element.__ref && !element.__ref.__hasRootState) return;
                    const parsedVal = isFunction2(val && val.parse) ? val.parse() : val;
                    obj[v] = isFunction2(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
                } else if (v === "scope") {
                    if (element.__ref && !element.__ref.__hasRootScope) return;
                    obj[v] = JSON.parse(JSON.stringify(val || {}));
                } else if (v === "props") {
                    const { __element: __element, update: update3, ...props } = element[v];
                    obj[v] = props;
                } else if (isDefined2(val) && Object.hasOwnProperty.call(element, v)) obj[v] = val;
            });
            return obj;
        }
        function parseDeep(excl = []) {
            const element = this;
            const obj = parse.call(element, excl);
            for(const v in obj){
                if (excl.includes(v)) return;
                if (isObjectLike2(obj[v])) obj[v] = parseDeep.call(obj[v], excl);
            }
            return obj;
        }
        function verbose(element, ...args) {
            if (isProduction2()) return;
            const parent2 = this;
            const { __ref: ref } = parent2;
            console.groupCollapsed(parent2.key);
            if (args.length) args.forEach((v)=>console.log(`%c${v}:
`, "font-weight: bold", parent2[v]));
            else {
                console.log(ref.path);
                const keys3 = parent2.keys();
                keys3.forEach((v)=>console.log(`%c${v}:`, "font-weight: bold", parent2[v]));
            }
            console.log(parent2);
            console.groupEnd(parent2.key);
            return parent2;
        }
        function log(...params) {
            console.log(...params);
        }
        function warn(...params) {
            console.warn(...params, this);
        }
        function error(...params) {
            var _a, _b, _c, _d;
            if ((_a = params[params.length - 1]) == null ? void 0 : _a.debugger) debugger;
            if ((_b = params[params.length - 1]) == null ? void 0 : _b.verbose) verbose.call(this, ...params);
            if (isFunction2((_c = params[params.length - 1]) == null ? void 0 : _c.onError)) (_d = params[params.length - 1]) == null || _d.onError.call(this, ...params);
            console.error(...params, this);
        }
        function nextElement() {
            const element = this;
            const { key: key, parent: parent2 } = element;
            const { __children: __children } = parent2.__ref;
            const currentIndex = __children.indexOf(key);
            const nextChild = __children[currentIndex + 1];
            return parent2[nextChild];
        }
        async function append(el, key, opts) {
            return await create(el, this, key, opts);
        }
        function previousElement(el) {
            const element = el || this;
            const { key: key, parent: parent2 } = element;
            const { __children: __children } = parent2.__ref;
            if (!__children) return;
            const currentIndex = __children.indexOf(key);
            return parent2[__children[currentIndex - 1]];
        }
        function variables(obj = {}) {
            const element = this;
            if (!element.data) element.data = {};
            if (!element.data.varCaches) element.data.varCaches = {};
            const varCaches = element.data.varCaches;
            const changes = {};
            let changed;
            for(const key in obj)if (obj[key] !== varCaches[key]) {
                changed = true;
                changes[key] = obj[key];
            }
            return {
                changed: (cb)=>{
                    if (!changed || !varCaches) return;
                    const returns = cb(changes, clone(varCaches));
                    for(const key in changes)varCaches[key] = changes[key];
                    return returns;
                },
                timeout: (cb, timeout)=>{
                    if (!changed) return;
                    const t = setTimeout(()=>{
                        cb(changes);
                        clearTimeout(t);
                    }, timeout);
                }
            };
        }
        function call(fnKey, ...args) {
            const fn = getContextFunction.call(this, fnKey);
            if (!fn) return void 0;
            try {
                const result = fn.call(this, ...args);
                if (result && typeof result.then === "function") return result;
                return result;
            } catch (error2) {
                console.error(`Error calling function: '${fnKey}'
`, error2);
                throw new Error(error2);
            }
        }
        var METHODS2 = [
            "set",
            "reset",
            "update",
            "remove",
            "updateContent",
            "removeContent",
            "lookup",
            "lookdown",
            "lookdownAll",
            "getRef",
            "getChildren",
            "getPath",
            "getRootState",
            "getRoot",
            "getRootData",
            "getRootContext",
            "getContext",
            "setNodeStyles",
            "spotByPath",
            "keys",
            "parse",
            "setProps",
            "parseDeep",
            "variables",
            "if",
            "log",
            "verbose",
            "groupLog",
            "groupLogEnd",
            "warn",
            "error",
            "call",
            "nextElement",
            "append",
            "previousElement"
        ];
        function isMethod(param, element) {
            var _a, _b;
            return METHODS2.includes(param) || ((_b = (_a = element == null ? void 0 : element.context) == null ? void 0 : _a.methods) == null ? void 0 : _b[param]);
        }
        var throughInitialExec = async (element, exclude = {})=>{
            const { __ref: ref } = element;
            for(const param in element){
                if (exclude[param]) continue;
                const prop = element[param];
                if (isFunction2(prop) && !isMethod(param, element) && !isVariant(param)) {
                    ref.__exec[param] = prop;
                    element[param] = await prop(element, element.state, element.context);
                }
            }
        };
        var throughUpdatedExec = async (element, options = {
            excludes: METHODS_EXL
        })=>{
            const { __ref: ref } = element;
            const changes = {};
            for(const param in ref.__exec){
                const prop = element[param];
                const isDefinedParam = ref.__defineCache[param];
                if (isDefinedParam) continue;
                const newExec = await ref.__exec[param](element, element.state, element.context);
                const execReturnsString = isString2(newExec) || isNumber2(newExec);
                if (prop && prop.node && execReturnsString) overwrite2(prop, {
                    text: newExec
                }, options);
                else if (newExec !== prop) {
                    if (checkIfKeyIsComponent(param)) {
                        const { extend: extend, ...newElem } = extendizeByKey(newExec, element, param);
                        overwrite2(prop, newElem, options);
                    } else {
                        ref.__cached[param] = changes[param] = prop;
                        element[param] = newExec;
                    }
                }
            }
            return changes;
        };
        var throughExecProps = (element, opts)=>{
            const { __ref: ref } = element;
            const { props: props } = element;
            for(const k in props){
                const isDefine = k.startsWith("is") || k.startsWith("has") || k.startsWith("use");
                if (!ref.__execProps) return warn.call(element, "Element was not initiated to execute props");
                const cachedExecProp = ref.__execProps[k];
                if (isFunction2(cachedExecProp)) props[k] = exec2(cachedExecProp, element, element.state, element.context, opts);
                else if (isDefine && isFunction2(props[k])) {
                    ref.__execProps[k] = props[k];
                    props[k] = exec2(props[k], element, element.state, element.context, opts);
                }
            }
        };
        var throughInitialDefine = async (element, opts)=>{
            const { define: define, context: context, __ref: ref } = element;
            let defineObj = {};
            const hasGlobalDefine = context && isObject2(context.define);
            if (isObject2(define)) defineObj = {
                ...define
            };
            if (hasGlobalDefine) defineObj = {
                ...defineObj,
                ...context.define
            };
            for(const param in defineObj){
                let elementProp = element[param];
                if (isFunction2(elementProp) && !isMethod(param, element) && !isVariant(param)) {
                    ref.__exec[param] = elementProp;
                    const execParam2 = elementProp = await exec2(elementProp, element, element.state, element.context, opts);
                    if (execParam2) {
                        elementProp = element[param] = execParam2.parse ? execParam2.parse() : execParam2;
                        ref.__defineCache[param] = elementProp;
                    }
                }
                const execParam = await defineObj[param](elementProp, element, element.state, element.context);
                if (execParam) element[param] = execParam;
            }
            return element;
        };
        var throughUpdatedDefine = async (element, opts)=>{
            const { context: context, define: define, __ref: ref } = element;
            const changes = {};
            let obj = {};
            if (isObject2(define)) obj = {
                ...define
            };
            if (isObject2(context && context.define)) obj = {
                ...obj,
                ...context.define
            };
            for(const param in obj){
                const execParam = ref.__exec[param];
                if (execParam) ref.__defineCache[param] = await execParam(element, element.state, element.context);
                const cached = await exec2(ref.__defineCache[param], element, element.state, element.context, opts);
                const newExecParam = await obj[param](cached, element, element.state, element.context);
                if (newExecParam) element[param] = newExecParam;
            }
            return changes;
        };
        var applyParam = async (param, element, options)=>{
            const { node: node, context: context, __ref: ref } = element;
            const prop = await exec2(element[param], element, element.state, element.context, options);
            const { onlyUpdate: onlyUpdate } = options;
            const DOMQLProperty = REGISTRY[param];
            const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
            const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
            const hasDefine = element.define && element.define[param];
            const hasContextDefine = context && context.define && context.define[param];
            if (!ref.__if) return;
            const hasOnlyUpdate = onlyUpdate ? onlyUpdate === param || element.lookup(onlyUpdate) : true;
            if (isGlobalTransformer && !hasContextDefine && hasOnlyUpdate) {
                if (isFunction2(isGlobalTransformer)) await isGlobalTransformer(prop, element, node, options);
                return;
            }
            return {
                hasDefine: hasDefine,
                hasContextDefine: hasContextDefine
            };
        };
        var propagateEventsFromProps = (element)=>{
            const { props: props, on: on } = element;
            const eventKeysFromProps = Object.keys(props).filter((key)=>key.startsWith("on"));
            eventKeysFromProps.forEach((v)=>{
                const eventName = lowercaseFirstLetter(v.split("on")[1]);
                const origEvent = on[eventName];
                const funcFromProps = props[v];
                if (isFunction2(origEvent)) on[eventName] = (...args)=>{
                    const originalEventRetunrs = origEvent(...args);
                    if (originalEventRetunrs !== false) return funcFromProps(...args);
                };
                else on[eventName] = funcFromProps;
            });
        };
        var createNode = async (element, options)=>{
            let { node: node, tag: tag, __ref: ref } = element;
            let isNewNode;
            if (options.routerContentElement && options.lastElement) {
                if (options.routerContentElement !== options.lastElement.content) return;
            }
            if (!node) {
                isNewNode = true;
                if (!ref.__if) return element;
                if (tag === "shadow") node = element.node = element.parent.node.attachShadow({
                    mode: "open"
                });
                else node = element.node = cacheNode(element);
                await triggerEventOn("attachNode", element, options);
            }
            node.ref = element;
            if (isFunction2(node.setAttribute)) node.setAttribute("key", element.key);
            throughExecProps(element, options);
            await throughInitialDefine(element, options);
            await throughInitialExec(element);
            if (element.tag !== "string" && element.tag !== "fragment") {
                propagateEventsFromProps(element);
                if (isNewNode && isObject2(element.on)) applyEventsOnNode(element, options);
            }
            const keys3 = Object.keys(element);
            for (const param of keys3){
                const value = element[param];
                if (!Object.hasOwnProperty.call(element, param)) continue;
                if (isUndefined2(value) || isMethod(param, element) || isVariant(param) || isObject2(REGISTRY[param])) continue;
                if (param === "onClick") debugger;
                const isElement = await applyParam(param, element, options);
                if (!isElement) continue;
                const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
                if (value && isElement && !hasDefine && !hasContextDefine) {
                    const createAsync = async ()=>{
                        try {
                            const val = await exec2(value, element);
                            await create(val, element, param, options);
                        } catch (error2) {
                            element.error("An unexpected error occurred:", error2);
                        }
                    };
                    if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(async ()=>{
                        await createAsync();
                        if (!options.preventUpdateListener) await triggerEventOn("lazyLoad", element, options);
                    });
                    else await createAsync();
                }
            }
            return element;
        };
        var IGNORE_STATE_PARAMS2 = [
            "update",
            "parse",
            "clean",
            "create",
            "destroy",
            "add",
            "toggle",
            "remove",
            "apply",
            "set",
            "reset",
            "replace",
            "quietReplace",
            "quietUpdate",
            "applyReplace",
            "applyFunction",
            "keys",
            "values",
            "ref",
            "rootUpdate",
            "parentUpdate",
            "parent",
            "__element",
            "__depends",
            "__ref",
            "__children",
            "root",
            "setByPath",
            "setPathCollection",
            "removeByPath",
            "removePathCollection",
            "getByPath"
        ];
        var __defProp22 = Object.defineProperty;
        var __defProps = Object.defineProperties;
        var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
        var __getOwnPropSymbols = Object.getOwnPropertySymbols;
        var __hasOwnProp22 = Object.prototype.hasOwnProperty;
        var __propIsEnum = Object.prototype.propertyIsEnumerable;
        var __defNormalProp = (obj, key, value)=>key in obj ? __defProp22(obj, key, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            }) : obj[key] = value;
        var __spreadValues = (a, b)=>{
            for(var prop in b || (b = {}))if (__hasOwnProp22.call(b, prop)) __defNormalProp(a, prop, b[prop]);
            if (__getOwnPropSymbols) {
                for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
            }
            return a;
        };
        var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
        var parse2 = function() {
            const state2 = this;
            if (isObject2(state2)) {
                const obj = {};
                for(const param in state2)if (!IGNORE_STATE_PARAMS2.includes(param)) obj[param] = state2[param];
                return obj;
            }
        };
        var clean = async function(options = {}) {
            const state2 = this;
            for(const param in state2)if (!IGNORE_STATE_PARAMS2.includes(param) && Object.hasOwnProperty.call(state2, param)) delete state2[param];
            if (!options.preventStateUpdate) await state2.update(state2, __spreadValues({
                replace: true
            }, options));
            return state2;
        };
        var destroy = async function(options = {}) {
            const state2 = this;
            const element = state2.__element;
            const stateKey = element.__ref.__state;
            if (isString2(stateKey)) {
                await element.parent.state.remove(stateKey, __spreadValues({
                    isHoisted: true
                }, options));
                return element.state;
            }
            delete element.state;
            element.state = state2.parent;
            if (state2.parent) delete state2.parent.__children[element.key];
            if (state2.__children) for(const key in state2.__children){
                const child = state2.__children[key];
                if (child.state) {
                    if (isArray2(child.state)) Object.defineProperty(child.state, "parent", {
                        value: state2.parent,
                        enumerable: false,
                        // Set this to true if you want the method to appear in for...in loops
                        configurable: true,
                        // Set this to true if you want to allow redefining/removing the property later
                        writable: true
                    });
                    else Object.setPrototypeOf(child, {
                        parent: state2.parent
                    });
                }
            }
            await element.state.update({}, __spreadValues({
                isHoisted: true
            }, options));
            return element.state;
        };
        var parentUpdate = async function(obj, options = {}) {
            const state2 = this;
            if (!state2 || !state2.parent) return;
            return await state2.parent.update(obj, __spreadValues({
                isHoisted: true
            }, options));
        };
        var rootUpdate = async function(obj, options = {}) {
            const state2 = this;
            if (!state2) return;
            const rootState = state2.__element.__ref.root.state;
            return await rootState.update(obj, __spreadValues({
                isHoisted: false
            }, options));
        };
        var add = async function(value, options = {}) {
            const state2 = this;
            if (isArray2(state2)) {
                await state2.push(value);
                return await state2.update(state2.parse(), __spreadValues({
                    overwrite: true
                }, options));
            } else if (isObject2(state2)) {
                const key = Object.keys(state2).length;
                return await state2.update({
                    [key]: value
                }, options);
            }
        };
        var toggle = async function(key, options = {}) {
            const state2 = this;
            return await state2.update({
                [key]: !Boolean(state2[key])
            }, options);
        };
        var remove2 = async function(key, options = {}) {
            const state2 = this;
            if (isArray2(state2)) removeFromArray(state2, key);
            if (isObject2(state2)) removeFromObject(state2, key);
            if (options.applyReset) return await state2.set(state2.parse(), __spreadValues({
                replace: true
            }, options));
            return await state2.update();
        };
        var set2 = async function(val, options = {}) {
            const state2 = this;
            const value = deepClone2(val);
            await state2.clean(__spreadValues({
                preventStateUpdate: true
            }, options));
            await state2.replace(value, options);
            return state2;
        };
        var setByPath = async function(path, val, options = {}) {
            const state2 = this;
            const value = deepClone2(val);
            if (!options.preventReplace) setInObjectByPath(state2, path, val);
            const update3 = createNestedObject(path, value);
            if (options.preventStateUpdate) return update3;
            return await state2.update(update3, options);
        };
        var setPathCollection = async function(changes, options = {}) {
            const state2 = this;
            const update3 = await changes.reduce(async (promacc, change)=>{
                const acc = await promacc;
                if (change[0] === "update") {
                    const result = await setByPath.call(state2, change[1], change[2], __spreadProps(__spreadValues({}, options), {
                        preventStateUpdate: true
                    }));
                    return overwriteDeep2(acc, result);
                } else if (change[0] === "delete") {
                    await removeByPath.call(state2, change[1], options);
                    const removedFromPath = change[1].slice(0, -1);
                    const removedFromValue = getInObjectByPath(state2, removedFromPath);
                    const result = createNestedObject(removedFromPath, isObject2(removedFromValue) ? {} : []);
                    return deepMerge2(acc, result);
                }
                return acc;
            }, {});
            return await state2.update(update3, options);
        };
        var removeByPath = async function(path, options = {}) {
            const state2 = this;
            removeNestedKeyByPath(state2, path);
            if (options.preventUpdate) return path;
            return await state2.update({}, options);
        };
        var removePathCollection = async function(changes, options = {}) {
            const state2 = this;
            changes.forEach(async (item)=>{
                await removeByPath(item, {
                    preventUpdate: true
                });
            });
            return await state2.update({}, options);
        };
        var getByPath = function(path, options = {}) {
            const state2 = this;
            return getInObjectByPath(state2, path);
        };
        var reset = async function(options = {}) {
            const state2 = this;
            const value = deepClone2(state2.parse());
            return await state2.set(value, __spreadValues({
                replace: true
            }, options));
        };
        var apply = async function(func, options = {}) {
            const state2 = this;
            if (isFunction2(func)) {
                const value = func(state2);
                return await state2.update(value, __spreadValues({
                    replace: true
                }, options));
            }
        };
        var applyReplace = async function(func, options = {}) {
            const state2 = this;
            if (isFunction2(func)) {
                const value = func(state2);
                return await state2.replace(value, options);
            }
        };
        var applyFunction = async function(func, options = {}) {
            const state2 = this;
            if (isFunction2(func)) {
                const result = func(state2);
                if (result instanceof Promise) await result;
                else result;
                return await state2.update(state2.parse(), __spreadValues({
                    replace: true
                }, options));
            }
        };
        var quietUpdate = async function(obj, options = {}) {
            const state2 = this;
            return await state2.update(obj, __spreadValues({
                preventUpdate: true
            }, options));
        };
        var replace = async function(obj, options = {}) {
            const state2 = this;
            for(const param in obj)state2[param] = obj[param];
            return await state2.update(obj, options);
        };
        var quietReplace = async function(obj, options = {}) {
            const state2 = this;
            return await state2.replace(obj, __spreadValues({
                preventUpdate: true
            }, options));
        };
        var keys2 = function(obj, options = {}) {
            const state2 = this;
            return Object.keys(state2);
        };
        var values = function(obj, options = {}) {
            const state2 = this;
            return Object.values(state2);
        };
        var getRootStateInKey = (stateKey, parentState)=>{
            if (!stateKey.includes("~/")) return;
            const arr = stateKey.split("~/");
            if (arr.length > 1) return parentState.root;
        };
        var getParentStateInKey = (stateKey, parentState)=>{
            if (!stateKey.includes("../")) return;
            const arr = stateKey.split("../");
            const arrLength = arr.length - 1;
            for(let i = 0; i < arrLength; i++){
                if (!parentState.parent) return null;
                parentState = parentState.parent;
            }
            return parentState;
        };
        var getChildStateInKey = (stateKey, parentState, options = {})=>{
            const arr = stateKey.split("/");
            const arrLength = arr.length - 1;
            for(let i = 0; i < arrLength; i++){
                const childKey = arr[i];
                const grandChildKey = arr[i + 1];
                if (childKey === "__proto__" || grandChildKey === "__proto__") return;
                let childInParent = parentState[childKey];
                if (!childInParent) childInParent = parentState[childKey] = {};
                if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {};
                stateKey = grandChildKey;
                parentState = childInParent;
            }
            if (options.returnParent) return parentState;
            return parentState[stateKey];
        };
        var findInheritedState = (element, parent2, options = {})=>{
            const ref = element.__ref;
            let stateKey = ref.__state;
            if (!checkIfInherits(element)) return;
            const rootState = getRootStateInKey(stateKey, parent2.state);
            let parentState = parent2.state;
            if (rootState) {
                parentState = rootState;
                stateKey = stateKey.replaceAll("~/", "");
            } else {
                const findGrandParentState = getParentStateInKey(stateKey, parent2.state);
                if (findGrandParentState) {
                    parentState = findGrandParentState;
                    stateKey = stateKey.replaceAll("../", "");
                }
            }
            if (!parentState) return;
            return getChildStateInKey(stateKey, parentState, options);
        };
        var createInheritedState = (element, parent2)=>{
            const ref = element.__ref;
            const inheritedState = findInheritedState(element, parent2);
            if (isUndefined2(inheritedState)) return element.state;
            if (is2(inheritedState)("object", "array")) return deepClone2(inheritedState, {
                exclude: IGNORE_STATE_PARAMS2
            });
            else if (is2(inheritedState)("string", "number", "boolean")) {
                ref.__stateType = typeof inheritedState;
                return {
                    value: inheritedState
                };
            }
            console.warn(ref.__state, "is not present. Replacing with", {});
        };
        var checkIfInherits = (element)=>{
            const ref = element.__ref;
            const stateKey = ref.__state;
            if (stateKey && is2(stateKey)("number", "string", "boolean")) return true;
            return false;
        };
        var createNestedObjectByKeyPath = (path, value)=>{
            if (!path) return value || {};
            const keys3 = path.split("/");
            const obj = {};
            let ref = obj;
            keys3.forEach((key, index)=>{
                ref[key] = index === keys3.length - 1 ? value || {} : {};
                ref = ref[key];
            });
            return obj;
        };
        var __defProp3 = Object.defineProperty;
        var __defProps2 = Object.defineProperties;
        var __getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
        var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
        var __hasOwnProp3 = Object.prototype.hasOwnProperty;
        var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
        var __defNormalProp2 = (obj, key, value)=>key in obj ? __defProp3(obj, key, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            }) : obj[key] = value;
        var __spreadValues2 = (a, b)=>{
            for(var prop in b || (b = {}))if (__hasOwnProp3.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
            if (__getOwnPropSymbols2) {
                for (var prop of __getOwnPropSymbols2(b))if (__propIsEnum2.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
            }
            return a;
        };
        var __spreadProps2 = (a, b)=>__defProps2(a, __getOwnPropDescs2(b));
        var STATE_UPDATE_OPTIONS = {
            overwrite: true,
            preventHoistElementUpdate: false,
            updateByState: true,
            isHoisted: true
        };
        var updateState = async function(obj, options = STATE_UPDATE_OPTIONS) {
            const state2 = this;
            const element = state2.__element;
            if (options.onEach) options.onEach(element, state2, element.context, options);
            if (!options.updateByState) merge2(options, STATE_UPDATE_OPTIONS);
            if (!state2.__element) report("ElementOnStateIsNotDefined");
            if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state2;
            else if (options.preventInheritAtCurrentState) return;
            if (!options.preventBeforeStateUpdateListener) {
                const beforeStateUpdateReturns = await triggerEventOnUpdate("beforeStateUpdate", obj, element, options);
                if (beforeStateUpdateReturns === false) return element;
            }
            applyOverwrite(state2, obj, options);
            const updateIsHoisted = await hoistStateUpdate(state2, obj, options);
            if (updateIsHoisted) return state2;
            await updateDependentState(state2, obj, options);
            const updated = await applyElementUpdate(state2, obj, options);
            if (updated === false) return false;
            if (!options.preventStateUpdateListener) await triggerEventOnUpdate("stateUpdate", obj, element, options);
            return state2;
        };
        var applyOverwrite = (state2, obj, options)=>{
            const { overwrite: overwrite3 } = options;
            if (!overwrite3) return;
            const shallow = overwrite3 === "shallow" || overwrite3 === "shallow-once";
            const merge22 = overwrite3 === "merge";
            if (merge22) {
                deepMerge2(state2, obj, IGNORE_STATE_PARAMS2);
                return;
            }
            const overwriteFunc = shallow ? overwriteShallow : overwriteDeep2;
            if (options.overwrite === "shallow-once") options.overwrite = true;
            overwriteFunc(state2, obj, IGNORE_STATE_PARAMS2);
        };
        var hoistStateUpdate = async (state2, obj, options)=>{
            const element = state2.__element;
            const { parent: parent2, __ref: ref } = element;
            const stateKey = ref == null ? void 0 : ref.__state;
            const stateType = ref == null ? void 0 : ref.__stateType;
            if (!stateKey) return;
            const asksForInherit = checkIfInherits(element);
            const inheritedState = findInheritedState(element, parent2, {
                returnParent: true
            });
            const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
            if (!shouldPropagateState) return;
            const isStringState = stateType === "string" || stateType === "number" || stateType === "boolean";
            const value = isStringState ? state2.value : state2.parse();
            const passedValue = isStringState ? state2.value : obj;
            const findRootState = getRootStateInKey(stateKey, parent2.state);
            const findGrandParentState = getParentStateInKey(stateKey, parent2.state);
            const changesValue = createNestedObjectByKeyPath(stateKey, passedValue);
            const targetParent = findRootState || findGrandParentState || parent2.state;
            if (options.replace) overwriteDeep2(targetParent, changesValue || value);
            await targetParent.update(changesValue, __spreadValues2({
                isHoisted: true,
                preventUpdate: options.preventHoistElementUpdate,
                overwrite: !options.replace
            }, options));
            const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
            if (!options.preventStateUpdateListener && hasNotUpdated) await triggerEventOnUpdate("stateUpdate", obj, element, options);
            return true;
        };
        var updateDependentState = async (state2, obj, options)=>{
            if (!state2.__depends) return;
            for(const el in state2.__depends){
                const dependentState = state2.__depends[el];
                await dependentState.set(state2.parse(), options);
            }
        };
        var applyElementUpdate = async (state2, obj, options)=>{
            const element = state2.__element;
            if (options.preventUpdate !== true) return await element.update({}, __spreadProps2(__spreadValues2({}, options), {
                updateByState: true
            }));
            else if (options.preventUpdate === "recursive") return await element.update({}, __spreadProps2(__spreadValues2({}, options), {
                isHoisted: false,
                updateByState: true,
                preventUpdate: true
            }));
        };
        var __defProp4 = Object.defineProperty;
        var __defProps3 = Object.defineProperties;
        var __getOwnPropDescs3 = Object.getOwnPropertyDescriptors;
        var __getOwnPropSymbols3 = Object.getOwnPropertySymbols;
        var __hasOwnProp4 = Object.prototype.hasOwnProperty;
        var __propIsEnum3 = Object.prototype.propertyIsEnumerable;
        var __defNormalProp3 = (obj, key, value)=>key in obj ? __defProp4(obj, key, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            }) : obj[key] = value;
        var __spreadValues3 = (a, b)=>{
            for(var prop in b || (b = {}))if (__hasOwnProp4.call(b, prop)) __defNormalProp3(a, prop, b[prop]);
            if (__getOwnPropSymbols3) {
                for (var prop of __getOwnPropSymbols3(b))if (__propIsEnum3.call(b, prop)) __defNormalProp3(a, prop, b[prop]);
            }
            return a;
        };
        var __spreadProps3 = (a, b)=>__defProps3(a, __getOwnPropDescs3(b));
        var createState = async function(element, parent2, options) {
            element.state = await applyInitialState(element, parent2, options);
            return element.state;
        };
        var applyInitialState = async function(element, parent2, options) {
            const objectizeState = await checkForTypes(element);
            if (objectizeState === false) return parent2.state || {};
            else element.state = objectizeState;
            const whatInitReturns = await triggerEventOn("stateInit", element, options);
            if (whatInitReturns === false) return element.state;
            if (checkIfInherits(element)) {
                const inheritedState = createInheritedState(element, parent2);
                element.state = isUndefined2(inheritedState) ? {} : inheritedState;
            }
            const dependentState = applyDependentState(element, element.state || parent2.state || {});
            if (dependentState) element.state = dependentState;
            applyMethods(element);
            await triggerEventOn("stateCreated", element, options);
            return element.state;
        };
        var applyDependentState = (element, state2)=>{
            const { __ref: __ref, ref: ref, __element: __element } = state2;
            const origState = exec2(__ref || ref || (__element == null ? void 0 : __element.state), element);
            if (!origState) return;
            const dependentState = deepClone2(origState, IGNORE_STATE_PARAMS2);
            const newDepends = {
                [element.key + Math.random()]: dependentState
            };
            const __depends = isObject2(origState.__depends) ? __spreadValues3(__spreadValues3({}, origState.__depends), newDepends) : newDepends;
            if (Array.isArray(origState)) addProtoToArray(origState, __spreadProps3(__spreadValues3({}, Object.getPrototypeOf(origState)), {
                __depends: __depends
            }));
            else Object.setPrototypeOf(origState, __spreadProps3(__spreadValues3({}, Object.getPrototypeOf(origState)), {
                __depends: __depends
            }));
            return dependentState;
        };
        var checkForTypes = async (element)=>{
            const { state: orig, props: props, __ref: ref } = element;
            const state2 = (props == null ? void 0 : props.state) || orig;
            if (isFunction2(state2)) {
                ref.__state = state2;
                return await exec2(state2, element);
            } else if (is2(state2)("string", "number")) {
                ref.__state = state2;
                return {
                    value: state2
                };
            } else if (state2 === true) {
                ref.__state = element.key;
                return {};
            } else if (state2) {
                ref.__hasRootState = true;
                return state2;
            } else return false;
        };
        var addProtoToArray = (state2, proto)=>{
            for(const key in proto)Object.defineProperty(state2, key, {
                value: proto[key],
                enumerable: false,
                // Set this to true if you want the method to appear in for...in loops
                configurable: true,
                // Set this to true if you want to allow redefining/removing the property later
                writable: true
            });
        };
        var applyMethods = (element)=>{
            const state2 = element.state;
            const ref = element.__ref;
            const proto = {
                clean: clean.bind(state2),
                parse: parse2.bind(state2),
                destroy: destroy.bind(state2),
                update: updateState.bind(state2),
                rootUpdate: rootUpdate.bind(state2),
                parentUpdate: parentUpdate.bind(state2),
                create: createState.bind(state2),
                add: add.bind(state2),
                toggle: toggle.bind(state2),
                remove: remove2.bind(state2),
                apply: apply.bind(state2),
                applyReplace: applyReplace.bind(state2),
                applyFunction: applyFunction.bind(state2),
                set: set2.bind(state2),
                quietUpdate: quietUpdate.bind(state2),
                replace: replace.bind(state2),
                quietReplace: quietReplace.bind(state2),
                reset: reset.bind(state2),
                parent: element.parent.state || state2,
                setByPath: setByPath.bind(state2),
                setPathCollection: setPathCollection.bind(state2),
                removeByPath: removeByPath.bind(state2),
                removePathCollection: removePathCollection.bind(state2),
                getByPath: getByPath.bind(state2),
                keys: keys2.bind(state2),
                values: values.bind(state2),
                __element: element,
                __children: {},
                root: ref.root ? ref.root.state : state2
            };
            if (isArray2(state2)) addProtoToArray(state2, proto);
            else Object.setPrototypeOf(state2, proto);
            if (state2.parent && state2.parent.__children) state2.parent.__children[element.key] = state2;
        };
        var snapshot = {
            snapshotId: createSnapshotId
        };
        var UPDATE_DEFAULT_OPTIONS = {
            stackChanges: false,
            cleanExec: true,
            preventRecursive: false,
            currentSnapshot: false,
            calleeElement: false,
            excludes: METHODS_EXL
        };
        var update2 = async function(params = {}, opts) {
            const calleeElementCache = opts == null ? void 0 : opts.calleeElement;
            const options = deepClone2(typeof opts === "object" ? deepMerge22(opts, UPDATE_DEFAULT_OPTIONS) : UPDATE_DEFAULT_OPTIONS, {
                exclude: [
                    "calleeElement",
                    "updatingCalleeElement"
                ]
            });
            const element = this;
            options.calleeElement = calleeElementCache;
            const { parent: parent2, node: node, key: key } = element;
            const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
            let ref = element.__ref;
            if (!ref) ref = element.__ref = {};
            const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = captureSnapshot(element, options);
            if (snapshotHasUpdated) return false;
            if (checkIfStorm(element, options)) return false;
            if (!options.preventListeners) await triggerEventOn("eventStart", element, options);
            if (!options.preventListeners) await triggerEventOnUpdate("startUpdate", params, element, options);
            if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return false;
            if (!excludes) merge2(options, UPDATE_DEFAULT_OPTIONS);
            if (isString2(params) || isNumber2(params)) params = {
                text: params
            };
            const inheritState = await inheritStateUpdates(element, options);
            if (inheritState === false) return false;
            const ifFails = checkIfOnUpdate(element, parent2, options);
            if (ifFails) return false;
            if (ref.__if && !options.preventPropsUpdate) {
                const hasParentProps = parent2.props && (parent2.props[key] || parent2.props.childProps);
                const hasFunctionInProps = ref.__props.filter((v)=>isFunction2(v));
                const props = params.props || hasParentProps || hasFunctionInProps.length;
                if (props) updateProps(props, element, parent2, options);
            }
            if (!options.preventBeforeUpdateListener && !options.preventListeners) {
                const beforeUpdateReturns = await triggerEventOnUpdate("beforeUpdate", params, element, options);
                if (beforeUpdateReturns === false) return element;
            }
            overwriteDeep2(element, params, {
                exclude: METHODS_EXL
            });
            throughExecProps(element, options);
            await throughUpdatedExec(element, {
                ignore: UPDATE_DEFAULT_OPTIONS
            });
            await throughUpdatedDefine(element, options);
            if (!options.isForced && !options.preventListeners) await triggerEventOn("beforeClassAssign", element, options);
            if (!ref.__if) return false;
            if (!node) return false;
            element.tag !== "fragment" && document.body.contains(node);
            const { preventUpdate: preventUpdate, preventDefineUpdate: preventDefineUpdate, preventContentUpdate: preventContentUpdate, preventStateUpdate: preventStateUpdate, preventRecursive: preventRecursive, preventUpdateListener: preventUpdateListener, preventUpdateAfter: preventUpdateAfter, preventUpdateAfterCount: preventUpdateAfterCount } = options;
            if (preventUpdateAfter) {
                if (isNumber2(preventUpdateAfterCount) && preventUpdateAfter <= preventUpdateAfterCount) return;
                else if (options.preventUpdateAfterCount === void 0) options.preventUpdateAfterCount = 1;
                else options.preventUpdateAfterCount++;
            }
            const keys3 = Object.keys(element);
            for (const param of keys3){
                const prop = element[param];
                if (!Object.hasOwnProperty.call(element, param)) continue;
                const isInPreventUpdate = isArray2(preventUpdate) && preventUpdate.includes(param);
                const isInPreventDefineUpdate = isArray2(preventDefineUpdate) && preventDefineUpdate.includes(param);
                const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
                if (isUndefined2(prop) || isInPreventUpdate || isInPreventDefineUpdate || preventDefineUpdate === true || preventDefineUpdate === param || preventContentUpdate && param === "content" && !hasCollection || (preventStateUpdate && param) === "state" || isMethod(param, element) || isObject2(REGISTRY[param]) || isVariant(param)) continue;
                if (preventStateUpdate === "once") options.preventStateUpdate = false;
                const isElement = await applyParam(param, element, options);
                if (isElement) {
                    const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
                    const canUpdate = isObject2(prop) && !hasDefine && !hasContextDefine && !preventRecursive;
                    if (!canUpdate) continue;
                    const lazyLoad = element.props.lazyLoad || options.lazyLoad;
                    if (options.onEachUpdate) options.onEachUpdate(param, element, element.state, element.context);
                    const childUpdateCall = async ()=>await update2.call(prop, params[prop], {
                            ...options,
                            currentSnapshot: snapshotOnCallee,
                            calleeElement: calleeElement
                        });
                    lazyLoad ? window22.requestAnimationFrame(async ()=>{
                        await childUpdateCall();
                        if (!options.preventUpdateListener) await triggerEventOn("lazyLoad", element, options);
                    }) : await childUpdateCall();
                }
            }
            if (!options.preventListeners) {
                if (!preventUpdateListener) await triggerEventOn("update", element, options);
                await triggerEventOn("eventComplete", element, options);
            }
        };
        var checkIfStorm = (element, options)=>{
            let ref = element.__ref;
            if (!options.updatingCalleeElement) options.updatingCalleeElement = element;
            if (ref.__stormAbortion && !options.allowStorm) {
                const stormAbortion = setTimeout(()=>{
                    delete ref.__stormAbortion;
                    clearTimeout(stormAbortion);
                }, 1e3);
                element.error("Potential storm update detected", options);
                return true;
            }
            if (element === options.updatingCalleeElement && !options.allowStorm) {
                if (ref.__selfCallIteration === void 0) ref.__selfCallIteration = 0;
                else ref.__selfCallIteration++;
                if (ref.__selfCallIteration > 100) {
                    ref.__selfCallIteration = 0;
                    ref.__stormAbortion = true;
                    element.error("Potential self calling loop in update detected", options);
                    return true;
                }
                const stormTimeout = setTimeout(()=>{
                    ref.__selfCallIteration = 0;
                    clearTimeout(stormTimeout);
                }, 350);
            }
        };
        var captureSnapshot = (element, options)=>{
            const ref = element.__ref;
            const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
            const isCallee = calleeElement === element;
            if (!calleeElement || isCallee) {
                const createdStanpshot = snapshot.snapshotId();
                ref.__currentSnapshot = createdStanpshot;
                return [
                    createdStanpshot,
                    element
                ];
            }
            const snapshotOnCallee = calleeElement.__ref.__currentSnapshot;
            if (currentSnapshot < snapshotOnCallee) return [
                snapshotOnCallee,
                calleeElement,
                true
            ];
            return [
                snapshotOnCallee,
                calleeElement
            ];
        };
        var checkIfOnUpdate = (element, parent2, options)=>{
            var _a, _b;
            const ifFn = ((_a = element.props) == null ? void 0 : _a.if) || element.if;
            if (!isFunction2(ifFn) || !parent2) return;
            const ref = element.__ref;
            const ifPassed = ifFn(element, element.state, element.context, options);
            const itWasFalse = ref.__if !== true;
            if (ifPassed) {
                ref.__if = true;
                if (itWasFalse) {
                    delete element.__hash;
                    delete element.__text;
                    delete element.extend;
                    if (!ref.__hasRootState) delete element.state;
                    if (ref.__state) element.state = ref.__state;
                    else if (!ref.__hasRootState) delete element.state;
                    if (element.node) {
                        element.node.remove();
                        delete element.node;
                    }
                    const contentKey = ref.contentElementKey;
                    if (element.$collection || element.$stateCollection || element.$propsCollection) element.removeContent();
                    else if ((_b = element[contentKey]) == null ? void 0 : _b.parseDeep) element[contentKey] = element[contentKey].parseDeep();
                    const previousElement2 = element.previousElement();
                    const previousNode = previousElement2 == null ? void 0 : previousElement2.node;
                    const hasPrevious = previousNode == null ? void 0 : previousNode.parentNode;
                    const nextElement2 = element.nextElement();
                    const nextNode = nextElement2 == null ? void 0 : nextElement2.node;
                    const hasNext = nextNode == null ? void 0 : nextNode.parentNode;
                    const attachOptions = (hasPrevious || hasNext) && {
                        position: hasPrevious ? "after" : hasNext ? "before" : null,
                        node: hasPrevious && previousNode || hasNext && nextNode
                    };
                    delete element.__ref;
                    delete element.parent;
                    const createdElement = create(element, parent2, element.key, OPTIONS.create, attachOptions);
                    if (options.preventUpdate !== true && element.on && isFunction2(element.on.update)) applyEvent(element.on.update, createdElement, createdElement.state);
                    return createdElement;
                }
            } else if (element.node && !ifPassed) {
                element.node.remove();
                delete ref.__if;
            }
        };
        var inheritStateUpdates = async (element, options)=>{
            const { __ref: ref } = element;
            const stateKey = ref.__state;
            const { parent: parent2 } = element;
            const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate } = options;
            if (preventUpdateTriggerStateUpdate) return;
            if (!stateKey && !ref.__hasRootState) {
                element.state = parent2 && parent2.state || {};
                return;
            }
            const keyInParentState = findInheritedState(element, element.parent);
            if (!keyInParentState || options.preventInheritedStateUpdate) return;
            if (!options.preventBeforeStateUpdateListener && !options.preventListeners) {
                const initStateReturns = await triggerEventOnUpdate("beforeStateUpdate", keyInParentState, element, options);
                if (initStateReturns === false) return element;
            }
            const newState = await createStateUpdate(element, parent2, options);
            if (!options.preventStateUpdateListener && !options.preventListeners) await triggerEventOnUpdate("stateUpdate", newState.parse(), element, options);
        };
        var createStateUpdate = async (element, parent2, options)=>{
            const __stateChildren = element.state.__children;
            const newState = await createState(element, parent2, options);
            element.state = newState;
            for(const child in __stateChildren){
                if (newState[child]) newState.__children[child] = __stateChildren[child];
                Object.getPrototypeOf(__stateChildren[child]).parent = newState;
            }
            return newState;
        };
        var addMethods = (element, parent2, options = {})=>{
            const proto = {
                set: set22,
                reset: reset2,
                update: update2,
                variables: variables,
                remove: remove,
                updateContent: updateContent,
                removeContent: removeContent,
                setProps: setProps,
                lookup: lookup,
                lookdown: lookdown,
                lookdownAll: lookdownAll,
                getRef: getRef,
                getRootState: getRootState,
                getRoot: getRoot,
                getRootData: getRootData,
                getRootContext: getRootContext,
                getContext: getContext,
                getPath: getPath,
                setNodeStyles: setNodeStyles,
                spotByPath: spotByPath,
                parse: parse,
                parseDeep: parseDeep,
                keys: keys,
                nextElement: nextElement,
                previousElement: previousElement,
                log: log,
                verbose: verbose,
                warn: warn,
                error: error,
                append: append,
                call: call
            };
            if (element.context.methods) (options.strict ? merge2 : overwrite)(proto, element.context.methods);
            Object.setPrototypeOf(element, proto);
        };
        var create = async (element, parent2, key, options = OPTIONS.create || {}, attachOptions)=>{
            const isValid = validateElement(element, options);
            if (!isValid) {
                error.call(element, "Error while creating element: Not valid type", element, options);
                return;
            }
            cacheOptions(element, options);
            if (checkIfPrimitive(element)) element = applyValueAsText(element, parent2, key);
            element = redefineElement(element, parent2, key, options);
            parent2 = redefineParent(element, parent2, key);
            key = createKey(element, parent2, key);
            const ref = addRef(element, parent2, key);
            ref.__initialProps = deepClone2(element.props);
            applyContext(element, parent2, options);
            applyComponentFromContext(element, parent2, options);
            if (!ref.__skipCreate) applyExtend(element, parent2, options);
            element.key = key;
            if (options.onlyResolveExtends) return await onlyResolveExtends(element, parent2, key, options);
            await triggerEventOn("eventStart", element, options);
            await triggerEventOn("start", element, options);
            switchDefaultOptions(element, parent2, options);
            addCaching(element, parent2, options);
            addMethods(element, parent2, options);
            createScope(element, parent2, options);
            await createState(element, parent2, options);
            if (element.scope === "state") element.scope = element.state;
            createIfConditionFlag(element, parent2);
            createProps(element, parent2, options);
            if (element.scope === "props" || element.scope === true) element.scope = element.props;
            createIfConditionFlag(element, parent2);
            if (element.node && ref.__if) return assignNode(element, parent2, key, attachOptions);
            applyVariant(element, parent2);
            addChildrenIfNotInOriginal(element, parent2, key);
            const onInit = await triggerEventOn("init", element, options);
            if (onInit === false) return element;
            const onEventInit = await triggerEventOn("eventInit", element, options);
            if (onEventInit === false) return element;
            await triggerEventOn("beforeClassAssign", element, options);
            assignKeyAsClassname(element);
            await renderElement(element, parent2, options, attachOptions);
            addElementIntoParentChildren(element, parent2);
            await triggerEventOn("complete", element, options);
            await triggerEventOn("eventComplete", element, options);
            return element;
        };
        var createBasedOnType = (element, parent2, key, options)=>{
            if (element === void 0) {
                if (isNotProduction2()) console.warn(key, "element is undefined in", parent2 && parent2.__ref && parent2.__ref.path);
                return {};
            }
            if (isString2(key) && key.slice(0, false)) {
                if (isNotProduction2()) console.warn(key, "seems like to be in __ref");
            }
            if (element === null) return;
            if (element === true) return {
                text: true
            };
            if (element.__hash) return {
                extend: element
            };
            if (typeof Node !== "undefined" && element instanceof Node || typeof DocumentFragment !== "undefined" && element instanceof DocumentFragment) return {
                node: element
            };
            return element;
        };
        var redefineElement = (element, parent2, key, options)=>{
            const elementWrapper = createBasedOnType(element, parent2, key, options);
            if (options.syntaxv3 || element.props && element.props.syntaxv3 || parent2 && parent2.props && parent2.props.syntaxv3) {
                if (element.props) element.props.syntaxv3 = true;
                else element.syntaxv3 = true;
                return createValidDomqlObjectFromSugar(element, parent2, key, options);
            } else if (checkIfKeyIsComponent(key)) return applyKeyComponentAsExtend(elementWrapper, parent2, key);
            if (checkIfMedia(key)) return applyMediaProps(elementWrapper, parent2, key);
            return elementWrapper;
        };
        var redefineParent = (element, parent2, key, options)=>{
            if (!parent2) return ROOT;
            if (isNode2(parent2)) {
                const parentNodeWrapper = {
                    key: ":root",
                    node: parent2
                };
                ROOT[`${key}_parent`] = parentNodeWrapper;
                return parentNodeWrapper;
            }
            return parent2;
        };
        var validateElement = (value, options)=>{
            if (value == null) return false;
            const t = typeof value;
            if (t === "function" || t === "symbol" || t === "bigint") return false;
            if (Number.isNaN(value) || value === Infinity || value === -Infinity) return false;
            const unsafeGlobals = [
                typeof window !== "undefined" && window,
                typeof document !== "undefined" && document,
                typeof globalThis !== "undefined" && globalThis,
                typeof navigator !== "undefined" && navigator,
                typeof location !== "undefined" && location,
                typeof history !== "undefined" && history,
                typeof screen !== "undefined" && screen,
                typeof frames !== "undefined" && frames,
                typeof parent !== "undefined" && parent,
                typeof self !== "undefined" && self,
                typeof top !== "undefined" && top,
                typeof performance !== "undefined" && performance,
                typeof console !== "undefined" && console,
                typeof indexedDB !== "undefined" && indexedDB,
                typeof caches !== "undefined" && caches,
                typeof localStorage !== "undefined" && localStorage,
                typeof sessionStorage !== "undefined" && sessionStorage,
                typeof crypto !== "undefined" && crypto,
                typeof visualViewport !== "undefined" && visualViewport,
                typeof customElements !== "undefined" && customElements
            ].filter(Boolean);
            if (unsafeGlobals.includes(value)) return false;
            if (typeof EventTarget !== "undefined" && value instanceof EventTarget) return false;
            if (typeof Event !== "undefined" && value instanceof Event) return false;
            if (value === Object.prototype || value === Array.prototype || value === Function.prototype || value === Map.prototype || value === Set.prototype || value === WeakMap.prototype || value === WeakSet.prototype || value === Promise.prototype || value === Symbol.prototype) return false;
            const unsafeConstructors = [
                typeof Worker !== "undefined" && Worker,
                typeof SharedWorker !== "undefined" && SharedWorker,
                typeof MessagePort !== "undefined" && MessagePort,
                typeof BroadcastChannel !== "undefined" && BroadcastChannel,
                typeof ReadableStream !== "undefined" && ReadableStream,
                typeof WritableStream !== "undefined" && WritableStream,
                typeof TransformStream !== "undefined" && TransformStream,
                typeof File !== "undefined" && File,
                typeof Blob !== "undefined" && Blob,
                typeof FormData !== "undefined" && FormData,
                typeof XMLHttpRequest !== "undefined" && XMLHttpRequest,
                typeof AbortController !== "undefined" && AbortController,
                typeof AbortSignal !== "undefined" && AbortSignal
            ].filter(Boolean);
            for (const Ctor of unsafeConstructors){
                if (value instanceof Ctor) return false;
            }
            return true;
        };
        var cacheOptions = (element, options)=>{
            if (options && !OPTIONS.create) {
                OPTIONS.create = options;
                OPTIONS.create.context = element.context || options.context;
            }
        };
        var createKey = (element, parent2, key)=>{
            return (exec2(key, element) || key || element.key || generateKey()).toString();
        };
        var addRef = (element, parent2)=>{
            if (element.__ref) element.__ref.origin = element;
            else element.__ref = {
                origin: element
            };
            return element.__ref;
        };
        var switchDefaultOptions = (element, parent2, options)=>{
            if (Object.keys(options).length) {
                REGISTRY.defaultOptions = options;
                if (options.ignoreChildExtend) delete options.ignoreChildExtend;
            }
        };
        var addElementIntoParentChildren = (element, parent2)=>{
            if (parent2.__ref && parent2.__ref.__children) parent2.__ref.__children.push(element.key);
        };
        var visitedElements = /* @__PURE__ */ new WeakMap();
        var renderElement = async (element, parent2, options, attachOptions)=>{
            var _a, _b, _c, _d;
            if (visitedElements.has(element)) {
                if (isNotProduction2()) console.warn("Cyclic rendering detected:", element.__ref.path);
            }
            visitedElements.set(element, true);
            const { __ref: ref, key: key } = element;
            const createNestedChild = async ()=>{
                const isInfiniteLoopDetected = detectInfiniteLoop(ref.path);
                if (ref.__uniqId || isInfiniteLoopDetected) return;
                await createNode(element, options);
                ref.__uniqId = Math.random();
            };
            if (isNotProduction2()) await createNestedChild();
            else try {
                await createNestedChild();
            } catch (e) {
                const path = ref.path;
                if (path.includes("ComponentsGrid")) path.splice(0, path.indexOf("ComponentsGrid") + 2);
                if (path.includes("demoComponent")) path.splice(0, path.indexOf("demoComponent") + 1);
                const isDemoComponent = (_b = (_a = element.lookup((el)=>el.state.key)) == null ? void 0 : _a.state) == null ? void 0 : _b.key;
                element.warn("Error happened in:", isDemoComponent ? isDemoComponent + " " : "" + path.join("."));
                element.verbose();
                element.error(e, options);
                if ((_c = element.on) == null ? void 0 : _c.error) element.on.error(e, element, element.state, element.context, options);
                if ((_d = element.props) == null ? void 0 : _d.onError) element.props.onError(e, element, element.state, element.context, options);
            }
            if (!ref.__if) {
                parent2[key || element.key] = element;
                return element;
            }
            assignNode(element, parent2, key, attachOptions);
            applyAnimationFrame(element, options);
            await triggerEventOn("render", element, options);
            await triggerEventOn("renderRouter", element, options);
            await triggerEventOn("done", element, options);
            await triggerEventOn("create", element, options);
        };
        var checkIfPrimitive = (element)=>is2(element)("string", "number");
        var applyValueAsText = (element, parent2, key)=>{
            const extendTag = element.extend && element.extend.tag;
            const childExtendTag = parent2.childExtend && parent2.childExtend.tag;
            const childPropsTag = parent2.props.childProps && parent2.props.childProps.tag;
            const isKeyValidHTMLTag = HTML_TAGS.body.indexOf(key) > -1 && key;
            return {
                text: element,
                tag: extendTag || childExtendTag || childPropsTag || isKeyValidHTMLTag || "string"
            };
        };
        var applyContext = (element, parent2, options)=>{
            const forcedOptionsContext = options.context && !ROOT.context && !element.context;
            if (forcedOptionsContext) ROOT.context = options.context;
            if (!element.context) element.context = parent2.context || options.context || ROOT.context;
        };
        var createScope = (element, parent2)=>{
            const { __ref: ref } = element;
            if (!element.scope) element.scope = parent2.scope || ref.root.scope || {};
        };
        var createIfConditionFlag = (element, parent2)=>{
            var _a;
            const { __ref: ref } = element;
            const ifFn = ((_a = element.props) == null ? void 0 : _a.if) || element.if;
            if (isFunction2(ifFn) && !ifFn(element, element.state, element.context)) delete ref.__if;
            else ref.__if = true;
        };
        var addCaching = (element, parent2)=>{
            const { __ref: ref, key: key } = element;
            let { __ref: parentRef } = parent2;
            if (!element.transform) element.transform = {};
            if (!ref.__cached) ref.__cached = {};
            if (!ref.__cachedContent) ref.__cachedContent = null;
            if (!ref.__defineCache) ref.__defineCache = {};
            if (!ref.__exec) ref.__exec = {};
            if (!ref.__execProps) ref.__execProps = {};
            if (!ref.__class) ref.__class = {};
            if (!ref.__classNames) ref.__classNames = {};
            if (!ref.__attr) ref.__attr = {};
            if (!ref.__changes) ref.__changes = [];
            if (!ref.__children) ref.__children = [];
            if (checkIfKeyIsComponent(key)) ref.__componentKey = key.split("_")[0].split(".")[0].split("+")[0];
            const hasRoot = parent2 && parent2.key === ":root";
            if (!ref.root) ref.root = hasRoot ? element : parentRef.root;
            if (!parentRef) parentRef = parent2.ref = {};
            if (!parentRef.path) parentRef.path = [];
            ref.path = parentRef.path.concat(element.key);
        };
        var onlyResolveExtends = async (element, parent2, key, options)=>{
            const { __ref: ref } = element;
            if (!ref.__skipCreate) {
                addCaching(element, parent2);
                addMethods(element, parent2, options);
                createScope(element, parent2);
                createState(element, parent2, options);
                if (element.scope === "state") element.scope = element.state;
                createIfConditionFlag(element, parent2);
                createProps(element, parent2, options);
                if (element.scope === "props" || element.scope === true) element.scope = element.props;
                if (element.node && ref.__if) parent2[key || element.key] = element;
                if (!element.props) element.props = {};
                applyVariant(element, parent2);
                addElementIntoParentChildren(element, parent2);
            }
            if (element.tag !== "string" && element.tag !== "fragment") {
                await throughInitialDefine(element);
                await throughInitialExec(element);
                for(const k in element){
                    if (isUndefined2(element[k]) || isMethod(k, element) || isObject2((REGISTRY.default || REGISTRY)[k]) || isVariant(k)) continue;
                    const hasDefine = element.define && element.define[k];
                    const contextHasDefine = element.context && element.context.define && element.context.define[k];
                    const optionsHasDefine = options.define && options.define[k];
                    if (!ref.__skipCreate && REGISTRY[k] && !optionsHasDefine) continue;
                    else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) create(exec2(element[k], element), element, k, options);
                }
            }
            parent2[key || element.key] = element;
            delete element.update;
            delete element.__element;
            if (element.props) {
                delete element.props.update;
                delete element.props.__element;
            }
            return element;
        };
        var checkIfMedia = (key)=>key.slice(0, 1) === "@";
        var applyMediaProps = (element, parent2, key)=>{
            const { props: props } = element;
            if (props) {
                props.display = "none";
                if (props[key]) props[key].display = props.display;
                else props[key] = {
                    display: props.display || "block"
                };
                return element;
            } else return {
                ...element,
                props: {
                    display: "none",
                    [key]: {
                        display: "block"
                    }
                }
            };
        };
        var resetElement = async (params, element, options)=>{
            if (!options.preventRemove) removeContent(element, options);
            const { __ref: ref } = element;
            const newContent = await create(params, element, ref.contentElementKey || "content", {
                ignoreChildExtend: true,
                ...REGISTRY.defaultOptions,
                ...OPTIONS.create,
                ...options
            });
            ref.__cachedContent = newContent;
        };
        var reset2 = async (options)=>{
            const element = void 0;
            await create(element, element.parent, void 0, {
                ignoreChildExtend: true,
                ...REGISTRY.defaultOptions,
                ...OPTIONS.create,
                ...options
            });
        };
        var set22 = async function(params, options = {}, el) {
            var _a, _b, _c, _d;
            const element = el || this;
            const { __ref: ref } = element;
            if (options.preventContentUpdate || options.preventUpdate && ((_b = (_a = options.preventUpdate).includes) == null ? void 0 : _b.call(_a, "content"))) return;
            if (options.routerContentElement && options.lastElement) {
                if (options.routerContentElement !== options.lastElement.content) return;
            }
            const contentKey = setContentKey(element, options);
            const content = element[contentKey];
            const __contentRef = content && content.__ref;
            const lazyLoad = element.props && element.props.lazyLoad;
            const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection || ((_c = element.props) == null ? void 0 : _c.children);
            if (options.preventContentUpdate === true && !hasCollection) return;
            if (options.forceUpdate && !options.forceReset && (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && deepContains(params, content))) {
                if (!options.preventBeforeUpdateListener && !options.preventListeners) {
                    const beforeUpdateReturns = await triggerEventOnUpdate("beforeUpdate", params, element, options);
                    if (beforeUpdateReturns === false) return element;
                }
                if (content == null ? void 0 : content.update) await content.update({}, options);
                if (!options.preventUpdateListener) await triggerEventOn("update", element, options);
                return;
            }
            if (params) {
                let { childExtend: childExtend, childExtendRecursive: childExtendRecursive, props: props } = params;
                if (!props) props = params.props = {};
                if (!childExtend && element.childExtend) {
                    params.childExtend = element.childExtend;
                    props.ignoreChildExtend = true;
                }
                if (!childExtendRecursive && element.childExtendRecursive) {
                    params.childExtendRecursive = element.childExtendRecursive;
                    props.ignoreChildExtendRecursive = true;
                }
                if (!(props == null ? void 0 : props.childProps) && ((_d = element.props) == null ? void 0 : _d.childProps)) {
                    props.childProps = element.props.childProps;
                    props.ignoreChildProps = true;
                }
                if (lazyLoad) window.requestAnimationFrame(async ()=>{
                    await resetElement(params, element, options);
                    if (!options.preventUpdateListener) await triggerEventOn("lazyLoad", element, options);
                });
                else await resetElement(params, element, options);
            } else if (!options.preventRemove) removeContent(element, options);
            return element;
        };
        var updateContent = async function(params, options) {
            const element = this;
            const ref = element.__ref;
            const contentKey = ref.contentElementKey;
            if (!element[contentKey]) return;
            if (element[contentKey].update) await element[contentKey].update(params, options);
        };
        var removeContent = function(el, opts = {}) {
            const element = el || this;
            const { __ref: ref } = element;
            const contentElementKey = setContentKey(element, opts);
            if (opts.contentElementKey !== "content") opts.contentElementKey = "content";
            const contentElement = element[contentElementKey];
            if (contentElement) {
                if (contentElement.node && element.node) {
                    if (contentElement.tag === "fragment") element.node.innerHTML = "";
                    else {
                        const contentNode = contentElement.node;
                        if (contentNode.parentNode === element.node) element.node.removeChild(contentElement.node);
                    }
                }
                const { __cachedContent: __cachedContent } = ref;
                if (__cachedContent) {
                    if (__cachedContent.tag === "fragment") __cachedContent.parent.node.innerHTML = "";
                    else if (__cachedContent && isFunction2(__cachedContent.remove)) __cachedContent.remove();
                    delete ref.__cachedContent;
                }
                ref.__children.splice(ref.__children.indexOf(contentElementKey), 1);
                delete element[contentElementKey];
            }
        };
        async function setContent(param, element, node, opts) {
            var _a;
            const contentElementKey = setContentKey(element, opts);
            if (!element) this.warn("No element to set content on");
            if (param) {
                if ((_a = element[contentElementKey]) == null ? void 0 : _a.update) await element[contentElementKey].update({}, opts);
                else await set22.call(element, param, opts);
            } else removeContent(element, opts);
        }
        function data(params, element, node) {
            if (params) {
                if (element.props.data) deepMerge2(params, element.props.data);
                if (params.showOnNode) {
                    if (!isObject2(params)) report("HTMLInvalidData", params);
                    for(const dataset in params)if (dataset !== "showOnNode") node.dataset[dataset] = exec2(params[dataset], element);
                }
            }
        }
        function html(param, element, node, opts) {
            var _a;
            const prop = element.call("exec", param, element, element.state, element.context, opts) || element.call("exec", (_a = element == null ? void 0 : element.props) == null ? void 0 : _a.html, element, element.state, element.context, opts);
            const { __ref: __ref } = element;
            if (prop !== __ref.__html) {
                if (node.nodeName === "SVG") node.textContent = prop;
                else node.innerHTML = prop;
                __ref.__html = prop;
            }
        }
        function style(params, element, node) {
            if (params) {
                if (isObject2(params)) map(node.style, params, element);
                else report("HTMLInvalidStyles", params);
            }
        }
        function text(param, element, node, opts) {
            let prop = exec2(param, element, element.state, element.context, opts);
            if (isString2(prop) && prop.includes("{{")) prop = element.call("replaceLiteralsWithObjectFields", prop);
            if (element.tag === "string") node.nodeValue = prop;
            else if (param !== void 0 || param !== null) {
                if (element.__text) {
                    if (element.__text.text === prop) return;
                    element.__text.text = prop;
                    if (element.__text.node) element.__text.node.nodeValue = prop;
                } else create({
                    tag: "string",
                    text: prop
                }, element, "__text");
            }
        }
        async function state(params, element, node, opts) {
            const state2 = exec2(params, element, element.state, element.context, opts);
            if (isObject2(state2)) {
                const keys3 = Object.keys(state2);
                for (const param of keys3){
                    if (IGNORE_STATE_PARAMS2.includes(param)) continue;
                    if (!Object.hasOwnProperty.call(state2, param)) continue;
                }
            }
            return element;
        }
        function scope(params, element, node) {
            if (!isObject2(params)) return;
            for(const scopeItem in params){
                const value = params[scopeItem];
                if (isFunction2(value)) element.scope[scopeItem] = value.bind(element);
                else element.scope[scopeItem] = value;
            }
        }
        var createValidDomqlObjectFromSugar = (el, parent2, key, options)=>{
            const newElem = {
                props: {},
                define: {}
            };
            const allowedKeys = [
                "data",
                "state",
                "attr",
                "if"
            ];
            for(const k in el){
                const value = el[k];
                const isComponent = checkIfKeyIsComponent(k);
                const isRegistry = REGISTRY[k];
                if (isComponent || isRegistry || allowedKeys.includes(k)) newElem[k] = value;
                else newElem.props[k] = value;
            }
            return newElem;
        };
        var overwriteVariant = (element, variant, variantProps)=>{
            let variantElement = element[variant];
            if (!variantElement) return;
            const props = isObject2(variantProps) ? variantProps : {};
            if (isString2(variantElement)) variantElement = {
                extend: [
                    {
                        props: props
                    },
                    variantElement
                ]
            };
            else if (variantElement.extend) variantElement = addAdditionalExtend({
                props: props
            }, variantElement);
            const extendedVariant = applyExtend(variantElement, element.parent);
            const { parent: parent2, ...rest } = extendedVariant;
            return overwriteDeep2(element, rest);
        };
        var applyVariant = (element)=>{
            const { props: props } = element;
            if (!hasVariantProp(element)) return element;
            const { variant: variant } = props;
            overwriteVariant(element, `.${variant}`);
            const elKeys = Object.keys(element).filter((key)=>isVariant(key));
            elKeys.forEach((variant2)=>{
                const slicedVariantElementKey = variant2.slice(1);
                const variantElementProps = props[slicedVariantElementKey];
                if (variantElementProps) overwriteVariant(element, variant2, variantElementProps);
            });
            return element;
        };
        function attr(params, element, node, opts) {
            const { __ref: ref, props: props } = element;
            const { __attr: __attr } = ref;
            if (isNot("object")) report("HTMLInvalidAttr", params);
            if (params) {
                if (props.attr) deepMerge22(params, props.attr);
                for(const attr2 in params){
                    const val = exec2(params[attr2], element, element.state, element.context, opts);
                    if (val !== false && !isUndefined2(val) && !isNull2(val) && node.setAttribute) node.setAttribute(attr2, exec2(val, element, element.state, element.context, opts));
                    else if (node.removeAttribute) node.removeAttribute(attr2);
                    __attr[attr2] = val;
                }
            }
        }
        var REGISTRY = {
            attr: attr,
            style: style,
            text: text,
            html: html,
            content: setContent,
            data: data,
            class: classList,
            state: state,
            scope: scope,
            deps: (param, el)=>param || el.parent.deps,
            extend: {},
            extends: {},
            childExtend: {},
            childExtends: {},
            childExtendsRecursive: {},
            helmet: {},
            metadata: {},
            props: {},
            path: {},
            if: {},
            define: {},
            transform: {},
            __name: {},
            __ref: {},
            __hash: {},
            __text: {},
            nextElement: {},
            previousElement: {},
            key: {},
            tag: {},
            query: {},
            parent: {},
            node: {},
            set: {},
            reset: {},
            update: {},
            error: {},
            warn: {},
            call: {},
            setProps: {},
            remove: {},
            updateContent: {},
            removeContent: {},
            variables: {},
            lookup: {},
            lookdown: {},
            getRef: {},
            getPath: {},
            lookdownAll: {},
            setNodeStyles: {},
            spotByPath: {},
            append: {},
            routes: {},
            keys: {},
            log: {},
            parse: {},
            parseDeep: {},
            on: {},
            component: {},
            context: {},
            $collection: {},
            $stateCollection: {},
            $propsCollection: {},
            $setCollection: {},
            $setStateCollection: {},
            $setPropsCollection: {}
        };
        var parseFilters = {
            elementKeys: [
                "tag",
                "text",
                "style",
                "attr",
                "class",
                "state",
                "props",
                "data",
                "content",
                "html",
                "on",
                "key",
                "extend",
                "childExtend",
                "childExtendsRecursive",
                "scope",
                "query",
                "$collection",
                "$stateCollection",
                "$propsCollection"
            ],
            propsKeys: [
                "__element",
                "update"
            ],
            stateKeys: []
        };
        function temporaryDomqlHack(value) {
            let obj = {
                ...value
            };
            const on = obj.on;
            if (this.call("isObject", on)) {
                delete obj.on;
                const transformedOn = {};
                for(const key in on){
                    const transformedKey = "on" + key.charAt(0).toUpperCase() + key.slice(1);
                    transformedOn[transformedKey] = on[key];
                }
                obj = {
                    ...transformedOn,
                    ...obj
                };
            }
            const props = obj.props;
            if (this.call("isObject", props)) {
                delete obj.props;
                obj = {
                    ...props,
                    ...obj
                };
            }
            const extendObj = {};
            if (obj.extend) {
                extendObj.extends = obj.extend;
                delete obj.extend;
            }
            if (obj.childExtend) {
                extendObj.childExtends = obj.childExtend;
                delete obj.childExtend;
            }
            return {
                ...extendObj,
                ...obj
            };
        }
        function temporaryDomqlHackReverse(value) {
            const obj = {
                ...value
            };
            if (obj.extends) {
                obj.extend = obj.extends;
                delete obj.extends;
            }
            if (obj.childExtends) {
                obj.childExtend = obj.childExtends;
                delete obj.childExtends;
            }
            for(const key in obj){
                const allowed = [
                    "transform",
                    "class"
                ];
                if (REGISTRY[key] && !allowed.includes(key) || /^[A-Z]/.test(key)) continue;
                else {
                    obj.props = obj.props || {};
                    obj.props[key] = obj[key];
                    delete obj[key];
                }
            }
            return obj;
        }
        var copyStringToClipboard = async (str)=>{
            try {
                await navigator.clipboard.writeText(str);
            } catch (err) {
                console.warn("Failed to copy text: ", err);
            }
        };
        var copyJavaScriptToClipboard = async (jsCode)=>{
            try {
                const blob = new Blob([
                    jsCode
                ], {
                    type: "text/javascript"
                });
                const clipboardItem = new window.ClipboardItem({
                    "text/plain": blob
                });
                await navigator.clipboard.write([
                    clipboardItem
                ]);
                console.log("JavaScript code copied to clipboard as text/javascript");
            } catch (err) {
                console.error("Failed to copy JavaScript code: ", err);
            }
        };
        var removeChars = (str)=>{
            return str.replace(/[^a-zA-Z0-9_]/g, "");
        };
        var toCamelCase2 = (str)=>{
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replaceAll(/\s+/g, "");
        };
        var toTitleCase = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        var toDashCase2 = (val)=>val.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
        var toDescriptionCase = (str = "")=>{
            if (typeof str !== "string") return;
            const result = str.replace(/([A-Z])/g, " $1");
            return result.charAt(0).toUpperCase() + result.slice(1);
        };
        var arrayzeValue3 = (val)=>{
            if (isArray2(val)) return val;
            if (isString2(val)) return val.split(" ");
            if (isObject2(val)) return Object.values(val);
            if (isNumber2(val)) return [
                val
            ];
        };
    }
});
// src/index.js
var $16baa215ff216ac9$var$index_exports = {};
$16baa215ff216ac9$var$__export($16baa215ff216ac9$var$index_exports, {
    ANIMATION: ()=>$16baa215ff216ac9$var$ANIMATION,
    BREAKPOINTS: ()=>$16baa215ff216ac9$var$BREAKPOINTS,
    CASES: ()=>$16baa215ff216ac9$var$CASES,
    CLASS: ()=>$16baa215ff216ac9$var$CLASS,
    COLOR: ()=>$16baa215ff216ac9$var$COLOR,
    CONFIG: ()=>$16baa215ff216ac9$var$CONFIG,
    CSS_UNITS: ()=>$16baa215ff216ac9$var$CSS_UNITS,
    CSS_VARS: ()=>$16baa215ff216ac9$var$CSS_VARS,
    DEVICES: ()=>$16baa215ff216ac9$var$DEVICES,
    DOCUMENT: ()=>$16baa215ff216ac9$var$DOCUMENT,
    FACTORY: ()=>$16baa215ff216ac9$var$FACTORY,
    FONT: ()=>$16baa215ff216ac9$var$FONT,
    FONT_FACE: ()=>$16baa215ff216ac9$var$FONT_FACE,
    FONT_FAMILY: ()=>$16baa215ff216ac9$var$FONT_FAMILY,
    FONT_FAMILY_TYPES: ()=>$16baa215ff216ac9$var$FONT_FAMILY_TYPES,
    GRADIENT: ()=>$16baa215ff216ac9$var$GRADIENT,
    GRID: ()=>$16baa215ff216ac9$var$GRID,
    ICONS: ()=>$16baa215ff216ac9$var$ICONS,
    MEDIA: ()=>$16baa215ff216ac9$var$MEDIA,
    RESET: ()=>$16baa215ff216ac9$var$RESET,
    SEMANTIC_ICONS: ()=>$16baa215ff216ac9$var$SEMANTIC_ICONS,
    SEQUENCE: ()=>$16baa215ff216ac9$var$SEQUENCE,
    SHADOW: ()=>$16baa215ff216ac9$var$SHADOW,
    SPACING: ()=>$16baa215ff216ac9$var$SPACING,
    SVG: ()=>$16baa215ff216ac9$var$SVG,
    SVG_DATA: ()=>$16baa215ff216ac9$var$SVG_DATA,
    TEMPLATES: ()=>$16baa215ff216ac9$var$TEMPLATES,
    THEME: ()=>$16baa215ff216ac9$var$THEME,
    TIMING: ()=>$16baa215ff216ac9$var$TIMING,
    TYPOGRAPHY: ()=>$16baa215ff216ac9$var$TYPOGRAPHY,
    UNIT: ()=>$16baa215ff216ac9$var$UNIT,
    VALUE_TRANSFORMERS: ()=>$16baa215ff216ac9$var$VALUE_TRANSFORMERS,
    activateConfig: ()=>$16baa215ff216ac9$var$activateConfig,
    appendSVGSprite: ()=>$16baa215ff216ac9$var$appendSVGSprite,
    appendSvgIconsSprite: ()=>$16baa215ff216ac9$var$appendSvgIconsSprite,
    applyDocument: ()=>$16baa215ff216ac9$var$applyDocument,
    applyHeadings: ()=>$16baa215ff216ac9$var$applyHeadings,
    applyMediaSequenceVars: ()=>$16baa215ff216ac9$var$applyMediaSequenceVars,
    applyReset: ()=>$16baa215ff216ac9$var$applyReset,
    applySequenceGlobalVars: ()=>$16baa215ff216ac9$var$applySequenceGlobalVars,
    applySequenceVars: ()=>$16baa215ff216ac9$var$applySequenceVars,
    applySpacingSequence: ()=>$16baa215ff216ac9$var$applySpacingSequence,
    applyTimingSequence: ()=>$16baa215ff216ac9$var$applyTimingSequence,
    applyTypographySequence: ()=>$16baa215ff216ac9$var$applyTypographySequence,
    changeLightness: ()=>$16baa215ff216ac9$var$changeLightness,
    checkIfBoxSize: ()=>$16baa215ff216ac9$var$checkIfBoxSize,
    colorStringToRgbaArray: ()=>$16baa215ff216ac9$var$colorStringToRgbaArray,
    convertSvgToSymbol: ()=>$16baa215ff216ac9$var$convertSvgToSymbol,
    findHeadingLetter: ()=>$16baa215ff216ac9$var$findHeadingLetter,
    findHeadings: ()=>$16baa215ff216ac9$var$findHeadings,
    generateSequence: ()=>$16baa215ff216ac9$var$generateSequence,
    generateSequencePosition: ()=>$16baa215ff216ac9$var$generateSequencePosition,
    generateSprite: ()=>$16baa215ff216ac9$var$generateSprite,
    generateSubSequence: ()=>$16baa215ff216ac9$var$generateSubSequence,
    getActiveConfig: ()=>$16baa215ff216ac9$var$getActiveConfig,
    getColor: ()=>$16baa215ff216ac9$var$getColor,
    getColorShade: ()=>$16baa215ff216ac9$var$getColorShade,
    getDefaultOrFirstKey: ()=>$16baa215ff216ac9$var$getDefaultOrFirstKey,
    getFnPrefixAndValue: ()=>$16baa215ff216ac9$var$getFnPrefixAndValue,
    getFontFace: ()=>$16baa215ff216ac9$var$getFontFace,
    getFontFaceEach: ()=>$16baa215ff216ac9$var$getFontFaceEach,
    getFontFaceEachString: ()=>$16baa215ff216ac9$var$getFontFaceEachString,
    getFontFaceString: ()=>$16baa215ff216ac9$var$getFontFaceString,
    getFontFamily: ()=>$16baa215ff216ac9$var$getFontFamily,
    getFontFormat: ()=>$16baa215ff216ac9$var$getFontFormat,
    getFontSizeByKey: ()=>$16baa215ff216ac9$var$getFontSizeByKey,
    getMediaColor: ()=>$16baa215ff216ac9$var$getMediaColor,
    getMediaTheme: ()=>$16baa215ff216ac9$var$getMediaTheme,
    getRgbTone: ()=>$16baa215ff216ac9$var$getRgbTone,
    getSequenceValue: ()=>$16baa215ff216ac9$var$getSequenceValue,
    getSequenceValueBySymbols: ()=>$16baa215ff216ac9$var$getSequenceValueBySymbols,
    getSequenceValuePropertyPair: ()=>$16baa215ff216ac9$var$getSequenceValuePropertyPair,
    getShadow: ()=>$16baa215ff216ac9$var$getShadow,
    getSpacingBasedOnRatio: ()=>$16baa215ff216ac9$var$getSpacingBasedOnRatio,
    getSpacingByKey: ()=>$16baa215ff216ac9$var$getSpacingByKey,
    getSubratio: ()=>$16baa215ff216ac9$var$getSubratio,
    getSubratioDifference: ()=>$16baa215ff216ac9$var$getSubratioDifference,
    getTheme: ()=>$16baa215ff216ac9$var$getTheme,
    getTimingByKey: ()=>$16baa215ff216ac9$var$getTimingByKey,
    getTimingFunction: ()=>$16baa215ff216ac9$var$getTimingFunction,
    hexToRgb: ()=>$16baa215ff216ac9$var$hexToRgb,
    hexToRgbArray: ()=>$16baa215ff216ac9$var$hexToRgbArray,
    hexToRgba: ()=>$16baa215ff216ac9$var$hexToRgba,
    hslToRgb: ()=>$16baa215ff216ac9$var$hslToRgb,
    isGoogleFontsUrl: ()=>$16baa215ff216ac9$var$isGoogleFontsUrl,
    isScalingUnit: ()=>$16baa215ff216ac9$var$isScalingUnit,
    mixTwoColors: ()=>$16baa215ff216ac9$var$mixTwoColors,
    mixTwoRgb: ()=>$16baa215ff216ac9$var$mixTwoRgb,
    mixTwoRgba: ()=>$16baa215ff216ac9$var$mixTwoRgba,
    numToLetterMap: ()=>$16baa215ff216ac9$var$numToLetterMap,
    opacify: ()=>$16baa215ff216ac9$var$opacify,
    returnSubThemeOrDefault: ()=>$16baa215ff216ac9$var$returnSubThemeOrDefault,
    rgbArrayToHex: ()=>$16baa215ff216ac9$var$rgbArrayToHex,
    rgbToHSL: ()=>$16baa215ff216ac9$var$rgbToHSL,
    rgbToHex: ()=>$16baa215ff216ac9$var$rgbToHex,
    runThroughMedia: ()=>$16baa215ff216ac9$var$runThroughMedia,
    scratchSystem: ()=>$16baa215ff216ac9$var$system_exports,
    scratchUtils: ()=>$16baa215ff216ac9$var$utils_exports,
    set: ()=>$16baa215ff216ac9$var$set,
    setActiveConfig: ()=>$16baa215ff216ac9$var$setActiveConfig,
    setColor: ()=>$16baa215ff216ac9$var$setColor,
    setCustomFont: ()=>$16baa215ff216ac9$var$setCustomFont,
    setCustomFontMedia: ()=>$16baa215ff216ac9$var$setCustomFontMedia,
    setEach: ()=>$16baa215ff216ac9$var$setEach,
    setFont: ()=>$16baa215ff216ac9$var$setFont,
    setFontFamily: ()=>$16baa215ff216ac9$var$setFontFamily,
    setFontImport: ()=>$16baa215ff216ac9$var$setFontImport,
    setGradient: ()=>$16baa215ff216ac9$var$setGradient,
    setInCustomFontMedia: ()=>$16baa215ff216ac9$var$setInCustomFontMedia,
    setMediaTheme: ()=>$16baa215ff216ac9$var$setMediaTheme,
    setSVG: ()=>$16baa215ff216ac9$var$setSVG,
    setScalingVar: ()=>$16baa215ff216ac9$var$setScalingVar,
    setShadow: ()=>$16baa215ff216ac9$var$setShadow,
    setSubScalingVar: ()=>$16baa215ff216ac9$var$setSubScalingVar,
    setSvgIcon: ()=>$16baa215ff216ac9$var$setSvgIcon,
    setTheme: ()=>$16baa215ff216ac9$var$setTheme,
    setValue: ()=>$16baa215ff216ac9$var$setValue,
    setVariables: ()=>$16baa215ff216ac9$var$setVariables,
    splitSpacedValue: ()=>$16baa215ff216ac9$var$splitSpacedValue,
    splitTransition: ()=>$16baa215ff216ac9$var$splitTransition,
    transformBackgroundImage: ()=>$16baa215ff216ac9$var$transformBackgroundImage,
    transformBorder: ()=>$16baa215ff216ac9$var$transformBorder,
    transformBoxShadow: ()=>$16baa215ff216ac9$var$transformBoxShadow,
    transformDuration: ()=>$16baa215ff216ac9$var$transformDuration,
    transformShadow: ()=>$16baa215ff216ac9$var$transformShadow,
    transformSize: ()=>$16baa215ff216ac9$var$transformSize,
    transformSizeRatio: ()=>$16baa215ff216ac9$var$transformSizeRatio,
    transformTextStroke: ()=>$16baa215ff216ac9$var$transformTextStroke,
    transformTransition: ()=>$16baa215ff216ac9$var$transformTransition,
    transfromGap: ()=>$16baa215ff216ac9$var$transfromGap
});
$16baa215ff216ac9$exports = $16baa215ff216ac9$var$__toCommonJS($16baa215ff216ac9$var$index_exports);
// src/utils/index.js
var $16baa215ff216ac9$var$utils_exports = {};
$16baa215ff216ac9$var$__export($16baa215ff216ac9$var$utils_exports, {
    CSS_UNITS: ()=>$16baa215ff216ac9$var$CSS_UNITS,
    applyMediaSequenceVars: ()=>$16baa215ff216ac9$var$applyMediaSequenceVars,
    applySequenceGlobalVars: ()=>$16baa215ff216ac9$var$applySequenceGlobalVars,
    applySequenceVars: ()=>$16baa215ff216ac9$var$applySequenceVars,
    changeLightness: ()=>$16baa215ff216ac9$var$changeLightness,
    colorStringToRgbaArray: ()=>$16baa215ff216ac9$var$colorStringToRgbaArray,
    convertSvgToSymbol: ()=>$16baa215ff216ac9$var$convertSvgToSymbol,
    findHeadingLetter: ()=>$16baa215ff216ac9$var$findHeadingLetter,
    findHeadings: ()=>$16baa215ff216ac9$var$findHeadings,
    generateSequence: ()=>$16baa215ff216ac9$var$generateSequence,
    generateSequencePosition: ()=>$16baa215ff216ac9$var$generateSequencePosition,
    generateSprite: ()=>$16baa215ff216ac9$var$generateSprite,
    generateSubSequence: ()=>$16baa215ff216ac9$var$generateSubSequence,
    getColorShade: ()=>$16baa215ff216ac9$var$getColorShade,
    getDefaultOrFirstKey: ()=>$16baa215ff216ac9$var$getDefaultOrFirstKey,
    getFnPrefixAndValue: ()=>$16baa215ff216ac9$var$getFnPrefixAndValue,
    getFontFace: ()=>$16baa215ff216ac9$var$getFontFace,
    getFontFaceEach: ()=>$16baa215ff216ac9$var$getFontFaceEach,
    getFontFaceEachString: ()=>$16baa215ff216ac9$var$getFontFaceEachString,
    getFontFaceString: ()=>$16baa215ff216ac9$var$getFontFaceString,
    getFontFormat: ()=>$16baa215ff216ac9$var$getFontFormat,
    getRgbTone: ()=>$16baa215ff216ac9$var$getRgbTone,
    getSequenceValue: ()=>$16baa215ff216ac9$var$getSequenceValue,
    getSequenceValueBySymbols: ()=>$16baa215ff216ac9$var$getSequenceValueBySymbols,
    getSequenceValuePropertyPair: ()=>$16baa215ff216ac9$var$getSequenceValuePropertyPair,
    getSubratio: ()=>$16baa215ff216ac9$var$getSubratio,
    getSubratioDifference: ()=>$16baa215ff216ac9$var$getSubratioDifference,
    hexToRgb: ()=>$16baa215ff216ac9$var$hexToRgb,
    hexToRgbArray: ()=>$16baa215ff216ac9$var$hexToRgbArray,
    hexToRgba: ()=>$16baa215ff216ac9$var$hexToRgba,
    hslToRgb: ()=>$16baa215ff216ac9$var$hslToRgb,
    isGoogleFontsUrl: ()=>$16baa215ff216ac9$var$isGoogleFontsUrl,
    isScalingUnit: ()=>$16baa215ff216ac9$var$isScalingUnit,
    mixTwoColors: ()=>$16baa215ff216ac9$var$mixTwoColors,
    mixTwoRgb: ()=>$16baa215ff216ac9$var$mixTwoRgb,
    mixTwoRgba: ()=>$16baa215ff216ac9$var$mixTwoRgba,
    numToLetterMap: ()=>$16baa215ff216ac9$var$numToLetterMap,
    opacify: ()=>$16baa215ff216ac9$var$opacify,
    returnSubThemeOrDefault: ()=>$16baa215ff216ac9$var$returnSubThemeOrDefault,
    rgbArrayToHex: ()=>$16baa215ff216ac9$var$rgbArrayToHex,
    rgbToHSL: ()=>$16baa215ff216ac9$var$rgbToHSL,
    rgbToHex: ()=>$16baa215ff216ac9$var$rgbToHex,
    setCustomFont: ()=>$16baa215ff216ac9$var$setCustomFont,
    setCustomFontMedia: ()=>$16baa215ff216ac9$var$setCustomFontMedia,
    setFontImport: ()=>$16baa215ff216ac9$var$setFontImport,
    setInCustomFontMedia: ()=>$16baa215ff216ac9$var$setInCustomFontMedia,
    setScalingVar: ()=>$16baa215ff216ac9$var$setScalingVar,
    setSubScalingVar: ()=>$16baa215ff216ac9$var$setSubScalingVar,
    setVariables: ()=>$16baa215ff216ac9$var$setVariables
});
// src/utils/unit.js
var $16baa215ff216ac9$var$isScalingUnit = (unit)=>{
    return unit === "em" || unit === "rem" || unit === "vw" || unit === "vh" || unit === "vmax" || unit === "vmin";
};
var $16baa215ff216ac9$var$CSS_UNITS = [
    // Absolute
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    // Font-relative
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    // Viewport-relative
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    // Container query units
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    // Angle
    "deg",
    "rad",
    "grad",
    "turn",
    // Time
    "s",
    "ms",
    // Resolution
    "dpi",
    "dpcm",
    "dppx",
    // Grid fractional
    "fr",
    "auto"
];
// ../../../domql/packages/utils/env.js
var $16baa215ff216ac9$var$NODE_ENV = "development";
var $16baa215ff216ac9$var$isProduction = (env = $16baa215ff216ac9$var$NODE_ENV)=>env === "production";
var $16baa215ff216ac9$var$isNotProduction = (env = $16baa215ff216ac9$var$NODE_ENV)=>!$16baa215ff216ac9$var$isProduction(env);
// ../../../domql/packages/utils/globals.js
var $16baa215ff216ac9$var$window2 = globalThis;
var $16baa215ff216ac9$var$document2 = $16baa215ff216ac9$var$window2.document;
// ../../../domql/packages/utils/node.js
var $16baa215ff216ac9$var$isDOMNode = (obj)=>{
    return typeof $16baa215ff216ac9$var$window2 !== "undefined" && (obj instanceof $16baa215ff216ac9$var$window2.Node || obj instanceof $16baa215ff216ac9$var$window2.Window || obj === $16baa215ff216ac9$var$window2 || obj === document);
};
// ../../../domql/packages/utils/types.js
var $16baa215ff216ac9$var$isObject = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object" && arg.constructor === Object;
};
var $16baa215ff216ac9$var$isString = (arg)=>typeof arg === "string";
var $16baa215ff216ac9$var$isNumber = (arg)=>typeof arg === "number";
var $16baa215ff216ac9$var$isFunction = (arg)=>typeof arg === "function";
var $16baa215ff216ac9$var$isBoolean = (arg)=>arg === true || arg === false;
var $16baa215ff216ac9$var$isNull = (arg)=>arg === null;
var $16baa215ff216ac9$var$isArray = (arg)=>Array.isArray(arg);
var $16baa215ff216ac9$var$isDate = (d)=>d instanceof Date;
var $16baa215ff216ac9$var$isObjectLike = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object";
};
var $16baa215ff216ac9$var$isDefined = (arg)=>{
    return $16baa215ff216ac9$var$isObject(arg) || $16baa215ff216ac9$var$isObjectLike(arg) || $16baa215ff216ac9$var$isString(arg) || $16baa215ff216ac9$var$isNumber(arg) || $16baa215ff216ac9$var$isFunction(arg) || $16baa215ff216ac9$var$isArray(arg) || $16baa215ff216ac9$var$isObjectLike(arg) || $16baa215ff216ac9$var$isBoolean(arg) || $16baa215ff216ac9$var$isDate(arg) || $16baa215ff216ac9$var$isNull(arg);
};
var $16baa215ff216ac9$var$isUndefined = (arg)=>{
    return arg === void 0;
};
// ../../../domql/packages/utils/array.js
var $16baa215ff216ac9$var$mergeArray = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>$16baa215ff216ac9$var$deepMerge(a, $16baa215ff216ac9$var$deepClone(c, {
            exclude: exclude
        }), exclude), {});
};
// ../../../domql/packages/utils/object.js
function $16baa215ff216ac9$var$exec(param, element, state, context, opts = {}) {
    if (!element) element = this;
    if ($16baa215ff216ac9$var$isFunction(param)) try {
        const result = param.call(element, element, state || element.state, context || element.context);
        if (result && typeof result.then === "function") return result;
        return result;
    } catch (e) {
        element.log(param);
        element.warn("Error executing function", e, opts);
    }
    return param;
}
var $16baa215ff216ac9$var$merge = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === void 0) element[e] = objProp;
    }
    return element;
};
var $16baa215ff216ac9$var$deepMerge = (element, extend, excludeFrom = [], level = Infinity)=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ($16baa215ff216ac9$var$isObjectLike(elementProp) && $16baa215ff216ac9$var$isObjectLike(extendProp)) {
            if (level > 0) $16baa215ff216ac9$var$deepMerge(elementProp, extendProp, excludeFrom, level - 1);
            else for(const k in extendProp){
                if (excludeFrom.includes(k) || elementProp[k] !== void 0) continue;
                elementProp[k] = extendProp[k];
            }
        } else if (elementProp === void 0) element[e] = extendProp;
    }
    return element;
};
var $16baa215ff216ac9$var$deepClone = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = /* @__PURE__ */ new WeakMap(), handleExtend: handleExtend = false } = options;
    const contentWindow = targetWindow || $16baa215ff216ac9$var$window2 || globalThis;
    if (!$16baa215ff216ac9$var$isObjectLike(obj) || $16baa215ff216ac9$var$isDOMNode(obj)) return obj;
    if (visited.has(obj)) return visited.get(obj);
    const clone = contentWindow ? $16baa215ff216ac9$var$isArray(obj) ? new contentWindow.Array() : new contentWindow.Object() : $16baa215ff216ac9$var$isArray(obj) ? [] : {};
    visited.set(obj, clone);
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        if (exclude.includes(key) || key.startsWith("__") || key === "__proto__") continue;
        let value = obj[key];
        if (cleanUndefined && $16baa215ff216ac9$var$isUndefined(value) || cleanNull && $16baa215ff216ac9$var$isNull(value)) continue;
        if ($16baa215ff216ac9$var$isDOMNode(value)) {
            clone[key] = value;
            continue;
        }
        if (handleExtend && key === "extend" && $16baa215ff216ac9$var$isArray(value)) {
            clone[key] = $16baa215ff216ac9$var$mergeArray(value, exclude);
            continue;
        }
        if ($16baa215ff216ac9$var$isFunction(value) && options.window) {
            clone[key] = contentWindow.eval("(" + value.toString() + ")");
            continue;
        }
        if ((value == null ? void 0 : value.__ref) && (value == null ? void 0 : value.node)) value = value.parseDeep();
        if (value == null ? void 0 : value.__element) value = value.parse();
        if ($16baa215ff216ac9$var$isObjectLike(value)) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            clone[key] = $16baa215ff216ac9$var$deepClone(value, {
                ...options,
                visited: visited
            });
        } else clone[key] = value;
    }
    return clone;
};
var $16baa215ff216ac9$var$overwriteDeep = (obj, params, opts = {}, visited = /* @__PURE__ */ new WeakMap())=>{
    const excl = opts.exclude || [];
    const forcedExclude = opts.preventForce ? [] : [
        "node",
        "window"
    ];
    if (!$16baa215ff216ac9$var$isObjectLike(obj) || !$16baa215ff216ac9$var$isObjectLike(params) || $16baa215ff216ac9$var$isDOMNode(obj) || $16baa215ff216ac9$var$isDOMNode(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    for(const e in params){
        if (!Object.hasOwnProperty.call(params, e)) continue;
        if (excl.includes(e) || forcedExclude && e.startsWith("__")) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ($16baa215ff216ac9$var$isDOMNode(paramsProp)) obj[e] = paramsProp;
        else if ($16baa215ff216ac9$var$isObjectLike(objProp) && $16baa215ff216ac9$var$isObjectLike(paramsProp)) obj[e] = $16baa215ff216ac9$var$overwriteDeep(objProp, paramsProp, opts, visited);
        else if (paramsProp !== void 0) obj[e] = paramsProp;
    }
    return obj;
};
// ../../../domql/packages/utils/cookie.js
var $16baa215ff216ac9$var$isMobile = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
// src/utils/color.js
var $16baa215ff216ac9$var$colorStringToRgbaArray = (color)=>{
    if (color === "") return [
        0,
        0,
        0,
        0
    ];
    if (color.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    if (color[0] === "#") {
        if (color.length < 7) color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : "");
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    if (color.indexOf("rgb") === -1) {
        if ($16baa215ff216ac9$var$document2 && $16baa215ff216ac9$var$window2) {
            const elem = $16baa215ff216ac9$var$document2.body.appendChild($16baa215ff216ac9$var$document2.createElement("fictum"));
            const flag = "rgb(1, 2, 3)";
            elem.style.color = flag;
            if (elem.style.color !== flag) {
                $16baa215ff216ac9$var$document2.body.removeChild(elem);
                return;
            }
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === "") {
                $16baa215ff216ac9$var$document2.body.removeChild(elem);
                return [
                    0,
                    0,
                    0,
                    0
                ];
            }
            color = $16baa215ff216ac9$var$window2.getComputedStyle(elem).color;
            $16baa215ff216ac9$var$document2.body.removeChild(elem);
        }
    }
    if (color.indexOf("rgb") === 0) {
        if (color.indexOf("rgba") === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a);
    }
    return [
        0,
        0,
        0,
        0
    ];
};
var $16baa215ff216ac9$var$mixTwoColors = (colorA, colorB, range = 0.5)=>{
    colorA = $16baa215ff216ac9$var$colorStringToRgbaArray(colorA);
    colorB = $16baa215ff216ac9$var$colorStringToRgbaArray(colorB);
    return $16baa215ff216ac9$var$mixTwoRgba(colorA, colorB, range);
};
var $16baa215ff216ac9$var$hexToRgb = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
var $16baa215ff216ac9$var$hexToRgbArray = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
var $16baa215ff216ac9$var$rgbToHex = (r, g, b)=>{
    return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
var $16baa215ff216ac9$var$rgbArrayToHex = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
var $16baa215ff216ac9$var$hexToRgba = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
var $16baa215ff216ac9$var$mixTwoRgb = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
var $16baa215ff216ac9$var$changeLightness = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
var $16baa215ff216ac9$var$rgbToHSL = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n);
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
var $16baa215ff216ac9$var$hslToRgb = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
var $16baa215ff216ac9$var$getColorShade = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 255) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 255) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 16777216).toString(16).slice(1);
};
var $16baa215ff216ac9$var$mixTwoRgba = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
var $16baa215ff216ac9$var$opacify = (color, opacity)=>{
    const arr = $16baa215ff216ac9$var$colorStringToRgbaArray(color);
    if (!arr) {
        if ($16baa215ff216ac9$var$isNotProduction()) console.warn(color + " color is not rgba");
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
var $16baa215ff216ac9$var$getRgbTone = (rgb, tone)=>{
    if ($16baa215ff216ac9$var$isString(rgb) && rgb.includes("rgb")) rgb = $16baa215ff216ac9$var$colorStringToRgbaArray(rgb).join(", ");
    if ($16baa215ff216ac9$var$isString(rgb)) rgb = rgb.split(",").map((v)=>parseFloat(v.trim()));
    if ($16baa215ff216ac9$var$isNumber(tone)) tone += "";
    const toHex = $16baa215ff216ac9$var$rgbArrayToHex(rgb);
    const abs = tone.slice(0, 1);
    if (abs === "-" || abs === "+") {
        const colorShade = $16baa215ff216ac9$var$getColorShade(toHex, parseFloat(tone));
        return $16baa215ff216ac9$var$hexToRgbArray(colorShade).join(", ");
    } else {
        const [r, g, b] = rgb;
        const hsl = $16baa215ff216ac9$var$rgbToHSL(r, g, b);
        const [h, s, l] = hsl;
        const newRgb = $16baa215ff216ac9$var$hslToRgb(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};
// src/utils/theme.js
var $16baa215ff216ac9$var$returnSubThemeOrDefault = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};
// src/utils/font.js
var $16baa215ff216ac9$var$getDefaultOrFirstKey = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
var $16baa215ff216ac9$var$getFontFormat = (url)=>{
    const ext = url.split(/[#?]/)[0].split(".").pop().trim();
    if ([
        "woff2",
        "woff",
        "ttf",
        "otf",
        "eot"
    ].includes(ext)) return ext;
    return null;
};
var $16baa215ff216ac9$var$isGoogleFontsUrl = (url)=>url && (url.includes("fonts.googleapis.com") || url.includes("fonts.gstatic.com"));
var $16baa215ff216ac9$var$setFontImport = (url)=>`@import url('${url}');`;
var $16baa215ff216ac9$var$setInCustomFontMedia = (str)=>`@font-face { ${str} }`;
var $16baa215ff216ac9$var$setCustomFont = (name, url, weight, options = {})=>{
    const format = $16baa215ff216ac9$var$getFontFormat(url);
    const formatStr = format ? ` format('${format}')` : "";
    return `
  font-family: '${name}';
  font-style: normal;${weight ? `
  font-weight: ${weight};` : ""}${options.fontStretch ? `
  font-stretch: ${options.fontStretch};` : ""}${options.fontDisplay ? `
  font-display: ${options.fontDisplay};` : ""}
  src: url('${url}')${formatStr};`;
};
var $16baa215ff216ac9$var$setCustomFontMedia = (name, url, weight, options)=>`@font-face {${$16baa215ff216ac9$var$setCustomFont(name, url, weight, options)}
}`;
var $16baa215ff216ac9$var$getFontFaceEach = (name, weights)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        return $16baa215ff216ac9$var$setCustomFont(name, url, fontWeight);
    });
};
var $16baa215ff216ac9$var$getFontFace = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$16baa215ff216ac9$var$getFontFaceEach(key, LIBRARY[key].value));
};
var $16baa215ff216ac9$var$getFontFaceEachString = (name, weights)=>{
    if (weights && weights.isVariable) {
        if ($16baa215ff216ac9$var$isGoogleFontsUrl(weights.url)) return $16baa215ff216ac9$var$setFontImport(weights.url);
        return $16baa215ff216ac9$var$setCustomFontMedia(name, weights.url, weights.fontWeight, {
            fontStretch: weights.fontStretch,
            fontDisplay: weights.fontDisplay || "swap"
        });
    }
    const isArr = weights[0];
    if (isArr) return $16baa215ff216ac9$var$getFontFaceEach(name, weights).map($16baa215ff216ac9$var$setInCustomFontMedia);
    return $16baa215ff216ac9$var$setCustomFontMedia(name, weights.url);
};
var $16baa215ff216ac9$var$getFontFaceString = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$16baa215ff216ac9$var$getFontFaceEachString(key, LIBRARY[key].value));
};
// src/utils/sequence.js
var $16baa215ff216ac9$var$import_utils4 = $16baa215ff216ac9$var$__toESM($16baa215ff216ac9$var$require_cjs(), 1);
// src/defaultConfig/index.js
var $16baa215ff216ac9$var$defaultConfig_exports = {};
$16baa215ff216ac9$var$__export($16baa215ff216ac9$var$defaultConfig_exports, {
    ANIMATION: ()=>$16baa215ff216ac9$var$ANIMATION,
    BREAKPOINTS: ()=>$16baa215ff216ac9$var$BREAKPOINTS,
    CASES: ()=>$16baa215ff216ac9$var$CASES,
    CLASS: ()=>$16baa215ff216ac9$var$CLASS,
    COLOR: ()=>$16baa215ff216ac9$var$COLOR,
    DEVICES: ()=>$16baa215ff216ac9$var$DEVICES,
    DOCUMENT: ()=>$16baa215ff216ac9$var$DOCUMENT,
    FONT: ()=>$16baa215ff216ac9$var$FONT,
    FONT_FACE: ()=>$16baa215ff216ac9$var$FONT_FACE,
    FONT_FAMILY: ()=>$16baa215ff216ac9$var$FONT_FAMILY,
    FONT_FAMILY_TYPES: ()=>$16baa215ff216ac9$var$FONT_FAMILY_TYPES,
    GRADIENT: ()=>$16baa215ff216ac9$var$GRADIENT,
    GRID: ()=>$16baa215ff216ac9$var$GRID,
    ICONS: ()=>$16baa215ff216ac9$var$ICONS,
    MEDIA: ()=>$16baa215ff216ac9$var$MEDIA,
    RESET: ()=>$16baa215ff216ac9$var$RESET,
    SEMANTIC_ICONS: ()=>$16baa215ff216ac9$var$SEMANTIC_ICONS,
    SEQUENCE: ()=>$16baa215ff216ac9$var$SEQUENCE,
    SHADOW: ()=>$16baa215ff216ac9$var$SHADOW,
    SPACING: ()=>$16baa215ff216ac9$var$SPACING,
    SVG: ()=>$16baa215ff216ac9$var$SVG,
    SVG_DATA: ()=>$16baa215ff216ac9$var$SVG_DATA,
    TEMPLATES: ()=>$16baa215ff216ac9$var$TEMPLATES,
    THEME: ()=>$16baa215ff216ac9$var$THEME,
    TIMING: ()=>$16baa215ff216ac9$var$TIMING,
    TYPOGRAPHY: ()=>$16baa215ff216ac9$var$TYPOGRAPHY,
    UNIT: ()=>$16baa215ff216ac9$var$UNIT
});
// src/defaultConfig/sequence.js
var $16baa215ff216ac9$var$SEQUENCE = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    // golden-ratio
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    // theodorus
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    // pythagoras
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    // archimedes
    "double-octave": 4
};
// src/defaultConfig/unit.js
var $16baa215ff216ac9$var$UNIT = {
    default: "em"
};
// src/defaultConfig/typography.js
var $16baa215ff216ac9$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: $16baa215ff216ac9$var$SEQUENCE["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
var $16baa215ff216ac9$var$TYPOGRAPHY = $16baa215ff216ac9$var$defaultProps;
// src/defaultConfig/font.js
var $16baa215ff216ac9$var$FONT = {};
// src/defaultConfig/font-family.js
var $16baa215ff216ac9$var$FONT_FAMILY = {};
var $16baa215ff216ac9$var$FONT_FAMILY_TYPES = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
};
var $16baa215ff216ac9$var$FONT_FACE = {};
// src/defaultConfig/media.js
var $16baa215ff216ac9$var$MEDIA = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
// src/defaultConfig/spacing.js
var $16baa215ff216ac9$var$defaultProps2 = {
    base: $16baa215ff216ac9$var$TYPOGRAPHY.base,
    type: "spacing",
    ratio: $16baa215ff216ac9$var$SEQUENCE.phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
};
var $16baa215ff216ac9$var$SPACING = $16baa215ff216ac9$var$defaultProps2;
// src/defaultConfig/color.js
var $16baa215ff216ac9$var$COLOR = {};
var $16baa215ff216ac9$var$GRADIENT = {};
// src/defaultConfig/theme.js
var $16baa215ff216ac9$var$THEME = {};
// src/defaultConfig/shadow.js
var $16baa215ff216ac9$var$SHADOW = {};
// src/defaultConfig/icons.js
var $16baa215ff216ac9$var$ICONS = {};
var $16baa215ff216ac9$var$SEMANTIC_ICONS = {};
// src/defaultConfig/timing.js
var $16baa215ff216ac9$var$defaultProps3 = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: $16baa215ff216ac9$var$SEQUENCE["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
};
var $16baa215ff216ac9$var$TIMING = $16baa215ff216ac9$var$defaultProps3;
// src/defaultConfig/document.js
var $16baa215ff216ac9$var$DOCUMENT = {};
// src/defaultConfig/responsive.js
var $16baa215ff216ac9$var$BREAKPOINTS = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
var $16baa215ff216ac9$var$DEVICES = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};
// src/defaultConfig/cases.js
var $16baa215ff216ac9$var$CASES = {};
// src/defaultConfig/animation.js
var $16baa215ff216ac9$var$ANIMATION = {};
// src/defaultConfig/svg.js
var $16baa215ff216ac9$var$SVG = {};
var $16baa215ff216ac9$var$SVG_DATA = {};
// src/defaultConfig/templates.js
var $16baa215ff216ac9$var$TEMPLATES = {};
// src/defaultConfig/grid.js
var $16baa215ff216ac9$var$defaultProps4 = {};
var $16baa215ff216ac9$var$GRID = $16baa215ff216ac9$var$defaultProps4;
// src/defaultConfig/class.js
var $16baa215ff216ac9$var$defaultProps5 = {};
var $16baa215ff216ac9$var$CLASS = $16baa215ff216ac9$var$defaultProps5;
// src/defaultConfig/index.js
var $16baa215ff216ac9$var$RESET = {};
// src/factory.js
var $16baa215ff216ac9$var$CSS_VARS = {};
var $16baa215ff216ac9$var$CONFIG = {
    verbose: false,
    useVariable: true,
    useReset: true,
    CSS_VARS: $16baa215ff216ac9$var$CSS_VARS,
    ...$16baa215ff216ac9$var$defaultConfig_exports
};
var $16baa215ff216ac9$var$cachedConfig = $16baa215ff216ac9$var$deepClone($16baa215ff216ac9$var$CONFIG);
var $16baa215ff216ac9$var$FACTORY = {
    active: "0",
    0: $16baa215ff216ac9$var$CONFIG
};
var $16baa215ff216ac9$var$activateConfig = (def)=>{
    if ($16baa215ff216ac9$var$isDefined(def)) $16baa215ff216ac9$var$FACTORY.active = def;
    return $16baa215ff216ac9$var$FACTORY[def || $16baa215ff216ac9$var$FACTORY.active];
};
var $16baa215ff216ac9$var$getActiveConfig = (def)=>{
    return $16baa215ff216ac9$var$FACTORY[def || $16baa215ff216ac9$var$FACTORY.active] || $16baa215ff216ac9$var$CONFIG;
};
var $16baa215ff216ac9$var$setActiveConfig = (newConfig)=>{
    if (!$16baa215ff216ac9$var$isObject(newConfig)) return;
    $16baa215ff216ac9$var$FACTORY.active = "1";
    $16baa215ff216ac9$var$FACTORY["1"] = $16baa215ff216ac9$var$deepMerge(newConfig, $16baa215ff216ac9$var$deepClone($16baa215ff216ac9$var$cachedConfig));
    return newConfig;
};
// src/utils/sequence.js
var $16baa215ff216ac9$var$numToLetterMap = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
};
var $16baa215ff216ac9$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
var $16baa215ff216ac9$var$getFnPrefixAndValue = (val)=>{
    if (!val.includes("(")) return val;
    const prefix = val.split("(")[0];
    const value = val.slice(val.indexOf("(") + 1, val.lastIndexOf(")"));
    return [
        prefix,
        value
    ];
};
var $16baa215ff216ac9$var$setScalingVar = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ($16baa215ff216ac9$var$isScalingUnit(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = "--" + (type && type.replace(".", "-"));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $16baa215ff216ac9$var$numToLetterMap[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $16baa215ff216ac9$var$numToLetterMap[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
var $16baa215ff216ac9$var$setSubScalingVar = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = "--" + (type && type.replace(".", "-"));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
var $16baa215ff216ac9$var$getSubratioDifference = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
var $16baa215ff216ac9$var$getSubratio = (base, ratio)=>{
    return $16baa215ff216ac9$var$getSubratioDifference(base, ratio).map((v)=>v / base);
};
var $16baa215ff216ac9$var$generateSubSequence = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $16baa215ff216ac9$var$getSubratioDifference(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1e3) / 1e3;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $16baa215ff216ac9$var$setSubScalingVar(k + 1, arr, variable, sequenceProps);
        const props2 = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $16baa215ff216ac9$var$setSequenceValue(props2, sequenceProps);
    });
};
var $16baa215ff216ac9$var$switchSequenceOnNegative = (key, base, ratio)=>{
    return base * Math.pow(ratio, key);
};
var $16baa215ff216ac9$var$generateSequence = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $16baa215ff216ac9$var$numToLetterMap[key];
        const value = $16baa215ff216ac9$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $16baa215ff216ac9$var$setScalingVar(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $16baa215ff216ac9$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $16baa215ff216ac9$var$generateSubSequence(props, sequenceProps);
    }
    return sequenceProps;
};
var $16baa215ff216ac9$var$generateSequencePosition = (sequenceProps, position = 0)=>{
    var _a;
    const { type: type, base: base, ratio: ratio, subSequence: subSequence } = sequenceProps;
    const letterKey = $16baa215ff216ac9$var$isString(position) ? position : $16baa215ff216ac9$var$numToLetterMap[position];
    const index = $16baa215ff216ac9$var$isString(position) ? (_a = Object.entries($16baa215ff216ac9$var$numToLetterMap).find(([, value2])=>value2 === position)) == null ? void 0 : _a[0] : position;
    if (!letterKey) {
        console.warn(`Position ${position} is out of range in numToLetterMap`);
        return null;
    }
    const result = {
        sequence: {},
        scales: {},
        vars: {},
        ...sequenceProps
    };
    const value = base * Math.pow(ratio, index);
    const scaling = ~~(value / base * 100) / 100;
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    const variable = prefix + letterKey;
    const scalingVariable = $16baa215ff216ac9$var$setScalingVar(index, sequenceProps);
    const props = {
        key: letterKey,
        variable: variable,
        value: value,
        base: base,
        scaling: scaling,
        scalingVariable: scalingVariable,
        ratio: ratio,
        index: index
    };
    $16baa215ff216ac9$var$setSequenceValue(props, result);
    if (subSequence) $16baa215ff216ac9$var$generateSubSequence(props, result);
    return result;
};
var $16baa215ff216ac9$var$getSequenceValue = (value = "A", sequenceProps)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { UNIT: UNIT2 } = CONFIG2;
    if ($16baa215ff216ac9$var$isString(value) && value.slice(0, 2) === "--") return `var(${value})`;
    const { sequence: sequence, unit: unit = UNIT2.default, useVariable: useVariable } = sequenceProps;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    const hasUnits = $16baa215ff216ac9$var$CSS_UNITS.some((unit2)=>value.includes(unit2));
    if (hasUnits || !startsWithDashOrLetter) return value;
    const skipArr = [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ];
    if (skipArr.includes(value)) return value;
    const prefix = `--${(0, $16baa215ff216ac9$var$import_utils4.toDashCase)(sequenceProps.type.replace(".", "-"))}-`;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === "-" ? "-" : "";
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = "";
    if (absValue.includes("_")) {
        mediaName = "_" + absValue.split("_")[1].toLowerCase();
        absValue = absValue.split("_")[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes("+")) {
        const [first, second] = absValue.split("+");
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("*")) {
        const [first, second] = absValue.split("*");
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("-")) {
        const [first, second] = absValue.split("-");
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG2.verbose) console.warn(absValue, "- value is not found because `subSequence` is set to false");
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG2.useVariable) {
        const varValue2 = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue2} * -1)` : varValue2;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === "ms" || unit === "s") return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
var $16baa215ff216ac9$var$getSequenceValueBySymbols = (value, sequenceProps)=>{
    const mathArr = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((v)=>value.includes(v + " "));
    if (!mathArr.length) return value;
    return mathArr.map((symbol)=>{
        const valuesArr = value.split(symbol + " ").map((v)=>v.trim());
        const transformedValues = valuesArr.map((v)=>{
            return $16baa215ff216ac9$var$getSequenceValue(v, sequenceProps);
        });
        return transformedValues.join(" " + symbol + " ");
    }).join("");
};
var $16baa215ff216ac9$var$getSequenceValuePropertyPair = (value, propertyName, sequenceProps, fnPrefix)=>{
    if (typeof value !== "string") {
        const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
        if (CONFIG2.verbose) console.warn(propertyName, value, "is not a string");
        return {
            [propertyName]: value
        };
    }
    if (value === "-" || value === "") return {};
    if (!fnPrefix && value.includes("(")) {
        const fnArr = $16baa215ff216ac9$var$getFnPrefixAndValue(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    const mathArr = [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((v)=>value.includes(v + " "));
    if (mathArr.length) value = $16baa215ff216ac9$var$getSequenceValueBySymbols(value, sequenceProps);
    else value = $16baa215ff216ac9$var$getSequenceValue(value, sequenceProps);
    return {
        [propertyName]: fnPrefix ? `${fnPrefix}(${value})` : value
    };
};
var $16baa215ff216ac9$var$findHeadingLetter = (h1Matches, index)=>$16baa215ff216ac9$var$numToLetterMap[h1Matches - index];
var $16baa215ff216ac9$var$findHeadings = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $16baa215ff216ac9$var$findHeadingLetter(h1Matches, i);
        return sequence[findLetter];
    });
};
// src/utils/var.js
var $16baa215ff216ac9$var$setVariables = (result, key)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { CSS_VARS: CSS_VARS2 } = CONFIG2;
    if ($16baa215ff216ac9$var$isObjectLike(result.value)) ;
    else CSS_VARS2[result.var] = result.value;
};
var $16baa215ff216ac9$var$applySequenceGlobalVars = (vars, obj, options)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { UNIT: UNIT2 } = CONFIG2;
    const unit = obj.unit || UNIT2.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = "--" + (type && type.replace(".", "-"));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = $16baa215ff216ac9$var$getSubratio(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
};
var $16baa215ff216ac9$var$applySequenceVars = (FACTORY2, options = {})=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { UNIT: UNIT2, TIMING: TIMING2, CSS_VARS: CSS_VARS2 } = CONFIG2;
    const unit = FACTORY2.unit || UNIT2.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY2;
    if (!mediaRegenerate) $16baa215ff216ac9$var$applySequenceGlobalVars(CSS_VARS2, FACTORY2, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY2.type === TIMING2.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS2[item.variable + "_default"] = value;
            CSS_VARS2[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS2[item.variable] = value;
        else {
            CSS_VARS2[item.variable + "_default"] = value;
            CSS_VARS2[item.variable] = `var(${item.variable + "_default"})`;
        }
    }
};
var $16baa215ff216ac9$var$applyMediaSequenceVars = (FACTORY2, media, options = {})=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { UNIT: UNIT2, MEDIA: MEDIA2, CSS_VARS: CSS_VARS2 } = CONFIG2;
    const mediaName = media.slice(1);
    const unit = FACTORY2.unit || UNIT2.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY2;
    const { sequence: sequence, scales: scales } = FACTORY2[media];
    const query = MEDIA2[mediaName];
    if (!query && CONFIG2.verbose) console.warn("Can't find media query ", query);
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS2[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS2[`@media ${query}`] = {};
        $16baa215ff216ac9$var$applySequenceGlobalVars(underMediaQuery, FACTORY2[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ($16baa215ff216ac9$var$isScalingUnit(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG2.verbose) console.warn("Can't find query ", query);
        let underMediaQuery = CSS_VARS2[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS2[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + "_" + mediaName})`;
        CSS_VARS2[item.variable + "_" + mediaName] = value;
    }
};
// src/utils/sprite.js
var $16baa215ff216ac9$var$isDev = $16baa215ff216ac9$var$isNotProduction();
var $16baa215ff216ac9$var$generateSprite = (icons)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    let sprite = "";
    for(const key in icons){
        if (CONFIG2.__svg_cache[key]) continue;
        else CONFIG2.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
var $16baa215ff216ac9$var$parseRootAttributes = (htmlString)=>{
    const val = htmlString.default || htmlString;
    if (!$16baa215ff216ac9$var$isString(val)) {
        if ($16baa215ff216ac9$var$isDev) console.warn("parseRootAttributes:", val, "is not a string");
        return;
    }
    const match = val.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split("=");
        acc[key] = value.replace(/['"]/g, "");
        return acc;
    }, {});
};
var $16baa215ff216ac9$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ($16baa215ff216ac9$var$isArray(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 1e5);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
var $16baa215ff216ac9$var$convertSvgToSymbol = (key, code)=>{
    const extractAttrs = $16baa215ff216ac9$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = "http://www.w3.org/2000/svg";
    const replacedCode = $16baa215ff216ac9$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace("<svg", `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, "");
    symbol = symbol.replace(/height="[^"]*"/, "");
    symbol = symbol.replace("</svg", "</symbol");
    return symbol;
};
// src/system/index.js
var $16baa215ff216ac9$var$system_exports = {};
$16baa215ff216ac9$var$__export($16baa215ff216ac9$var$system_exports, {
    appendSVGSprite: ()=>$16baa215ff216ac9$var$appendSVGSprite,
    appendSvgIconsSprite: ()=>$16baa215ff216ac9$var$appendSvgIconsSprite,
    applyDocument: ()=>$16baa215ff216ac9$var$applyDocument,
    applyHeadings: ()=>$16baa215ff216ac9$var$applyHeadings,
    applyReset: ()=>$16baa215ff216ac9$var$applyReset,
    applySpacingSequence: ()=>$16baa215ff216ac9$var$applySpacingSequence,
    applyTimingSequence: ()=>$16baa215ff216ac9$var$applyTimingSequence,
    applyTypographySequence: ()=>$16baa215ff216ac9$var$applyTypographySequence,
    checkIfBoxSize: ()=>$16baa215ff216ac9$var$checkIfBoxSize,
    getColor: ()=>$16baa215ff216ac9$var$getColor,
    getFontFamily: ()=>$16baa215ff216ac9$var$getFontFamily,
    getFontSizeByKey: ()=>$16baa215ff216ac9$var$getFontSizeByKey,
    getMediaColor: ()=>$16baa215ff216ac9$var$getMediaColor,
    getMediaTheme: ()=>$16baa215ff216ac9$var$getMediaTheme,
    getShadow: ()=>$16baa215ff216ac9$var$getShadow,
    getSpacingBasedOnRatio: ()=>$16baa215ff216ac9$var$getSpacingBasedOnRatio,
    getSpacingByKey: ()=>$16baa215ff216ac9$var$getSpacingByKey,
    getTheme: ()=>$16baa215ff216ac9$var$getTheme,
    getTimingByKey: ()=>$16baa215ff216ac9$var$getTimingByKey,
    getTimingFunction: ()=>$16baa215ff216ac9$var$getTimingFunction,
    runThroughMedia: ()=>$16baa215ff216ac9$var$runThroughMedia,
    setColor: ()=>$16baa215ff216ac9$var$setColor,
    setFont: ()=>$16baa215ff216ac9$var$setFont,
    setFontFamily: ()=>$16baa215ff216ac9$var$setFontFamily,
    setGradient: ()=>$16baa215ff216ac9$var$setGradient,
    setMediaTheme: ()=>$16baa215ff216ac9$var$setMediaTheme,
    setSVG: ()=>$16baa215ff216ac9$var$setSVG,
    setShadow: ()=>$16baa215ff216ac9$var$setShadow,
    setSvgIcon: ()=>$16baa215ff216ac9$var$setSvgIcon,
    setTheme: ()=>$16baa215ff216ac9$var$setTheme,
    splitSpacedValue: ()=>$16baa215ff216ac9$var$splitSpacedValue
});
// src/system/color.js
var $16baa215ff216ac9$var$getColor = (value, key, config)=>{
    const CONFIG2 = config || $16baa215ff216ac9$var$getActiveConfig();
    if (!$16baa215ff216ac9$var$isString(value)) {
        if (CONFIG2.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    if (key && value[key]) value = value[key];
    const [name, alpha, tone] = $16baa215ff216ac9$var$isArray(value) ? value : value.split(" ");
    const { COLOR: COLOR2, GRADIENT: GRADIENT2 } = CONFIG2;
    let val = COLOR2[name] || GRADIENT2[name];
    if (!val) {
        if (CONFIG2.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG2.verbose) console.warn(value, " - does not have ", key);
    }
    let rgb = val.rgb;
    if (!rgb) return CONFIG2.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = $16baa215ff216ac9$var$getRgbTone(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    return CONFIG2.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
var $16baa215ff216ac9$var$getMediaColor = (value, globalTheme, config)=>{
    const CONFIG2 = config || $16baa215ff216ac9$var$getActiveConfig();
    if (!globalTheme) globalTheme = CONFIG2.globalTheme;
    if (!$16baa215ff216ac9$var$isString(value)) {
        if (CONFIG2.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = $16baa215ff216ac9$var$isArray(value) ? value : value.split(" ");
    const { COLOR: COLOR2, GRADIENT: GRADIENT2 } = CONFIG2;
    const val = COLOR2[name] || GRADIENT2[name];
    const isObj = $16baa215ff216ac9$var$isObject(val);
    if (isObj && val.value) return $16baa215ff216ac9$var$getColor(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $16baa215ff216ac9$var$getColor(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG2.MEDIA[mediaName.slice(1)];
                const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
                obj[media] = $16baa215ff216ac9$var$getColor(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG2.verbose) console.warn("Can't find color", value);
        return value;
    }
};
var $16baa215ff216ac9$var$setColor = (val, key, suffix)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if ($16baa215ff216ac9$var$isString(val) && val.slice(0, 2) === "--") {
        val = $16baa215ff216ac9$var$getColor(val.slice(2));
        if (!(val.includes("rgb") || val.includes("var") || val.includes("#"))) {
            if (CONFIG2.verbose) console.warn(val, "- referred but does not exist");
            val = val.split(" ")[0];
        }
    }
    if ($16baa215ff216ac9$var$isArray(val)) return {
        "@light": $16baa215ff216ac9$var$setColor(val[0], key, "light"),
        "@dark": $16baa215ff216ac9$var$setColor(val[1], key, "dark")
    };
    if ($16baa215ff216ac9$var$isObject(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $16baa215ff216ac9$var$setColor(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : "");
    const colorArr = $16baa215ff216ac9$var$colorStringToRgbaArray(val.value || val);
    const [r, g, b, a = 1] = colorArr;
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG2.useVariable) CONFIG2.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
var $16baa215ff216ac9$var$setGradient = (val, key, suffix)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if ($16baa215ff216ac9$var$isString(val) && val.slice(0, 2) === "--") val = $16baa215ff216ac9$var$getColor(val.slice(2));
    if ($16baa215ff216ac9$var$isArray(val)) return {
        "@light": $16baa215ff216ac9$var$setGradient(val[0], key, "light"),
        "@dark": $16baa215ff216ac9$var$setGradient(val[0], key, "dark")
    };
    if ($16baa215ff216ac9$var$isObject(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $16baa215ff216ac9$var$setGradient(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG2.useVariable) CONFIG2.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};
// src/system/theme.js
var $16baa215ff216ac9$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            "color",
            "Color",
            "background",
            "border"
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? $16baa215ff216ac9$var$getColor(theme[key]) : theme[key];
    });
    return value;
};
var $16baa215ff216ac9$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $16baa215ff216ac9$var$setThemeValue(theme);
    return theme.value;
};
var $16baa215ff216ac9$var$getTheme = (value, modifier)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (CONFIG2.useVariable) return $16baa215ff216ac9$var$getMediaTheme(value, modifier);
    const { THEME: THEME2 } = CONFIG2;
    if ($16baa215ff216ac9$var$isString(value)) {
        const [theme, subtheme] = value.split(" ");
        const isOurTheme = THEME2[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $16baa215ff216ac9$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ($16baa215ff216ac9$var$isObjectLike(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME2[themeName];
        if (media && media[subThemeName]) return $16baa215ff216ac9$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $16baa215ff216ac9$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $16baa215ff216ac9$var$getThemeValue(state[subThemeName]);
    } else if ($16baa215ff216ac9$var$isObject(value)) return $16baa215ff216ac9$var$setThemeValue(value);
};
var $16baa215ff216ac9$var$setInverseTheme = (theme, variant, value)=>{
    if ($16baa215ff216ac9$var$isObject(variant)) theme.variants.inverse.value = $16baa215ff216ac9$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
var $16baa215ff216ac9$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $16baa215ff216ac9$var$getTheme(variant);
    themeValue[`&:${key}`] = result;
    if ($16baa215ff216ac9$var$isObject(variant) && !variant.value) variant.value = result;
};
var $16baa215ff216ac9$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $16baa215ff216ac9$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
var $16baa215ff216ac9$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $16baa215ff216ac9$var$getTheme(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ($16baa215ff216ac9$var$isObject(variant) && !variant.value) variant.value = result;
};
var $16baa215ff216ac9$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === "dark" || key === "light") $16baa215ff216ac9$var$setPrefersScheme(theme, key, variant, value);
        if (key === "inverse") $16baa215ff216ac9$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
var $16baa215ff216ac9$var$setHelpers = (theme, value)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ($16baa215ff216ac9$var$isString(helper)) helpers[key] = CONFIG2.THEME[helper];
        else $16baa215ff216ac9$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
var $16baa215ff216ac9$var$setTheme = (val, key)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (CONFIG2.useVariable) return $16baa215ff216ac9$var$setMediaTheme(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $16baa215ff216ac9$var$setThemeValue(val, key);
    const CSSvar = `--theme-${key}`;
    $16baa215ff216ac9$var$setSelectors(val, value);
    $16baa215ff216ac9$var$setMedia(val, value);
    $16baa215ff216ac9$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
var $16baa215ff216ac9$var$setMediaTheme = (val, key, suffix, prefers)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { CSS_VARS: CSS_VARS2 } = CONFIG2;
    const theme = {
        value: val
    };
    if ($16baa215ff216ac9$var$isObjectLike(val)) {
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === "@" || symb === ":" || symb === ".") {
                const hasPrefers = symb === "@" && param;
                theme[param] = $16baa215ff216ac9$var$setMediaTheme(value, key, param, prefers || hasPrefers);
            } else {
                const color = $16baa215ff216ac9$var$getColor(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? "-" + metaSuffixes.join("-") : "";
                const CSSVar = `--theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG2.useVariable) {
                    CSS_VARS2[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        if (theme.background || theme.color || theme.backgroundColor) theme[".inversed"] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ($16baa215ff216ac9$var$isString(val) && val.slice(0, 2) === "--") {
        const { THEME: THEME2 } = CONFIG2;
        const value = THEME2[val.slice(2)];
        const getReferenced = $16baa215ff216ac9$var$getMediaTheme(value, prefers);
        return getReferenced;
    }
    return theme;
};
var $16baa215ff216ac9$var$recursiveTheme = (val)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ($16baa215ff216ac9$var$isObjectLike(val[param])) {
            if (symb === "@") {
                const query = CONFIG2.MEDIA[param.slice(1)];
                const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
                obj[media] = $16baa215ff216ac9$var$recursiveTheme(val[param]);
            } else if (symb === ":") obj[`&${param}`] = $16baa215ff216ac9$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
var $16baa215ff216ac9$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $16baa215ff216ac9$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
var $16baa215ff216ac9$var$findModifier = (val, modifier)=>{
    if ($16baa215ff216ac9$var$isArray(modifier)) return $16baa215ff216ac9$var$findModifierFromArray(val, modifier);
    else if ($16baa215ff216ac9$var$isString(modifier) && val[modifier]) return val[modifier];
    else return val;
};
var $16baa215ff216ac9$var$getMediaTheme = (value, modifier)=>{
    const activeConfig = $16baa215ff216ac9$var$getActiveConfig();
    if ($16baa215ff216ac9$var$isString(value) && value.slice(0, 2) === "--") value = $16baa215ff216ac9$var$getMediaTheme(value.slice(2));
    if (!value || !$16baa215ff216ac9$var$isString(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = $16baa215ff216ac9$var$isArray(value) ? value : value.split(" ");
    let themeValue = activeConfig.THEME[themeName];
    if (themeValue && (themeModifiers || modifier)) themeValue = $16baa215ff216ac9$var$findModifier(themeValue, themeModifiers.length ? themeModifiers : modifier);
    const resolvedTheme = $16baa215ff216ac9$var$recursiveTheme(themeValue);
    return resolvedTheme;
};
// src/system/font.js
var $16baa215ff216ac9$var$import_utils11 = $16baa215ff216ac9$var$__toESM($16baa215ff216ac9$var$require_cjs(), 1);
var $16baa215ff216ac9$var$setFont = (val, key)=>{
    const CSSvar = `--font-${key}`;
    if (!val || $16baa215ff216ac9$var$isArray(val) && !val[0]) return;
    let fontFace;
    if (val.isVariable) {
        if ($16baa215ff216ac9$var$isGoogleFontsUrl(val.url)) fontFace = $16baa215ff216ac9$var$setFontImport(val.url);
        else fontFace = $16baa215ff216ac9$var$setCustomFontMedia(key, val.url, val.fontWeight, {
            fontStretch: val.fontStretch,
            fontDisplay: val.fontDisplay || "swap"
        });
    } else if (val[0]) fontFace = $16baa215ff216ac9$var$getFontFaceEach(key, val);
    else fontFace = $16baa215ff216ac9$var$setCustomFontMedia(key, val.url);
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
var $16baa215ff216ac9$var$getFontFamily = (key, factory)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { FONT_FAMILY: FONT_FAMILY2 } = CONFIG2;
    return $16baa215ff216ac9$var$getDefaultOrFirstKey(factory || FONT_FAMILY2, key);
};
var $16baa215ff216ac9$var$setFontFamily = (val, key)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { FONT_FAMILY: FONT_FAMILY2, FONT_FAMILY_TYPES: FONT_FAMILY_TYPES2 } = CONFIG2;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY2.default = key;
    if ($16baa215ff216ac9$var$isObject(value)) value = (0, $16baa215ff216ac9$var$import_utils11.arrayzeValue)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(", ")}, ${FONT_FAMILY_TYPES2[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};
// src/system/typography.js
var $16baa215ff216ac9$var$runThroughMedia = (FACTORY2)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TYPOGRAPHY: TYPOGRAPHY2, MEDIA: MEDIA2 } = CONFIG2;
    for(const prop in FACTORY2){
        const isPropMedia = prop.slice(0, 1) === "@";
        const mediaValue = FACTORY2[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY2;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY2;
        $16baa215ff216ac9$var$merge(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const query = MEDIA2[mediaName];
        const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
        TYPOGRAPHY2.templates[media] = {
            fontSize: mediaValue.base / TYPOGRAPHY2.browserDefault + unit
        };
        if (!mediaRegenerate) {
            $16baa215ff216ac9$var$applyMediaSequenceVars(FACTORY2, prop);
            continue;
        }
        $16baa215ff216ac9$var$merge(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        $16baa215ff216ac9$var$generateSequence(mediaValue);
        $16baa215ff216ac9$var$applyMediaSequenceVars(FACTORY2, prop);
    }
};
var $16baa215ff216ac9$var$applyHeadings = (props)=>{
    var _a, _b;
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = $16baa215ff216ac9$var$findHeadings(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG2.useVariable ? `var(${(_a = HEADINGS[k]) == null ? void 0 : _a.variable})` : `${(_b = HEADINGS[k]) == null ? void 0 : _b.scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
var $16baa215ff216ac9$var$applyTypographySequence = ()=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TYPOGRAPHY: TYPOGRAPHY2 } = CONFIG2;
    $16baa215ff216ac9$var$generateSequence(TYPOGRAPHY2);
    $16baa215ff216ac9$var$applyHeadings(TYPOGRAPHY2);
    $16baa215ff216ac9$var$applySequenceVars(TYPOGRAPHY2);
    $16baa215ff216ac9$var$runThroughMedia(TYPOGRAPHY2);
};
var $16baa215ff216ac9$var$getFontSizeByKey = (value)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TYPOGRAPHY: TYPOGRAPHY2 } = CONFIG2;
    return $16baa215ff216ac9$var$getSequenceValuePropertyPair(value, "fontSize", TYPOGRAPHY2);
};
// src/system/spacing.js
var $16baa215ff216ac9$var$import_utils15 = $16baa215ff216ac9$var$__toESM($16baa215ff216ac9$var$require_cjs(), 1);
var $16baa215ff216ac9$var$runThroughMedia2 = (FACTORY2)=>{
    for(const prop in FACTORY2){
        const mediaProps = FACTORY2[prop];
        const isMediaName = prop.slice(0, 1) === "@";
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY2;
        $16baa215ff216ac9$var$merge(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        $16baa215ff216ac9$var$generateSequence(mediaProps);
        $16baa215ff216ac9$var$applyMediaSequenceVars(FACTORY2, prop);
    }
};
var $16baa215ff216ac9$var$checkIfBoxSize = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    const includesWidth = prop.includes("width") || prop.includes("height");
    const includesBorder = prop.includes("border") || prop.includes("outline");
    return includesWidth && !includesBorder;
};
var $16baa215ff216ac9$var$applySpacingSequence = ()=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { SPACING: SPACING2 } = CONFIG2;
    $16baa215ff216ac9$var$generateSequence(SPACING2);
    $16baa215ff216ac9$var$applySequenceVars(SPACING2);
    $16baa215ff216ac9$var$runThroughMedia2(SPACING2);
};
var $16baa215ff216ac9$var$getSequence = (sequenceProps)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { SPACING: SPACING2 } = CONFIG2;
    if (!sequenceProps || !sequenceProps.sequence) return SPACING2;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : $16baa215ff216ac9$var$generateSequence(sequenceProps);
};
var $16baa215ff216ac9$var$getSpacingByKey = (value, propertyName = "padding", sequenceProps, fnPrefix)=>{
    const sequence = $16baa215ff216ac9$var$getSequence(sequenceProps);
    if ($16baa215ff216ac9$var$isString(value)) {
        if (!fnPrefix && value.includes("(")) {
            const fnArray = $16baa215ff216ac9$var$getFnPrefixAndValue(value);
            fnPrefix = fnArray[0];
            value = fnArray[1];
        }
    }
    const stack = fnPrefix ? [
        value
    ] : (0, $16baa215ff216ac9$var$import_utils15.arrayzeValue)(value);
    if (!$16baa215ff216ac9$var$isArray(stack)) return;
    if (stack.length > 1) {
        let suffix = "";
        if (propertyName === "borderWidth") {
            propertyName = "border";
            suffix = "Width";
        }
        const directions = {
            2: [
                "Block",
                "Inline"
            ],
            3: [
                "BlockStart",
                "Inline",
                "BlockEnd"
            ],
            4: [
                "BlockStart",
                "InlineEnd",
                "BlockEnd",
                "InlineStart"
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>$16baa215ff216ac9$var$getSequenceValuePropertyPair(stack[i], propertyName + direction + suffix, sequence, fnPrefix);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return $16baa215ff216ac9$var$getSequenceValuePropertyPair(value, propertyName, sequence, fnPrefix);
};
var $16baa215ff216ac9$var$getSpacingBasedOnRatio = (props, propertyName, val, fnPrefix)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { SPACING: SPACING2 } = CONFIG2;
    let value = val || props[propertyName];
    if (!fnPrefix && $16baa215ff216ac9$var$isString(value) && value.includes("(")) {
        const fnArr = $16baa215ff216ac9$var$getFnPrefixAndValue(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    if (props.spacingRatio) {
        const sequenceProps = applyCustomSequence(props);
        return $16baa215ff216ac9$var$getSpacingByKey(value, propertyName, sequenceProps, fnPrefix);
    }
    return $16baa215ff216ac9$var$getSpacingByKey(value, propertyName, SPACING2, fnPrefix);
};
var $16baa215ff216ac9$var$splitSpacedValue = (val)=>{
    const addDefault = (v)=>{
        const isSymbol = [
            "+",
            "-",
            "*",
            "/"
        ].includes(v);
        const hasUnits = $16baa215ff216ac9$var$CSS_UNITS.some((unit)=>val.includes(unit));
        if (isSymbol || hasUnits) return v;
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        if (isSingleLetter) return v + "_default";
        return v;
    };
    return val.split(",").map((v)=>v.trim()).map(addDefault).join(",").split(" ").map(addDefault).join(" ");
};
// src/system/shadow.js
var $16baa215ff216ac9$var$setShadow = (value, key, suffix, prefers)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if ($16baa215ff216ac9$var$isArray(value)) return {
        "@light": $16baa215ff216ac9$var$setShadow(value[0], key, "light"),
        "@dark": $16baa215ff216ac9$var$setShadow(value[1], key, "dark")
    };
    if ($16baa215ff216ac9$var$isObject(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $16baa215ff216ac9$var$setShadow(value[variant], key, variant.startsWith("@") ? variant.slice(1) : variant);
        return obj;
    }
    if ($16baa215ff216ac9$var$isString(value) && value.includes(",")) value = value.split(",").map((v)=>{
        v = v.trim();
        if (v.startsWith("--")) return `var(${v})`;
        if ($16baa215ff216ac9$var$getColor(v).length > 2) return $16baa215ff216ac9$var$getColor(v);
        if (v.includes("px") || v.slice(-2) === "em") return v;
        const arr = v.split(" ");
        if (!arr.length) return v;
        return arr.map((v2)=>$16baa215ff216ac9$var$getSpacingByKey(v2, "shadow").shadow).join(" ");
    }).join(" ");
    const CSSVar = `--shadow-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG2.useVariable) CONFIG2.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
var $16baa215ff216ac9$var$getShadow = (value, globalTheme)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (!globalTheme) globalTheme = CONFIG2.globalTheme;
    if (!$16baa215ff216ac9$var$isString(value)) {
        if (CONFIG2.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = $16baa215ff216ac9$var$isArray(value) ? value : value.split(" ");
    const { SHADOW: SHADOW2 } = CONFIG2;
    const val = SHADOW2[name];
    const isObj = $16baa215ff216ac9$var$isObject(val);
    if (!val) {
        if (CONFIG2.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG2.verbose) console.warn(value, " - does not have ", globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG2.MEDIA[mediaName.slice(1)];
            const media = "@media " + (query === "print" ? `${query}` : `screen and ${query}`);
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG2.verbose) console.warn("Can't find color", value);
    return value;
};
// src/system/timing.js
var $16baa215ff216ac9$var$import_utils19 = $16baa215ff216ac9$var$__toESM($16baa215ff216ac9$var$require_cjs(), 1);
var $16baa215ff216ac9$var$applyTimingSequence = ()=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TIMING: TIMING2 } = CONFIG2;
    $16baa215ff216ac9$var$generateSequence(TIMING2);
    $16baa215ff216ac9$var$applySequenceVars(TIMING2);
};
var $16baa215ff216ac9$var$getTimingFunction = (value)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TIMING: TIMING2 } = CONFIG2;
    return TIMING2[value] || TIMING2[(0, $16baa215ff216ac9$var$import_utils19.toCamelCase)(value)] || value;
};
var $16baa215ff216ac9$var$getTimingByKey = (value, property = "timing")=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { TIMING: TIMING2 } = CONFIG2;
    return $16baa215ff216ac9$var$getSequenceValuePropertyPair(value, property, TIMING2);
};
// src/system/document.js
var $16baa215ff216ac9$var$applyDocument = ()=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { DOCUMENT: DOCUMENT2, FONT_FAMILY: FONT_FAMILY2, THEME: THEME2, TYPOGRAPHY: TYPOGRAPHY2 } = CONFIG2;
    return $16baa215ff216ac9$var$merge(DOCUMENT2, {
        theme: THEME2.document,
        fontFamily: $16baa215ff216ac9$var$getDefaultOrFirstKey(FONT_FAMILY2),
        fontSize: TYPOGRAPHY2.base,
        lineHeight: TYPOGRAPHY2.lineHeight
    });
};
// src/system/svg.js
var $16baa215ff216ac9$var$DEF_OPTIONS = {
    document: $16baa215ff216ac9$var$document2
};
var $16baa215ff216ac9$var$setSVG = (val, key)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (!val) {
        if (CONFIG2.verbose) console.warn("setSVG: val is not defined", key);
        return;
    }
    if (CONFIG2.useSvgSprite) return $16baa215ff216ac9$var$convertSvgToSymbol(key, val);
    return val;
};
var $16baa215ff216ac9$var$appendSVGSprite = (LIBRARY, options = $16baa215ff216ac9$var$DEF_OPTIONS)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG2.SVG;
    for(const key in LIBRARY)lib[key] = CONFIG2.SVG[key];
    $16baa215ff216ac9$var$appendSVG(lib, options);
};
var $16baa215ff216ac9$var$setSvgIcon = (val, key)=>{
    var _a;
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    if (CONFIG2.useIconSprite && !((_a = CONFIG2.SEMANTIC_ICONS) == null ? void 0 : _a[key])) return $16baa215ff216ac9$var$setSVG(val, key);
    return val;
};
var $16baa215ff216ac9$var$appendSvgIconsSprite = (LIBRARY, options = $16baa215ff216ac9$var$DEF_OPTIONS)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG2.ICONS;
    for(const key in LIBRARY)lib[key] = CONFIG2.ICONS[key];
    $16baa215ff216ac9$var$appendSVG(lib, options);
};
var $16baa215ff216ac9$var$createSVGSpriteElement = (options = {
    isRoot: true
})=>{
    if (!$16baa215ff216ac9$var$document2 || !$16baa215ff216ac9$var$document2.createElementNS) return;
    const svgElem = $16baa215ff216ac9$var$document2.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (options.isRoot) {
        svgElem.setAttribute("aria-hidden", "true");
        svgElem.setAttribute("width", "0");
        svgElem.setAttribute("height", "0");
        svgElem.setAttribute("style", "position:absolute");
        svgElem.setAttribute("id", "svgSprite");
    }
    return svgElem;
};
var $16baa215ff216ac9$var$appendSVG = (lib, options = $16baa215ff216ac9$var$DEF_OPTIONS)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const doc = options.document || $16baa215ff216ac9$var$document2;
    if (!doc || !doc.documentElement) {
        if (CONFIG2.verbose) console.warn("To append SVG sprites it should be run in browser environment");
        return $16baa215ff216ac9$var$generateSprite(lib);
    }
    const exists = doc.querySelector("#svgSprite");
    const SVGsprite = $16baa215ff216ac9$var$generateSprite(lib);
    if (exists) {
        const tempSVG = $16baa215ff216ac9$var$createSVGSpriteElement({
            isRoot: false
        });
        tempSVG.innerHTML = SVGsprite;
        exists.append(...tempSVG.children);
    } else {
        const svgSpriteDOM = $16baa215ff216ac9$var$createSVGSpriteElement();
        if (svgSpriteDOM && svgSpriteDOM.nodeType) {
            svgSpriteDOM.innerHTML = SVGsprite;
            doc.body.prepend(svgSpriteDOM);
        }
    }
};
// src/system/reset.js
var $16baa215ff216ac9$var$applyReset = (reset = {})=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { RESET: RESET2, TYPOGRAPHY: TYPOGRAPHY2, DOCUMENT: DOCUMENT2 } = CONFIG2;
    if (RESET2) {
        if (RESET2[":root"]) {
            const configReset = RESET2;
            const configTemplates = TYPOGRAPHY2.templates;
            configReset.body = {
                ...CONFIG2.useDocumentTheme ? $16baa215ff216ac9$var$getMediaTheme("document", `@${CONFIG2.globalTheme}`) : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY2.templates;
        const globalTheme = CONFIG2.useDocumentTheme ? $16baa215ff216ac9$var$getMediaTheme("document", `@${CONFIG2.globalTheme}`) : {};
        if (RESET2.html) $16baa215ff216ac9$var$overwriteDeep(RESET2.html, globalTheme);
        return $16baa215ff216ac9$var$deepMerge($16baa215ff216ac9$var$merge(RESET2, reset), {
            html: {
                position: "absolute",
                // overflow: 'hidden',
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...globalTheme,
                fontSize: TYPOGRAPHY2.browserDefault + "px",
                fontFamily: DOCUMENT2.fontFamily,
                lineHeight: DOCUMENT2.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: DOCUMENT2.fontFamily,
                fontSize: TYPOGRAPHY2.base / TYPOGRAPHY2.browserDefault + CONFIG2.UNIT.default,
                ...templates,
                ...body
            },
            a: {
                color: "currentColor"
            },
            // form elements
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: DOCUMENT2.fontFamily
            }
        });
    }
};
// src/transforms/index.js
var $16baa215ff216ac9$var$isBorderStyle = (str)=>[
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset",
        "initial"
    ].some((v)=>str.includes(v));
var $16baa215ff216ac9$var$transformBorder = (border)=>{
    const arr = (border + "").split(", ");
    return arr.map((v)=>{
        v = v.trim();
        if (v.slice(0, 2) === "--") return `var(${v})`;
        else if ($16baa215ff216ac9$var$isBorderStyle(v)) return v || "solid";
        else if (v.slice(-2) === "px" || v.slice(-2) === "em") return v;
        else if ($16baa215ff216ac9$var$getColor(v).length > 2) return $16baa215ff216ac9$var$getColor(v);
        return $16baa215ff216ac9$var$getSpacingByKey(v, "border").border;
    }).join(" ");
};
var $16baa215ff216ac9$var$transformTextStroke = (stroke)=>{
    return stroke.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("px")) return v;
        else if ($16baa215ff216ac9$var$getColor(v)) return $16baa215ff216ac9$var$getColor(v);
        return v;
    }).join(" ");
};
var $16baa215ff216ac9$var$transformShadow = (sh, globalTheme)=>$16baa215ff216ac9$var$getShadow(sh, globalTheme);
var $16baa215ff216ac9$var$transformBoxShadow = (shadows, globalTheme)=>shadows.split("|").map((shadow)=>{
        return shadow.split(",").map((v)=>{
            v = v.trim();
            if (v.slice(0, 2) === "--") return `var(${v})`;
            if ($16baa215ff216ac9$var$getColor(v).length > 2) {
                const color = $16baa215ff216ac9$var$getMediaColor(v, globalTheme);
                if ($16baa215ff216ac9$var$isObject(color)) return Object.values(color).filter((v2)=>v2.includes(": " + globalTheme))[0];
                return color;
            }
            if (v.includes("px") || v.slice(-2) === "em") return v;
            const arr = v.split(" ");
            if (!arr.length) return v;
            return arr.map((v2)=>$16baa215ff216ac9$var$getSpacingByKey(v2, "shadow").shadow).join(" ");
        }).join(" ");
    }).join(",");
var $16baa215ff216ac9$var$transformBackgroundImage = (backgroundImage, globalTheme)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    return backgroundImage.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("url") || v.includes("gradient")) return v;
        else if (CONFIG2.GRADIENT[backgroundImage]) return {
            backgroundImage: $16baa215ff216ac9$var$getMediaColor(backgroundImage, globalTheme || CONFIG2.globalTheme)
        };
        else if (v.includes("/") || v.startsWith("http") || v.includes(".")) return `url(${v})`;
        return v;
    }).join(" ");
};
var $16baa215ff216ac9$var$transfromGap = (gap)=>$16baa215ff216ac9$var$isString(gap) && gap.split(" ").map((v)=>$16baa215ff216ac9$var$getSpacingByKey(v, "gap").gap).join(" ");
var $16baa215ff216ac9$var$transformTransition = (transition)=>{
    const arr = transition.split(" ");
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.length < 3 || v.includes("ms")) {
            const mapWithSequence = $16baa215ff216ac9$var$getTimingByKey(v);
            return mapWithSequence.timing || v;
        }
        if ($16baa215ff216ac9$var$getTimingFunction(v)) return $16baa215ff216ac9$var$getTimingFunction(v);
        return v;
    }).join(" ");
};
var $16baa215ff216ac9$var$transformDuration = (duration, props, propertyName)=>{
    if (!$16baa215ff216ac9$var$isString(duration)) return;
    return duration.split(",").map((v)=>$16baa215ff216ac9$var$getTimingByKey(v).timing || v).join(",");
};
var $16baa215ff216ac9$var$splitTransition = (transition)=>{
    const arr = transition.split(",");
    if (!arr.length) return;
    return arr.map($16baa215ff216ac9$var$transformTransition).join(",");
};
function $16baa215ff216ac9$var$transformSize(propertyName, val, props = {}, opts = {}) {
    let value = $16baa215ff216ac9$var$exec.call(this, val || props[propertyName]);
    if ($16baa215ff216ac9$var$isUndefined(value) && $16baa215ff216ac9$var$isNull(value)) return;
    let fnPrefix;
    if ($16baa215ff216ac9$var$isString(value)) {
        if (value.includes("(")) {
            const fnArr = $16baa215ff216ac9$var$getFnPrefixAndValue(value);
            fnPrefix = fnArr[0];
            value = fnArr[1];
        }
        const shouldScaleBoxSize = props.scaleBoxSize;
        const isBoxSize = $16baa215ff216ac9$var$checkIfBoxSize(propertyName);
        if (!shouldScaleBoxSize && isBoxSize) value = $16baa215ff216ac9$var$splitSpacedValue(value);
    }
    return opts.ratio ? $16baa215ff216ac9$var$getSpacingBasedOnRatio(props, propertyName, value, fnPrefix) : $16baa215ff216ac9$var$getSpacingByKey(value, propertyName, void 0, fnPrefix);
}
function $16baa215ff216ac9$var$transformSizeRatio(propertyName, props) {
    return $16baa215ff216ac9$var$transformSize(propertyName, null, props, {
        ratio: true
    });
}
// src/set.js
var $16baa215ff216ac9$var$setCases = (val, key)=>{
    if ($16baa215ff216ac9$var$isFunction(val)) return val();
    return val;
};
var $16baa215ff216ac9$var$setSameValue = (val, key)=>val;
var $16baa215ff216ac9$var$VALUE_TRANSFORMERS = {
    color: $16baa215ff216ac9$var$setColor,
    gradient: $16baa215ff216ac9$var$setGradient,
    font: $16baa215ff216ac9$var$setFont,
    font_family: $16baa215ff216ac9$var$setFontFamily,
    theme: $16baa215ff216ac9$var$setTheme,
    icons: $16baa215ff216ac9$var$setSvgIcon,
    semantic_icons: $16baa215ff216ac9$var$setSameValue,
    svg: $16baa215ff216ac9$var$setSVG,
    svg_data: $16baa215ff216ac9$var$setSameValue,
    typography: $16baa215ff216ac9$var$setSameValue,
    cases: $16baa215ff216ac9$var$setCases,
    shadow: $16baa215ff216ac9$var$setShadow,
    spacing: $16baa215ff216ac9$var$setSameValue,
    media: $16baa215ff216ac9$var$setSameValue,
    grid: $16baa215ff216ac9$var$setSameValue,
    class: $16baa215ff216ac9$var$setSameValue,
    timing: $16baa215ff216ac9$var$setSameValue,
    reset: $16baa215ff216ac9$var$setSameValue,
    unit: $16baa215ff216ac9$var$setSameValue,
    animation: $16baa215ff216ac9$var$setSameValue
};
var $16baa215ff216ac9$var$setValue = (FACTORY_NAME, value, key)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const factoryName = FACTORY_NAME.toLowerCase();
    const FACTORY2 = CONFIG2[FACTORY_NAME];
    if ($16baa215ff216ac9$var$VALUE_TRANSFORMERS[factoryName]) try {
        const result = $16baa215ff216ac9$var$VALUE_TRANSFORMERS[factoryName](value, key);
        FACTORY2[key] = result;
        return FACTORY2;
    } catch (error) {
        if (CONFIG2.verbose) console.warn("Error setting", factoryName, "value", value, key, error);
    }
    if (CONFIG2.verbose) console.warn("Can not find", factoryName, "method in scratch");
};
var $16baa215ff216ac9$var$setEach = (factoryName, props)=>{
    const CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const FACTORY_NAME = factoryName.toUpperCase();
    const keys = Object.keys(props);
    keys.forEach((key)=>{
        try {
            return $16baa215ff216ac9$var$setValue(FACTORY_NAME, props[key], key);
        } catch (error) {
            if (CONFIG2.verbose) console.warn("Error setting", FACTORY_NAME, "value", props[key], key, error);
        }
    });
    return CONFIG2[FACTORY_NAME];
};
var $16baa215ff216ac9$var$SET_OPTIONS = {};
var $16baa215ff216ac9$var$set = (recivedConfig, options = $16baa215ff216ac9$var$SET_OPTIONS)=>{
    let CONFIG2 = $16baa215ff216ac9$var$getActiveConfig();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, SEMANTIC_ICONS: SEMANTIC_ICONS2, ...config } = recivedConfig;
    if (options.newConfig) CONFIG2 = $16baa215ff216ac9$var$setActiveConfig(options.newConfig);
    if (verbose !== void 0) CONFIG2.verbose = verbose;
    if (useVariable !== void 0) CONFIG2.useVariable = useVariable;
    if (useReset !== void 0) CONFIG2.useReset = useReset;
    if (useFontImport !== void 0) CONFIG2.useFontImport = useFontImport;
    if (useSvgSprite !== void 0) CONFIG2.useSvgSprite = useSvgSprite;
    if (useIconSprite !== void 0) CONFIG2.useIconSprite = useIconSprite;
    if (useDocumentTheme !== void 0) CONFIG2.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== void 0) CONFIG2.globalTheme = globalTheme;
    if (useDefaultConfig !== void 0) CONFIG2.useDefaultConfig = useDefaultConfig;
    if (SEMANTIC_ICONS2 !== void 0) CONFIG2.SEMANTIC_ICONS = SEMANTIC_ICONS2;
    if (CONFIG2.verbose) console.log(CONFIG2);
    if (!CONFIG2.__svg_cache) CONFIG2.__svg_cache = {};
    const keys = Object.keys(config);
    keys.map((key)=>$16baa215ff216ac9$var$setEach(key, config[key]));
    if (config.TYPOGRAPHY) try {
        $16baa215ff216ac9$var$applyTypographySequence();
    } catch (e) {
        if (CONFIG2.verbose) console.warn("Error applying typography sequence", e);
    }
    if (config.SPACING) try {
        $16baa215ff216ac9$var$applySpacingSequence();
    } catch (e) {
        if (CONFIG2.verbose) console.warn("Error applying typography sequence", e);
    }
    if (config.TIMING) try {
        $16baa215ff216ac9$var$applyTimingSequence();
    } catch (e) {
        if (CONFIG2.verbose) console.warn("Error applying typography sequence", e);
    }
    $16baa215ff216ac9$var$applyDocument();
    $16baa215ff216ac9$var$applyReset();
    return CONFIG2;
}; // @preserve-env



var $cBUNY = parcelRequire("cBUNY");
var $8319f99b46b296c9$exports = {};

$parcel$export($8319f99b46b296c9$exports, "copyStringToClipboard", () => $8319f99b46b296c9$export$4cdfed7d7fed21b8);
$parcel$export($8319f99b46b296c9$exports, "copyJavaScriptToClipboard", () => $8319f99b46b296c9$export$62b326c3a2efe2fb);
$parcel$export($8319f99b46b296c9$exports, "removeChars", () => $8319f99b46b296c9$export$3cc82ee301fb0516);
$parcel$export($8319f99b46b296c9$exports, "toCamelCase", () => $8319f99b46b296c9$export$86f54f62aa7a7514);
$parcel$export($8319f99b46b296c9$exports, "toTitleCase", () => $8319f99b46b296c9$export$f06f8b3003f18927);
$parcel$export($8319f99b46b296c9$exports, "toDashCase", () => $8319f99b46b296c9$export$6401d9e8afa09755);
$parcel$export($8319f99b46b296c9$exports, "toDescriptionCase", () => $8319f99b46b296c9$export$c82070d8669cc24e);
$parcel$export($8319f99b46b296c9$exports, "arrayzeValue", () => $8319f99b46b296c9$export$d1ef4b1a340dec10);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $e1c1a1db2dbe5b1b$exports = {};

$parcel$export($e1c1a1db2dbe5b1b$exports, "toggleFullscreen", () => $e1c1a1db2dbe5b1b$export$1aba1ee5e6dc1474);
'use strict';
async function $e1c1a1db2dbe5b1b$export$1aba1ee5e6dc1474(opts) {
    if (!document.fullscreenElement) try {
        await (this.node || document).requestFullscreen();
    } catch (err) {
        console.warn(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
    }
    else await document.exitFullscreen();
}


var $6d2b41257afed6ac$exports = {};

$parcel$export($6d2b41257afed6ac$exports, "findClosestNumber", () => $6d2b41257afed6ac$export$97a41db892f2d4c);
$parcel$export($6d2b41257afed6ac$exports, "findClosestNumberInFactory", () => $6d2b41257afed6ac$export$63c606e1170dd201);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $6d2b41257afed6ac$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $EqHTq.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $6d2b41257afed6ac$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $EqHTq.isObject)(factory)) factory = Object.values(factory);
    return $6d2b41257afed6ac$export$97a41db892f2d4c(val, factory);
};


var $6990ad4ace0aad0d$exports = {};

$parcel$export($6990ad4ace0aad0d$exports, "formatDate", () => $6990ad4ace0aad0d$export$3ae94a2503e890a1);
'use strict';
const $6990ad4ace0aad0d$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return '';
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat('en', {
        year: 'numeric'
    }).format(d);
    const mo = new Intl.DateTimeFormat('en', {
        month: 'short'
    }).format(d);
    const da = new Intl.DateTimeFormat('en', {
        day: '2-digit'
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};


var $e990850556ffcaa4$exports = {};

$parcel$export($e990850556ffcaa4$exports, "fibonacciNumberByIndex", () => $e990850556ffcaa4$export$6d35f41941932cbd);
'use strict';
const $e990850556ffcaa4$export$6d35f41941932cbd = function fibonacciNumberByIndex(n) {
    const fib = [
        0,
        1
    ];
    for(let i = 2; i <= n; i++)fib[i] = fib[i - 1] + fib[i - 2];
    return fib[n];
};


var $87262e2f758cc557$exports = {};

$parcel$export($87262e2f758cc557$exports, "loadJavascriptFile", () => $87262e2f758cc557$export$f5254c626a3f7f04);
$parcel$export($87262e2f758cc557$exports, "loadJavascriptFileSync", () => $87262e2f758cc557$export$f846581269718859);
$parcel$export($87262e2f758cc557$exports, "loadJavascriptFileEmbedSync", () => $87262e2f758cc557$export$2e2cf34468b4616);
$parcel$export($87262e2f758cc557$exports, "loadCssFile", () => $87262e2f758cc557$export$adc703d835881894);
$parcel$export($87262e2f758cc557$exports, "loadJavascript", () => $87262e2f758cc557$export$8b7778d7ecfcc995);
$parcel$export($87262e2f758cc557$exports, "loadRemoteScript", () => $87262e2f758cc557$export$c432db100969a36b);
$parcel$export($87262e2f758cc557$exports, "loadRemoteCSS", () => $87262e2f758cc557$export$d146908f5d25486);
'use strict';
const $87262e2f758cc557$export$f5254c626a3f7f04 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const scriptEle = doc.createElement('script');
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;
            scriptEle.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            scriptEle.addEventListener('error', (ev)=>{
                reject(new Error({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                }));
            });
            doc.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};
const $87262e2f758cc557$export$f846581269718859 = (fileUrl, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.src = fileUrl;
        // Create a blocking overlay
        const blocker = doc.createElement('div');
        blocker.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;';
        doc.body.appendChild(blocker);
        scriptEle.onload = ()=>{
            console.log(`Successfully loaded: ${fileUrl}`);
            doc.body.removeChild(blocker);
            resolve();
        };
        scriptEle.onerror = ()=>{
            doc.body.removeChild(blocker);
            reject(new Error(`Failed to load: ${fileUrl}`));
        };
        doc.body.appendChild(scriptEle);
    });
};
const $87262e2f758cc557$export$2e2cf34468b4616 = (FILE_URL, doc = document, fallback, type = 'text/javascript')=>{
    const xhr = new window.XMLHttpRequest();
    xhr.open('GET', FILE_URL, false) // false makes the request synchronous
    ;
    xhr.send();
    if (xhr.status === 200) {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.text = xhr.responseText;
        doc.body.appendChild(scriptEle);
        if (typeof fallback === 'function') fallback();
    } else throw new Error(`Failed to load the script ${FILE_URL}`);
};
const $87262e2f758cc557$export$adc703d835881894 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const linkElem = doc.createElement('link');
            linkElem.rel = 'stylesheet';
            linkElem.href = FILE_URL;
            linkElem.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            doc.head.appendChild(linkElem);
        } catch (error) {
            reject(error);
        }
    });
};
const $87262e2f758cc557$export$8b7778d7ecfcc995 = (body, async = false, doc = document, type = 'text/javascript', id = 'smbls-script')=>{
    try {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.async = async;
        scriptEle.id = id;
        scriptEle.innerHTML = body;
        doc.body.appendChild(scriptEle);
    } catch (error) {
        console.warn(error);
    }
};
function $87262e2f758cc557$export$c432db100969a36b(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if script is already loaded
        const existingScript = document1.querySelector(`script[src="${url}"]`);
        if (existingScript) return resolve(existingScript);
        // Create script element
        const script = document1.createElement('script');
        script.src = url;
        script.async = options.async === true;
        script.type = options.type || 'text/javascript';
        // Add optional attributes
        if (options.id) script.id = options.id;
        if (options.integrity) script.integrity = options.integrity;
        if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        script.onload = ()=>{
            script.onerror = script.onload = null;
            resolve(script);
        };
        script.onerror = ()=>{
            script.onerror = script.onload = null;
            reject(new Error(`Failed to load script: ${url}`));
        };
        // Append the script to the document head
        document1.head.appendChild(script);
    });
}
async function $87262e2f758cc557$export$d146908f5d25486(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if stylesheet is already loaded
        const existingLink = document1.querySelector(`link[href="${url}"]`);
        if (existingLink) return resolve(existingLink);
        // Create link element
        const link = document1.createElement('link');
        link.href = url;
        link.rel = options.rel || 'stylesheet';
        link.type = 'text/css';
        link.media = options.media || 'all';
        // Add optional attributes
        if (options.id) link.id = options.id;
        if (options.integrity) link.integrity = options.integrity;
        if (options.crossOrigin) link.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        link.onload = ()=>{
            link.onerror = link.onload = null;
            resolve(link);
        };
        link.onerror = ()=>{
            link.onerror = link.onload = null;
            reject(new Error(`Failed to load stylesheet: ${url}`));
        };
        // Append the link to the document head
        document1.head.appendChild(link);
    });
}


var $4f97b2e5237841c3$exports = {};

$parcel$export($4f97b2e5237841c3$exports, "isPhoto", () => $4f97b2e5237841c3$export$722f9ea87a439ca4);
'use strict';
const $4f97b2e5237841c3$export$722f9ea87a439ca4 = (format)=>[
        'jpeg',
        'gif',
        'jpg',
        'png',
        'tiff',
        'woff'
    ].includes(format);


var $b2f161ebe0baa04e$exports = {};

$parcel$export($b2f161ebe0baa04e$exports, "temporaryDomqlHack", () => $b2f161ebe0baa04e$export$e80af5c1d47c0e62);
$parcel$export($b2f161ebe0baa04e$exports, "temporaryDomqlHackReverse", () => $b2f161ebe0baa04e$export$88c48fe3b498e47b);

var $ajGUj = parcelRequire("ajGUj");
function $b2f161ebe0baa04e$export$e80af5c1d47c0e62(value) {
    let obj = {
        ...value
    };
    const on = obj.on;
    if (this.call('isObject', on)) {
        delete obj.on;
        const transformedOn = {};
        for(const key in on){
            const transformedKey = 'on' + key.charAt(0).toUpperCase() + key.slice(1);
            transformedOn[transformedKey] = on[key];
        }
        obj = {
            ...transformedOn,
            ...obj
        };
    }
    const props = obj.props;
    if (this.call('isObject', props)) {
        delete obj.props;
        obj = {
            ...props,
            ...obj
        };
    }
    const extendObj = {};
    if (obj.extend) {
        extendObj.extends = obj.extend;
        delete obj.extend;
    }
    if (obj.childExtend) {
        extendObj.childExtends = obj.childExtend;
        delete obj.childExtend;
    }
    return {
        ...extendObj,
        ...obj
    };
}
function $b2f161ebe0baa04e$export$88c48fe3b498e47b(value) {
    const obj = {
        ...value
    };
    if (obj.extends) {
        obj.extend = obj.extends;
        delete obj.extends;
    }
    if (obj.childExtends) {
        obj.childExtend = obj.childExtends;
        delete obj.childExtends;
    }
    for(const key in obj){
        const allowed = [
            'transform',
            'class'
        ];
        if ((0, $ajGUj.REGISTRY)[key] && !allowed.includes(key) || /^[A-Z]/.test(key)) continue;
        else {
            obj.props = obj.props || {};
            obj.props[key] = obj[key];
            delete obj[key];
        }
    }
    return obj;
}


'use strict';
const $8319f99b46b296c9$export$4cdfed7d7fed21b8 = async (str)=>{
    try {
        await navigator.clipboard.writeText(str);
    } catch (err) {
        console.warn('Failed to copy text: ', err);
    }
};
const $8319f99b46b296c9$export$62b326c3a2efe2fb = async (jsCode)=>{
    try {
        // Create a Blob for the JavaScript code with the 'text/javascript' MIME type
        const blob = new Blob([
            jsCode
        ], {
            type: 'text/javascript'
        });
        // Create a ClipboardItem with the 'text/javascript' Blob
        const clipboardItem = new window.ClipboardItem({
            'text/plain': blob
        });
        // Copy the ClipboardItem to the clipboard
        await navigator.clipboard.write([
            clipboardItem
        ]);
        console.log('JavaScript code copied to clipboard as text/javascript');
    } catch (err) {
        console.error('Failed to copy JavaScript code: ', err);
    }
};
const $8319f99b46b296c9$export$3cc82ee301fb0516 = (str)=>{
    return str.replace(/[^a-zA-Z0-9_]/g, '');
};
const $8319f99b46b296c9$export$86f54f62aa7a7514 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, '');
};
const $8319f99b46b296c9$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $8319f99b46b296c9$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, ' ') // Replace non-alphanumeric characters with spaces
    .trim() // Remove leading and trailing spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/-+/g, '-') // Replace consecutive dashes with a single dash
    .replace(/^-|-$/g, '') // Remove leading and trailing dashes
;
const $8319f99b46b296c9$export$c82070d8669cc24e = (str = '')=>{
    if (typeof str !== 'string') return;
    const result = str.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $8319f99b46b296c9$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $EqHTq.isArray)(val)) return val;
    if ((0, $EqHTq.isString)(val)) return val.split(' ');
    if ((0, $EqHTq.isObject)(val)) return Object.values(val);
    if ((0, $EqHTq.isNumber)(val)) return [
        val
    ];
};
$parcel$exportWildcard($8319f99b46b296c9$exports, $e1c1a1db2dbe5b1b$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $6d2b41257afed6ac$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $6990ad4ace0aad0d$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $e990850556ffcaa4$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $87262e2f758cc557$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $4f97b2e5237841c3$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $b2f161ebe0baa04e$exports);



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($76500f1a9bc57c92$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-' + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function() {
    return (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
            (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $298fb931ed4fbf8b$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}


var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5f1e384d41b6dbd9$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $76500f1a9bc57c92$export$2e2bcd8739ae039)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $5f1e384d41b6dbd9$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $5f1e384d41b6dbd9$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};


'use strict';
const $b3468425a35a59c8$export$100c3af055d141e0 = (key = 'smbls', container)=>{
    const cleanKey = key.replaceAll(/\./g, '-');
    return (0, $f80ae5e019588f18$export$2e2bcd8739ae039)({
        key: cleanKey,
        container: container
    });
};
const $b3468425a35a59c8$export$51d693b3d243fd90 = $b3468425a35a59c8$export$100c3af055d141e0();


var $0e6c01aab9a4ae9b$exports = {};
$0e6c01aab9a4ae9b$exports = JSON.parse("{}");


'use strict';
const $31242768b5023c84$var$CONFIG = (0, $16baa215ff216ac9$exports.getActiveConfig)();
const $31242768b5023c84$var$mergeWithLocalFile = (config = $31242768b5023c84$var$CONFIG, options)=>{
    const rcfile = (0, $EqHTq.isObject)(options.localFile) ? options.localFile : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {};
    const clonedFile = (0, $8wu6n.deepClone)(rcfile.designSystem || {});
    return (0, $8wu6n.deepMerge)(config, clonedFile);
};
const $31242768b5023c84$var$SET_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $31242768b5023c84$export$2cd8252107eb640b = (config, options = $31242768b5023c84$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $16baa215ff216ac9$exports.set)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $16baa215ff216ac9$exports.getFontFaceString)(conf.FONT);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) emotion.injectGlobal({
        ':root': conf.CSS_VARS
    });
    if (useReset) emotion.injectGlobal(conf.RESET);
    if (hasSvgs) (0, $16baa215ff216ac9$exports.appendSVGSprite)(hasSvgs, {
        document: options.document
    });
    else if (useSvgSprite) (0, $16baa215ff216ac9$exports.appendSVGSprite)(conf.SVG, {
        document: options.document
    });
    if (hasIcons) (0, $16baa215ff216ac9$exports.appendSvgIconsSprite)(hasIcons, {
        document: options.document
    });
    else if (useIconSprite) (0, $16baa215ff216ac9$exports.appendSvgIconsSprite)(conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $31242768b5023c84$var$UPDATE_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90)
};
const $31242768b5023c84$export$b545ad0f2df0be16 = (config, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {}, options);
    // const prevStyles = document.querySelector('[data-emotion="smbls"]')
    // console.log(prevStyles)
    const conf = (0, $16baa215ff216ac9$exports.set)({
        verbose: false,
        ...resultConfig
    });
    if (!options.preventInject) {
        emotion.injectGlobal({
            ':root': conf.CSS_VARS
        });
        emotion.injectGlobal(conf.RESET);
    }
    return conf;
};
const $31242768b5023c84$export$3a26aa64e59aeaff = (styles, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $31242768b5023c84$export$ed2c61d2d8a098be = (config, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ':root': config.CSS_VARS
    });
};
const $31242768b5023c84$export$2796c4ce44e61efa = (props, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{} // setClassname(props, options.emotion.css)
;



var $yWtDc = parcelRequire("yWtDc");
var $32a808518113ee1c$exports = {};

$parcel$defineInteropFlag($32a808518113ee1c$exports);

$parcel$export($32a808518113ee1c$exports, "getActiveRoute", () => $32a808518113ee1c$export$e7a685f330e7752);
$parcel$export($32a808518113ee1c$exports, "lastPathname", () => $32a808518113ee1c$export$7a9e7a91cdf4fce1);
$parcel$export($32a808518113ee1c$exports, "lastLevel", () => $32a808518113ee1c$export$ed098f724085d263);
$parcel$export($32a808518113ee1c$exports, "router", () => $32a808518113ee1c$export$5375cda95f0b0eb4);
$parcel$export($32a808518113ee1c$exports, "default", () => $32a808518113ee1c$export$2e2bcd8739ae039);
parcelRequire("60dnU");
var $4qxjt = parcelRequire("4qxjt");
parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");
var $bGXur = parcelRequire("bGXur");
var $32a808518113ee1c$var$__defProp = Object.defineProperty;
var $32a808518113ee1c$var$__defProps = Object.defineProperties;
var $32a808518113ee1c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $32a808518113ee1c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $32a808518113ee1c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $32a808518113ee1c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $32a808518113ee1c$var$__defNormalProp = (obj, key, value)=>key in obj ? $32a808518113ee1c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $32a808518113ee1c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($32a808518113ee1c$var$__hasOwnProp.call(b, prop)) $32a808518113ee1c$var$__defNormalProp(a, prop, b[prop]);
    if ($32a808518113ee1c$var$__getOwnPropSymbols) {
        for (var prop of $32a808518113ee1c$var$__getOwnPropSymbols(b))if ($32a808518113ee1c$var$__propIsEnum.call(b, prop)) $32a808518113ee1c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $32a808518113ee1c$var$__spreadProps = (a, b)=>$32a808518113ee1c$var$__defProps(a, $32a808518113ee1c$var$__getOwnPropDescs(b));
const $32a808518113ee1c$export$e7a685f330e7752 = (level = 0, route = (0, $jvD5p.window).location.pathname)=>{
    const routeArray = route.split("/");
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $32a808518113ee1c$export$7a9e7a91cdf4fce1;
let $32a808518113ee1c$export$ed098f724085d263 = 0;
const $32a808518113ee1c$var$defaultOptions = {
    level: $32a808518113ee1c$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $jvD5p.document) && (0, $jvD5p.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    }
};
const $32a808518113ee1c$export$5375cda95f0b0eb4 = async function(path, el, state = {}, options = {}) {
    var _a, _b;
    const element = el || this;
    const win = ((_a = element.context) == null ? void 0 : _a.window) || (0, $jvD5p.window);
    const doc = ((_b = element.context) == null ? void 0 : _b.document) || (0, $jvD5p.document);
    const opts = $32a808518113ee1c$var$__spreadValues($32a808518113ee1c$var$__spreadValues($32a808518113ee1c$var$__spreadValues({}, $32a808518113ee1c$var$defaultOptions), element.context.routerOptions), options);
    $32a808518113ee1c$export$ed098f724085d263 = opts.lastLevel;
    const ref = element.__ref;
    if (opts.contentElementKey !== "content" && opts.contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = opts.contentElementKey || "content";
    const contentElementKey = (0, $bGXur.setContentKey)(element, opts);
    const urlObj = new win.URL(win.location.origin + path);
    const { pathname: pathname, search: search, hash: hash } = urlObj;
    const rootNode = element.node;
    const route = $32a808518113ee1c$export$e7a685f330e7752(opts.level, pathname);
    let content;
    const singlePathContent = element.routes[route];
    const fullpathnameContent = element.routes[pathname];
    if (route !== pathname && !(singlePathContent == null ? void 0 : singlePathContent.routes) && fullpathnameContent) content = fullpathnameContent;
    else content = singlePathContent || fullpathnameContent || element.routes["/"] || element.routes["/*"];
    const scrollNode = opts.scrollToNode ? rootNode : opts.scrollNode;
    const hashChanged = hash && hash !== win.location.hash.slice(1);
    const pathChanged = pathname !== $32a808518113ee1c$export$7a9e7a91cdf4fce1;
    $32a808518113ee1c$export$7a9e7a91cdf4fce1 = pathname;
    if (!content || element.state.root.debugging) {
        element.state.root.debugging = false;
        return;
    }
    if (opts.pushState) win.history.pushState(state, null, pathname + (search || "") + (hash || ""));
    if (pathChanged || !hashChanged) {
        if (opts.updateState) await element.state.update({
            route: route,
            hash: hash,
            debugging: false
        }, {
            preventContentUpdate: true
        });
        if (contentElementKey && opts.removeOldElement) await element[contentElementKey].remove();
        element.removeContent();
        await element.set({
            tag: opts.useFragment && "fragment",
            extend: content
        }, {
            contentElementKey: contentElementKey
        });
    }
    if (opts.scrollToTop) scrollNode.scrollTo($32a808518113ee1c$var$__spreadProps($32a808518113ee1c$var$__spreadValues({}, opts.scrollToOptions || {}), {
        top: 0,
        left: 0
    }));
    if (opts.scrollToNode) content[contentElementKey].node.scrollTo($32a808518113ee1c$var$__spreadProps($32a808518113ee1c$var$__spreadValues({}, opts.scrollToOptions || {}), {
        top: 0,
        left: 0
    }));
    if (hash) {
        const activeNode = doc.getElementById(hash);
        if (activeNode) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - opts.scrollToOffset || 0;
            scrollNode.scrollTo($32a808518113ee1c$var$__spreadProps($32a808518113ee1c$var$__spreadValues({}, opts.scrollToOptions || {}), {
                top: top,
                left: 0
            }));
        }
    }
    await (0, $4qxjt.triggerEventOn)("routeChanged", element, opts);
};
var $32a808518113ee1c$export$2e2bcd8739ae039 = $32a808518113ee1c$export$5375cda95f0b0eb4;


'use strict';
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $cBUNY);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $8319f99b46b296c9$exports);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $yWtDc);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $32a808518113ee1c$exports);


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jvD5p = parcelRequire("jvD5p");
var $be006f1a0fabd945$exports = {};
var $73d59c6c3fce378b$exports = {};
var $c4098057d78edae9$exports = {};

$parcel$export($c4098057d78edae9$exports, "getSystemGlobalTheme", () => $c4098057d78edae9$export$f12bbb197a836138);
$parcel$export($c4098057d78edae9$exports, "Box", () => $c4098057d78edae9$export$e71c4d32a2263218);
$parcel$export($c4098057d78edae9$exports, "Circle", () => $c4098057d78edae9$export$c89a927ffc67e6fa);
$parcel$export($c4098057d78edae9$exports, "Hr", () => $c4098057d78edae9$export$c65504044f62f430);
$parcel$export($c4098057d78edae9$exports, "Br", () => $c4098057d78edae9$export$9130f216d904f5ea);
$parcel$export($c4098057d78edae9$exports, "Div", () => $c4098057d78edae9$export$5bfb0bc6cd684584);
$parcel$export($c4098057d78edae9$exports, "Span", () => $c4098057d78edae9$export$5f1714a13ed34c01);
$parcel$export($c4098057d78edae9$exports, "Li", () => $c4098057d78edae9$export$4de39c9f3329bb96);
$parcel$export($c4098057d78edae9$exports, "Ul", () => $c4098057d78edae9$export$d4f99c77eeffeaea);
$parcel$export($c4098057d78edae9$exports, "Ol", () => $c4098057d78edae9$export$60180a808b215c38);
$parcel$export($c4098057d78edae9$exports, "Gutter", () => $c4098057d78edae9$export$b710539649c46ff);
$parcel$export($c4098057d78edae9$exports, "Flex", () => $c4098057d78edae9$export$f51f4c4ede09e011);
parcelRequire("fmM4W");
var $8dU3Q = parcelRequire("8dU3Q");

parcelRequire("cBUNY");
var $bGXur = parcelRequire("bGXur");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $c031e540a33546ea$exports = {};

$parcel$export($c031e540a33546ea$exports, "depth", () => $c031e540a33546ea$export$b202ba015b5882cd);
$parcel$export($c031e540a33546ea$exports, "SHAPES", () => $c031e540a33546ea$export$511e1d54a4a8684e);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $9da0db98e0c07b6d$exports = {};

$parcel$export($9da0db98e0c07b6d$exports, "RESET", () => $9da0db98e0c07b6d$export$4a991c87e640ef77);
var $d2de3d327c0c6201$exports = {};

$parcel$export($d2de3d327c0c6201$exports, "SEQUENCE", () => $d2de3d327c0c6201$export$34694f8d8b23ee2a);
'use strict';
const $d2de3d327c0c6201$export$34694f8d8b23ee2a = {
    'minor-second': 1.067,
    'major-second': 1.125,
    'minor-third': 1.2,
    'major-third': 1.25,
    'perfect-fourth': 1.333,
    'augmented-fourth': 1.414,
    'perfect-fifth': 1.5,
    'minor-sixth': 1.6,
    phi: 1.618,
    'major-sixth': 1.667,
    'square-root-3': 1.732,
    'minor-seventh': 1.778,
    'major-seventh': 1.875,
    octave: 2,
    'square-root-5': 2.23,
    'major-tenth': 2.5,
    'major-eleventh': 2.667,
    'major-twelfth': 3,
    pi: 3.14,
    'double-octave': 4
};


var $9ac3be22fd3c73fc$exports = {};

$parcel$export($9ac3be22fd3c73fc$exports, "UNIT", () => $9ac3be22fd3c73fc$export$97361b7a0c542045);
'use strict';
const $9ac3be22fd3c73fc$export$97361b7a0c542045 = {
    default: 'em'
};


var $cc16a6638a049274$exports = {};

$parcel$export($cc16a6638a049274$exports, "TYPOGRAPHY", () => $cc16a6638a049274$export$d36796ab73e728d9);

'use strict';
const $cc16a6638a049274$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: 'font-size',
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)['minor-third'],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $cc16a6638a049274$export$d36796ab73e728d9 = $cc16a6638a049274$var$defaultProps;


var $2015873c4c2cfb72$exports = {};

$parcel$export($2015873c4c2cfb72$exports, "FONT", () => $2015873c4c2cfb72$export$75d3998385cc196f);
'use strict';
var $2015873c4c2cfb72$var$defFont = {
    name: '',
    url: '',
    fontStyle: '',
    fontWeight: 500,
    fontStretch: 'normal',
    fontOpticalSizing: 'auto'
};
const $2015873c4c2cfb72$export$75d3998385cc196f = {};


var $814e605b31851b50$exports = {};

$parcel$export($814e605b31851b50$exports, "FONT_FAMILY", () => $814e605b31851b50$export$530097e879f93363);
$parcel$export($814e605b31851b50$exports, "FONT_FAMILY_TYPES", () => $814e605b31851b50$export$756e583a6734f96e);
$parcel$export($814e605b31851b50$exports, "FONT_FACE", () => $814e605b31851b50$export$2c16de31893252e6);
'use strict';
var $814e605b31851b50$var$defaultFont = {
    name: '',
    family: '',
    type: ''
};
const $814e605b31851b50$export$530097e879f93363 = {};
const $814e605b31851b50$export$756e583a6734f96e = {
    'sans-serif': 'Helvetica, Arial, sans-serif, --system-default',
    serif: 'Times New Roman, Georgia, serif, --system-default',
    monospace: 'Courier New, monospace, --system-default'
};
const $814e605b31851b50$export$2c16de31893252e6 = {};


var $1dbcec70a81fc9be$exports = {};

$parcel$export($1dbcec70a81fc9be$exports, "MEDIA", () => $1dbcec70a81fc9be$export$500415a86c544f73);
'use strict';
const $1dbcec70a81fc9be$export$500415a86c544f73 = {
    tv: '(min-width: 2780px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};


var $950c64c959f06041$exports = {};

$parcel$export($950c64c959f06041$exports, "SPACING", () => $950c64c959f06041$export$82ea42e772d49e5b);


'use strict';
const $950c64c959f06041$var$defaultProps = {
    base: (0, $cc16a6638a049274$export$d36796ab73e728d9).base,
    type: 'spacing',
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    sequence: {},
    scales: {},
    vars: {}
};
const $950c64c959f06041$export$82ea42e772d49e5b = $950c64c959f06041$var$defaultProps;


var $891220fdda3d21a2$exports = {};

$parcel$export($891220fdda3d21a2$exports, "COLOR", () => $891220fdda3d21a2$export$9b982809044276a6);
$parcel$export($891220fdda3d21a2$exports, "GRADIENT", () => $891220fdda3d21a2$export$3d856cf049c09ba8);
'use strict';
var $891220fdda3d21a2$var$proto = {
    name: '',
    value: ''
};
const $891220fdda3d21a2$export$9b982809044276a6 = {};
const $891220fdda3d21a2$export$3d856cf049c09ba8 = {};


var $d3a916a1fb7d8435$exports = {};

$parcel$export($d3a916a1fb7d8435$exports, "THEME", () => $d3a916a1fb7d8435$export$5714e40777c1bcc2);
'use strict';
const $d3a916a1fb7d8435$var$themeA = {
    text: 'blue',
    background: 'white',
    border: 'black',
    active: {},
    helpers: [],
    themes: {},
    inverse: {} // schemeAInverse
};
const $d3a916a1fb7d8435$export$5714e40777c1bcc2 = {};


var $8bcf1bed1aa8dad9$exports = {};

$parcel$export($8bcf1bed1aa8dad9$exports, "SHADOW", () => $8bcf1bed1aa8dad9$export$98b6069deb71e13e);
'use strict';
const $8bcf1bed1aa8dad9$var$shadow = {
    name: 'primaryShadow',
    boxShadow: 'gray12, 0 0px 50px 50px'
};
const $8bcf1bed1aa8dad9$export$98b6069deb71e13e = {};


var $60fc9d3d8a249143$exports = {};

$parcel$export($60fc9d3d8a249143$exports, "ICONS", () => $60fc9d3d8a249143$export$fde44257752a9f60);
$parcel$export($60fc9d3d8a249143$exports, "SEMANTIC_ICONS", () => $60fc9d3d8a249143$export$e63edd959d6ceec9);
'use strict';
const $60fc9d3d8a249143$export$fde44257752a9f60 = {};
const $60fc9d3d8a249143$export$e63edd959d6ceec9 = {};


var $0cc3469566cd77c9$exports = {};

$parcel$export($0cc3469566cd77c9$exports, "TIMING", () => $0cc3469566cd77c9$export$3c9e9dc0cdfaa753);

'use strict';
const $0cc3469566cd77c9$var$defaultProps = {
    default: 150,
    base: 150,
    type: 'timing',
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)['perfect-fourth'],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: 'ms',
    sequence: {},
    scales: {},
    vars: {}
};
const $0cc3469566cd77c9$export$3c9e9dc0cdfaa753 = $0cc3469566cd77c9$var$defaultProps;


var $438de410da63932f$exports = {};

$parcel$export($438de410da63932f$exports, "DOCUMENT", () => $438de410da63932f$export$ef011b4e114b1fba);
'use strict';
const $438de410da63932f$export$ef011b4e114b1fba = {};


var $567db250b885dfb6$exports = {};

$parcel$export($567db250b885dfb6$exports, "BREAKPOINTS", () => $567db250b885dfb6$export$426e07cd0772984d);
$parcel$export($567db250b885dfb6$exports, "DEVICES", () => $567db250b885dfb6$export$7e1b78538df536d8);
'use strict';
const $567db250b885dfb6$export$426e07cd0772984d = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $567db250b885dfb6$export$7e1b78538df536d8 = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};


var $49f0f03e163f2585$exports = {};

$parcel$export($49f0f03e163f2585$exports, "CASES", () => $49f0f03e163f2585$export$ddbef7dfaa374d2d);
'use strict';
const $49f0f03e163f2585$export$ddbef7dfaa374d2d = {};


var $fc04128916812e44$exports = {};

$parcel$export($fc04128916812e44$exports, "ANIMATION", () => $fc04128916812e44$export$a8fef325e42f6db3);
'use strict';
const $fc04128916812e44$export$a8fef325e42f6db3 = {};


var $f4fd3215e1191093$exports = {};

$parcel$export($f4fd3215e1191093$exports, "SVG", () => $f4fd3215e1191093$export$13f4b12aafeba5d6);
$parcel$export($f4fd3215e1191093$exports, "SVG_DATA", () => $f4fd3215e1191093$export$9738e40199601663);
'use strict';
const $f4fd3215e1191093$export$13f4b12aafeba5d6 = {};
const $f4fd3215e1191093$export$9738e40199601663 = {};


var $a13c32e8633d5002$exports = {};

$parcel$export($a13c32e8633d5002$exports, "TEMPLATES", () => $a13c32e8633d5002$export$b8020e85ad90bfe5);
'use strict';
const $a13c32e8633d5002$export$b8020e85ad90bfe5 = {};


var $13ef10175c6bbe24$exports = {};

$parcel$export($13ef10175c6bbe24$exports, "GRID", () => $13ef10175c6bbe24$export$e2b0b9a5e613f348);
'use strict';
const $13ef10175c6bbe24$var$defaultProps = {};
const $13ef10175c6bbe24$export$e2b0b9a5e613f348 = $13ef10175c6bbe24$var$defaultProps;


var $cc2ac05ddcef8e7b$exports = {};

$parcel$export($cc2ac05ddcef8e7b$exports, "CLASS", () => $cc2ac05ddcef8e7b$export$6120d77db9a8f6cb);
'use strict';
const $cc2ac05ddcef8e7b$var$defaultProps = {};
const $cc2ac05ddcef8e7b$export$6120d77db9a8f6cb = $cc2ac05ddcef8e7b$var$defaultProps;


'use strict';
const $9da0db98e0c07b6d$export$4a991c87e640ef77 = {};
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d2de3d327c0c6201$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $9ac3be22fd3c73fc$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $cc16a6638a049274$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $2015873c4c2cfb72$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $814e605b31851b50$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $1dbcec70a81fc9be$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $950c64c959f06041$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $891220fdda3d21a2$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d3a916a1fb7d8435$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $8bcf1bed1aa8dad9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $60fc9d3d8a249143$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $0cc3469566cd77c9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $438de410da63932f$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $567db250b885dfb6$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $49f0f03e163f2585$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $fc04128916812e44$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $f4fd3215e1191093$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $a13c32e8633d5002$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $13ef10175c6bbe24$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $cc2ac05ddcef8e7b$exports);


'use strict';
const $5a3b725cdb25b0eb$export$220f2e5d84ced4cb = {};
const $5a3b725cdb25b0eb$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    CSS_VARS: $5a3b725cdb25b0eb$export$220f2e5d84ced4cb,
    ...$9da0db98e0c07b6d$exports.default || $9da0db98e0c07b6d$exports
};
const $5a3b725cdb25b0eb$var$cachedConfig = (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$export$1630b5343357e8b5);
const $5a3b725cdb25b0eb$export$ee513c29aad6cc62 = {
    active: '0',
    0: $5a3b725cdb25b0eb$export$1630b5343357e8b5
};
const $5a3b725cdb25b0eb$export$8a278b801d0668ff = (def)=>{
    if ((0, $EqHTq.isDefined)(def)) $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = def;
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
const $5a3b725cdb25b0eb$export$e23c3d522afb24cd = (def)=>{
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active] || $5a3b725cdb25b0eb$export$1630b5343357e8b5;
};
const $5a3b725cdb25b0eb$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $EqHTq.isObject)(newConfig)) return;
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = '1';
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62['1'] = (0, $8wu6n.deepMerge)(newConfig, (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$var$cachedConfig));
    return newConfig;
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

'use strict';
const $18dbdacc7a38df0d$export$6a836bb704f10b75 = (unit)=>{
    return unit === 'em' || unit === 'rem' || unit === 'vw' || unit === 'vh' || unit === 'vmax' || unit === 'vmin';
};
const $18dbdacc7a38df0d$export$7263016d8c64b932 = [
    // Absolute
    'px',
    'cm',
    'mm',
    'in',
    'pt',
    'pc',
    // Font-relative
    'em',
    'rem',
    'ex',
    'cap',
    'ch',
    'ic',
    'lh',
    'rlh',
    // Viewport-relative
    '%',
    'vw',
    'vh',
    'vmin',
    'vmax',
    'svw',
    'svh',
    'lvw',
    'lvh',
    'dvw',
    'dvh',
    // Container query units
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax',
    // Angle
    'deg',
    'rad',
    'grad',
    'turn',
    // Time
    's',
    'ms',
    // Resolution
    'dpi',
    'dpcm',
    'dppx',
    // Grid fractional
    'fr',
    'auto'
];


parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");
var $jOLBF = parcelRequire("jOLBF");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $1ef99b0b26632769$export$fa32e9c99a43479e = (color)=>{
    if (color === '') return [
        0,
        0,
        0,
        0
    ];
    if (color.toLowerCase() === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
    if (color[0] === '#') {
        if (color.length < 7) color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    // convert named colors
    if (color.indexOf('rgb') === -1) {
        if ((0, $jvD5p.document) && (0, $jvD5p.window)) {
            // intentionally use unknown tag to lower chances of css rule override with !important
            const elem = (0, $jvD5p.document).body.appendChild((0, $jvD5p.document).createElement('fictum'));
            // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            const flag = 'rgb(1, 2, 3)';
            elem.style.color = flag;
            // color set failed - some monstrous css rule is probably taking over the color of our object
            if (elem.style.color !== flag) {
                (0, $jvD5p.document).body.removeChild(elem);
                return;
            }
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === '') {
                (0, $jvD5p.document).body.removeChild(elem);
                return [
                    0,
                    0,
                    0,
                    0
                ] // color parse failed
                ;
            }
            color = (0, $jvD5p.window).getComputedStyle(elem).color;
            (0, $jvD5p.document).body.removeChild(elem);
        }
    }
    // convert 'rgb(R,G,B)' to 'rgb(R,G,B,A)' which looks awful but will pass the regxep below
    if (color.indexOf('rgb') === 0) {
        if (color.indexOf('rgba') === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a) // eslint-disable-line
        ;
    }
    return [
        0,
        0,
        0,
        0
    ];
};
const $1ef99b0b26632769$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $1ef99b0b26632769$export$fa32e9c99a43479e(colorA);
    colorB = $1ef99b0b26632769$export$fa32e9c99a43479e(colorB);
    return $1ef99b0b26632769$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $1ef99b0b26632769$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $1ef99b0b26632769$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $1ef99b0b26632769$export$34d09c4a771c46ef = (r, g, b)=>{
    return '#' + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $1ef99b0b26632769$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $1ef99b0b26632769$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $1ef99b0b26632769$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n //eslint-disable-line
    );
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $1ef99b0b26632769$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $1ef99b0b26632769$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 0x1000000).toString(16).slice(1);
};
const $1ef99b0b26632769$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $1ef99b0b26632769$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ((0, $jOLBF.isNotProduction)()) console.warn(color + ' color is not rgba');
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $EqHTq.isString)(rgb) && rgb.includes('rgb')) rgb = $1ef99b0b26632769$export$fa32e9c99a43479e(rgb).join(', ');
    if ((0, $EqHTq.isString)(rgb)) rgb = rgb.split(',').map((v)=>parseFloat(v.trim()));
    if ((0, $EqHTq.isNumber)(tone)) tone += '';
    const toHex = $1ef99b0b26632769$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === '-' || abs === '+') {
        const colorShade = $1ef99b0b26632769$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $1ef99b0b26632769$export$fc66327a54d8eee6(colorShade).join(', ');
    } else {
        const [r, g, b] = rgb;
        const hsl = $1ef99b0b26632769$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl // eslint-disable-line
        ;
        const newRgb = $1ef99b0b26632769$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};


'use strict';
const $08f037a4512e32ac$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};


'use strict';
const $acb660e77bec9cb5$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $acb660e77bec9cb5$export$6c7bbed5530e9474 = (url)=>{
    const ext = url.split(/[#?]/)[0].split('.').pop().trim();
    if ([
        'woff2',
        'woff',
        'ttf',
        'otf',
        'eot'
    ].includes(ext)) return ext;
    return null;
};
const $acb660e77bec9cb5$export$460f73444f66199c = (url)=>url && (url.includes('fonts.googleapis.com') || url.includes('fonts.gstatic.com'));
const $acb660e77bec9cb5$export$3a1ea4c2338850e0 = (url)=>`@import url('${url}');`;
const $acb660e77bec9cb5$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $acb660e77bec9cb5$export$27bb82ae7d3ac02b = (name, url, weight, options = {})=>{
    const format = $acb660e77bec9cb5$export$6c7bbed5530e9474(url);
    const formatStr = format ? ` format('${format}')` : '';
    return `
  font-family: '${name}';
  font-style: normal;${weight ? `
  font-weight: ${weight};` : ''}${options.fontStretch ? `
  font-stretch: ${options.fontStretch};` : ''}${options.fontDisplay ? `
  font-display: ${options.fontDisplay};` : ''}
  src: url('${url}')${formatStr};`;
};
const $acb660e77bec9cb5$export$2593ac3417be5ed7 = (name, url, weight, options)=>`@font-face {${$acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, weight, options)}
}`;
const $acb660e77bec9cb5$export$198e04e3616f042a = (name, weights)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        return $acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, fontWeight);
    });
};
const $acb660e77bec9cb5$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $acb660e77bec9cb5$export$c26ef91aac8931ec = (name, weights)=>{
    if (weights && weights.isVariable) {
        if ($acb660e77bec9cb5$export$460f73444f66199c(weights.url)) return $acb660e77bec9cb5$export$3a1ea4c2338850e0(weights.url);
        return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, weights.url, weights.fontWeight, {
            fontStretch: weights.fontStretch,
            fontDisplay: weights.fontDisplay || 'swap'
        });
    }
    const isArr = weights[0];
    if (isArr) return $acb660e77bec9cb5$export$198e04e3616f042a(name, weights).map($acb660e77bec9cb5$export$e84fe2812840a337);
    return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, weights.url);
};
const $acb660e77bec9cb5$export$8b73d71a1d936bc = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$c26ef91aac8931ec(key, LIBRARY[key].value));
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



'use strict';
const $366218d35fdab076$export$81ab9dc24d52c4ba = {
    '-6': 'U',
    '-5': 'V',
    '-4': 'W',
    '-3': 'X',
    '-2': 'Y',
    '-1': 'Z',
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D',
    4: 'E',
    5: 'F',
    6: 'G',
    7: 'H',
    8: 'I',
    9: 'J',
    10: 'K',
    11: 'L',
    12: 'M',
    13: 'N',
    14: 'O',
    15: 'P',
    16: 'Q',
    17: 'R',
    18: 'S',
    19: 'T'
};
const $366218d35fdab076$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
const $366218d35fdab076$export$30fba622059784de = (val)=>{
    if (!val.includes('(')) return val;
    const prefix = val.split('(')[0];
    const value = val.slice(val.indexOf('(') + 1, val.lastIndexOf(')'));
    return [
        prefix,
        value
    ];
};
const $366218d35fdab076$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = '--' + (type && type.replace('.', '-'));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $366218d35fdab076$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = '--' + (type && type.replace('.', '-'));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $366218d35fdab076$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $366218d35fdab076$export$50db87b17b1557b4 = (base, ratio)=>{
    return $366218d35fdab076$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $366218d35fdab076$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $366218d35fdab076$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1000) / 1000;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $366218d35fdab076$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
    });
};
const $366218d35fdab076$var$switchSequenceOnNegative = (key, base, ratio)=>{
    // const values = Object.values(SEQUENCE)
    // const index = values.indexOf(ratio)
    // const diffRatio = ratio / SPACING.ratio
    // const total = values[values.length - 1] - values[0]
    // const avg = total / 2
    // const diff = avg - ratio
    // const scale = total / ratio
    // const finalDiff = avg + avg / diffRatio
    // if (key < 0) return base * Math.pow(avg, key)
    return base * Math.pow(ratio, key);
};
const $366218d35fdab076$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = '--' + (type && type.replace('.', '-')) + '-';
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key];
        const value = $366218d35fdab076$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $366218d35fdab076$export$7b7c0090b74e1e64 = (sequenceProps, position = 0)=>{
    const { type: type, base: base, ratio: ratio, subSequence: subSequence } = sequenceProps;
    const letterKey = (0, $EqHTq.isString)(position) ? position : $366218d35fdab076$export$81ab9dc24d52c4ba[position];
    const index = (0, $EqHTq.isString)(position) ? Object.entries($366218d35fdab076$export$81ab9dc24d52c4ba).find(([, value])=>value === position)?.[0] : position;
    if (!letterKey) {
        console.warn(`Position ${position} is out of range in numToLetterMap`);
        return null;
    }
    const result = {
        sequence: {},
        scales: {},
        vars: {},
        ...sequenceProps
    };
    const value = base * Math.pow(ratio, index);
    const scaling = ~~(value / base * 100) / 100;
    const prefix = '--' + (type && type.replace('.', '-')) + '-';
    const variable = prefix + letterKey;
    const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(index, sequenceProps);
    const props = {
        key: letterKey,
        variable: variable,
        value: value,
        base: base,
        scaling: scaling,
        scalingVariable: scalingVariable,
        ratio: ratio,
        index: index
    };
    $366218d35fdab076$var$setSequenceValue(props, result);
    if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, result);
    return result;
};
const $366218d35fdab076$export$efde09b5692f9bd0 = (value = 'A', sequenceProps)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    if ((0, $EqHTq.isString)(value) && value.slice(0, 2) === '--') return `var(${value})`;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    const hasUnits = (0, $18dbdacc7a38df0d$export$7263016d8c64b932).some((unit)=>value.includes(unit));
    if (hasUnits || !startsWithDashOrLetter) return value;
    const skipArr = [
        'none',
        'auto',
        'max-content',
        'min-content',
        'fit-content',
        'inherit',
        'initial',
        'unset',
        'revert',
        'revert-layer'
    ];
    if (skipArr.includes(value)) return value;
    const prefix = `--${(0, $8319f99b46b296c9$export$6401d9e8afa09755)(sequenceProps.type.replace('.', '-'))}-`;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === '-' ? '-' : '';
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = '';
    if (absValue.includes('_')) {
        mediaName = '_' + absValue.split('_')[1].toLowerCase();
        absValue = absValue.split('_')[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes('+')) {
        const [first, second] = absValue.split('+');
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('*')) {
        const [first, second] = absValue.split('*');
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('-')) {
        // TODO: check this
        // check for the first char
        const [first, second] = absValue.split('-');
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    // if subsequence is not set but value is applied
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, '- value is not found because `subSequence` is set to false');
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue} * -1)` : varValue;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === 'ms' || unit === 's') return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $366218d35fdab076$export$69f332a3be1b2f36 = (value, sequenceProps)=>{
    const mathArr = [
        '+',
        '-',
        '*',
        '/',
        ','
    ].filter((v)=>value.includes(v + ' '));
    if (!mathArr.length) return value;
    return mathArr.map((symbol)=>{
        const valuesArr = value.split(symbol + ' ').map((v)=>v.trim());
        const transformedValues = valuesArr.map((v)=>{
            return $366218d35fdab076$export$efde09b5692f9bd0(v, sequenceProps);
        });
        return transformedValues.join(' ' + symbol + ' ');
    }).join('');
};
const $366218d35fdab076$export$86c0052f25dacc45 = (value, propertyName, sequenceProps, fnPrefix)=>{
    if (typeof value !== 'string') {
        const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
        if (CONFIG.verbose) console.warn(propertyName, value, 'is not a string');
        return {
            [propertyName]: value
        };
    }
    if (value === '-' || value === '') return {};
    if (!fnPrefix && value.includes('(')) {
        const fnArr = $366218d35fdab076$export$30fba622059784de(value);
        fnPrefix = fnArr[0];
        value = fnArr[1];
    }
    const mathArr = [
        '+',
        '-',
        '*',
        '/',
        ','
    ].filter((v)=>value.includes(v + ' '));
    if (mathArr.length) value = $366218d35fdab076$export$69f332a3be1b2f36(value, sequenceProps);
    else value = $366218d35fdab076$export$efde09b5692f9bd0(value, sequenceProps);
    return {
        [propertyName]: fnPrefix ? `${fnPrefix}(${value})` : value
    };
};
const $366218d35fdab076$export$14c834a042d41297 = (h1Matches, index)=>$366218d35fdab076$export$81ab9dc24d52c4ba[h1Matches - index];
const $366218d35fdab076$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $366218d35fdab076$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



'use strict';
const $313f46bb97bb8cbe$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if ((0, $EqHTq.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $313f46bb97bb8cbe$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = '--' + (type && type.replace('.', '-'));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $366218d35fdab076$export$50db87b17b1557b4)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
// vars[`${prefix}-sub-ratio-1`] = first
// vars[`${prefix}-sub-ratio-2`] = middle
// vars[`${prefix}-sub-ratio-3`] = second
};
const $313f46bb97bb8cbe$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, TIMING: TIMING, CSS_VARS: CSS_VARS } = CONFIG;
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $313f46bb97bb8cbe$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = `var(${item.variable + '_default'})`;
        }
    }
};
const $313f46bb97bb8cbe$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, MEDIA: MEDIA, CSS_VARS: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = FACTORY[media];
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn('Can\'t find media query ', query);
    // if mediaRegenerate is not applied ratio and and sequence sizes
    // will be applied using CSS vars
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $313f46bb97bb8cbe$export$eba6b21fdce78bcd(underMediaQuery, FACTORY[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn('Can\'t find query ', query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + '_' + mediaName})`;
        CSS_VARS[item.variable + '_' + mediaName] = value;
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");

'use strict';
const $da07070d258f49a5$var$isDev = (0, $jOLBF.isNotProduction)();
const $da07070d258f49a5$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    let sprite = '';
    for(const key in icons){
        if (CONFIG.__svg_cache[key]) continue;
        else CONFIG.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $da07070d258f49a5$var$parseRootAttributes = (htmlString)=>{
    const val = htmlString.default || htmlString;
    if (!(0, $EqHTq.isString)(val)) {
        if ($da07070d258f49a5$var$isDev) console.warn('parseRootAttributes:', val, 'is not a string');
        return;
    }
    const match = val.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split('=');
        acc[key] = value.replace(/['"]/g, '');
        return acc;
    }, {});
};
const $da07070d258f49a5$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $EqHTq.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 100000);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $da07070d258f49a5$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $da07070d258f49a5$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = 'http://www.w3.org/2000/svg';
    const replacedCode = $da07070d258f49a5$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace('<svg', `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, '');
    symbol = symbol.replace(/height="[^"]*"/, '');
    symbol = symbol.replace('</svg', '</symbol');
    return symbol;
};


'use strict';


'use strict';
const $c6753c52b98cd54e$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if (value.slice(0, 2) === '--') return `var(${value})`;
    if (key && value[key]) value = value[key];
    const [name, alpha, tone] = (0, $EqHTq.isArray)(value) ? value : value.split(' ');
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn('Can\'t find color ', name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, ' - does not have ', key);
    }
    // TODO: support variables
    // if (alpha) return `rgba(var(${val[shade || ''].var}), ${modifier})`
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $1ef99b0b26632769$export$2d78fefdcfb7f222)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $c6753c52b98cd54e$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if (value.slice(0, 2) === '--') return `var(${value})`;
    const [name] = (0, $EqHTq.isArray)(value) ? value : value.split(' ');
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $EqHTq.isObject)(val);
    if (isObj && val.value) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG.MEDIA[mediaName.slice(1)];
                const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
                obj[media] = $c6753c52b98cd54e$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn('Can\'t find color', value);
        return value;
    }
};
const $c6753c52b98cd54e$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === '--') {
        val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
        if (!(val.includes('rgb') || val.includes('var') || val.includes('#'))) {
            if (CONFIG.verbose) console.warn(val, '- referred but does not exist');
            val = val.split(' ')[0];
        }
    }
    if ((0, $EqHTq.isArray)(val)) return {
        '@light': $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[0], key, 'light'),
        '@dark': $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[1], key, 'dark')
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : '');
    const colorArr = (0, $1ef99b0b26632769$export$fa32e9c99a43479e)(val.value || val);
    const [r, g, b, a = 1] = colorArr;
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $c6753c52b98cd54e$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === '--') val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $EqHTq.isArray)(val)) return {
        '@light': $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, 'light'),
        '@dark': $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, 'dark')
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : '');
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};



'use strict';
const $c031e540a33546ea$var$CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
const $c031e540a33546ea$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$c031e540a33546ea$var$CONFIG.UNIT.default} 4${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$c031e540a33546ea$var$CONFIG.UNIT.default} 6${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$c031e540a33546ea$var$CONFIG.UNIT.default} 10${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$c031e540a33546ea$var$CONFIG.UNIT.default} 16${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$c031e540a33546ea$var$CONFIG.UNIT.default} 26${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$c031e540a33546ea$var$CONFIG.UNIT.default} 42${$c031e540a33546ea$var$CONFIG.UNIT.default}`
    }
};
const $c031e540a33546ea$var$getComputedBackgroundColor = ({ props: props })=>{
    return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.shapeDirectionColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.borderColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.backgroundColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.background);
};
const $c031e540a33546ea$var$inheritTransition = ({ props: props, deps: deps })=>{
    const exec = (0, $c4098057d78edae9$export$e71c4d32a2263218).class.transition({
        props: props,
        deps: deps
    });
    return exec && exec.transition;
};
const $c031e540a33546ea$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: '100%'
    },
    bubble: {},
    tv: {
        borderRadius: '1.15em/2.5em'
    },
    tooltip: ({ props: props, deps: deps })=>({
            position: props.position || 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
                border: '.35em solid',
                borderColor: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'border-color',
                position: 'absolute',
                borderRadius: '.15em'
            }
        }),
    tooltipDirection: {
        top: {
            '&:before': {
                top: '0',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                right: '0',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                bottom: '0',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                left: '0',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        }
    },
    tag: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background',
                borderRadius: '.25em',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%'
            }
        }),
    tagDirection: {
        top: {
            '&:before': {
                bottom: '100%',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                left: '100%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                top: '100%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                right: '100%',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        }
    },
    hexagon: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                borderRadius: '.25em',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%',
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            },
            '&:after': {
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }),
    chevron: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                transition: $c031e540a33546ea$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                background: `linear-gradient(225deg, ${$c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%), linear-gradient(315deg, ${$c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%)`
            },
            '&:after': {
                background: $c031e540a33546ea$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                borderRadius: '.25em'
            }
        }),
    chevronDirection: {
        left: {
            '&:before': {
                height: '100%',
                left: '100%',
                transform: 'translate3d(-1%, -50%, 1px) scale(-1, 1)'
            },
            '&:after': {
                height: '73%',
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                height: '100%',
                left: '0',
                transform: 'translate3d(-99%, -50%, 1px)'
            },
            '&:after': {
                height: '73%',
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }
    }
};


var $bc85e892389de1ab$exports = {};

$parcel$export($bc85e892389de1ab$exports, "keySetters", () => $bc85e892389de1ab$export$5c168558fab3755c);
$parcel$export($bc85e892389de1ab$exports, "beforeClassAssign", () => $bc85e892389de1ab$export$e6abde80e220280b);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");

'use strict';
const $bc85e892389de1ab$export$5c168558fab3755c = {
    '@': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyMediaProps(key, props, isSubtree ? result : result && result.media, element),
    ':': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '[': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '*': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '+': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '~': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '&': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    '>': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    $: (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyCaseProps(key, props, isSubtree ? result : result && result.case, element),
    '-': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyVariableProps(key, props, isSubtree ? result : result && result.variable, element),
    '.': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalCaseProps(key, props, isSubtree ? result : result && result.case, element),
    '!': (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalFalsyProps(key, props, isSubtree ? result : result && result.case, element)
};
const $bc85e892389de1ab$var$execClass = (key, props, result, element)=>{
    const { class: className } = element;
    const classnameExec = className[key];
    if (typeof classnameExec !== 'function') return;
    let classExec = classnameExec({
        props: props,
        context: element.context,
        state: element.state,
        deps: element.deps
    }, element.state, element.context);
    if ((0, $EqHTq.isArray)(classExec)) classExec = classExec.reduce((a, c)=>(0, $8wu6n.merge)(a, c), {});
    for(const finalProp in classExec)result[finalProp] = classExec[finalProp];
    return classExec;
};
const $bc85e892389de1ab$var$convertPropsToClass = (props, result, element)=>{
    const propsClassObj = {};
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (setter) {
            setter(key, props[key], propsClassObj, element, true);
            continue;
        } else $bc85e892389de1ab$var$execClass(key, props, propsClassObj, element);
    }
    return propsClassObj;
};
const $bc85e892389de1ab$var$applyMediaProps = (key, props, result, element)=>{
    const { context: context } = element;
    if (!context.designSystem || !context.designSystem.MEDIA) return;
    const globalTheme = (0, $c4098057d78edae9$export$f12bbb197a836138)(element);
    const { MEDIA: MEDIA } = context.designSystem;
    const mediaValue = MEDIA[key.slice(1)];
    const generatedClass = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    const name = key.slice(1);
    const isTheme = [
        'dark',
        'light'
    ].includes(name);
    const matchesGlobal = name === globalTheme;
    if (globalTheme && isTheme) {
        if (matchesGlobal) return (0, $8wu6n.merge)(result, generatedClass);
        return;
    }
    const printValue = '@media ' + (mediaValue === 'print' ? `${mediaValue}` : `screen and ${mediaValue}`);
    const mediaKey = mediaValue ? printValue : key;
    result[mediaKey] = generatedClass;
    return result[mediaKey];
};
const $bc85e892389de1ab$var$applyAndProps = (key, props, result, element)=>{
    result[key] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[key];
};
const $bc85e892389de1ab$var$applySelectorProps = (key, props, result, element)=>{
    const selectorKey = `&${key}`;
    result[selectorKey] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[selectorKey];
};
const $bc85e892389de1ab$var$applyCaseProps = (key, props, result, element)=>{
    const { CASES: CASES } = element.context && element.context.designSystem;
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey];
    if (!CASES[caseKey] && !isPropTrue) return;
    return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyVariableProps = (key, props, result, element)=>{
    result[key] = props;
    return result;
};
const $bc85e892389de1ab$var$applyConditionalCaseProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (!isPropTrue) return; // remove classname if not here
    return (0, $8wu6n.overwriteDeep)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyConditionalFalsyProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (!isPropTrue) return (0, $8wu6n.overwriteDeep)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyTrueProps = (props, result, element)=>(0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
const $bc85e892389de1ab$export$e6abde80e220280b = (element, s, ctx)=>{
    const { props: props, class: className, context: context } = element;
    const CLASS_NAMES = {
        media: {},
        selector: {},
        case: {},
        variable: {}
    };
    if (!context) return;
    const globalTheme = context.designSystem.globalTheme;
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (globalTheme) {
            if (key === 'theme' && !props.themeModifier) props.themeModifier = globalTheme;
        // props.update(
        //   {
        //     themeModifier: globalTheme
        //   },
        //   {
        //     preventListeners: true,
        //     preventRecursive: true,
        //     isForced: true,
        //     preventDefineUpdate: true
        //   }
        // )
        }
        if (setter) setter(key, props[key], CLASS_NAMES, element);
        else if (key === 'class') {
            const value = element.props.class;
            if (!element.call('isString', value)) return;
            const classArr = value.split(' ');
            const scratchClasses = ctx.designSystem.CLASS;
            CLASS_NAMES.class = classArr.reduce((accumulator, current)=>{
                const scratchClass = scratchClasses[current];
                return (0, $8wu6n.merge)(accumulator, scratchClass);
            }, {});
        } else if (key === 'true') $bc85e892389de1ab$var$applyTrueProps(props[key], CLASS_NAMES, element);
    }
    // override props
    // if (props['^']) {
    //   for (const key in props['^']) {
    //     execClass(key, props, CLASS_NAMES, element)
    //   }
    // }
    const parentProps = element.parent && element.parent.props;
    if (parentProps && parentProps.spacingRatio && parentProps.inheritSpacingRatio) element.setProps({
        spacingRatio: parentProps.spacingRatio,
        inheritSpacingRatio: true
    }, {
        preventListeners: true,
        preventRecursive: true,
        isForced: true,
        preventDefineUpdate: true
    });
    (0, $8wu6n.overwriteShallow)(className, CLASS_NAMES);
};



'use strict';
const $c4098057d78edae9$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $c4098057d78edae9$var$transformBorderRadius = (radius, props, propertyName)=>{
    if (!(0, $EqHTq.isString)(radius)) return;
    return {
        borderRadius: radius.split(' ').map((v, k)=>(0, $16baa215ff216ac9$exports.getSpacingBasedOnRatio)(props, propertyName, v)[propertyName]).join(' ')
    };
};
const $c4098057d78edae9$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    if ((0, $EqHTq.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $c4098057d78edae9$var$PropsCSS = {
    class: {
        style: (el)=>el.props && el.props.style
    }
};
const $c4098057d78edae9$export$e71c4d32a2263218 = {
    extend: [
        $c4098057d78edae9$var$PropsCSS,
        'Text'
    ],
    deps: {
        getSpacingBasedOnRatio: $16baa215ff216ac9$exports.getSpacingBasedOnRatio,
        getSpacingByKey: $16baa215ff216ac9$exports.getSpacingByKey,
        transfromGap: $16baa215ff216ac9$exports.transfromGap,
        transformSizeRatio: $16baa215ff216ac9$exports.transformSizeRatio,
        transformSize: $16baa215ff216ac9$exports.transformSize,
        applyAnimationProps: $c4098057d78edae9$var$applyAnimationProps,
        isUndefined: $EqHTq.isUndefined,
        isString: $EqHTq.isString,
        getTimingFunction: $16baa215ff216ac9$exports.getTimingFunction,
        getTimingByKey: $16baa215ff216ac9$exports.getTimingByKey,
        splitTransition: $16baa215ff216ac9$exports.splitTransition,
        transformDuration: $16baa215ff216ac9$exports.transformDuration,
        depth: $c031e540a33546ea$export$b202ba015b5882cd,
        exec: $8wu6n.exec,
        getSystemGlobalTheme: $c4098057d78edae9$export$f12bbb197a836138,
        getMediaTheme: $16baa215ff216ac9$exports.getMediaTheme,
        getMediaColor: $16baa215ff216ac9$exports.getMediaColor,
        transformTextStroke: $16baa215ff216ac9$exports.transformTextStroke,
        transformShadow: $16baa215ff216ac9$exports.transformShadow,
        transformBoxShadow: $16baa215ff216ac9$exports.transformBoxShadow,
        transformBorder: $16baa215ff216ac9$exports.transformBorder,
        transformBackgroundImage: $16baa215ff216ac9$exports.transformBackgroundImage,
        transformBorderRadius: $c4098057d78edae9$var$transformBorderRadius,
        applyAnimationProps: $c4098057d78edae9$var$applyAnimationProps
    },
    attr: {
        id: (el)=>el.call('isString', el.props.id) && el.props.id,
        title: (el)=>el.call('isString', el.props.title) && el.props.title,
        contentEditable: (el, s)=>{
            const isEditable = el.props.contentEditable || el.props.contenteditable;
            if (isEditable) return el.call(isEditable, el, s);
        },
        dir: (el)=>el.props.dir,
        draggable: (el)=>el.props.draggable,
        hidden: (el)=>el.props.hidden,
        lang: (el)=>el.props.lang,
        spellcheck: (el)=>el.props.spellcheck,
        tabindex: (el)=>el.props.tabindex,
        translate: (el)=>el.props.translate,
        'data-testid': (el, s)=>(s.root.ENV === 'testing' || s.root.ENV === 'staging') && ((el.__ref.path.length > 5 ? el.__ref.path.slice(1, 4).concat(el.__ref.path.slice(-2)) : el.__ref.path.slice(1)).join('.') || 'root')
    },
    define: {
        $collection: async (param, el, state)=>{
            const { __ref: ref } = el;
            const { children: childrenProps, childrenAs: childrenAs, childExtends: childExtends } = el.props || {};
            const children = childrenProps && await (0, $8wu6n.exec)(childrenProps, el, state);
            const childrenAsDefault = childrenAs || 'props';
            if (children) {
                if ((0, $EqHTq.isObject)(children)) {
                    if (children.$$typeof) return el.call('renderReact', children, el);
                    if (childrenAsDefault && childrenAsDefault !== 'state') {
                        param = (0, $8wu6n.deepClone)(children);
                        param = Object.keys(param).map((v)=>{
                            const val = param[v];
                            return (0, $bGXur.addAdditionalExtend)(v, val);
                        });
                    }
                } else if ((0, $EqHTq.isArray)(children)) {
                    param = (0, $8wu6n.deepClone)(children);
                    if (childrenAsDefault && childrenAsDefault !== 'element') param = param.map((v)=>({
                            ...childExtends && {
                                extend: childExtends
                            },
                            [childrenAsDefault]: (0, $EqHTq.isObjectLike)(v) ? v : childrenAsDefault === 'state' ? {
                                value: v
                            } : {
                                text: v
                            }
                        }));
                } else if ((0, $EqHTq.isString)(children) || (0, $EqHTq.isNumber)(children)) {
                    el.removeContent();
                    el.content = {
                        text: param
                    };
                    return;
                }
            }
            if (!param) return;
            const filterReact = param.filter((v)=>!v.$$typeof);
            if (filterReact.length !== param.length) {
                const extractedReactComponents = param.filter((v)=>v.$$typeof);
                el.call('renderReact', extractedReactComponents, el);
            }
            param = filterReact;
            if ((0, $EqHTq.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8dU3Q.getChildStateInKey)(param, state);
            }
            if ((0, $8dU3Q.isState)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)('array', 'object')) return;
            param = (0, $8wu6n.deepClone)(param);
            if (ref.__collectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__collectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__collectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__collectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = (0, $EqHTq.isObjectLike)(value) ? value : {
                    value: value
                };
            }
            el.removeContent();
            el.content = obj;
        // return deepClone(param)
        },
        $setCollection: async (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8dU3Q.getChildStateInKey)(param, state);
            }
            const data = ((0, $EqHTq.isArray)(param) ? param : (0, $EqHTq.isObject)(param) ? Object.values(param) : []).map((item)=>!(0, $EqHTq.isObjectLike)(item) ? {
                    props: {
                        value: item
                    }
                } : item);
            if (data.length) {
                const t = setTimeout(()=>{
                    el.set({
                        tag: 'fragment',
                        ...data
                    }, {
                        preventDefineUpdate: '$setCollection'
                    });
                    clearTimeout(t);
                });
            }
            return data;
        },
        $stateCollection: async (param, el, state, ctx)=>{
            const { children: children, childrenAs: childrenAs } = el.props || {};
            if (!param || children || childrenAs) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8dU3Q.getChildStateInKey)(param, state);
            }
            if ((0, $8dU3Q.isState)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)('array', 'object')) return;
            const { __ref: ref } = el;
            param = (0, $8wu6n.deepClone)(param);
            if (ref.__stateCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__stateCollectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = {
                    state: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
        // return deepClone(param)
        },
        $propsCollection: async (param, el, state)=>{
            const { children: children, childrenAs: childrenAs } = el.props || {};
            if (!param || children || childrenAs) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8dU3Q.getChildStateInKey)(param, state);
            }
            if ((0, $8dU3Q.isState)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)('array', 'object')) return;
            const { __ref: ref } = el;
            param = (0, $8wu6n.deepClone)(param);
            if (ref.__propsCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__propsCollectionCache) // eslint-disable-line
                ;
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = {
                    props: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
        // const set = () => {
        //   el.set(obj, { preventDefineUpdate: '$propsCollection' })
        // }
        // if (el.props && el.props.lazyLoad) {
        //   window.requestAnimationFrame(set)
        // } else set()
        // return deepClone(param)
        }
    },
    class: {
        flow: (element)=>{
            const { props: props, deps: deps } = element;
            const flow = deps.exec.call(element, props.flow);
            const reverse = deps.exec.call(element, props.reverse);
            if (!(0, $EqHTq.isString)(flow)) return;
            let [direction, wrap] = (flow || 'row').split(' ');
            if (flow.startsWith('x') || flow === 'row') direction = 'row';
            if (flow.startsWith('y') || flow === 'column') direction = 'column';
            return {
                display: 'flex',
                flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
            };
        },
        wrap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.wrap);
            if (!val) return;
            return {
                display: 'flex',
                flexWrap: val
            };
        },
        align: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.align);
            if (!(0, $EqHTq.isString)(val)) return;
            const [alignItems, justifyContent] = val.split(' ');
            return {
                display: 'flex',
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        },
        show: (el, s, ctx)=>!!(ctx.utils.exec(el.props.show, el, s) === false) && {
                display: 'none !important'
            },
        hide: (el, s, ctx)=>!!ctx.utils.exec(el.props.hide, el, s) && {
                display: 'none !important'
            },
        height: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'height', props);
        },
        width: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'width', props);
        },
        boxSizing: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.boxSizing);
            return !deps.isUndefined(val) ? {
                boxSizing: val
            } : {
                boxSizing: 'border-box'
            };
        },
        boxSize: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.boxSize);
            if (!deps.isString(val)) return;
            const [height, width] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'height', height),
                ...deps.transformSize.call(el, 'width', width || height)
            };
        },
        inlineSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'inlineSize', props);
        },
        blockSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'blockSize', props);
        },
        minWidth: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'minWidth', props);
        },
        maxWidth: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'maxWidth', props);
        },
        widthRange: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.widthRange);
            if (!deps.isString(val)) return;
            const [minWidth, maxWidth] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'minWidth', minWidth),
                ...deps.transformSize.call(el, 'maxWidth', maxWidth || minWidth)
            };
        },
        minHeight: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'minHeight', props);
        },
        maxHeight: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'maxHeight', props);
        },
        heightRange: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.heightRange);
            if (!deps.isString(val)) return;
            const [minHeight, maxHeight] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'minHeight', minHeight),
                ...deps.transformSize.call(el, 'maxHeight', maxHeight || minHeight)
            };
        },
        size: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.size);
            if (!deps.isString(val)) return;
            const [inlineSize, blockSize] = val.split(' ');
            return {
                ...deps.transformSizeRatio.call(el, 'inlineSize', inlineSize),
                ...deps.transformSizeRatio.call(el, 'blockSize', blockSize || inlineSize)
            };
        },
        minBlockSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'minBlockSize', props);
        },
        minInlineSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'minInlineSize', props);
        },
        maxBlockSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'maxBlockSize', props);
        },
        maxInlineSize: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'maxInlineSize', props);
        },
        minSize: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.minSize);
            if (!deps.isString(val)) return;
            const [minInlineSize, minBlockSize] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'minInlineSize', minInlineSize),
                ...deps.transformSize.call(el, 'minBlockSize', minBlockSize || minInlineSize)
            };
        },
        maxSize: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.maxSize);
            if (!deps.isString(val)) return;
            const [maxInlineSize, maxBlockSize] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'maxInlineSize', maxInlineSize),
                ...deps.transformSize.call(el, 'maxBlockSize', maxBlockSize || maxInlineSize)
            };
        },
        borderWidth: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'borderWidth', props);
        },
        padding: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'padding', props);
        },
        scrollPadding: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'scrollPadding', props);
        },
        paddingInline: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.paddingInline);
            if (!deps.isString(val)) return;
            const [paddingInlineStart, paddingInlineEnd] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'paddingInlineStart', paddingInlineStart),
                ...deps.transformSize('paddingInlineEnd', paddingInlineEnd || paddingInlineStart)
            };
        },
        paddingBlock: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.paddingBlock);
            if (!deps.isString(val)) return;
            const [paddingBlockStart, paddingBlockEnd] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'paddingBlockStart', paddingBlockStart),
                ...deps.transformSize('paddingBlockEnd', paddingBlockEnd || paddingBlockStart)
            };
        },
        paddingInlineStart: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'paddingInlineStart', props);
        },
        paddingInlineEnd: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'paddingInlineEnd', props);
        },
        paddingBlockStart: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'paddingBlockStart', props);
        },
        paddingBlockEnd: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'paddingBlockEnd', props);
        },
        margin: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'margin', props);
        },
        marginInline: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.marginInline);
            if (!deps.isString(val)) return;
            const [marginInlineStart, marginInlineEnd] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'marginInlineStart', marginInlineStart),
                ...deps.transformSize('marginInlineEnd', marginInlineEnd || marginInlineStart)
            };
        },
        marginBlock: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.marginBlock);
            if (!deps.isString(val)) return;
            const [marginBlockStart, marginBlockEnd] = val.split(' ');
            return {
                ...deps.transformSize.call(el, 'marginBlockStart', marginBlockStart),
                ...deps.transformSize('marginBlockEnd', marginBlockEnd || marginBlockStart)
            };
        },
        marginInlineStart: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'marginInlineStart', props);
        },
        marginInlineEnd: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'marginInlineEnd', props);
        },
        marginBlockStart: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'marginBlockStart', props);
        },
        marginBlockEnd: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'marginBlockEnd', props);
        },
        gap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gap);
            if (deps.isUndefined(val)) return;
            return {
                gap: (0, $16baa215ff216ac9$exports.transfromGap)(val)
            };
        },
        columnGap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnGap);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingBasedOnRatio({
                ...props,
                columnGap: val
            }, 'columnGap');
        },
        rowGap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.rowGap);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingBasedOnRatio({
                ...props,
                rowGap: val
            }, 'rowGap');
        },
        flexWrap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flexWrap);
            if (deps.isUndefined(val)) return;
            return {
                display: 'flex',
                flexFlow: (props.flexFlow || 'row').split(' ')[0] + ' ' + val
            };
        },
        flexFlow: (element)=>{
            const { props: props, deps: deps } = element;
            const flexFlow = deps.exec.call(element, props.flexFlow);
            const reverse = deps.exec.call(element, props.reverse);
            if (!deps.isString(flexFlow)) return;
            let [direction, wrap] = (flexFlow || 'row').split(' ');
            if (flexFlow.startsWith('x') || flexFlow === 'row') direction = 'row';
            if (flexFlow.startsWith('y') || flexFlow === 'column') direction = 'column';
            return {
                display: 'flex',
                flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
            };
        },
        flexAlign: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.flexAlign);
            if (!deps.isString(val)) return;
            const [alignItems, justifyContent] = val.split(' ');
            return {
                display: 'flex',
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        },
        // block:css
        display: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.display);
            if (deps.isUndefined(val)) return;
            return {
                display: val
            };
        },
        direction: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.direction);
            if (deps.isUndefined(val)) return;
            return {
                direction: val
            };
        },
        objectFit: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.objectFit);
            if (deps.isUndefined(val)) return;
            return {
                objectFit: val
            };
        },
        aspectRatio: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.aspectRatio);
            if (deps.isUndefined(val)) return;
            return {
                aspectRatio: val
            };
        },
        gridArea: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridArea);
            if (!val) return;
            return {
                gridArea: val
            };
        },
        float: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.float);
            if (deps.isUndefined(val)) return;
            return {
                float: val
            };
        },
        flex: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flex);
            if (deps.isUndefined(val)) return;
            return {
                flex: val
            };
        },
        flexDirection: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flexDirection);
            if (deps.isUndefined(val)) return;
            return {
                flexDirection: val
            };
        },
        alignItems: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.alignItems);
            if (deps.isUndefined(val)) return;
            return {
                alignItems: val
            };
        },
        alignContent: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.alignContent);
            if (deps.isUndefined(val)) return;
            return {
                alignContent: val
            };
        },
        justifyContent: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.justifyContent);
            if (deps.isUndefined(val)) return;
            return {
                justifyContent: val
            };
        },
        justifyItems: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.justifyItems);
            if (deps.isUndefined(val)) return;
            return {
                justifyItems: val
            };
        },
        alignSelf: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.alignSelf);
            if (deps.isUndefined(val)) return;
            return {
                alignSelf: val
            };
        },
        order: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.order);
            if (deps.isUndefined(val)) return;
            return {
                order: val
            };
        },
        gridColumn: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridColumn);
            if (deps.isUndefined(val)) return;
            return {
                gridColumn: val
            };
        },
        gridColumnStart: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridColumnStart);
            if (deps.isUndefined(val)) return;
            return {
                gridColumnStart: val
            };
        },
        gridRow: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridRow);
            if (deps.isUndefined(val)) return;
            return {
                gridRow: val
            };
        },
        gridRowStart: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridRowStart);
            if (deps.isUndefined(val)) return;
            return {
                gridRowStart: val
            };
        },
        resize: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.resize);
            if (deps.isUndefined(val)) return;
            return {
                resize: val
            };
        },
        verticalAlign: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.verticalAlign);
            if (deps.isUndefined(val)) return;
            return {
                verticalAlign: val
            };
        },
        columns: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columns);
            if (deps.isUndefined(val)) return;
            return {
                columns: val
            };
        },
        columnRule: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnRule);
            if (deps.isUndefined(val)) return;
            return {
                columnRule: val
            };
        },
        columnWidth: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnWidth);
            if (deps.isUndefined(val)) return;
            return {
                columnWidth: val
            };
        },
        columnSpan: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnSpan);
            if (deps.isUndefined(val)) return;
            return {
                columnSpan: val
            };
        },
        columnFill: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnFill);
            if (deps.isUndefined(val)) return;
            return {
                columnFill: val
            };
        },
        columnCount: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnCount);
            if (deps.isUndefined(val)) return;
            return {
                columnCount: val
            };
        },
        // direction
        direction: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.direction);
            if (!val) return;
            return {
                direction: val
            };
        },
        position: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.position);
            if (!val) return;
            return {
                position: val
            };
        },
        inset: (element, s, ctx)=>{
            const { props: props, deps: deps } = element;
            const inset = deps.exec.call(element, props.inset);
            if (ctx.utils.isNumber(inset)) return {
                inset: inset
            };
            if (!ctx.utils.isString(inset)) return;
            return {
                inset: inset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k).join(' ')
            };
        },
        left: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.left);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingByKey(val, 'left');
        },
        top: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.top);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingByKey(val, 'top');
        },
        right: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.right);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingByKey(val, 'right');
        },
        bottom: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.bottom);
            if (deps.isUndefined(val)) return;
            return deps.getSpacingByKey(val, 'bottom');
        },
        verticalInset: (element)=>{
            const { props: props, deps: deps } = element;
            const verticalInset = deps.exec.call(element, props.verticalInset);
            if (typeof verticalInset !== 'string') return;
            const vi = verticalInset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k);
            return {
                top: vi[0],
                bottom: vi[1] || vi[0]
            };
        },
        horizontalInset: (element)=>{
            const { props: props, deps: deps } = element;
            const horizontalInset = deps.exec.call(element, props.horizontalInset);
            if (typeof horizontalInset !== 'string') return;
            const vi = horizontalInset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k);
            return {
                left: vi[0],
                right: vi[1] || vi[0]
            };
        },
        overflow: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.overflow);
            if (deps.isUndefined(val)) return;
            return {
                overflow: val,
                scrollBehavior: 'smooth'
            };
        },
        overflowX: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.overflowX);
            if (deps.isUndefined(val)) return;
            return {
                overflowX: val
            };
        },
        overflowY: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.overflowY);
            if (deps.isUndefined(val)) return;
            return {
                overflowY: val
            };
        },
        overscrollBehavior: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.overscrollBehavior);
            if (deps.isUndefined(val)) return;
            return {
                overscrollBehavior: val
            };
        },
        userSelect: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.userSelect);
            if (!val) return;
            return {
                userSelect: val
            };
        },
        pointerEvents: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.pointerEvents);
            if (!val) return;
            return {
                pointerEvents: val
            };
        },
        cursor: (el, s, ctx)=>{
            let val = el.deps.exec.call(el, el.props.cursor);
            if (!val) return;
            const file = ctx.files && ctx.files[val];
            if (file && file.content) val = `url(${file.content.src})`;
            return {
                cursor: val
            };
        },
        content: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.content);
            if (!val) return;
            return {
                content: val
            };
        },
        transition: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transition);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transition: deps.splitTransition(val)
            };
        },
        willChange: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.willChange);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                willChange: val
            };
        },
        transitionDuration: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transitionDuration);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transitionDuration: deps.transformDuration(val)
            };
        },
        transitionDelay: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transitionDelay);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transitionDelay: deps.transformDuration(val)
            };
        },
        transitionTimingFunction: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transitionTimingFunction);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transitionTimingFunction: deps.getTimingFunction(val)
            };
        },
        transitionProperty: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transitionProperty);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transitionProperty: val,
                willChange: val
            };
        },
        zoom: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.zoom);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                zoom: val
            };
        },
        transform: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transform);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transform: val
            };
        },
        transformOrigin: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.transformOrigin);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                transformOrigin: val
            };
        },
        backfaceVisibility: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backfaceVisibility);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backfaceVisibility: val
            };
        },
        zIndex: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.zIndex);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                zIndex: val
            };
        },
        perspective: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.perspective);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                perspective: val
            };
        },
        perspectiveOrigin: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.perspectiveOrigin);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                perspectiveOrigin: val
            };
        },
        depth: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.depth);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return deps.depth[val];
        },
        theme: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.theme) return;
            const theme = deps.exec.call(element, props.theme);
            const hasSubtheme = theme.includes(' ') && !theme.includes('@');
            const globalThemeForced = `@${props.themeModifier || globalTheme}`;
            if (hasSubtheme) {
                const themeAppliedInVal = theme.split(' ');
                themeAppliedInVal.splice(1, 0, globalThemeForced);
                return deps.getMediaTheme(themeAppliedInVal);
            } else if (theme.includes('@{globalTheme}')) theme.replace('@{globalTheme}', globalThemeForced);
            return deps.getMediaTheme(theme, `@${props.themeModifier || globalTheme}`);
        },
        color: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.color) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const color = deps.exec.call(element, props.color);
            return {
                color: deps.getMediaColor(color, globalTheme)
            };
        },
        background: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.background) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const background = deps.exec.call(element, props.background);
            return {
                background: deps.getMediaColor(background, globalTheme)
            };
        },
        backgroundColor: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.backgroundColor) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const backgroundColor = deps.exec.call(element, props.backgroundColor);
            return {
                backgroundColor: deps.getMediaColor(backgroundColor, globalTheme)
            };
        },
        backgroundImage: (el, s, ctx)=>{
            const { props: props, deps: deps } = el;
            const globalTheme = deps.getSystemGlobalTheme(el);
            let val = ctx.utils.exec.call(el, props.backgroundImage);
            if (!val) return;
            if (ctx.utils.isString.call(el, val) && val.includes('{{')) val = ctx.utils.replaceLiteralsWithObjectFields.call(el, val);
            const file = ctx.files && ctx.files[val];
            if (file && file.content) val = file.content.src;
            return {
                backgroundImage: deps.transformBackgroundImage(val, globalTheme)
            };
        },
        backgroundSize: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backgroundSize);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backgroundSize: val
            };
        },
        backgroundPosition: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backgroundPosition);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backgroundPosition: val
            };
        },
        backgroundRepeat: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backgroundRepeat);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backgroundRepeat: val
            };
        },
        textStroke: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textStroke);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitTextStroke: deps.transformTextStroke(val)
            };
        },
        outline: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.outline);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                outline: deps.transformBorder(val)
            };
        },
        outlineOffset: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'outlineOffset', props);
        },
        border: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.border);
            if (!(0, $EqHTq.isString)(val) && !(0, $EqHTq.isNumber)(val)) return;
            return {
                border: deps.transformBorder(val)
            };
        },
        borderColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.borderColor) return;
            const val = deps.exec.call(element, props.borderColor);
            return {
                borderColor: deps.getMediaColor(val, globalTheme)
            };
        },
        borderStyle: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.borderStyle);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                borderStyle: val
            };
        },
        borderLeft: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.borderLeft);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                borderLeft: deps.transformBorder(val)
            };
        },
        borderTop: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.borderTop);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                borderTop: deps.transformBorder(val)
            };
        },
        borderRight: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.borderRight);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                borderRight: deps.transformBorder(val)
            };
        },
        borderBottom: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.borderBottom);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                borderBottom: deps.transformBorder(val)
            };
        },
        shadow: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const val = deps.exec.call(element, props.shadow);
            if (!val) return;
            return {
                boxShadow: deps.transformShadow(val, globalTheme)
            };
        },
        // boxShadow: ({ props, deps }) => isString(props.boxShadow) && ({
        //   boxShadow: deps.transformBoxShadow(props.boxShadow)
        // }),
        boxShadow: (element, state, context)=>{
            const { props: props, deps: deps } = element;
            const boxShadow = deps.exec.call(element, props.boxShadow);
            if (!(0, $EqHTq.isString)(boxShadow)) return;
            const [val, hasImportant] = boxShadow.split('!importan');
            const globalTheme = $c4098057d78edae9$export$f12bbb197a836138(element);
            const important = hasImportant ? ' !important' : '';
            return {
                boxShadow: deps.transformBoxShadow(val.trim(), globalTheme) + important
            };
        },
        textShadow: (element)=>{
            const { props: props, deps: deps, context: context } = element;
            const val = deps.exec.call(element, props.textShadow);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textShadow: deps.transformBoxShadow(val, context.designSystem.globalTheme)
            };
        },
        backdropFilter: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backdropFilter);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backdropFilter: val
            };
        },
        caretColor: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.caretColor);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                caretColor: val
            };
        },
        opacity: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.opacity);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                opacity: val
            };
        },
        visibility: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.visibility);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                visibility: val
            };
        },
        columnRule: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.columnRule);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                columnRule: deps.transformBorder(val)
            };
        },
        filter: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.filter);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                filter: val
            };
        },
        mixBlendMode: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.mixBlendMode);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                mixBlendMode: val
            };
        },
        appearance: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.appearance);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                appearance: val
            };
        },
        animation: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.animation);
            if (!val) return;
            return {
                animationName: deps.applyAnimationProps(val, el),
                animationDuration: deps.getTimingByKey(deps.exec.call(el, props.animationDuration) || 'A').timing,
                animationDelay: deps.getTimingByKey(deps.exec.call(el, props.animationDelay) || '0s').timing,
                animationTimingFunction: deps.getTimingFunction(deps.exec.call(el, props.animationTimingFunction) || 'ease'),
                animationFillMode: deps.exec.call(el, props.animationFillMode) || 'both',
                animationPlayState: deps.exec.call(el, props.animationPlayState),
                animationDirection: deps.exec.call(el, props.animationDirection)
            };
        },
        animationName: (el)=>{
            const { props: props, deps: deps } = el;
            const val = deps.exec.call(el, props.animationName);
            if (!val) return;
            return {
                animationName: deps.applyAnimationProps(val, el)
            };
        },
        animationDuration: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationDuration);
            if (!val) return;
            return {
                animationDuration: deps.getTimingByKey(val).timing
            };
        },
        animationDelay: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationDelay);
            if (!val) return;
            return {
                animationDelay: deps.getTimingByKey(val).timing
            };
        },
        animationTimingFunction: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationTimingFunction);
            if (!val) return;
            return {
                animationTimingFunction: deps.getTimingFunction(val)
            };
        },
        // animation:css
        animationFillMode: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationFillMode);
            if (!val) return;
            return {
                animationFillMode: val
            };
        },
        animationPlayState: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationPlayState);
            if (!val) return;
            return {
                animationPlayState: val
            };
        },
        animationIterationCount: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationIterationCount);
            if (!val) return;
            return {
                animationIterationCount: val || 1
            };
        },
        animationDirection: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.animationDirection);
            if (!val) return;
            return {
                animationDirection: val
            };
        },
        shape: (element)=>{
            const { props: props, deps: deps } = element;
            const shape = deps.exec.call(element, props.shape);
            return deps.exec((0, $c031e540a33546ea$export$511e1d54a4a8684e)[shape], {
                props: props,
                deps: deps
            });
        },
        shapeDirection: (element)=>{
            const { props: props, deps: deps } = element;
            const shape = deps.exec.call(element, props.shape);
            const shapeDirection = deps.exec.call(element, props.shapeDirection);
            if (!shape || !shapeDirection) return;
            const shapeDir = (0, $c031e540a33546ea$export$511e1d54a4a8684e)[shape + 'Direction'];
            return shape && shapeDir ? shapeDir[shapeDirection || 'left'] : null;
        },
        shapeDirectionColor: (element)=>{
            const { props: props, deps: deps } = element;
            const background = deps.exec.call(element, props.background);
            const backgroundColor = deps.exec.call(element, props.backgroundColor);
            const borderColor = {
                borderColor: deps.getMediaColor(background || backgroundColor)
            };
            const shapeDirection = deps.exec.call(element, props.shapeDirection);
            return shapeDirection ? borderColor : null;
        },
        round: (element)=>{
            const { props: props, deps: deps } = element;
            const round = deps.exec.call(element, props.round);
            const borderRadius = deps.exec.call(element, props.borderRadius);
            return deps.transformBorderRadius(round || borderRadius, props, 'round');
        },
        borderRadius: (element)=>{
            const { props: props, deps: deps } = element;
            const borderRadius = deps.exec.call(element, props.borderRadius);
            const round = deps.exec.call(element, props.round);
            return deps.transformBorderRadius(borderRadius || round, props, 'borderRadius');
        },
        clip: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.clip);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                clip: val
            };
        },
        scrollbarWidth: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'scrollbarWidth', props);
        },
        gridTemplate: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridTemplate);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridTemplate: val
            };
        },
        gridTemplateColumns: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridTemplateColumns);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridTemplateColumns: val
            };
        },
        gridTemplateRows: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridTemplateRows);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridTemplateRows: val
            };
        },
        gridTemplateAreas: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridTemplateAreas);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridTemplateAreas: val
            };
        },
        gridAutoColumns: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridAutoColumns);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridAutoColumns: val
            };
        },
        gridAutoRows: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridAutoRows);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridAutoRows: val
            };
        },
        gridAutoFlow: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridAutoFlow);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridAutoFlow: val
            };
        },
        grid: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.grid);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                grid: val
            };
        },
        gridColumnEnd: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridColumnEnd);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridColumnEnd: val
            };
        },
        gridRowEnd: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.gridRowEnd);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                gridRowEnd: val
            };
        },
        container: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.container);
            if (!val) return;
            return {
                container: val
            };
        },
        containerName: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.containerName);
            if (!val) return;
            return {
                containerName: val || 1
            };
        },
        containerType: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.containerType);
            if (!val) return;
            return {
                containerType: val
            };
        },
        backgroundClip: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.backgroundClip);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                backgroundClip: val,
                WebkitBackgroundClip: val
            };
        },
        clipPath: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.clipPath);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                clipPath: val
            };
        },
        lineClamp: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.lineClamp);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: val,
                overflow: 'hidden'
            };
        },
        WebkitBoxOrient: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.webkitBoxOrient);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitBoxOrient: val
            };
        },
        WebkitLineClamp: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.webkitLineClamp);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitLineClamp: val
            };
        },
        WebkitBackgroundClip: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.webkitBackgroundClip);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitBackgroundClip: val
            };
        },
        WebkitTextFillColor: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.webkitTextFillColor) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const val = deps.exec.call(element, props.webkitTextFillColor);
            return {
                WebkitTextFillColor: deps.getMediaColor(val, globalTheme)
            };
        },
        WebkitOverflowScrolling: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.webkitOverflowScrolling);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitOverflowScrolling: val
            };
        },
        WebkitFontSmoothing: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.webkitFontSmoothing);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                WebkitFontSmoothing: val
            };
        },
        WebkitTapHighlightColor: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.webkitTapHighlightColor) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const val = deps.exec.call(element, props.webkitTapHighlightColor);
            return {
                WebkitTapHighlightColor: deps.getMediaColor(val, globalTheme)
            };
        },
        objectPosition: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.objectPosition);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                objectPosition: val
            };
        },
        isolation: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.isolation);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                isolation: val
            };
        },
        touchAction: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.touchAction);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                touchAction: val
            };
        },
        flexGrow: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flexGrow);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                flexGrow: val
            };
        },
        flexShrink: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flexShrink);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                flexShrink: val
            };
        },
        flexBasis: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.flexBasis);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                flexBasis: val
            };
        },
        justifySelf: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.justifySelf);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                justifySelf: val
            };
        },
        placeSelf: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.placeSelf);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                placeSelf: val
            };
        },
        placeItems: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.placeItems);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                placeItems: val
            };
        },
        placeContent: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.placeContent);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                placeContent: val
            };
        },
        scrollSnapType: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.scrollSnapType);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                scrollSnapType: val
            };
        },
        scrollSnapAlign: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.scrollSnapAlign);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                scrollSnapAlign: val
            };
        },
        writingMode: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.writingMode);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                writingMode: val
            };
        },
        tabSize: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.tabSize);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                tabSize: val
            };
        },
        listStyle: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.listStyle);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                listStyle: val
            };
        },
        listStyleType: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.listStyleType);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                listStyleType: val
            };
        },
        accentColor: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.accentColor) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const val = deps.exec.call(element, props.accentColor);
            return {
                accentColor: deps.getMediaColor(val, globalTheme)
            };
        },
        outlineColor: (element)=>{
            const { props: props, deps: deps } = element;
            if (!props.outlineColor) return;
            const globalTheme = deps.getSystemGlobalTheme(element);
            const val = deps.exec.call(element, props.outlineColor);
            return {
                outlineColor: deps.getMediaColor(val, globalTheme)
            };
        },
        outlineStyle: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.outlineStyle);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                outlineStyle: val
            };
        },
        outlineWidth: (el)=>{
            const { props: props, deps: deps } = el;
            return deps.transformSizeRatio.call(el, 'outlineWidth', props);
        }
    },
    on: {
        beforeClassAssign: $bc85e892389de1ab$export$e6abde80e220280b
    }
};
const $c4098057d78edae9$export$c89a927ffc67e6fa = {
    props: {
        round: '100%'
    }
};
const $c4098057d78edae9$export$c65504044f62f430 = {
    tag: 'hr',
    props: {
        margin: 'C1 0',
        borderWidth: '0 0 1px 0'
    }
};
const $c4098057d78edae9$export$9130f216d904f5ea = {
    tag: 'br'
};
const $c4098057d78edae9$export$5bfb0bc6cd684584 = {
    tag: 'div'
};
const $c4098057d78edae9$export$5f1714a13ed34c01 = {
    tag: 'span'
};
const $c4098057d78edae9$export$4de39c9f3329bb96 = {
    tag: 'li'
};
const $c4098057d78edae9$export$d4f99c77eeffeaea = {
    tag: 'ul',
    childExtend: {
        extend: 'Li'
    }
};
const $c4098057d78edae9$export$60180a808b215c38 = {
    tag: 'ol',
    childExtend: {
        extend: 'Li'
    }
};
const $c4098057d78edae9$export$b710539649c46ff = {
    props: {
        size: 'C1'
    }
};
const $c4098057d78edae9$export$f51f4c4ede09e011 = {
    props: {
        display: 'flex'
    }
};


var $afd03220988cb716$exports = {};

$parcel$export($afd03220988cb716$exports, "Grid", () => $afd03220988cb716$export$ef2184bd89960b14);
'use strict';
const $afd03220988cb716$export$ef2184bd89960b14 = {
    props: {
        display: 'grid'
    },
    class: {
        area: ({ props: props })=>props.area ? {
                gridArea: props.area
            } : null,
        template: ({ props: props })=>props.template ? {
                gridTemplate: props.template
            } : null,
        templateAreas: ({ props: props })=>props.templateAreas ? {
                gridTemplateAreas: props.templateAreas
            } : null,
        column: ({ props: props })=>props.column ? {
                gridColumn: props.column
            } : null,
        columns: ({ props: props })=>props.columns ? {
                gridTemplateColumns: props.columns
            } : null,
        templateColumns: ({ props: props })=>props.templateColumns ? {
                gridTemplateColumns: props.templateColumns
            } : null,
        autoColumns: ({ props: props })=>props.autoColumns ? {
                gridAutoColumns: props.autoColumns
            } : null,
        columnStart: ({ props: props })=>props.columnStart ? {
                gridColumnStart: props.columnStart
            } : null,
        row: ({ props: props })=>props.row ? {
                gridRow: props.row
            } : null,
        rows: ({ props: props })=>props.rows ? {
                gridTemplateRows: props.rows
            } : null,
        templateRows: ({ props: props })=>props.templateRows ? {
                gridTemplateRows: props.templateRows
            } : null,
        autoRows: ({ props: props })=>props.autoRows ? {
                gridAutoRows: props.autoRows
            } : null,
        rowStart: ({ props: props })=>props.rowStart ? {
                gridRowStart: props.rowStart
            } : null,
        autoFlow: ({ props: props })=>props.autoFlow ? {
                gridAutoFlow: props.autoFlow
            } : null
    }
};


var $c95002999fe11fd8$exports = {};

$parcel$export($c95002999fe11fd8$exports, "Img", () => $c95002999fe11fd8$export$cc7b5f925acc71d3);
'use strict';
const $c95002999fe11fd8$export$cc7b5f925acc71d3 = {
    tag: 'img',
    attr: {
        src: (el)=>{
            const { props: props, context: context } = el;
            let src = (props.preSrc || '') + el.call('exec', props.src, el);
            if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
            let isUrl;
            try {
                isUrl = new URL(src);
            } catch (e) {}
            if (isUrl) return src;
            const file = context.files && context.files[src];
            if (file) return file.content && file.content.src;
        },
        alt: ({ props: props })=>props.alt,
        title: ({ props: props })=>props.title || props.alt
    }
};


var $f085155ee8a416c4$exports = {};

$parcel$export($f085155ee8a416c4$exports, "Form", () => $f085155ee8a416c4$export$a7fed597f4b8afd8);
'use strict';
const $f085155ee8a416c4$export$a7fed597f4b8afd8 = {
    tag: 'form',
    attr: {
        action: ({ props: props })=>props.action,
        method: ({ props: props })=>props.method,
        enctype: ({ props: props })=>props.enctype
    }
};



var $0b0e26e2a21aab54$exports = {};

$parcel$export($0b0e26e2a21aab54$exports, "Iframe", () => $0b0e26e2a21aab54$export$5137ec99f248330b);
'use strict';
const $0b0e26e2a21aab54$export$5137ec99f248330b = {
    tag: 'iframe',
    props: {
        position: 'relative',
        minWidth: 'H',
        minHeight: 'H'
    },
    attr: {
        src: (el, s)=>{
            let src = el.call('exec', el.props.src, el);
            if (!src) return;
            if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
            return src;
        },
        srcdoc: ({ props: props })=>props.srcdoc,
        sandbox: ({ props: props })=>props.sandbox,
        seamless: ({ props: props })=>props.seamless,
        loading: ({ props: props })=>props.loading,
        allowfullscreen: ({ props: props })=>props.allowfullscreen,
        webkitallowfullscreen: ({ props: props })=>props.webkitallowfullscreen,
        mozallowfullscreen: ({ props: props })=>props.mozallowfullscreen,
        name: ({ props: props })=>props.name,
        title: ({ props: props })=>props.title,
        frameborder: ({ props: props })=>props.frameborder,
        allow: ({ props: props })=>props.allow,
        referrerpolicy: ({ props: props })=>props.referrerpolicy
    }
};


var $c3656ade3a6fd1e0$exports = {};

$parcel$export($c3656ade3a6fd1e0$exports, "Hoverable", () => $c3656ade3a6fd1e0$export$8cf654b375a16d2d);
$parcel$export($c3656ade3a6fd1e0$exports, "Clickable", () => $c3656ade3a6fd1e0$export$2f51d37476d4c437);
$parcel$export($c3656ade3a6fd1e0$exports, "Focusable", () => $c3656ade3a6fd1e0$export$35a3bebf7ef2d934);
$parcel$export($c3656ade3a6fd1e0$exports, "FocusableComponent", () => $c3656ade3a6fd1e0$export$b177f82f5511f000);
'use strict';
const $c3656ade3a6fd1e0$var$style = {
    appearance: 'none',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit'
};
const $c3656ade3a6fd1e0$export$8cf654b375a16d2d = {
    props: {
        transition: 'C defaultBezier',
        transitionProperty: 'opacity, transform',
        opacity: 0.85,
        ':hover': {
            opacity: 0.9,
            transform: 'scale(1.015)'
        },
        ':active': {
            opacity: 1,
            transform: 'scale(1.015)'
        },
        '.active': {
            opacity: 1,
            transform: 'scale(1.015)',
            ':hover': {
                opacity: 1
            }
        }
    }
};
const $c3656ade3a6fd1e0$export$2f51d37476d4c437 = {
    extend: $c3656ade3a6fd1e0$export$8cf654b375a16d2d,
    props: {
        ':active': {
            opacity: 1,
            transform: 'scale(1.015)'
        },
        '.active': {
            opacity: 1
        }
    }
};
const $c3656ade3a6fd1e0$export$35a3bebf7ef2d934 = {
    props: {
        border: 'none',
        outline: 'solid, 0, blue .3',
        ':focus-visible': {
            opacity: 1,
            outline: 'solid, X, blue .3'
        }
    },
    attr: {
        placeholder: ({ props: props })=>props.placeholder,
        tabIndex: ({ props: props })=>props.tabIndex
    }
};
const $c3656ade3a6fd1e0$export$b177f82f5511f000 = {
    extend: $c3656ade3a6fd1e0$export$35a3bebf7ef2d934,
    tag: 'button',
    props: {
        fontSize: 'A',
        type: 'button',
        border: 'none',
        textDecoration: 'none',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        fontFamily: 'inherit',
        style: $c3656ade3a6fd1e0$var$style
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};


var $80736e04e60e3fa1$exports = {};

$parcel$export($80736e04e60e3fa1$exports, "Picture", () => $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f);

'use strict';
const $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemGlobalTheme: $c4098057d78edae9$export$f12bbb197a836138
    },
    tag: 'picture',
    childExtend: {
        tag: 'source',
        attr: {
            media: (element)=>{
                const { props: props, key: key, context: context, deps: deps } = element;
                const { MEDIA: MEDIA } = context.designSystem;
                const globalTheme = deps.getSystemGlobalTheme(element);
                const mediaName = (props.media || key).slice(1);
                if (mediaName === globalTheme) return '(min-width: 0px)';
                else if (mediaName === 'dark' || mediaName === 'light') return '(max-width: 0px)';
                return MEDIA[mediaName];
            },
            srcset: ({ props: props })=>props.srcset
        }
    },
    Img: ({ props: props })=>({
            width: 'inherit',
            ignoreChildExtend: true,
            height: 'inherit',
            src: props.src
        })
};


var $7d36ad90912ad279$exports = {};

$parcel$export($7d36ad90912ad279$exports, "Svg", () => $7d36ad90912ad279$export$e17b9c1182212c96);
'use strict';
const $7d36ad90912ad279$export$e17b9c1182212c96 = {
    tag: 'svg',
    props: {},
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        'xmlns:xlink': 'http://www.w3.org/1999/xlink'
    },
    html: (el)=>{
        const { props: props, context: context } = el;
        if (props.semantic_symbols) return;
        if (props.html) return el.call('exec', props.html, el);
        const { designSystem: designSystem, utils: utils } = context;
        const SVG = designSystem && designSystem.SVG;
        const useSvgSprite = props.spriteId || context.designSystem && context.designSystem.useSvgSprite;
        const src = el.call('exec', props.src, el);
        if (!useSvgSprite && src) return src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = props.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        const symbolId = Symbol.for(src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (src) utils.init({
            svg: {
                [SVGKey]: src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};



var $23a4770c72ef76cc$exports = {};

$parcel$export($23a4770c72ef76cc$exports, "Video", () => $23a4770c72ef76cc$export$ae01dedf5c052bb);
'use strict';
const $23a4770c72ef76cc$export$ae01dedf5c052bb = {
    tag: 'video',
    childExtend: {
        tag: 'source',
        attr: {
            src: ({ props: props })=>props.src,
            type: ({ props: props })=>props.type,
            controls: ({ props: props })=>props.controls
        }
    },
    props: {
        controls: true
    },
    attr: {
        src: (el, s)=>{
            let src = el.call('exec', el.props.src, el);
            if (!src) return;
            if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
            return src;
        },
        playsinline: ({ props: props })=>props.playsinline,
        autoplay: ({ props: props })=>props.autoplay,
        loop: ({ props: props })=>props.loop,
        poster: ({ props: props })=>props.poster,
        muted: ({ props: props })=>props.muted,
        preload: ({ props: props })=>props.preload,
        controls: ({ props: props })=>props.controls
    }
};


var $b448a4a1f1311a88$exports = {};

$parcel$export($b448a4a1f1311a88$exports, "Text", () => $b448a4a1f1311a88$export$5f1af8db9871e1d6);
$parcel$export($b448a4a1f1311a88$exports, "H1", () => $b448a4a1f1311a88$export$5523b16adee8048);
$parcel$export($b448a4a1f1311a88$exports, "H2", () => $b448a4a1f1311a88$export$cb94397127ac9363);
$parcel$export($b448a4a1f1311a88$exports, "H3", () => $b448a4a1f1311a88$export$746be9e3a3dfff1f);
$parcel$export($b448a4a1f1311a88$exports, "H4", () => $b448a4a1f1311a88$export$cc5e069d64fda823);
$parcel$export($b448a4a1f1311a88$exports, "H5", () => $b448a4a1f1311a88$export$88ef9fdaf11f7a1f);
$parcel$export($b448a4a1f1311a88$exports, "H6", () => $b448a4a1f1311a88$export$a559fb8039b06400);
$parcel$export($b448a4a1f1311a88$exports, "P", () => $b448a4a1f1311a88$export$56c0d5a1e737357d);
$parcel$export($b448a4a1f1311a88$exports, "Caption", () => $b448a4a1f1311a88$export$32fbfacc5d962e0c);
$parcel$export($b448a4a1f1311a88$exports, "Strong", () => $b448a4a1f1311a88$export$f301627d437cff88);
$parcel$export($b448a4a1f1311a88$exports, "U", () => $b448a4a1f1311a88$export$3a6d5c9ae78a2c08);
$parcel$export($b448a4a1f1311a88$exports, "Underline", () => $b448a4a1f1311a88$export$741ee5bff4f2bc22);
$parcel$export($b448a4a1f1311a88$exports, "Italic", () => $b448a4a1f1311a88$export$1cfcf4275506b1c6);
$parcel$export($b448a4a1f1311a88$exports, "Title", () => $b448a4a1f1311a88$export$f99233281efd08a0);
$parcel$export($b448a4a1f1311a88$exports, "Headline", () => $b448a4a1f1311a88$export$e1faab0803786bcf);
$parcel$export($b448a4a1f1311a88$exports, "Subhead", () => $b448a4a1f1311a88$export$17e07beff4cf82a6);
$parcel$export($b448a4a1f1311a88$exports, "Footnote", () => $b448a4a1f1311a88$export$54539b446c9863da);
$parcel$export($b448a4a1f1311a88$exports, "B", () => $b448a4a1f1311a88$export$ef35774e6d314e91);
$parcel$export($b448a4a1f1311a88$exports, "I", () => $b448a4a1f1311a88$export$9bb611d729802a56);
$parcel$export($b448a4a1f1311a88$exports, "Data", () => $b448a4a1f1311a88$export$2d0294657ab35f1b);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

'use strict';
const $b448a4a1f1311a88$var$props = {
    fontSize: (el)=>{
        const { props: props, deps: deps } = el;
        const val = deps.exec.call(el, props.fontSize);
        return val ? deps.getFontSizeByKey(val) : null;
    },
    fontFamily: (element)=>{
        const { props: props, deps: deps } = element;
        const val = deps.exec.call(element, props.fontFamily);
        return {
            fontFamily: deps.getFontFamily(val) || val
        };
    },
    fontWeight: (element)=>{
        const { props: props, deps: deps } = element;
        const val = deps.exec.call(element, props.fontWeight);
        return {
            fontWeight: val,
            fontVariationSettings: '"wght" ' + val
        };
    }
};
const $b448a4a1f1311a88$export$5f1af8db9871e1d6 = {
    deps: {
        exec: $8wu6n.exec,
        getFontSizeByKey: $16baa215ff216ac9$exports.getFontSizeByKey,
        getFontFamily: $16baa215ff216ac9$exports.getFontFamily
    },
    text: (el)=>{
        const { key: key, props: props, state: state, deps: deps } = el;
        if (props.text === true) return state && state[key] || props && props[key];
        return deps.exec.call(el, props.text);
    },
    class: {
        font: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.font);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                font: val
            };
        },
        lineHeight: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.lineHeight);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                lineHeight: val
            };
        },
        textDecoration: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textDecoration);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textDecoration: val
            };
        },
        textTransform: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textTransform);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textTransform: val
            };
        },
        wordBreak: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.wordBreak);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                wordBreak: val
            };
        },
        whiteSpace: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.whiteSpace);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                whiteSpace: val
            };
        },
        wordWrap: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.wordWrap);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                wordWrap: val
            };
        },
        letterSpacing: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.letterSpacing);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                letterSpacing: val
            };
        },
        textOverflow: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textOverflow);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textOverflow: val
            };
        },
        textAlign: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textAlign);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textAlign: val
            };
        },
        writingMode: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.writingMode);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                writingMode: val
            };
        },
        textOrientation: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textOrientation);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textOrientation: val
            };
        },
        textIndent: (element)=>{
            const { props: props, deps: deps } = element;
            const val = deps.exec.call(element, props.textIndent);
            if ((0, $EqHTq.isUndefined)(val)) return;
            return {
                textIndent: val
            };
        },
        ...$b448a4a1f1311a88$var$props
    }
};
const $b448a4a1f1311a88$export$5523b16adee8048 = {
    tag: 'h1'
};
const $b448a4a1f1311a88$export$cb94397127ac9363 = {
    tag: 'h2'
};
const $b448a4a1f1311a88$export$746be9e3a3dfff1f = {
    tag: 'h3'
};
const $b448a4a1f1311a88$export$cc5e069d64fda823 = {
    tag: 'h4'
};
const $b448a4a1f1311a88$export$88ef9fdaf11f7a1f = {
    tag: 'h5'
};
const $b448a4a1f1311a88$export$a559fb8039b06400 = {
    tag: 'h6'
};
const $b448a4a1f1311a88$export$56c0d5a1e737357d = {
    tag: 'p'
};
const $b448a4a1f1311a88$export$32fbfacc5d962e0c = {
    tag: 'caption'
};
const $b448a4a1f1311a88$export$f301627d437cff88 = {
    tag: 'strong',
    props: {
        fontWeight: '700'
    }
};
const $b448a4a1f1311a88$export$3a6d5c9ae78a2c08 = {
    tag: 'u'
};
const $b448a4a1f1311a88$export$741ee5bff4f2bc22 = {
    tag: 'u'
};
const $b448a4a1f1311a88$export$1cfcf4275506b1c6 = {
    tag: 'i'
};
const $b448a4a1f1311a88$export$f99233281efd08a0 = {};
const $b448a4a1f1311a88$export$e1faab0803786bcf = {
    tag: 'h6',
    props: {
        fontSize: 'B',
        fontWeight: 500
    }
};
const $b448a4a1f1311a88$export$17e07beff4cf82a6 = {
    tag: 'span',
    props: {
        fontSize: 'Z1'
    }
};
const $b448a4a1f1311a88$export$54539b446c9863da = {
    tag: 'span',
    props: {
        fontSize: 'Z'
    }
};
const $b448a4a1f1311a88$export$ef35774e6d314e91 = {
    tag: 'b'
};
const $b448a4a1f1311a88$export$9bb611d729802a56 = {
    tag: 'i'
};
const $b448a4a1f1311a88$export$2d0294657ab35f1b = {
    tag: 'data'
};


var $70c6d81ead918d7f$exports = {};

$parcel$export($70c6d81ead918d7f$exports, "Hgroup", () => $70c6d81ead918d7f$export$bd5b3f7ef3b94a4a);
$parcel$export($70c6d81ead918d7f$exports, "HgroupRows", () => $70c6d81ead918d7f$export$4c6ac4526c395f50);
$parcel$export($70c6d81ead918d7f$exports, "HgroupButton", () => $70c6d81ead918d7f$export$7fa5389f12735f1f);
'use strict';
const $70c6d81ead918d7f$export$bd5b3f7ef3b94a4a = {
    tag: 'hgroup',
    extend: [
        'Flex'
    ],
    props: {
        flow: 'y',
        gap: 'Z'
    },
    H: {
        tag: 'h3',
        text: 'Heading',
        lineHeight: '1em',
        margin: '0'
    },
    P: {
        text: 'Paragraph',
        margin: '0',
        color: 'paragraph'
    }
};
const $70c6d81ead918d7f$export$4c6ac4526c395f50 = {
    extend: 'Hgroup',
    H: {
        extends: 'Flex',
        color: 'title',
        align: 'center space-between'
    },
    P: {
        color: 'paragraph',
        align: 'center space-between'
    }
};
const $70c6d81ead918d7f$export$7fa5389f12735f1f = {
    extend: 'HgroupRows',
    H: {
        justifyContent: 'space-between',
        Span: {},
        Button: {
            background: 'transparent',
            color: 'currentColor',
            padding: '0',
            Icon: {
                name: 'x',
                fontSize: 'C'
            }
        }
    },
    P: {}
};


'use strict';
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c4098057d78edae9$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $afd03220988cb716$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c95002999fe11fd8$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f085155ee8a416c4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $bc85e892389de1ab$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $0b0e26e2a21aab54$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c3656ade3a6fd1e0$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $80736e04e60e3fa1$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $7d36ad90912ad279$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c031e540a33546ea$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $23a4770c72ef76cc$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b448a4a1f1311a88$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $70c6d81ead918d7f$exports);


var $f8a17223267b0208$exports = {};

$parcel$export($f8a17223267b0208$exports, "Icon", () => $f8a17223267b0208$export$f04a61298a47a40f);
$parcel$export($f8a17223267b0208$exports, "IconText", () => $f8a17223267b0208$export$fe7c634bfc18e397);
$parcel$export($f8a17223267b0208$exports, "FileIcon", () => $f8a17223267b0208$export$8c1a3d13e85d78b7);
'use strict';
const $f8a17223267b0208$export$f04a61298a47a40f = {
    extend: 'Svg',
    props: (el, s, ctx)=>{
        const { props: props, parent: parent } = el;
        const { ICONS: ICONS, useIconSprite: useIconSprite, verbose: verbose } = ctx && ctx.designSystem;
        const { toCamelCase: toCamelCase } = ctx && ctx.utils;
        const inheritFromIsActive = (el)=>{
            const { props: props } = el;
            const propsActive = props['.isActive'];
            return el.call('exec', propsActive.name || propsActive.icon);
        };
        const getSemanticIcon = (el, s, ctx)=>{
            const { SEMANTIC_ICONS: SEMANTIC_ICONS } = ctx && ctx.designSystem;
            const { toCamelCase: toCamelCase } = ctx && ctx.utils;
            let iconName = getIconName(el, s);
            const camelCase = toCamelCase(iconName);
            const isArray = camelCase.split(/([a-z])([A-Z])/g);
            const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
            const semanticIcon = SEMANTIC_ICONS && SEMANTIC_ICONS[semanticIconRootName];
            if (semanticIcon) {
                const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
                iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
                return {
                    tag: 'span',
                    semantic_symbols: true,
                    width: 'A',
                    height: 'A',
                    lineHeight: '1em',
                    ':after': {
                        fontSize: 'Z',
                        fontWeight: '300',
                        content: `"${iconName}"`,
                        textAlign: 'center',
                        display: 'inline-block',
                        style: {
                            color: 'currentColor',
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        };
        const getIconName = (el, s)=>{
            const { key: key, props: props } = el;
            let icon = el.call('exec', props.name || props.icon || key, el);
            if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
            return el.call('isString', icon) ? icon : key;
        };
        const iconName = getIconName(el, s);
        const camelCase = toCamelCase(iconName);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        const semanticIcon = getSemanticIcon(el, s, ctx);
        if (semanticIcon) return semanticIcon;
        let activeIconName;
        if (props.isActive) activeIconName = inheritFromIsActive(el);
        const parentProps = parent.props;
        const parentPropsActive = parentProps['.isActive'];
        if (parent && parentProps && parentProps.isActive && parentPropsActive && parentPropsActive.icon) activeIconName = el.call('exec', parentPropsActive.icon || parentPropsActive.Icon.name || parentPropsActive.Icon.icon, el);
        if (el.call('isString', activeIconName) && activeIconName.includes('{{')) activeIconName = el.call('replaceLiteralsWithObjectFields', activeIconName);
        let iconInContext;
        if (ICONS[activeIconName]) iconInContext = activeIconName;
        if (ICONS[camelCase]) iconInContext = camelCase;
        else if (ICONS[isArray[0] + isArray[1]]) iconInContext = isArray[0] + isArray[1];
        else if (ICONS[isArray[0]]) iconInContext = isArray[0];
        else if (verbose) el.warn("Can't find icon:", iconName, iconInContext);
        const iconFromLibrary = ICONS[iconInContext];
        const directSrc = parent && parent.props && parent.props.src || props.src;
        return {
            width: 'A',
            height: 'A',
            display: 'inline-block',
            spriteId: useIconSprite && iconInContext,
            src: iconFromLibrary || directSrc || ICONS.noIcon,
            style: {
                fill: 'currentColor',
                '*': {
                    fill: 'currentColor'
                }
            }
        };
    },
    attr: {
        viewBox: '0 0 24 24'
    }
};
const $f8a17223267b0208$export$fe7c634bfc18e397 = {
    extend: 'Flex',
    props: {
        align: 'center center',
        lineHeight: 1,
        gap: 'X',
        '.reversed': {
            flow: 'row-reverse'
        },
        '.vertical': {
            flow: 'column'
        }
    },
    Icon: {
        if: (el)=>{
            const { parent: parent, props: props } = el;
            return el.call('exec', parent.props.icon || props.name || props.sfSymbols || parent.props.sfSymbols, el);
        },
        icon: (el)=>el.call('exec', el.parent.props.icon, el.parent)
    },
    text: ({ props: props })=>props.text
};
const $f8a17223267b0208$export$8c1a3d13e85d78b7 = {
    extend: 'Flex',
    props: {
        theme: 'tertiary',
        boxSize: 'C1',
        align: 'center center',
        round: 'Z'
    },
    Icon: {
        fontSize: 'B',
        margin: 'auto',
        icon: 'file'
    }
};


var $59e9b7f5a8955db9$exports = {};

$parcel$export($59e9b7f5a8955db9$exports, "Link", () => $59e9b7f5a8955db9$export$a6c7ac8248d6e38a);
$parcel$export($59e9b7f5a8955db9$exports, "A", () => $59e9b7f5a8955db9$export$ebd11618f299a286);
$parcel$export($59e9b7f5a8955db9$exports, "RouterLink", () => $59e9b7f5a8955db9$export$fce709ebdac448ed);
$parcel$export($59e9b7f5a8955db9$exports, "RouteLink", () => $59e9b7f5a8955db9$export$9a6dc2d0fce7da79);
'use strict';
const $59e9b7f5a8955db9$export$a6c7ac8248d6e38a = {
    extend: 'Focusable',
    tag: 'a',
    props: {
        aria: {},
        fontWeight: 'bold',
        textDecoration: 'none',
        color: 'currentColor',
        draggable: false
    },
    attr: {
        href: (el, s, ctx)=>{
            const props = el.props;
            const href = el.call('exec', props.href, el) || el.call('exec', el.call('exec', props, el).href, el);
            if (el.call('isString', href) && href.includes('{{')) return el.call('replaceLiteralsWithObjectFields', href);
            return href;
        },
        target: ({ props: props })=>props.target,
        'aria-label': ({ props: props })=>props.aria ? props.aria.label : props.text,
        draggable: ({ props: props })=>props.draggable
    }
};
const $59e9b7f5a8955db9$export$ebd11618f299a286 = {
    extend: 'Link'
};
const $59e9b7f5a8955db9$export$fce709ebdac448ed = {
    props: {
        onClick: (event, el, s)=>{
            const { props: props, context: ctx } = el;
            const { href: h, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = props;
            let href = el.call('exec', h, el);
            if (el.call('isString', href) && href.includes('{{')) href = el.call('replaceLiteralsWithObjectFields', href);
            if (stopPropagation) event.stopPropagation();
            if (!href) return;
            const { routerOptions: routerOptions } = ctx;
            const root = el.__ref.root;
            const linkIsExternal = href.includes('http://') || href.includes('https://') || href.includes('mailto:') || href.includes('tel:');
            if (href && !linkIsExternal) try {
                el.call('router', href, root, {}, {
                    scrollToOptions: {
                        behaviour: 'instant'
                    },
                    scrollToTop: el.call('isDefined', scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...props.routerOptions
                });
                event.preventDefault();
            } catch (e) {
                el.warn(e);
            }
        }
    }
};
const $59e9b7f5a8955db9$export$9a6dc2d0fce7da79 = {
    extend: [
        $59e9b7f5a8955db9$export$a6c7ac8248d6e38a,
        $59e9b7f5a8955db9$export$fce709ebdac448ed
    ]
};


var $7f02b9e3018c9249$exports = {};
var $d4fa7f19f335d32f$exports = {};

$parcel$export($d4fa7f19f335d32f$exports, "Input", () => $d4fa7f19f335d32f$export$f5b8910cec6cf069);
'use strict';
const $d4fa7f19f335d32f$export$f5b8910cec6cf069 = {
    extend: [
        'Focusable'
    ],
    tag: 'input',
    props: {
        border: 'none',
        type: 'input',
        theme: 'field',
        fontSize: 'A',
        round: 'C',
        lineHeight: '1',
        padding: 'Z2 B'
    },
    attr: {
        pattern: ({ props: props })=>props.pattern,
        minLength: ({ props: props })=>props.minlength,
        maxLength: ({ props: props })=>props.maxlength,
        name: ({ props: props })=>props.name,
        autocomplete: ({ props: props })=>props.autocomplete,
        placeholder: (el)=>{
            if (!el.props || !el.props.placeholder) return;
            const placeholder = el.call('exec', el.props.placeholder, el);
            if (el.call('isString', placeholder) && placeholder.includes('{{')) return el.call('replaceLiteralsWithObjectFields', placeholder);
            return placeholder;
        },
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        },
        checked: (el)=>el.call('exec', el.props.checked, el),
        readonly: (el)=>el.call('exec', el.props.readonly),
        required: (el)=>el.call('exec', el.props.required),
        disabled: (el)=>el.call('exec', el.props.disabled),
        type: (el)=>el.call('exec', el.props.type)
    }
};


var $213c0d90580abffb$exports = {};

$parcel$export($213c0d90580abffb$exports, "NumberInput", () => $213c0d90580abffb$export$6bf0cd3a219bbade);
'use strict';
const $213c0d90580abffb$export$6bf0cd3a219bbade = {
    extend: [
        'Flex',
        'Input'
    ],
    props: {
        type: 'number',
        boxSize: 'C+X',
        align: 'center center',
        textAlign: 'center',
        round: 'Y1',
        theme: 'transparent',
        border: 'solid, gray3',
        borderWidth: '1px',
        placeholder: '0',
        fontWeight: '400',
        '::-webkit-inner-spin-button': {
            appearance: 'none'
        }
    },
    attr: {
        step: ({ props: props })=>props.step,
        min: ({ props: props })=>props.min,
        max: ({ props: props })=>props.max
    }
};


var $59b438ee4e9b846d$exports = {};

$parcel$export($59b438ee4e9b846d$exports, "Checkbox", () => $59b438ee4e9b846d$export$48513f6b9f8ce62d);
$parcel$export($59b438ee4e9b846d$exports, "CheckboxHgroup", () => $59b438ee4e9b846d$export$8d7a3c6c6de62e1f);
'use strict';
const $59b438ee4e9b846d$export$48513f6b9f8ce62d = {
    extend: 'Focusable',
    tag: 'label',
    props: {
        boxSize: 'fit-content fit-content',
        cursor: 'pointer',
        round: 'Y'
    },
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked + div': {
            theme: 'primary'
        },
        ':checked + div > svg': {
            transform: 'none',
            opacity: '1'
        },
        attr: {
            name: (el)=>el.call('exec', el.parent.props.name),
            checked: (el)=>el.call('exec', el.parent.props.checked)
        }
    },
    Flex: {
        align: 'center center',
        fontSize: 'B1',
        padding: 'V',
        theme: 'field',
        round: 'X2',
        transition: 'background A defaultBezier',
        Icon: {
            icon: 'check',
            opacity: '0',
            transform: 'scale(0.9) rotate(-15deg)',
            transition: 'opacity B defaultBezier'
        }
    }
};
const $59b438ee4e9b846d$export$8d7a3c6c6de62e1f = {
    extend: 'Flex',
    tag: 'label',
    props: {
        boxSize: 'fit-content',
        align: 'flex-start flex-start',
        gap: 'A'
    },
    Checkbox: {
        tag: 'div'
    },
    HgroupRows: {
        gap: 'Z1',
        margin: 'Y - - -'
    }
};


var $36ec4dd7c97e9ba6$exports = {};

$parcel$export($36ec4dd7c97e9ba6$exports, "Radio", () => $36ec4dd7c97e9ba6$export$d7b12c4107be0d61);
$parcel$export($36ec4dd7c97e9ba6$exports, "RadioHgroup", () => $36ec4dd7c97e9ba6$export$4a51391209c6c8b9);
'use strict';
const $36ec4dd7c97e9ba6$export$d7b12c4107be0d61 = {
    extend: 'Checkbox',
    Input: {
        type: 'radio',
        ':checked + div:after': {
            opacity: '1'
        }
    },
    Flex: {
        round: '100%',
        padding: 'Y',
        ':after': {
            content: '""',
            display: 'block',
            boxSize: 'X+W1',
            round: '100%',
            background: 'white',
            opacity: '0',
            transition: 'opacity .15s ease-in-out'
        },
        Icon: null
    }
};
const $36ec4dd7c97e9ba6$export$4a51391209c6c8b9 = {
    extend: 'CheckboxHgroup',
    Checkbox: null,
    Radio: {}
};


var $d0c993a5e2b7f197$exports = {};

$parcel$export($d0c993a5e2b7f197$exports, "Toggle", () => $d0c993a5e2b7f197$export$bea8ebba691c5813);
$parcel$export($d0c993a5e2b7f197$exports, "ToggleHgroup", () => $d0c993a5e2b7f197$export$9c397544fb27ca65);
'use strict';
const $d0c993a5e2b7f197$export$bea8ebba691c5813 = {
    extend: 'Checkbox',
    Input: {
        ':checked + div': {
            background: 'green2 +8',
            justifyContent: 'flex-end'
        }
    },
    Flex: {
        boxSize: 'A1 B1',
        padding: '- W_default',
        round: 'D',
        align: 'center flex-start',
        theme: 'field',
        border: 'none',
        transition: 'opacity .15s ease',
        ':after': {
            content: '""',
            boxSize: 'A A',
            round: '100%',
            background: 'white',
            boxShadow: '1px, 1px, Z, gray .2'
        },
        Icon: null
    }
};
const $d0c993a5e2b7f197$export$9c397544fb27ca65 = {
    extend: 'CheckboxHgroup',
    Checkbox: null,
    Toggle: {}
};


var $20f1327918487e94$exports = {};

$parcel$export($20f1327918487e94$exports, "Textarea", () => $20f1327918487e94$export$379139ebc1c2b235);
$parcel$export($20f1327918487e94$exports, "TextareaWithButton", () => $20f1327918487e94$export$b70f05b5c6092f02);
'use strict';
const $20f1327918487e94$export$379139ebc1c2b235 = {
    tag: 'textarea',
    extend: [
        'Input',
        'Flex'
    ],
    props: {
        variant: 'outlined',
        fontfamily: 'Avenir',
        theme: 'field',
        round: 'Z1',
        placeholder: 'Leave us a message...',
        padding: 'A',
        theme: 'field',
        border: 'none',
        maxWidth: 'G1_default',
        minHeight: 'E_default',
        width: '100%',
        height: 'E1_default',
        fontFamily: 'inherit',
        style: {
            resize: 'none'
        }
    },
    html: (el, s)=>{
        const val = el.call('exec', el.props.value, el);
        if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
        return val || '';
    }
};
const $20f1327918487e94$export$b70f05b5c6092f02 = {
    extend: 'Flex',
    props: {
        gap: 'Y2'
    },
    Textarea: {
        height: 'C2+W',
        minWidth: 'H',
        padding: 'A',
        fontSize: 'Z1',
        round: 'Z2',
        minHeight: 'fit-content'
    },
    SquareButton: {
        background: 'blue',
        Icon: {
            name: 'send'
        }
    }
};


'use strict';
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d4fa7f19f335d32f$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $213c0d90580abffb$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $59b438ee4e9b846d$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $36ec4dd7c97e9ba6$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d0c993a5e2b7f197$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $20f1327918487e94$exports);


var $c038997f2687863c$exports = {};

$parcel$export($c038997f2687863c$exports, "Select", () => $c038997f2687863c$export$ef9b1a59e592288f);
'use strict';
const $c038997f2687863c$export$ef9b1a59e592288f = {
    extend: 'Focusable',
    tag: 'select',
    props: {
        fontSize: 'A',
        border: 'none',
        boxSizing: 'border-box',
        theme: 'field',
        cursor: 'pointer',
        childProps: {
            tag: 'option',
            attr: {
                text: ({ props: props })=>props.text || props.value,
                required: (el)=>el.call('exec', el.props.required),
                disabled: (el)=>el.call('exec', el.props.disabled),
                value: (el)=>{
                    if (!el.props || !el.props.value) return;
                    const val = el.call('exec', el.props.value, el);
                    if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
                    return val;
                }
            }
        }
    },
    attr: {
        name: ({ props: props })=>props.name,
        required: (el)=>el.call('exec', el.props.required),
        disabled: (el)=>el.call('exec', el.props.disabled),
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        }
    }
};


var $ca26469f43255c37$exports = {};

$parcel$export($ca26469f43255c37$exports, "Button", () => $ca26469f43255c37$export$353f5b6fc5456de1);
$parcel$export($ca26469f43255c37$exports, "SquareButton", () => $ca26469f43255c37$export$51cd5c72b5e560c6);
$parcel$export($ca26469f43255c37$exports, "CircleButton", () => $ca26469f43255c37$export$235c11ae4b685dbd);
$parcel$export($ca26469f43255c37$exports, "KangorooButton", () => $ca26469f43255c37$export$6fbe98cd572b6a70);
$parcel$export($ca26469f43255c37$exports, "ButtonSet", () => $ca26469f43255c37$export$87e672a75327e04b);
$parcel$export($ca26469f43255c37$exports, "IconButton", () => $ca26469f43255c37$export$c25acd513dcc8062);
'use strict';
const $ca26469f43255c37$export$353f5b6fc5456de1 = {
    extend: [
        'IconText',
        'FocusableComponent'
    ],
    tag: 'button',
    props: {
        fontSize: 'A',
        type: 'button',
        borderStyle: 'none',
        display: 'inline-flex',
        align: 'center center',
        textDecoration: 'none',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        padding: 'Z B2',
        fontWeight: '500',
        fontFamily: 'inherit',
        round: 'C2'
    },
    attr: {
        type: ({ props: props })=>props.type,
        disabled: (el)=>el.call('exec', el.props.disabled)
    }
};
const $ca26469f43255c37$export$51cd5c72b5e560c6 = {
    extend: 'Button',
    props: {
        fontSize: 'A',
        width: 'A',
        padding: 'Z',
        aspectRatio: '1 / 1',
        icon: 'smile',
        boxSize: 'fit-content fit-content',
        justifyContent: 'center',
        round: 'Z',
        boxSizing: 'content-box'
    }
};
const $ca26469f43255c37$export$235c11ae4b685dbd = {
    extend: 'SquareButton',
    props: {
        round: 'C'
    }
};
const $ca26469f43255c37$export$6fbe98cd572b6a70 = {
    extend: 'Button',
    childExtend: 'IconText'
};
const $ca26469f43255c37$export$87e672a75327e04b = {
    tag: 'nav',
    extend: 'Flex',
    childExtend: 'SquareButton'
};
const $ca26469f43255c37$export$c25acd513dcc8062 = {
    extend: [
        'SquareButton'
    ],
    props: {
        round: 'Z'
    },
    __hash: '3a7v57sk5rd'
};


var $14b0ee601310f298$exports = {};

$parcel$export($14b0ee601310f298$exports, "Dialog", () => $14b0ee601310f298$export$3ddf2d174ce01153);
$parcel$export($14b0ee601310f298$exports, "DialogHeader", () => $14b0ee601310f298$export$742513523b177e3b);
$parcel$export($14b0ee601310f298$exports, "DialogFooter", () => $14b0ee601310f298$export$7bbfb2d443473050);
'use strict';
const $14b0ee601310f298$export$3ddf2d174ce01153 = {
    extend: 'Flex',
    tag: 'dialog',
    props: {
        flow: 'column',
        border: '0',
        theme: 'dialog',
        round: 'Z2'
    }
};
const $14b0ee601310f298$export$742513523b177e3b = {
    extend: 'Hgroup',
    props: {
        minWidth: '100%',
        gap: 'A'
    },
    Title: {
        align: 'center space-between',
        Text: {
            text: 'Title'
        },
        SquareButton: {
            icon: 'x',
            theme: 'transparent'
        }
    },
    Paragraph: {
        color: 'caption'
    }
};
const $14b0ee601310f298$export$7bbfb2d443473050 = {
    extend: 'Flex',
    props: {
        align: 'center flex-end',
        gap: 'X2',
        margin: 'auto - -',
        padding: 'Y2 X2'
    },
    childExtend: {
        extend: 'Button',
        props: {
            textTransform: 'uppercase',
            background: 'transparent',
            '@dark': {
                theme: 'primary @dark .color-only'
            },
            '@light': {
                theme: 'primary @light .color-only'
            },
            '&': {
                padding: 'Z A'
            },
            ':hover': {
                theme: 'tertiary'
            },
            ':active': {
                background: 'white .1'
            }
        }
    },
    cancel: {
        text: 'cancel'
    },
    ok: {
        text: 'ok'
    }
};


var $5789735af6bd85de$exports = {};

$parcel$export($5789735af6bd85de$exports, "Tooltip", () => $5789735af6bd85de$export$28c660c63b792dea);
$parcel$export($5789735af6bd85de$exports, "TooltipHidden", () => $5789735af6bd85de$export$92ba62bde414cbb2);
$parcel$export($5789735af6bd85de$exports, "TooltipParent", () => $5789735af6bd85de$export$1d54d90a050b9c15);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $5789735af6bd85de$export$28c660c63b792dea = {
    extend: 'Flex',
    props: {
        theme: 'dialog',
        background: 'black',
        flow: 'column',
        shape: 'tooltip',
        shapeDirection: 'left',
        padding: 'Z1 A',
        round: 'Y2',
        width: 'fit-content',
        minWidth: 'D2',
        maxWidth: 'F2',
        gap: 'X',
        textAlign: 'center'
    },
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent, props: props })=>(0, $EqHTq.isDefined)(parent.props.title) || props.text,
        width: 'fit-content',
        fontWeight: 500,
        color: 'gray12',
        text: ({ parent: parent })=>parent.props.title
    },
    P: {
        if: (el, s)=>el.call('isDefined', el.call('exec', el.parent.props.description, el)) || el.props.text,
        width: 'fit-content',
        fontSize: 'Z2',
        margin: '0',
        color: 'gray6',
        fontWeight: '400',
        text: (el, s)=>el.call('exec', el.parent.props.description, el)
    }
};
const $5789735af6bd85de$export$92ba62bde414cbb2 = {
    extend: 'Tooltip',
    props: ({ props: props })=>({
            position: 'absolute',
            pointerEvents: 'none',
            opacity: '0',
            visibility: 'hidden',
            transition: 'C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform',
            ...!props.shapeDirection || props.shapeDirection === 'top' ? {
                top: '112%',
                left: '50%',
                transform: 'translate3d(-50%,10%,0)',
                '.isActive': {
                    transform: 'translate3d(-50%,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : props.shapeDirection === 'right' ? {
                transform: 'translate3d(10%,-50%,0)',
                left: '112%',
                top: '50%',
                '.isActive': {
                    transform: 'translate3d(0%,-50%,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : ({ props: props })=>props.shapeDirection === 'bottom' ? {
                    transform: 'translate3d(-50%,-10%,0)',
                    bottom: '112%',
                    left: '50%',
                    '.isActive': {
                        transform: 'translate3d(-50%,0,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : props.shapeDirection === 'left' ? {
                    transform: 'translate3d(10%,-50%,0)',
                    right: '112%',
                    top: '50%',
                    '.isActive': {
                        transform: 'translate3d(0%,-50%,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : {}
        })
};
const $5789735af6bd85de$export$1d54d90a050b9c15 = {
    props: (el)=>{
        const { Tooltip: Tooltip, TooltipHidden: TooltipHidden } = el;
        const TooltipElem = Tooltip || TooltipHidden;
        if (!TooltipElem) return;
        const TooltipActive = TooltipElem && TooltipElem.props && TooltipElem.props['.isActive'];
        return {
            position: 'relative',
            zIndex: 999,
            ':hover, &:focus-visible': {
                zIndex: 1000,
                '& [tooltip]': TooltipActive || {
                    transform: 'translate3d(-50%, 0, 0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        };
    }
};


var $d0fd1386e51a3c49$exports = {};

$parcel$export($d0fd1386e51a3c49$exports, "Avatar", () => $d0fd1386e51a3c49$export$e2255cf6045e8d47);
'use strict';
const $d0fd1386e51a3c49$export$e2255cf6045e8d47 = {
    extend: 'Img',
    props: {
        display: 'block',
        avatarType: 'adventurer-neutral',
        borderRadius: '100%',
        boxSize: 'C+X C+X',
        src: (el)=>`https://avatars.symbo.ls/${el.props.avatarType || 'initials'}/svg?seed=${el.props.key || el.key || 'no-avatar'}`
    }
};


var $781e0e9576e3e707$exports = {};

$parcel$export($781e0e9576e3e707$exports, "Range", () => $781e0e9576e3e707$export$9a58ef0d7ad3278c);

'use strict';
const $781e0e9576e3e707$export$9a58ef0d7ad3278c = {
    props: {
        appearance: 'none',
        width: '100%',
        height: '2px',
        outline: 'none',
        flex: 1,
        onInput: (ev, el, s)=>{
            const props = el.props;
            if (el.call('isFunction', props.onInput)) props.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        onChange: (ev, el, s)=>{
            const props = el.props;
            if (el.call('isFunction', props.onChange)) props.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        '::-webkit-slider-thumb': {
            boxSizing: 'content-box',
            width: '8px',
            height: '8px',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderRadius: '100%',
            opacity: '.8',
            style: {
                appearance: 'none'
            }
        },
        '::-webkit-slider-runnable-track': {},
        '@dark': {
            background: 'white 0.2',
            '::-webkit-slider-thumb': {
                background: '#232526',
                borderColor: (0, $16baa215ff216ac9$exports.opacify)('#454646', 0.75)
            },
            ':hover': {
                '::-webkit-slider-thumb': {
                    borderColor: (0, $16baa215ff216ac9$exports.opacify)('#fff', 0.35)
                }
            },
            ':focus': {
                '::-webkit-slider-thumb': {
                    borderColor: '#3C6AC0'
                }
            }
        },
        '@light': {
            background: 'gray9',
            '::-webkit-slider-thumb': {
                background: 'white',
                borderColor: 'gray9'
            },
            ':hover': {
                '::-webkit-slider-thumb': {
                    borderColor: 'gray7'
                }
            },
            ':focus': {
                '::-webkit-slider-thumb': {
                    borderColor: 'blue'
                }
            }
        }
    },
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el.props && el.call('exec', el.props[property], el);
            const r = el.call('isFunction', val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
            return r + '';
        }
    },
    tag: 'input',
    attr: {
        type: 'range',
        value: (el, s)=>el.call('exec', s.value || el.props.value || el.props.defaultValue, el),
        min: (el, s)=>el.deps.returnPropertyValue(el, 'min', 0),
        max: (el, s)=>el.deps.returnPropertyValue(el, 'max', 100),
        step: (el, s)=>el.deps.returnPropertyValue(el, 'step', 1)
    }
};


var $954e4cb4adbc0299$exports = {};

$parcel$export($954e4cb4adbc0299$exports, "DropdownList", () => $954e4cb4adbc0299$export$e40cc1c58d22b809);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParent", () => $954e4cb4adbc0299$export$b162207c9836937);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParentFocus", () => $954e4cb4adbc0299$export$89c2e92edc22fd8f);
$parcel$export($954e4cb4adbc0299$exports, "DropdownSiblingFocus", () => $954e4cb4adbc0299$export$60701cc380f56748);
'use strict';
const $954e4cb4adbc0299$export$e40cc1c58d22b809 = {
    extend: 'Flex',
    attr: {
        dropdown: true
    },
    props: {
        padding: '0 Y',
        maxHeight: 'G',
        flow: 'column',
        theme: 'quaternary',
        overflow: 'hidden auto',
        style: {
            listStyleType: 'none'
        },
        transition: 'B defaultBezier',
        transitionProperty: 'transform, opacity, visibility',
        children: ({ props: props })=>props.options || [],
        '.hidden': {
            transform: 'translate3d(0,10%,0)',
            opacity: 0,
            visibility: 'hidden'
        }
    },
    childExtend: {
        extend: 'Button',
        state: {},
        props: {
            isActive: ({ key: key, state: state })=>state.active === key,
            position: 'relative',
            round: '0',
            align: 'center flex-end',
            flow: 'row-reverse',
            padding: 'Z2 C Z2 Y2',
            margin: '0',
            gap: 'Y2',
            theme: 'quaternary .child',
            ':hover': {
                style: {
                    svg: {
                        opacity: '0.5'
                    }
                }
            },
            Icon: {
                isActive: ({ key: key, state: state })=>state.active === key,
                name: 'checkmark',
                opacity: '0.1',
                '.active': {
                    opacity: '1'
                }
            },
            ':not(:first-child)': {
                '@dark': {
                    border: 'gray4 .65, solid'
                },
                '@light': {
                    border: 'gray11, solid'
                },
                borderWidth: '1px 0 0'
            }
        }
    }
};
const $954e4cb4adbc0299$export$b162207c9836937 = {
    props: {
        position: 'relative',
        zIndex: 999,
        style: {
            '&:hover': {
                zIndex: 1000,
                '& [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    }
};
const $954e4cb4adbc0299$export$89c2e92edc22fd8f = {
    props: {
        position: 'relative',
        tabindex: '0',
        style: {
            '&:focus-within': {
                zIndex: 1000,
                '& [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        visibility: 'hidden',
        position: 'absolute',
        inset: '0',
        onUpdate: (el)=>el.node.blur()
    },
    Dropdown: {
        // onClick: (ev, el) => el.parent.Input_trigger.node.blur()
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
};
const $954e4cb4adbc0299$export$60701cc380f56748 = {
    props: {
        position: 'relative',
        tabindex: '0',
        style: {
            '&:focus-within': {
                zIndex: 1000,
                '& ~ [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        visibility: 'hidden',
        position: 'absolute',
        inset: '0',
        onUpdate: (el)=>el.node.blur()
    }
};


var $e39e4f558cd2a095$exports = {};

$parcel$export($e39e4f558cd2a095$exports, "Notification", () => $e39e4f558cd2a095$export$14834abbfce3b8cd);
'use strict';
const $e39e4f558cd2a095$export$14834abbfce3b8cd = {
    extend: 'Flex',
    props: {
        theme: 'alert',
        padding: 'Z1 B Z A',
        round: 'A A A Y2',
        gap: 'X2',
        cursor: 'pointer',
        align: 'flex-start center'
    },
    IconText: {
        Icon: {
            name: 'info outline'
        },
        Text: {
            ':empty': {
                hide: true
            }
        }
    },
    Hgroup: {
        extends: [
            'Flex',
            'Hgroup'
        ],
        flow: 'y',
        align: 'flex-start',
        gap: 'X2',
        H: {
            tag: 'h6',
            margin: '0',
            fontWeight: '600',
            lineHeight: '1em',
            text: 'Notification',
            ':empty': {
                hide: true
            }
        },
        P: {
            fontSize: 'Z',
            margin: '0',
            text: 'is not always a distraction',
            ':empty': {
                hide: true
            }
        }
    }
};


'use strict';
$parcel$exportWildcard($be006f1a0fabd945$exports, $73d59c6c3fce378b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f8a17223267b0208$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $59e9b7f5a8955db9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7f02b9e3018c9249$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c038997f2687863c$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ca26469f43255c37$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $14b0ee601310f298$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5789735af6bd85de$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d0fd1386e51a3c49$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $781e0e9576e3e707$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $954e4cb4adbc0299$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $e39e4f558cd2a095$exports);


'use strict';
const $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $4747ce2ab72764ea$export$cf7ee87ede64229c = (element, context)=>{
    if (context.router === false) return;
    else if (context.router === true) context.router = $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    else (0, $8wu6n.merge)(context.router || {}, $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = context.router;
    const onRouterRenderDefault = (el, s)=>{
        const { pathname: pathname, search: search, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + search + hash;
        if (el.routes) element.call('router', url, el, {}, {
            initialRender: true
        });
    };
    const hasRenderRouter = element.on && !(0, $EqHTq.isUndefined)(element.on.renderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) {
        if (element.on) element.on.renderRouter = onRouterRenderDefault;
        else element.on = {
            renderRouter: onRouterRenderDefault
        };
    }
    $4747ce2ab72764ea$export$54b760094ac80b64(routerOptions);
    return routerOptions;
};
let $4747ce2ab72764ea$var$popStateFired;
const $4747ce2ab72764ea$export$7fe20beff2421d2d = (element, context)=>{
    if ($4747ce2ab72764ea$var$popStateFired) return;
    $4747ce2ab72764ea$var$popStateFired = true;
    const routerOptions = context.router || $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    (0, $jvD5p.window).onpopstate = async (event)=>{
        const { pathname: pathname, search: search, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + search + hash;
        await element.call('router', url, element, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0,
            event: event
        });
    };
};
const $4747ce2ab72764ea$export$54b760094ac80b64 = (routerOptions)=>{
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $8wu6n.deepMerge)((0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a), (0, $59e9b7f5a8955db9$export$fce709ebdac448ed));
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cBUNY = parcelRequire("cBUNY");
'use strict';
const { window: $b7a07a87e1dff17d$var$window, overwriteDeep: $b7a07a87e1dff17d$var$overwriteDeep, deepDestringifyFunctions: $b7a07a87e1dff17d$var$deepDestringifyFunctions } = $cBUNY;
const $b7a07a87e1dff17d$var$IS_DEVELOPMENT = $b7a07a87e1dff17d$var$window && $b7a07a87e1dff17d$var$window.location ? $b7a07a87e1dff17d$var$window.location.host.includes('dev.') : $cBUNY.isDevelopment();
const $b7a07a87e1dff17d$var$SERVER_URL = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? 'http://localhost:8080/get' : 'https://api.symbols.app/get';
const $b7a07a87e1dff17d$var$defaultOptions = {
    endpoint: $b7a07a87e1dff17d$var$SERVER_URL
};
const $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3 = globalThis.fetch;
const $b7a07a87e1dff17d$export$db36d2f1649120da = async (key, options = $b7a07a87e1dff17d$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $b7a07a87e1dff17d$var$SERVER_URL;
    const route = options.serviceRoute ? $cBUNY.isArray(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase() + '=true').join('&') : options.serviceRoute : '';
    let response;
    try {
        response = await $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3(baseUrl + '/' + '?' + route, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-AppKey': key,
                'X-Metadata': options.metadata
            }
        });
        return await response.json();
    } catch (e) {
        if ($cBUNY.isFunction(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $b7a07a87e1dff17d$export$525bc467aeb111d5 = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT || options.isDevelopment ? $b7a07a87e1dff17d$var$deepDestringifyFunctions(data) : $b7a07a87e1dff17d$var$deepDestringifyFunctions(data.releases[0]);
        if (editor.serviceRoute) {
            if ($cBUNY.isArray(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                $b7a07a87e1dff17d$var$overwriteDeep(options[route], evalData[route.toLowerCase()]);
            });
            else $b7a07a87e1dff17d$var$overwriteDeep(options[editor.serviceRoute], evalData);
        } else [
            'state',
            'designSystem',
            'components',
            'snippets',
            'pages',
            'utils',
            'files',
            'packages',
            'functions'
        ].forEach((key)=>{
            $b7a07a87e1dff17d$var$overwriteDeep(options[key], evalData[key.toLowerCase()]);
        });
    }
    return options;
};
const $b7a07a87e1dff17d$export$571411efd7718583 = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT || options.isDevelopment ? $b7a07a87e1dff17d$var$deepDestringifyFunctions(data) : $b7a07a87e1dff17d$var$deepDestringifyFunctions(data.releases[0]);
        callback(evalData);
    }
};


'use strict';
const $5e586daec44b56de$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await (0, $b7a07a87e1dff17d$export$525bc467aeb111d5)(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $5e586daec44b56de$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        if (options.editor.async) (0, $b7a07a87e1dff17d$export$571411efd7718583)(key, options, callback || ((data)=>{
            const designSystem = data.designSystem;
            if ((0, $EqHTq.isObject)(designSystem)) options.utils.init(designSystem);
            if ((0, $EqHTq.isObject)(data.state)) app.state.set(data.state);
        }));
    } catch (e) {
        console.error(e);
    }
};



'use strict';
const $596256ead72518a6$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    // deps: (param, el) => param || el.parent.deps,
    $router: (param, el)=>{
        if (!param) return;
        const obj = {
            tag: 'fragment',
            ...param
        };
        const set = ()=>{
            el.set(obj, {
                preventDefineUpdate: '$router'
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else set();
        return obj;
    },
    $collection: (0, $c4098057d78edae9$export$e71c4d32a2263218).define.$collection,
    $setCollection: (0, $c4098057d78edae9$export$e71c4d32a2263218).define.$setCollection,
    $stateCollection: (0, $c4098057d78edae9$export$e71c4d32a2263218).define.$stateCollection,
    $propsCollection: (0, $c4098057d78edae9$export$e71c4d32a2263218).define.$propsCollection
};


'use strict';
const $d5fc17b4ecb94b3e$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useDefaultIcons: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $d5fc17b4ecb94b3e$export$7f202753e6a32b2b = {
    forceDomql3OnInit: true,
    forceDomql3: true,
    state: {},
    pages: {},
    components: {},
    router: {
        initRouter: true,
        popState: true,
        injectRouterInLinkComponent: true
    },
    define: (0, $596256ead72518a6$export$6588fc50c67b09a2)
};
var $d5fc17b4ecb94b3e$export$2e2bcd8739ae039 = $d5fc17b4ecb94b3e$export$7f202753e6a32b2b;




var $b18jb = parcelRequire("b18jb");

var $cKpeW = parcelRequire("cKpeW");

var $6HSQm = parcelRequire("6HSQm");

var $yWtDc = parcelRequire("yWtDc");
parcelRequire("lI5Kt");
var $ajGUj = parcelRequire("ajGUj");
'use strict';
var $dd5b413a87318846$export$2e2bcd8739ae039 = (params, options = {})=>{
    const { overwrite: overwrite } = options;
    for(const param in params)if ((0, $ajGUj.REGISTRY)[param] && !overwrite) (0, $yWtDc.report)('OverwriteToBuiltin', param);
    else (0, $ajGUj.REGISTRY)[param] = params[param];
};



var $2bilB = parcelRequire("2bilB");

var $grKOq = parcelRequire("grKOq");
'use strict';


var $cKpeW = parcelRequire("cKpeW");
var $b18jb = parcelRequire("b18jb");
'use strict';
const $07fce7224ceb45c2$var$create = async (element, parent, key, options)=>{
    const domqlElement = await ((0, $cKpeW.default).default || (0, $cKpeW.default))(element, parent, key, options);
    const complete = domqlElement.on?.complete;
    if (complete) await domqlElement.on.complete(element, element.state, element.context, options);
    const onComplete = domqlElement.props?.onComplete;
    if (onComplete) await domqlElement.props?.onComplete(element, element.state, element.context, options);
    const initInspect = domqlElement.on?.initInspect;
    if (initInspect) await domqlElement.on.initInspect(element, element.state, element.context, options);
    const initSync = domqlElement.on?.initSync;
    if (initSync) await domqlElement.on.initSync(element, element.state, element.context, options);
    return domqlElement;
};
var $07fce7224ceb45c2$export$2e2bcd8739ae039 = {
    TREE: $b18jb.TREE,
    create: $07fce7224ceb45c2$var$create
};



parcelRequire("cBUNY");
var $cPMIO = parcelRequire("cPMIO");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("60dnU");
var $btZia = parcelRequire("btZia");


var $a66481cfd70d9541$exports = {};
$a66481cfd70d9541$exports = JSON.parse("{\"name\":\"@symbo.ls/create\",\"version\":\"2.34.34\",\"license\":\"MIT\",\"gitHead\":\"597f4c9a825058204d2e92c904d125ebbd58cc5c\",\"type\":\"module\",\"module\":\"src/index.js\",\"main\":\"src/index.js\",\"unpkg\":\"dist/iife/index.js\",\"jsdelivr\":\"dist/iife/index.js\",\"exports\":{\".\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"default\":\"./dist/esm/index.js\"}},\"source\":\"src/index.js\",\"files\":[\"src\",\"dist\"],\"scripts\":{\"copy:package:cjs\":\"cp ../../build/package-cjs.json dist/cjs/package.json\",\"build:esm\":\"npx cross-env NODE_ENV=$NODE_ENV npx esbuild src/*.js --target=es2017 --format=esm --outdir=dist/esm\",\"build:cjs\":\"npx cross-env NODE_ENV=$NODE_ENV npx esbuild src/*.js --target=node16 --format=cjs --outdir=dist/cjs\",\"build:iife\":\"npx cross-env NODE_ENV=$NODE_ENV npx esbuild src/*.js --target=node16 --format=iife --outdir=dist/iife\",\"build\":\"rimraf -I dist; npm run build:cjs; npm run build:esm\",\"prepublish\":\"npm run build; npm run copy:package:cjs\"},\"dependencies\":{\"@domql/emotion\":\"^2.34.34\",\"@domql/event\":\"^2.34.34\",\"@domql/report\":\"^2.34.34\",\"@domql/router\":\"^2.34.34\",\"@symbo.ls/fetch\":\"^2.34.34\",\"@symbo.ls/init\":\"^2.34.34\",\"@symbo.ls/scratch\":\"^2.34.34\",\"@symbo.ls/sync\":\"^2.34.34\",\"@symbo.ls/uikit\":\"^2.34.34\",\"@symbo.ls/utils\":\"^2.34.34\",\"domql\":\"^2.34.34\"},\"devDependencies\":{\"@babel/core\":\"^7.27.1\"}}");


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");



var $73MNt = parcelRequire("73MNt");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $jvD5p = parcelRequire("jvD5p");
'use strict';
// const ANIMATION = {
//   fadeInUp: {
//     from: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     },
//     to: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     }
//   },
//   fadeOutDown: {
//     from: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     },
//     to: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     }
//   }
// }
// const COLOR = {
//   black: '#000000',
//   blue: '#3686F7'
// }
// set({
//   COLOR,
//   ANIMATION
// })
const $e26365dd1fe7f8fa$var$NOTIF_COLORS = {
    success: 'green',
    error: 'red',
    warning: 'yellow'
};
const $e26365dd1fe7f8fa$export$f34bb2007ac88e4d = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: 'Connected',
                message: 'to the Symbols live server'
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.setProps({
                    animation: 'fadeOutDown'
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3000);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: 'Disconnected',
            type: 'error'
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            if (element.notifications.content.connected) element.notifications.content.connected.setProps({
                animation: 'fadeOutDown'
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3000);
    }
};
const $e26365dd1fe7f8fa$export$36ba2f559d49a8f6 = {
    state: {
        notifications: []
    },
    Notifications: {
        position: 'fixed',
        left: 'A2',
        bottom: 'Z2',
        zIndex: '999',
        childExtends: 'Notification',
        childProps: ({ state: state })=>({
                animationDuration: 'C',
                background: $e26365dd1fe7f8fa$var$NOTIF_COLORS[state.type || 'success'],
                icon: null,
                Flex: {
                    Title: {
                        text: '{{ title }}'
                    },
                    P: {
                        text: '{{ title }}'
                    }
                },
                onRender: (e, el, s)=>{
                    el.setProps({
                        animation: 'fadeInUp'
                    });
                },
                onClick: (e, el, s)=>{
                    delete s.notifications[el.key];
                    el.setProps({
                        animation: 'fadeOutDown'
                    });
                    if (s.onClose) s.onClose(e, el, s);
                }
            }),
        IconText: null,
        childrenAs: 'state',
        children: ({ state: state })=>state.notifications
    }
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cVSYW = parcelRequire("cVSYW");
'use strict';
function $d701fa452bb83497$var$returnStringExtend(extend) {
    return (0, $EqHTq.isString)(extend) ? extend : (0, $EqHTq.isArray)(extend) ? extend.find((extItem)=>(0, $EqHTq.isString)(extItem)) : '';
}
function $d701fa452bb83497$var$getComponentKey(el) {
    if (!el) return;
    const __componentKey = el.__ref.__componentKey;
    const extendStr = el.extend && $d701fa452bb83497$var$returnStringExtend(el.extend);
    const parentChildExtendStr = el.parent && el.parent.childExtend && $d701fa452bb83497$var$returnStringExtend(el.parent.childExtend);
    return (__componentKey || extendStr || parentChildExtendStr || '').split('_')[0].split('.')[0].split('+')[0];
}
function $d701fa452bb83497$var$findComponent(el) {
    if (!el || !el.__ref) return;
    const { components: components, pages: pages, editor: editor } = el.context;
    const componentKey = $d701fa452bb83497$var$getComponentKey(el);
    if (editor && editor.onInitInspect) {
        const initInspectReturns = editor.onInitInspect(componentKey, el, el.state);
        if (!initInspectReturns) return $d701fa452bb83497$var$findComponent(el.parent);
    }
    if (componentKey && (components[componentKey] || pages[componentKey])) return el;
    return $d701fa452bb83497$var$findComponent(el.parent);
}
const $d701fa452bb83497$var$onInspect = (app, state, ctx)=>{
    const windowOpts = ctx.window || window;
    windowOpts.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventUpdate: true,
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    windowOpts.onkeyup = (ev)=>{
        if (app.state.preventSelect && (!ev.altKey || !ev.shiftKey)) {
            app.state.replace({
                debugging: false,
                preventSelect: false
            }, {
                preventUpdate: true,
                preventContentUpdate: true,
                preventRecursive: true
            });
            app.Inspector.state.update({
                area: false
            });
        }
    };
};
const $d701fa452bb83497$export$d1a121333e17a5bb = {
    props: {
        '.preventSelect': {
            userSelect: 'none'
        },
        '!preventSelect': {
            userSelect: 'auto'
        },
        onInspect: $d701fa452bb83497$var$onInspect,
        onMousemove: (ev, e, state)=>{
            const el = ev.target.ref;
            const component = $d701fa452bb83497$var$findComponent(el);
            const focusState = e.Inspector.state;
            if (!component || !state.debugging || !component.__ref) return focusState.update({
                area: false
            });
            const componentKey = $d701fa452bb83497$var$getComponentKey(component);
            const updateValue = (area)=>{
                focusState.update({
                    area: area,
                    focusKey: componentKey
                });
            };
            const update = ()=>{
                if (ev.altKey && ev.shiftKey) {
                    const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                    const area = {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                    if (!focusState.area) return updateValue(area);
                    if (focusState.area.x !== area.x) updateValue(area);
                } else if (focusState.area) focusState.update({
                    area: false
                });
            };
            window.requestAnimationFrame(()=>{
                update();
                window.requestAnimationFrame(update);
            });
        },
        onMousedown: (ev, elem, state)=>{
            if (!state.debugging) return;
            const el = ev.target.ref;
            const component = $d701fa452bb83497$var$findComponent(el);
            if (!component) return;
            const componentKey = $d701fa452bb83497$var$getComponentKey(component);
            if (!componentKey) return;
            const editor = el.context.editor;
            if (editor && editor.onInspect) return editor.onInspect(componentKey, el, el.state, {
                allowRouterWhileInspect: true
            });
            const data = JSON.stringify({
                componentKey: `${componentKey}`
            });
            (0, $cVSYW.send).call(el.context.socket, 'route', data);
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        }
    },
    Inspector: {
        state: {},
        props: (el, s)=>({
                transition: 'all, defaultBezier, X',
                position: 'fixed',
                hide: !(s.area && s.parent.debugging),
                style: {
                    boxShadow: '0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A',
                    zIndex: '9999999',
                    borderRadius: '10px',
                    pointerEvents: 'none'
                }
            }),
        span: {
            props: {
                position: 'absolute',
                margin: 'A2 0',
                fontSize: 'Z',
                color: 'text',
                // color: 'blue',
                zIndex: '99999999',
                transition: 'all, defaultBezier, X',
                textDecoration: 'underline',
                fontWeight: '500',
                top: '100%',
                style: {
                    boxShadow: '0 25px 10px 35px black',
                    textShadow: '0 0 10px black'
                },
                text: '{{ focusKey }}'
            }
        },
        on: {
            init: ({ context: context })=>{
                const { components: components } = context;
                if ((0, $EqHTq.isObject)(components)) {
                    const { Content: Content, ...rest } = components;
                    for(const key in rest){
                        if ($be006f1a0fabd945$exports[key]) continue;
                        if (!rest[key].__ref) rest[key].__ref = {};
                        if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                    }
                }
            },
            beforeUpdate: (ch, el, s)=>{
                const { area: area } = s;
                const isDebugging = s.area && s.parent.debugging;
                let style;
                if (!isDebugging) style = 'display: none !important';
                else if (area) {
                    const { x: x, y: y, width: width, height: height } = area;
                    // el.node.style = Object.stringify({
                    //   top: y - 6 + 'px',
                    //   left: x - 6 + 'px',
                    //   width: width + 12 + 'px',
                    //   height: height + 12 + 'px'
                    // })
                    style = `
            display: block !important;
            top: ${y - 6}px;
            left: ${x - 6}px;
            width: ${width + 12}px;
            height: ${height + 12}px;
          `;
                }
                el.node.style = style;
                el.span.node.innerText = s.focusKey;
                return false;
            }
        }
    }
};


const $a3bcd877efa191fa$var$isLocal = false;
// ---------------------------------------------
// Utility helpers to apply ops
const $a3bcd877efa191fa$var$deletePath = (obj, path)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (acc && v in acc) {
            if (i !== arr.length - 1) return acc[v];
            delete acc[v];
        }
        return void 0;
    }, obj);
};
const $a3bcd877efa191fa$var$setPath = (obj, path, value, createNestedObjects = false)=>{
    if (!obj || !Array.isArray(path)) return;
    path.reduce((acc, v, i, arr)=>{
        if (!acc) return void 0;
        if (i !== arr.length - 1) {
            if (!acc[v] && createNestedObjects) acc[v] = {};
            return acc[v];
        }
        acc[v] = value;
        return void 0;
    }, obj);
};
const $a3bcd877efa191fa$var$applyOpsToCtx = (ctx, changes)=>{
    const topLevelChanged = new Set();
    if (!Array.isArray(changes)) return topLevelChanged;
    for (const [action, path, change] of changes){
        if (!Array.isArray(path) || !path.length) continue;
        topLevelChanged.add(path[0]);
        switch(action){
            case 'delete':
                $a3bcd877efa191fa$var$deletePath(ctx, path);
                break;
            case 'update':
            case 'set':
                $a3bcd877efa191fa$var$setPath(ctx, path, change, true);
                break;
            default:
                break;
        }
    }
    return topLevelChanged;
};
// ---------------------------------------------
const $a3bcd877efa191fa$var$fetchServiceToken = async ()=>{
    try {
        const urlBase = $a3bcd877efa191fa$var$isLocal ? 'http://localhost:8080' : 'https://api.symbols.app';
        const res = await (0, $jvD5p.window).fetch(`${urlBase}/service-token`, {
            method: 'GET'
        });
        // Attempt to parse JSON first – recent versions return `{ token: "..." }`
        // Fall back to treating the response as raw text for backward-compatibility.
        let txt;
        try {
            const json = await res.clone().json();
            if (json && typeof json.token === 'string') return json.token.trim();
            // If json parsing succeeds but no token field, fall back to text below.
            txt = await res.text();
        } catch  {
            // Response is not JSON – treat as plain text token.
            txt = await res.text();
        }
        return (txt || '').replace(/\s+/gu, '') || void 0;
    } catch (e) {
        console.error('[sync] Failed to fetch service-token', e);
    }
};
const $a3bcd877efa191fa$var$onSnapshot = (el, s, ctx)=>(payload = {})=>{
        let { data: data } = payload;
        const { schema: schema } = payload;
        if (!data) return;
        data = el.call('deepDestringifyFunctions', data, Array.isArray(data) ? [] : {});
        // Overwrite high-level objects shallowly so references are preserved
        Object.entries(data).forEach(([key, val])=>{
            if (ctx[key] && typeof ctx[key] === 'object') {
                if (key === 'designSystem') (0, $31242768b5023c84$export$2cd8252107eb640b)(val);
                else (0, $8wu6n.overwriteShallow)(ctx[key], val);
            } else ctx[key] = val;
        });
        // Optionally make schema available on ctx
        if (schema) ctx.schema = schema;
    };
const $a3bcd877efa191fa$var$onOps = (el, s, ctx)=>(payload = {})=>{
        let { changes: changes } = payload;
        if (!changes || !Array.isArray(changes) || !changes.length) return;
        changes = el.call('deepDestringifyFunctions', changes, Array.isArray(changes) ? [] : {});
        // Iterate over components and pages to run domql3hack
        if (ctx.forceDomql3) {
            for(const key in changes.components)if (!key.includes('smbls.') && changes.components.hasOwnProperty(key)) changes.components[key] = temporaryDomqlHackReverse(changes.components[key]);
            for(const key in changes.pages)if (changes.pages.hasOwnProperty(key)) changes.pages[key] = temporaryDomqlHackReverse(changes.pages[key]);
        }
        const changed = $a3bcd877efa191fa$var$applyOpsToCtx(ctx, changes);
        // React to specific top-level changes
        if (changed.has('state')) {
            const route = ctx.state?.route;
            if (route) el.call('router', route.replace('/state', '') || '/', el.__ref.root, {}, {
                scrollToTop: false
            });
            else s.update(ctx.state);
        }
        if ([
            'pages',
            'components',
            'snippets',
            'functions'
        ].some((k)=>changed.has(k))) {
            const { pathname: pathname, search: search, hash: hash } = ctx.window.location;
            el.call('router', pathname + search + hash, el.__ref.root, {}, {
                scrollToTop: false
            });
        }
        if (changed.has('designSystem')) (0, $31242768b5023c84$export$2cd8252107eb640b)(ctx.designSystem);
    };
const $a3bcd877efa191fa$export$c57211ae658b2a31 = async (el, s, ctx)=>{
    const token = await $a3bcd877efa191fa$var$fetchServiceToken();
    if (!token) {
        console.warn("[sync] No service token \u2013 live collaboration disabled");
        return null;
    }
    const projectKey = ctx.key;
    if (!projectKey) {
        console.warn("[sync] ctx.key missing \u2013 cannot establish collaborative connection");
        return null;
    }
    const socketBaseUrl = $a3bcd877efa191fa$var$isLocal ? 'http://localhost:8080' : 'https://api.symbols.app';
    const socket = (0, $73MNt.io)(socketBaseUrl, {
        path: '/collab-socket',
        transports: [
            'websocket'
        ],
        auth: {
            token: token,
            projectKey: projectKey,
            branch: 'main',
            live: true,
            clientType: 'platform'
        },
        reconnectionAttempts: Infinity,
        reconnectionDelayMax: 4000
    });
    socket.on('connect', ()=>{
        if (ctx.editor?.verbose) console.info('[sync] Connected to collab socket');
    });
    socket.on('snapshot', $a3bcd877efa191fa$var$onSnapshot(el, s, ctx));
    socket.on('ops', $a3bcd877efa191fa$var$onOps(el, s, ctx));
    socket.on('clients', (data)=>{
        if (ctx.editor?.verbose) (0, $e26365dd1fe7f8fa$export$f34bb2007ac88e4d)(data, el, s);
    });
    socket.on('disconnect', (reason)=>{
        if (ctx.editor?.verbose) console.info('[sync] Disconnected from collab socket', reason);
    });
    return socket;
};
const $a3bcd877efa191fa$export$a8792fa004fc1e59 = {
    on: {
        initSync: $a3bcd877efa191fa$export$c57211ae658b2a31
    }
};
const $a3bcd877efa191fa$export$d05f3dc416482df7 = {
    extend: [
        $a3bcd877efa191fa$export$a8792fa004fc1e59,
        (0, $d701fa452bb83497$export$d1a121333e17a5bb),
        (0, $e26365dd1fe7f8fa$export$36ba2f559d49a8f6)
    ]
};


'use strict';
const $5b6a3972014f3e94$export$c8d1988b2aeaf8a9 = (app, ctx)=>{
    return (0, $EqHTq.isObjectLike)(app.extend) ? app.extend : [];
};
const $5b6a3972014f3e94$export$f04cca198b6322f4 = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const liveSync = (0, $EqHTq.isUndefined)(editor.liveSync) ? (0, $jOLBF.isDevelopment)() : editor.liveSync;
    if (liveSync) {
        if ((0, $EqHTq.isArray)(app.extend)) app.extend.push((0, $a3bcd877efa191fa$export$a8792fa004fc1e59));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $a3bcd877efa191fa$export$a8792fa004fc1e59)
        ];
        else app.extend = [
            (0, $a3bcd877efa191fa$export$a8792fa004fc1e59)
        ];
    }
};
const $5b6a3972014f3e94$export$6919748479ac6c4f = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const inspect = (0, $EqHTq.isUndefined)(editor.inspect) ? (0, $jOLBF.isDevelopment)() : editor.inspect;
    if (inspect) {
        if ((0, $EqHTq.isArray)(app.extend)) app.extend.push((0, $d701fa452bb83497$export$d1a121333e17a5bb));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $d701fa452bb83497$export$d1a121333e17a5bb)
        ];
        else app.extend = [
            (0, $d701fa452bb83497$export$d1a121333e17a5bb)
        ];
    }
};
const $5b6a3972014f3e94$export$cf84b69175b2f78a = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const verbose = (0, $EqHTq.isUndefined)(editor.verbose) ? (0, $jOLBF.isDevelopment)() || ctx.verbose : editor.verbose;
    if (verbose) {
        if ((0, $EqHTq.isArray)(app.extend)) app.extend.push((0, $e26365dd1fe7f8fa$export$36ba2f559d49a8f6));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $e26365dd1fe7f8fa$export$36ba2f559d49a8f6)
        ];
        else app.extend = [
            (0, $e26365dd1fe7f8fa$export$36ba2f559d49a8f6)
        ];
    }
};


parcelRequire("cBUNY");
var $bGXur = parcelRequire("bGXur");
var $8wu6n = parcelRequire("8wu6n");
var $jOLBF = parcelRequire("jOLBF");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $deb2b9270b7f90e5$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === 'string' && key.charAt(0) === '_' && key.charAt(1) !== '_') element.class = key.slice(1);
};
const $deb2b9270b7f90e5$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $8wu6n.exec)(param, element)}`;
    }
    return className;
};
const $deb2b9270b7f90e5$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $deb2b9270b7f90e5$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, ' ').trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $deb2b9270b7f90e5$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $deb2b9270b7f90e5$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
function $deb2b9270b7f90e5$export$f1a8a7f322d4587c(params, element, node) {
    $deb2b9270b7f90e5$export$e8f750c9f10c0a7b(params, element, node);
}
var $deb2b9270b7f90e5$export$2e2bcd8739ae039 = $deb2b9270b7f90e5$export$f1a8a7f322d4587c;


'use strict';
const $a03ad4de26254f62$export$c79b0dc85ccca679 = (emotion)=>{
    return (params, element, state)=>{
        const execParams = (0, $8wu6n.exec)(params, element);
        if (params) {
            if ((0, $EqHTq.isObjectLike)(element.class)) element.class.elementStyle = execParams;
            else element.class = {
                elementStyle: execParams
            };
        }
        $a03ad4de26254f62$export$62b33bcc98e42249(emotion)(element.class, element, element.state, true);
    };
};
const $a03ad4de26254f62$export$62b33bcc98e42249 = (emotion)=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (!(0, $EqHTq.isObjectLike)(params)) return;
        if (element.props.class) __classNames.classProps = element.props.class;
        if (element.attr.class) __classNames.class = element.attr.class;
        for(const key in params){
            const prop = (0, $8wu6n.exec)(params[key], element);
            if (!prop) {
                delete __class[key];
                delete __classNames[key];
                continue;
            }
            const isEqual = (0, $8wu6n.isEqualDeep)(__class[key], prop);
            if (!isEqual) {
                if (!(0, $jOLBF.isProduction)() && (0, $EqHTq.isObject)(prop)) prop.label = key || element.key;
                let className;
                if ((0, $EqHTq.isString)(prop) || (0, $EqHTq.isNumber)(prop)) className = prop;
                else if ((0, $EqHTq.isBoolean)(prop)) className = element.key;
                else className = emotion.css(prop);
                __class[key] = prop;
                __classNames[key] = className;
            }
        }
        (0, $deb2b9270b7f90e5$export$e8f750c9f10c0a7b)(__classNames, element, element.node);
    // return element.class
    };
};
const $a03ad4de26254f62$export$23627aa597d6e60c = (emotion, options)=>{
    if (!emotion) emotion = (0, $f80ae5e019588f18$export$2e2bcd8739ae039)(options || {
        key: 'smbls'
    });
    return {
        style: $a03ad4de26254f62$export$c79b0dc85ccca679(emotion),
        class: $a03ad4de26254f62$export$62b33bcc98e42249(emotion)
    };
};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

'use strict';
const $7c0747b58b41b25c$export$6be23892b3f5233 = {
    symbols: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    logo: '<svg height="24" width="24"><path d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    arrowDownCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-circle"><circle cx="12" cy="12" r="10"/><path d="M8 12l4 4 4-4M12 8v8"/></svg>',
    arrowDownLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-left"><path d="M17 7L7 17M17 17H7V7"/></svg>',
    arrowDownRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-right"><path d="M7 7l10 10M17 7v10H7"/></svg>',
    arrowDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>',
    arrowLeftCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left-circle"><circle cx="12" cy="12" r="10"/><path d="M12 8l-4 4 4 4M16 12H8"/></svg>',
    arrowLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    arrowRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    arrowRightCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"/><path d="M12 16l4-4-4-4M8 12h8"/></svg>',
    arrowUpCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-circle"><circle cx="12" cy="12" r="10"/><path d="M16 12l-4-4-4 4M12 16V8"/></svg>',
    arrowUpLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-left"><path d="M17 17L7 7M7 17V7h10"/></svg>',
    arrowUpRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-right"><path d="M7 17L17 7M7 7h10v10"/></svg>',
    arrowUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    checkCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>',
    check: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><path d="M20 6L9 17l-5-5"/></svg>',
    chevronDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><path d="M6 9l6 6 6-6"/></svg>',
    chevronLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><path d="M15 18l-6-6 6-6"/></svg>',
    chevronRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><path d="M9 18l6-6-6-6"/></svg>',
    chevronUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><path d="M18 15l-6-6-6 6"/></svg>',
    copy: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>',
    eyeOff: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></svg>',
    eye: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    info: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
    lock: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
    minus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><path d="M5 12h14"/></svg>',
    sun: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>',
    moon: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>',
    moreHorizontal: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>',
    moreVertical: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
    send: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    smile: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-smile"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>',
    search: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>',
    upload: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>',
    video: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
    x: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    star: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>',
    plus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><path d="M12 5v14M5 12h14"/></svg>'
};


'use strict';
const $68c1235a721b25ba$export$9b982809044276a6 = {
    blue: '#213eb0',
    green: '#389d34',
    red: '#e15c55',
    yellow: '#EDCB38',
    orange: '#e97c16',
    transparent: 'rgba(0, 0, 0, 0)',
    black: 'black',
    gray: '#4e4e50',
    white: 'white',
    title: [
        '--gray 1 -168',
        '--gray 1 +168'
    ],
    caption: [
        '--gray 1 -68',
        '--gray 1 +68'
    ],
    paragraph: [
        '--gray 1 -42',
        '--gray 1 +42'
    ],
    disabled: [
        '--gray 1 -26',
        '--gray 1 +26'
    ],
    line: [
        '--gray 1 -16',
        '--gray 1 +16'
    ]
};
const $68c1235a721b25ba$export$3d856cf049c09ba8 = {
    'gradient-blue-light': `linear-gradient(to right,
    rgba(4, 116, 242, 1),
    rgba(0, 48, 103, 1)
  )`,
    'gradient-blue-dark': `linear-gradient(to right,
    #0474F2,
    #003067
  )`,
    'gradient-dark': `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    'gradient-dark-active': `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
    'gradient-light': `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    'gradient-light-active': `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    'gradient-colorful': `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
};


'use strict';
const $ff633047a5e6ba5f$var$PRIORITIES = {
    primary: {
        '@dark': {
            color: 'white',
            background: 'blue',
            '.color-only': {
                color: 'blue'
            },
            '.inactive': {
                background: 'gray 1 +16'
            },
            '.gradient': {
                color: 'white',
                background: 'gradient-blue'
            }
        },
        '@light': {
            color: 'white',
            background: 'gradient-blue',
            '.color-only': {
                color: 'blue'
            },
            '.gradient': {
                color: 'white',
                background: 'gradient-colorful'
            }
        }
    },
    secondary: {
        '@dark': {
            color: 'white',
            background: 'green',
            '.color-only': {
                color: 'green'
            }
        },
        '@light': {
            color: 'white',
            background: 'green',
            '.color-only': {
                color: 'green'
            }
        },
        '.child': '--primary'
    },
    tertiary: {
        '@dark': {
            color: 'white',
            background: 'gray .92 +8'
        },
        '@light': {
            background: 'gray .1'
        }
    },
    quaternary: {
        '@light': {
            color: 'white',
            background: 'gradient-light'
        },
        '@dark': {
            color: 'white',
            background: 'gradient-dark-active'
        }
    },
    quinary: {
        '@dark': {
            color: 'gray 1 90',
            background: 'gradient-light',
            ':hover': {
                color: 'gray 1 95',
                background: 'gradient-light-active'
            },
            ':focus': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            },
            ':active': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            },
            '.active': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray1',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray1',
                background: 'gradient-dark-active'
            },
            '.active': {
                color: 'gray1',
                background: 'gradient-dark-active'
            }
        }
    }
};
const $ff633047a5e6ba5f$var$STATES = {
    alert: {
        '@dark': {
            color: 'white',
            background: 'red'
        }
    },
    warning: {
        '@dark': {
            color: 'black',
            background: 'yellow'
        }
    },
    success: {
        '@dark': {
            color: 'black',
            background: 'green'
        }
    }
};
const $ff633047a5e6ba5f$var$UI = {
    field: {
        '@light': {
            color: 'black',
            background: 'gray .975 +144',
            borderColor: 'gray .975 +144',
            '::placeholder': {
                color: 'gray 1 -68'
            }
        },
        '@dark': {
            color: 'white',
            background: 'gray .975 -52',
            borderColor: 'gray .975 -52',
            '::placeholder': {
                color: 'gray 1 +68'
            }
        }
    },
    label: {
        '@dark': {
            color: 'white',
            background: 'gray .92 +8'
        },
        '@light': {
            background: 'gray .1'
        },
        '.light': {
            color: 'white',
            background: 'gray3'
        },
        '.dark': {
            color: 'white',
            background: 'black .35'
        }
    },
    card: {
        '@light': {
            background: 'gray .975 +150'
        },
        '@dark': {
            color: 'white',
            background: 'gray .975 -56'
        },
        '.child': {
            color: 'white',
            background: 'gray3'
        },
        '.secondary': {
            color: 'white',
            background: 'gradient-blue-dark',
            '.child': {
                color: 'white',
                background: 'black .35'
            }
        }
    },
    dialog: {
        '@dark': {
            color: 'white',
            background: 'gray .92',
            '.helper': {
                color: 'white',
                background: 'black'
            }
        },
        '@light': {
            color: 'currentColor',
            background: 'gray .1'
        }
    }
};
const $ff633047a5e6ba5f$export$5714e40777c1bcc2 = {
    document: {
        '@light': {
            color: 'black',
            background: 'white'
        },
        '@dark': {
            color: 'white',
            background: 'black'
        }
    },
    ...$ff633047a5e6ba5f$var$PRIORITIES,
    ...$ff633047a5e6ba5f$var$STATES,
    ...$ff633047a5e6ba5f$var$UI,
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    }
};


'use strict';
const $5f8d538af304c7c6$export$d36796ab73e728d9 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


'use strict';
const $79ffe4ae2b30fe08$export$82ea42e772d49e5b = {
    ratio: 1.618,
    subSequence: true
};


'use strict';
const $dbb948e0eaf3d49a$export$75d3998385cc196f = {
    SourceSans: [
        {
            url: ''
        }
    ]
};
const $dbb948e0eaf3d49a$export$530097e879f93363 = {
    system: {
        value: [
            '"Helvetica Neue"',
            'Helvetica',
            'Arial'
        ],
        type: 'sans-serif'
    }
};


'use strict';
const $99bfc4205b1fbca6$export$500415a86c544f73 = {
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024px)',
    mobileL: '(max-width: 768px)',
    'mobileL<': '(min-width: 768px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};


'use strict';
const $ab3d361449dd62cb$export$3c9e9dc0cdfaa753 = {
    base: 150,
    ratio: 1.333,
    unit: 'ms',
    subSequence: true
};


'use strict';
const $812d27f1e77a76ab$export$c2f8e0cc249a8d8f = {
    version: '0.0.1',
    COLOR: $68c1235a721b25ba$export$9b982809044276a6,
    GRADIENT: $68c1235a721b25ba$export$3d856cf049c09ba8,
    THEME: $ff633047a5e6ba5f$export$5714e40777c1bcc2,
    TYPOGRAPHY: $5f8d538af304c7c6$export$d36796ab73e728d9,
    SPACING: $79ffe4ae2b30fe08$export$82ea42e772d49e5b,
    FONT: $dbb948e0eaf3d49a$export$75d3998385cc196f,
    FONT_FAMILY: $dbb948e0eaf3d49a$export$530097e879f93363,
    TIMING: $ab3d361449dd62cb$export$3c9e9dc0cdfaa753,
    ICONS: (0, $7c0747b58b41b25c$export$6be23892b3f5233),
    MEDIA: $99bfc4205b1fbca6$export$500415a86c544f73,
    RESET: {
        html: {},
        body: {}
    },
    ANIMATION: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    DEVICES: {},
    CASES: {},
    CLASS: {},
    SVG: {} // TODO: Check with @nikoloza on this
};
var $812d27f1e77a76ab$export$2e2bcd8739ae039 = $812d27f1e77a76ab$export$c2f8e0cc249a8d8f;


'use strict';
const $0cb0e0c91cc6836f$export$e567b959eb9cc2cc = (key, options = {})=>{
    const doc = options.parent || options.document || document;
    const initOptions = options.initOptions || {};
    const emotion = initOptions.emotion;
    if (!initOptions.emotion) initOptions.emotion = (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const registry = options.registry || (0, $a03ad4de26254f62$export$23627aa597d6e60c)(initOptions.emotion, options);
    const designSystem = initOptions.useDefaultConfig || options.designSystem?.useDefaultConfig ? (0, $8wu6n.deepMerge)(options.designSystem, (0, $8wu6n.deepClone)((0, $812d27f1e77a76ab$export$c2f8e0cc249a8d8f))) : options.designSystem || (0, $8wu6n.deepClone)((0, $812d27f1e77a76ab$export$c2f8e0cc249a8d8f));
    const scratchSystem = (0, $31242768b5023c84$export$2cd8252107eb640b)(designSystem, {
        key: key,
        emotion: emotion,
        verbose: options.verbose,
        document: doc,
        ...(0, $d5fc17b4ecb94b3e$export$882cd4124a942c79),
        ...initOptions
    });
    return [
        scratchSystem,
        emotion,
        registry
    ];
};





'use strict';
const $f46ec85bc7cd1647$export$c3727843bfb8bb3b = (context)=>{
    if (typeof window === 'undefined') window = globalThis || {} // eslint-disable-line
    ;
    if (typeof document === 'undefined') {
        if (!window.document) window.document = globalThis.document || {
            body: {}
        };
        document = window.document // eslint-disable-line
        ;
    }
    context.document = context.document || document;
    context.window = context.window || window;
    return context.window;
};
function $f46ec85bc7cd1647$var$onlyDotsAndNumbers(str) {
    return /^[0-9.]+$/.test(str) && str !== '';
}
const $f46ec85bc7cd1647$var$CDN_PROVIDERS = {
    skypack: {
        url: 'https://cdn.skypack.dev',
        formatUrl: (pkg, version)=>`${$f46ec85bc7cd1647$var$CDN_PROVIDERS.skypack.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}`
    },
    symbols: {
        url: 'https://pkg.symbo.ls',
        formatUrl: (pkg, version)=>{
            if (pkg.split('/').length > 2 || !$f46ec85bc7cd1647$var$onlyDotsAndNumbers(version)) return `${$f46ec85bc7cd1647$var$CDN_PROVIDERS.symbols.url}/${pkg}`;
            return `${$f46ec85bc7cd1647$var$CDN_PROVIDERS.symbols.url}/${pkg}/${version}.js`;
        }
    }
};
const $f46ec85bc7cd1647$export$8407093f131dcef1 = (packageName, version = 'latest', provider = 'skypack')=>{
    const cdnConfig = $f46ec85bc7cd1647$var$CDN_PROVIDERS[provider] || $f46ec85bc7cd1647$var$CDN_PROVIDERS.skypack;
    return cdnConfig.formatUrl(packageName, version);
};
const $f46ec85bc7cd1647$var$UIkitWithPrefix = (prefix = 'smbls')=>{
    const newObj = {};
    for(const key in $be006f1a0fabd945$exports)if (Object.prototype.hasOwnProperty.call($be006f1a0fabd945$exports, key)) {
        if ((0, $bGXur.checkIfKeyIsComponent)(key)) newObj[`${prefix}.${key}`] = $be006f1a0fabd945$exports[key];
        else newObj[key] = $be006f1a0fabd945$exports[key];
    }
    return newObj;
};
const $f46ec85bc7cd1647$export$4f2633f1ff10978c = (context)=>{
    return context.components ? {
        ...$f46ec85bc7cd1647$var$UIkitWithPrefix(),
        ...context.components
    } : $f46ec85bc7cd1647$var$UIkitWithPrefix();
};
const $f46ec85bc7cd1647$export$348dc3ccba7d17b1 = (context)=>{
    return {
        ...$2a60ce89a661a6b2$exports,
        ...$32a808518113ee1c$exports,
        ...$2a60ce89a661a6b2$exports.scratchUtils,
        ...context.utils,
        ...context.snippets,
        ...context.functions
    };
};
const $f46ec85bc7cd1647$export$bb03004b651040c = (context)=>{
    return {
        ...context.methods || {},
        require: context.utils.require,
        requireOnDemand: context.utils.requireOnDemand,
        router: context.utils.router
    };
};
const $f46ec85bc7cd1647$var$cachedDeps = {};
const $f46ec85bc7cd1647$export$c40391394e7726ed = async ({ dependencies: dependencies, dependenciesOnDemand: dependenciesOnDemand, document: document1, preventCaching: preventCaching = false, cdnProvider: cdnProvider = 'skypack' })=>{
    if (!dependencies || Object.keys(dependencies).length === 0) return null;
    for (const [dependency, version] of Object.entries(dependencies)){
        if (dependenciesOnDemand && dependenciesOnDemand[dependency]) continue;
        const random = (0, $jOLBF.isDevelopment)() && preventCaching ? `?${Math.random()}` : '';
        const url = $f46ec85bc7cd1647$export$8407093f131dcef1(dependency, version, cdnProvider) + random;
        try {
            if ($f46ec85bc7cd1647$var$cachedDeps[dependency]) return;
            $f46ec85bc7cd1647$var$cachedDeps[dependency] = true;
            await $2a60ce89a661a6b2$exports.loadRemoteScript(url, {
                document: document1,
                type: 'module'
            });
        } catch (e) {
            console.error(`Failed to load ${dependency} from ${cdnProvider}:`, e);
            if (cdnProvider !== 'symbols') try {
                const fallbackUrl = $f46ec85bc7cd1647$export$8407093f131dcef1(dependency, version, 'symbols') + random;
                await $2a60ce89a661a6b2$exports.loadRemoteScript(fallbackUrl, {
                    document: document1
                });
                console.log(`Successfully loaded ${dependency} from fallback (symbols.ls)`);
            } catch (fallbackError) {
                console.error(`Failed to load ${dependency} from fallback:`, fallbackError);
            }
        }
    }
    return dependencies;
};
const $f46ec85bc7cd1647$export$52302ef84805a6f8 = async (packages, ctx)=>{
    const windowOpts = ctx.window || window;
    const defaultProvider = ctx.cdnProvider || 'skypack';
    const initRequire = async (ctx)=>async (key, provider)=>{
            const windowOpts = ctx.window || window;
            const pkg = windowOpts.packages[key];
            if (typeof pkg === 'function') return pkg();
            return pkg;
        };
    const initRequireOnDemand = async (ctx)=>async (key, provider = defaultProvider)=>{
            const { dependenciesOnDemand: dependenciesOnDemand } = ctx;
            const documentOpts = ctx.document || document;
            const windowOpts = ctx.window || window;
            if (!windowOpts.packages[key]) {
                const random = (0, $jOLBF.isDevelopment)() ? `?${Math.random()}` : '';
                if (dependenciesOnDemand && dependenciesOnDemand[key]) {
                    const version = dependenciesOnDemand[key];
                    const url = $f46ec85bc7cd1647$export$8407093f131dcef1(key, version, provider) + random;
                    try {
                        await ctx.utils.loadRemoteScript(url, {
                            window: windowOpts,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        // Fallback to symbo if not already using it
                        if (provider !== 'symbols') {
                            const fallbackUrl = $f46ec85bc7cd1647$export$8407093f131dcef1(key, version, 'symbols') + random;
                            await ctx.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts,
                                document: documentOpts
                            });
                        }
                    }
                } else {
                    const url = $f46ec85bc7cd1647$export$8407093f131dcef1(key, 'latest', provider) + random;
                    try {
                        await ctx.utils.loadRemoteScript(url, {
                            window: windowOpts,
                            document: documentOpts
                        });
                    } catch (e) {
                        console.error(`Failed to load ${key} from ${provider}:`, e);
                        // Fallback to symbo if not already using it
                        if (provider !== 'symbols') {
                            const fallbackUrl = $f46ec85bc7cd1647$export$8407093f131dcef1(key, 'latest', 'symbols') + random;
                            await ctx.utils.loadRemoteScript(fallbackUrl, {
                                window: windowOpts,
                                document: documentOpts
                            });
                        }
                    }
                    windowOpts.packages[key] = 'loadedOnDeman';
                }
            }
            return await windowOpts.require(key, provider);
        };
    if (windowOpts.packages) windowOpts.packages = (0, $8wu6n.merge)(windowOpts.packages, packages);
    else windowOpts.packages = packages;
    if (!windowOpts.require) {
        ctx.utils.require = await initRequire(ctx);
        windowOpts.require = ctx.utils.require;
    }
    if (!windowOpts.requireOnDemand) {
        ctx.utils.requireOnDemand = await initRequireOnDemand(ctx);
        windowOpts.requireOnDemand = ctx.utils.requireOnDemand;
    }
};
const $f46ec85bc7cd1647$export$d54de307475be07a = (key, context)=>{
    const [scratcDesignhSystem, emotion, registry] = (0, $0cb0e0c91cc6836f$export$e567b959eb9cc2cc)(key, context);
    return [
        scratcDesignhSystem,
        emotion,
        registry
    ];
};
const $f46ec85bc7cd1647$export$beb986ec1c64324 = (app, context)=>{
    const state = {};
    if (context.state) $2a60ce89a661a6b2$exports.deepMerge(state, context.state);
    if (app && app.state) (0, $8wu6n.deepMerge)(state, app.state);
    state.isRootState = true;
    return (0, $8wu6n.deepClone)(state);
};
const $f46ec85bc7cd1647$export$b2f7e94520d001d1 = (app, context)=>{
    if ((0, $EqHTq.isObject)(app.routes) && (0, $EqHTq.isObject)(context.pages)) (0, $8wu6n.merge)(app.routes, context.pages);
    const pages = app.routes || context.pages || {};
    return Object.keys(pages).filter((v)=>!v.startsWith('/')).reduce((pages, v)=>{
        const index = v === 'index' ? '' : v;
        pages['/' + index] = pages[v];
        delete pages[v];
        return pages;
    }, pages);
};
const $f46ec85bc7cd1647$export$2068a53156b77a95 = (context)=>{
    const sharedLibraries = context.sharedLibraries;
    for(let i = 0; i < sharedLibraries.length; i++){
        const sharedLib = sharedLibraries[i];
        if (context.type === 'template') {
            (0, $8wu6n.overwriteShallow)(context.designSystem, sharedLib.designSystem);
            (0, $8wu6n.deepMerge)(context, sharedLib, [
                'designSystem'
            ], 1);
        } else (0, $8wu6n.deepMerge)(context, sharedLib, [], 1);
    }
};



'use strict';
const $a04f9f910a252074$export$9c634076e0a91d1f = async (app, context = {})=>{
    const key = context.key = context.key || ((0, $EqHTq.isString)(app) ? app : 'smblsapp');
    context.define = context.define || (0, $596256ead72518a6$export$6588fc50c67b09a2);
    context.window = (0, $f46ec85bc7cd1647$export$c3727843bfb8bb3b)(context);
    if (context.sharedLibraries) (0, $f46ec85bc7cd1647$export$2068a53156b77a95)(context);
    const [scratcDesignSystem, emotion, registry] = (0, $f46ec85bc7cd1647$export$d54de307475be07a)(key, context);
    context.designSystem = scratcDesignSystem;
    context.registry = registry;
    context.emotion = emotion;
    const state = (0, $f46ec85bc7cd1647$export$beb986ec1c64324)(app, context);
    context.state = state;
    context.pages = (0, $f46ec85bc7cd1647$export$b2f7e94520d001d1)(app, context);
    context.components = (0, $f46ec85bc7cd1647$export$4f2633f1ff10978c)(context);
    context.utils = (0, $f46ec85bc7cd1647$export$348dc3ccba7d17b1)(context);
    context.dependencies = await (0, $f46ec85bc7cd1647$export$c40391394e7726ed)(context);
    context.methods = (0, $f46ec85bc7cd1647$export$bb03004b651040c)(context);
    context.routerOptions = (0, $4747ce2ab72764ea$export$cf7ee87ede64229c)(app, context);
    context.defaultExtends = [
        $c4098057d78edae9$export$e71c4d32a2263218
    ];
    context.version = (0, $a66481cfd70d9541$exports.version);
    // Iterate over components and pages to run domql3hack
    if (context.forceDomql3) {
        for(const key in context.components)if (!key.includes('smbls.') && context.components.hasOwnProperty(key)) context.components[key] = (0, $b2f161ebe0baa04e$export$88c48fe3b498e47b)(context.components[key]);
        for(const key in context.pages)if (context.pages.hasOwnProperty(key)) context.pages[key] = (0, $b2f161ebe0baa04e$export$88c48fe3b498e47b)(context.pages[key]);
    }
    return context;
};
const $a04f9f910a252074$export$b5b313bfdabf2fb4 = async (app, ctx)=>{
    if (!(0, $EqHTq.isObject)(ctx)) ctx = {};
    if ((0, $cPMIO.isNode)(app)) {
        app = {};
        ctx.parent = app;
    } else if ((0, $EqHTq.isString)(app)) {
        app = {};
        ctx.key = app;
    } else if (!(0, $EqHTq.isObject)(app)) app = {};
    else if (ctx.forceDomql3 && ctx.forceDomql3OnInit) app = (0, $b2f161ebe0baa04e$export$88c48fe3b498e47b)(app);
    await $a04f9f910a252074$export$9c634076e0a91d1f(app, ctx);
    app.extend = (0, $5b6a3972014f3e94$export$c8d1988b2aeaf8a9)(app, ctx);
    app.routes = ctx.pages;
    app.state = ctx.state;
    app.context = ctx;
    app.data = app.data || {};
    app.data.frameListeners = (0, $btZia.initAnimationFrame)(ctx);
    await (0, $f46ec85bc7cd1647$export$52302ef84805a6f8)({
        functions: ctx.functions,
        utils: ctx.utils,
        snippets: ctx.snippets,
        ...ctx.files
    }, ctx);
    (0, $5b6a3972014f3e94$export$f04cca198b6322f4)(app, ctx);
    // initializeInspect(app, ctx)
    (0, $5b6a3972014f3e94$export$cf84b69175b2f78a)(app, ctx);
    const parentNode = ctx.parent || ctx.document.body;
    const domqlCreate = (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default && (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default.create || (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).create;
    const smblsApp = await domqlCreate(app, parentNode, ctx.key, {
        verbose: ctx.verbose,
        ...ctx.domqlOptions
    });
    return smblsApp;
};


'use strict';
const $22cae8e82746fd5e$var$mergeWithLocalFile = (options, optionsExternalFile)=>(0, $8wu6n.deepMerge)(options, (0, $EqHTq.isObject)(optionsExternalFile) ? optionsExternalFile : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {});
const $22cae8e82746fd5e$export$185802fd694ee1f5 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions).then((App)=>{
        (0, $4747ce2ab72764ea$export$7fe20beff2421d2d)(App, redefinedOptions);
        if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    });
    return domqlApp;
};
const $22cae8e82746fd5e$export$fa0abf86dcc47d66 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const domqlApp = $22cae8e82746fd5e$export$185802fd694ee1f5(App, options, optionsExternalFile);
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // const SYMBOLS_KEY = process.env.SYMBOLS_KEY
    const key = redefinedOptions.key;
    (0, $5e586daec44b56de$export$beca342e15b450be)(domqlApp, key, {
        utils: $2a60ce89a661a6b2$exports,
        ...redefinedOptions
    });
    return domqlApp;
};
const $22cae8e82746fd5e$export$df2a74307fafca3b = async (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // const SYMBOLS_KEY = process.env.SYMBOLS_KEY
    const key = options.key;
    await (0, $5e586daec44b56de$export$8946d631417d8ced)(key, redefinedOptions);
    const domqlApp = await (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $4747ce2ab72764ea$export$7fe20beff2421d2d)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) await redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    return domqlApp;
};
const $22cae8e82746fd5e$export$9cb2e3fca5d0556e = (App = {}, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    return $22cae8e82746fd5e$export$185802fd694ee1f5({
        deps: {
            isUndefined: $EqHTq.isUndefined
        },
        ...App
    }, (0, $8wu6n.deepMerge)({
        domqlOptions: {
            onlyResolveExtends: true
        }
    }, options), optionsExternalFile);
};
var $22cae8e82746fd5e$export$2e2bcd8739ae039 = $22cae8e82746fd5e$export$185802fd694ee1f5;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

parcelRequire("cBUNY");
var $hSU9O = parcelRequire("hSU9O");
var $a291138c47ac21b4$exports = {};
var $45cd02eecb649c43$exports = {};

$parcel$export($45cd02eecb649c43$exports, "ANIMATION_PROPS", () => $45cd02eecb649c43$export$29173f57c6f2005);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


'use strict';
const $45cd02eecb649c43$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    if ((0, $EqHTq.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $45cd02eecb649c43$export$29173f57c6f2005 = {
    animation: (el)=>({
            animationName: $45cd02eecb649c43$var$applyAnimationProps(el.props.animation, el),
            animationDuration: (0, $16baa215ff216ac9$exports.getTimingByKey)(el.props.animationDuration || 'A').timing,
            animationDelay: (0, $16baa215ff216ac9$exports.getTimingByKey)(el.props.animationDelay || '0s').timing,
            animationTimingFunction: (0, $16baa215ff216ac9$exports.getTimingFunction)(el.props.animationTimingFunction || 'ease'),
            animationFillMode: el.props.animationFillMode || 'both',
            animationPlayState: el.props.animationPlayState,
            animationDirection: el.props.animationDirection
        }),
    animationName: (el)=>({
            animationName: $45cd02eecb649c43$var$applyAnimationProps(el.props.animationName, el)
        }),
    animationDuration: ({ props: props, deps: deps })=>({
            animationDuration: deps.getTimingByKey(props.animationDuration).timing
        }),
    animationDelay: ({ props: props, deps: deps })=>({
            animationDelay: deps.getTimingByKey(props.animationDelay).timing
        }),
    animationTimingFunction: ({ props: props, deps: deps })=>({
            animationTimingFunction: deps.getTimingFunction(props.animationTimingFunction)
        })
};


var $c8546b8815e9ba6b$exports = {};

$parcel$export($c8546b8815e9ba6b$exports, "BLOCK_PROPS", () => $c8546b8815e9ba6b$export$d8a4821b5338da9d);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

'use strict';
const $c8546b8815e9ba6b$export$d8a4821b5338da9d = {
    show: (el, s, ctx)=>!!(ctx.utils.exec(el.props.show, el, s) === false) && {
            display: 'none !important'
        },
    hide: (el, s, ctx)=>!!ctx.utils.exec(el.props.hide, el, s) && {
            display: 'none !important'
        },
    height: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('height', props),
    width: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('width', props),
    boxSizing: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.boxSizing) ? {
            boxSizing: props.boxSizing
        } : {
            boxSizing: 'border-box'
        },
    boxSize: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.boxSize)) return;
        const [height, width] = props.boxSize.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('height', height),
            ...(0, $16baa215ff216ac9$exports.transformSize)('width', width || height)
        };
    },
    inlineSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('inlineSize', props),
    blockSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('blockSize', props),
    minWidth: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('minWidth', props),
    maxWidth: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('maxWidth', props),
    widthRange: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.widthRange)) return;
        const [minWidth, maxWidth] = props.widthRange.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('minWidth', minWidth),
            ...(0, $16baa215ff216ac9$exports.transformSize)('maxWidth', maxWidth || minWidth)
        };
    },
    minHeight: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('minHeight', props),
    maxHeight: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('maxHeight', props),
    heightRange: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.heightRange)) return;
        const [minHeight, maxHeight] = props.heightRange.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('minHeight', minHeight),
            ...(0, $16baa215ff216ac9$exports.transformSize)('maxHeight', maxHeight || minHeight)
        };
    },
    size: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.size)) return;
        const [inlineSize, blockSize] = props.size.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSizeRatio)('inlineSize', inlineSize),
            ...(0, $16baa215ff216ac9$exports.transformSizeRatio)('blockSize', blockSize || inlineSize)
        };
    },
    minBlockSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('minBlockSize', props),
    minInlineSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('minInlineSize', props),
    maxBlockSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('maxBlockSize', props),
    maxInlineSize: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('maxInlineSize', props),
    minSize: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.minSize)) return;
        const [minInlineSize, minBlockSize] = props.minSize.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('minInlineSize', minInlineSize),
            ...(0, $16baa215ff216ac9$exports.transformSize)('minBlockSize', minBlockSize || minInlineSize)
        };
    },
    maxSize: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.maxSize)) return;
        const [maxInlineSize, maxBlockSize] = props.maxSize.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('maxInlineSize', maxInlineSize),
            ...(0, $16baa215ff216ac9$exports.transformSize)('maxBlockSize', maxBlockSize || maxInlineSize)
        };
    },
    borderWidth: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('borderWidth', props),
    padding: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('padding', props),
    scrollPadding: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('scrollPadding', props),
    paddingInline: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.paddingInline)) return;
        const [paddingInlineStart, paddingInlineEnd] = props.paddingInline.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('paddingInlineStart', paddingInlineStart),
            ...(0, $16baa215ff216ac9$exports.transformSize)('paddingInlineEnd', paddingInlineEnd || paddingInlineStart)
        };
    },
    paddingBlock: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.paddingBlock)) return;
        const [paddingBlockStart, paddingBlockEnd] = props.paddingBlock.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('paddingBlockStart', paddingBlockStart),
            ...(0, $16baa215ff216ac9$exports.transformSize)('paddingBlockEnd', paddingBlockEnd || paddingBlockStart)
        };
    },
    paddingInlineStart: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('paddingInlineStart', props),
    paddingInlineEnd: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('paddingInlineEnd', props),
    paddingBlockStart: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('paddingBlockStart', props),
    paddingBlockEnd: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('paddingBlockEnd', props),
    margin: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('margin', props),
    marginInline: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.marginInline)) return;
        const [marginInlineStart, marginInlineEnd] = props.marginInline.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('marginInlineStart', marginInlineStart),
            ...(0, $16baa215ff216ac9$exports.transformSize)('marginInlineEnd', marginInlineEnd || marginInlineStart)
        };
    },
    marginBlock: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.marginBlock)) return;
        const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(' ');
        return {
            ...(0, $16baa215ff216ac9$exports.transformSize)('marginBlockStart', marginBlockStart),
            ...(0, $16baa215ff216ac9$exports.transformSize)('marginBlockEnd', marginBlockEnd || marginBlockStart)
        };
    },
    marginInlineStart: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('marginInlineStart', props),
    marginInlineEnd: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('marginInlineEnd', props),
    marginBlockStart: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('marginBlockStart', props),
    marginBlockEnd: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('marginBlockEnd', props),
    gap: ({ props: props })=>({
            gap: (0, $16baa215ff216ac9$exports.transfromGap)(props.gap)
        }),
    columnGap: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingBasedOnRatio)(props, 'columnGap'),
    rowGap: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingBasedOnRatio)(props, 'rowGap'),
    flexWrap: ({ props: props })=>({
            display: 'flex',
            flexFlow: (props.flexFlow || 'row').split(' ')[0] + ' ' + props.flexWrap
        }),
    flexFlow: ({ props: props })=>{
        const { flexFlow: flexFlow, reverse: reverse } = props;
        if (!(0, $EqHTq.isString)(flexFlow)) return;
        let [direction, wrap] = (flexFlow || 'row').split(' ');
        if (flexFlow.startsWith('x') || flexFlow === 'row') direction = 'row';
        if (flexFlow.startsWith('y') || flexFlow === 'column') direction = 'column';
        return {
            display: 'flex',
            flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
        };
    },
    flexAlign: ({ props: props })=>{
        if (!(0, $EqHTq.isString)(props.flexAlign)) return;
        const [alignItems, justifyContent] = props.flexAlign.split(' ');
        return {
            display: 'flex',
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    }
};


var $51a1840afadb9e23$exports = {};

$parcel$export($51a1840afadb9e23$exports, "FONT_PROPS", () => $51a1840afadb9e23$export$e6c8c930b1cd765);

'use strict';
const $51a1840afadb9e23$export$e6c8c930b1cd765 = {
    fontSize: (el)=>{
        const { props: props } = el;
        return props.fontSize ? (0, $16baa215ff216ac9$exports.getFontSizeByKey)(props.fontSize) : null;
    },
    fontFamily: ({ props: props })=>({
            fontFamily: (0, $16baa215ff216ac9$exports.getFontFamily)(props.fontFamily) || props.fontFamily
        }),
    fontWeight: ({ props: props })=>({
            fontWeight: props.fontWeight,
            fontVariationSettings: '"wght" ' + props.fontWeight
        })
};


var $1ecb6f6de1b9b12c$exports = {};

$parcel$export($1ecb6f6de1b9b12c$exports, "MISC_PROPS", () => $1ecb6f6de1b9b12c$export$24dfac4a0da20903);
'use strict';
const $1ecb6f6de1b9b12c$export$24dfac4a0da20903 = {
    overflow: ({ props: props, deps: deps })=>!deps.isUndefined(props.overflow) && {
            overflow: props.overflow,
            scrollBehavior: 'smooth'
        },
    cursor: (el, s, ctx)=>{
        let val = el.props.cursor;
        if (!val) return;
        const file = ctx.files && ctx.files[val];
        if (file && file.content) val = `url(${file.content.src})`;
        return {
            cursor: val
        };
    }
};


var $dd262031a14f28fd$exports = {};

$parcel$export($dd262031a14f28fd$exports, "POSITION_PROPS", () => $dd262031a14f28fd$export$c0036cbb5416e2bc);

'use strict';
const $dd262031a14f28fd$export$c0036cbb5416e2bc = {
    inset: ({ props: props, context: context })=>{
        const { inset: inset } = props;
        if (context.utils.isNumber(inset)) return {
            inset: inset
        };
        if (!context.utils.isString(inset)) return;
        return {
            inset: inset.split(' ').map((v)=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(v, 'k').k).join(' ')
        };
    },
    left: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(props.left, 'left'),
    top: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(props.top, 'top'),
    right: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(props.right, 'right'),
    bottom: ({ props: props })=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(props.bottom, 'bottom'),
    verticalInset: ({ props: props })=>{
        const { verticalInset: verticalInset } = props;
        if (typeof verticalInset !== 'string') return;
        const vi = verticalInset.split(' ').map((v)=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(v, 'k').k);
        return {
            top: vi[0],
            bottom: vi[1] || vi[0]
        };
    },
    horizontalInset: ({ props: props })=>{
        const { horizontalInset: horizontalInset } = props;
        if (typeof horizontalInset !== 'string') return;
        const vi = horizontalInset.split(' ').map((v)=>(0, $16baa215ff216ac9$exports.getSpacingByKey)(v, 'k').k);
        return {
            left: vi[0],
            right: vi[1] || vi[0]
        };
    }
};


var $c20ed3ccc46ab540$exports = {};

$parcel$export($c20ed3ccc46ab540$exports, "getSystemGlobalTheme", () => $c20ed3ccc46ab540$export$f12bbb197a836138);
$parcel$export($c20ed3ccc46ab540$exports, "THEME_PROPS", () => $c20ed3ccc46ab540$export$11ce017e3ee09814);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
'use strict';
const $c20ed3ccc46ab540$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $c20ed3ccc46ab540$export$11ce017e3ee09814 = {
    theme: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.theme) return;
        const hasSubtheme = props.theme.includes(' ') && !props.theme.includes('@');
        const globalThemeForced = `@${props.themeModifier || globalTheme}`;
        if (hasSubtheme) {
            const themeAppliedInVal = props.theme.split(' ');
            themeAppliedInVal.splice(1, 0, globalThemeForced);
            return (0, $16baa215ff216ac9$exports.getMediaTheme)(themeAppliedInVal);
        } else if (props.theme.includes('@{globalTheme}')) props.theme.replace('@{globalTheme}', globalThemeForced);
        return (0, $16baa215ff216ac9$exports.getMediaTheme)(props.theme, `@${props.themeModifier || globalTheme}`);
    },
    color: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.color) return;
        return {
            color: (0, $16baa215ff216ac9$exports.getMediaColor)(props.color, globalTheme)
        };
    },
    background: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.background) return;
        return {
            background: (0, $16baa215ff216ac9$exports.getMediaColor)(props.background, globalTheme)
        };
    },
    backgroundColor: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.backgroundColor) return;
        return {
            backgroundColor: (0, $16baa215ff216ac9$exports.getMediaColor)(props.backgroundColor, globalTheme)
        };
    },
    backgroundImage: (element, s, ctx)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        let val = props.backgroundImage;
        if (!val) return;
        const file = ctx.files && ctx.files[val];
        if (file && file.content) val = file.content.src;
        return {
            backgroundImage: (0, $16baa215ff216ac9$exports.transformBackgroundImage)(val, globalTheme)
        };
    },
    backgroundSize: ({ props: props })=>({
            backgroundSize: props.backgroundSize
        }),
    backgroundPosition: ({ props: props })=>({
            backgroundPosition: props.backgroundPosition
        }),
    backgroundRepeat: ({ props: props })=>({
            backgroundRepeat: props.backgroundRepeat
        }),
    textStroke: ({ props: props })=>({
            WebkitTextStroke: (0, $16baa215ff216ac9$exports.transformTextStroke)(props.textStroke)
        }),
    outline: ({ props: props })=>(0, $EqHTq.isDefined)(props.outline) && {
            outline: (0, $16baa215ff216ac9$exports.transformBorder)(props.outline)
        },
    outlineOffset: ({ props: props })=>(0, $16baa215ff216ac9$exports.transformSizeRatio)('outlineOffset', props),
    border: ({ props: props })=>(0, $EqHTq.isDefined)(props.border) && {
            border: (0, $16baa215ff216ac9$exports.transformBorder)(props.border)
        },
    borderColor: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.borderColor) return;
        return {
            borderColor: (0, $16baa215ff216ac9$exports.getMediaColor)(props.borderColor, globalTheme)
        };
    },
    borderLeft: ({ props: props })=>({
            borderLeft: (0, $16baa215ff216ac9$exports.transformBorder)(props.borderLeft)
        }),
    borderTop: ({ props: props })=>({
            borderTop: (0, $16baa215ff216ac9$exports.transformBorder)(props.borderTop)
        }),
    borderRight: ({ props: props })=>({
            borderRight: (0, $16baa215ff216ac9$exports.transformBorder)(props.borderRight)
        }),
    borderBottom: ({ props: props })=>({
            borderBottom: (0, $16baa215ff216ac9$exports.transformBorder)(props.borderBottom)
        }),
    shadow: (element)=>{
        const { props: props } = element;
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        if (!props.backgroundImage) return;
        return {
            boxShadow: (0, $16baa215ff216ac9$exports.transformShadow)(props.shadow, globalTheme)
        };
    },
    boxShadow: (element, state, context)=>{
        const { props: props } = element;
        if (!(0, $EqHTq.isString)(props.boxShadow)) return;
        const [val, hasImportant] = props.boxShadow.split('!importan');
        const globalTheme = $c20ed3ccc46ab540$export$f12bbb197a836138(element);
        const important = hasImportant ? ' !important' : '';
        return {
            boxShadow: (0, $16baa215ff216ac9$exports.transformBoxShadow)(val.trim(), globalTheme) + important
        };
    },
    textShadow: ({ props: props, context: context })=>({
            textShadow: (0, $16baa215ff216ac9$exports.transformBoxShadow)(props.textShadow, context.designSystem.globalTheme)
        }),
    columnRule: ({ props: props })=>({
            columnRule: (0, $16baa215ff216ac9$exports.transformBorder)(props.columnRule)
        })
};


var $39f812117129238d$exports = {};

$parcel$export($39f812117129238d$exports, "TIMING_PROPS", () => $39f812117129238d$export$801d104720a35e80);

'use strict';
const $39f812117129238d$export$801d104720a35e80 = {
    transition: ({ props: props })=>({
            transition: (0, $16baa215ff216ac9$exports.splitTransition)(props.transition)
        }),
    transitionDuration: ({ props: props })=>({
            transitionDuration: (0, $16baa215ff216ac9$exports.transformDuration)(props.transitionDuration)
        }),
    transitionDelay: ({ props: props })=>({
            transitionDelay: (0, $16baa215ff216ac9$exports.transformDuration)(props.transitionDelay)
        }),
    transitionTimingFunction: ({ props: props })=>({
            transitionTimingFunction: (0, $16baa215ff216ac9$exports.getTimingFunction)(props.transitionTimingFunction)
        }),
    transitionProperty: ({ props: props })=>({
            transitionProperty: props.transitionProperty,
            willChange: props.transitionProperty
        })
};


'use strict';
$parcel$exportWildcard($a291138c47ac21b4$exports, $45cd02eecb649c43$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $c8546b8815e9ba6b$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $51a1840afadb9e23$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $1ecb6f6de1b9b12c$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $dd262031a14f28fd$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $c20ed3ccc46ab540$exports);
$parcel$exportWildcard($a291138c47ac21b4$exports, $39f812117129238d$exports);



'use strict';
const $7b5e32a367d1defe$export$b474245a861fc144 = (0, $hSU9O.mergeArray)([
    (0, $b448a4a1f1311a88$export$5f1af8db9871e1d6)
]).class;
const $7b5e32a367d1defe$export$c6537d1a7d8e90af = (0, $hSU9O.mergeArray)(Object.values($a291138c47ac21b4$exports));


const $963208d44dd1e716$export$33f20e95f48422c = [
    'accentColor',
    'alignContent',
    'alignItems',
    'alignSelf',
    'alignmentBaseline',
    'all',
    'animation',
    'animationDelay',
    'animationDirection',
    'animationDuration',
    'animationFillMode',
    'animationIterationCount',
    'animationName',
    'animationPlayState',
    'animationTimingFunction',
    'appearance',
    'aspectRatio',
    'backdropFilter',
    'backfaceVisibility',
    'background',
    'backgroundAttachment',
    'backgroundBlendMode',
    'backgroundClip',
    'backgroundColor',
    'backgroundImage',
    'backgroundOrigin',
    'backgroundPosition',
    'backgroundPositionX',
    'backgroundPositionY',
    'backgroundRepeat',
    'backgroundRepeatX',
    'backgroundRepeatY',
    'backgroundSize',
    'baselineShift',
    'blockSize',
    'border',
    'borderBlock',
    'borderBlockColor',
    'borderBlockEnd',
    'borderBlockEndColor',
    'borderBlockEndStyle',
    'borderBlockEndWidth',
    'borderBlockStart',
    'borderBlockStartColor',
    'borderBlockStartStyle',
    'borderBlockStartWidth',
    'borderBlockStyle',
    'borderBlockWidth',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderCollapse',
    'borderColor',
    'borderImage',
    'borderImageOutset',
    'borderImageRepeat',
    'borderImageSlice',
    'borderImageSource',
    'borderImageWidth',
    'borderLeft',
    'borderLeftColor',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightStyle',
    'borderRightWidth',
    'borderSpacing',
    'borderStyle',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'bottom',
    'boxDecorationBreak',
    'boxShadow',
    'boxSizing',
    'breakAfter',
    'breakBefore',
    'breakInside',
    'captionSide',
    'caretColor',
    'clear',
    'clip',
    'clipPath',
    'color',
    'colorAdjust',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorRendering',
    'columnCount',
    'columnFill',
    'columnGap',
    'columnRule',
    'columnRuleColor',
    'columnRuleStyle',
    'columnRuleWidth',
    'columnSpan',
    'columnWidth',
    'columns',
    'contain',
    'content',
    'counterIncrement',
    'counterReset',
    'cursor',
    'direction',
    'display',
    'emptyCells',
    'filter',
    'flex',
    'flexBasis',
    'flexDirection',
    'flexFlow',
    'flexGrow',
    'flexShrink',
    'flexWrap',
    'float',
    'font',
    'fontFamily',
    'fontFeatureSettings',
    'fontKerning',
    'fontLanguageOverride',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontVariantAlternates',
    'fontVariantCaps',
    'fontVariantEastAsian',
    'fontVariantNumeric',
    'fontVariantPosition',
    'fontWeight',
    'fontVariationSettings',
    'fontSynthesis',
    'forcedColorAdjust',
    'gap',
    'grid',
    'gridArea',
    'gridAutoColumns',
    'gridAutoFlow',
    'gridAutoRows',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnGap',
    'gridColumnStart',
    'gridGap',
    'gridRow',
    'gridRowEnd',
    'gridRowGap',
    'gridRowStart',
    'gridTemplate',
    'gridTemplateAreas',
    'gridTemplateColumns',
    'gridTemplateRows',
    'height',
    'hyphens',
    'imageOrientation',
    'imageRendering',
    'imeMode',
    'inset',
    'insetBlock',
    'insetBlockEnd',
    'insetBlockStart',
    'insetInline',
    'insetInlineEnd',
    'insetInlineStart',
    'initialLetter',
    'isolation',
    'justifyContent',
    'justifyItems',
    'justifySelf',
    'left',
    'letterSpacing',
    'lineBreak',
    'lineClamp',
    'lineHeight',
    'listStyle',
    'listStyleImage',
    'listStylePosition',
    'listStyleType',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBlock',
    'marginBlockEnd',
    'marginBlockStart',
    'marginInline',
    'marginInlineEnd',
    'marginInlineStart',
    'mask',
    'maskBorder',
    'maskBorderImage',
    'maskBorderOutset',
    'maskBorderRepeat',
    'maskBorderSlice',
    'maskBorderSource',
    'maskBorderWidth',
    'maskClip',
    'maskComposite',
    'maskImage',
    'maskOrigin',
    'maskPosition',
    'maskRepeat',
    'maskSize',
    'maskType',
    'maxBlockSize',
    'maxHeight',
    'maxInlineSize',
    'maxWidth',
    'minBlockSize',
    'minHeight',
    'minInlineSize',
    'minWidth',
    'mixBlendMode',
    'objectFit',
    'objectPosition',
    'objectViewBox',
    'offset',
    'offsetDistance',
    'offsetPath',
    'offsetRotate',
    'opacity',
    'order',
    'orientation',
    'outline',
    'outlineColor',
    'outlineOffset',
    'outlineStyle',
    'outlineWidth',
    'overflow',
    'overflowAnchor',
    'overflowClip',
    'overflowScrolling',
    'overflowWrap',
    'overflowX',
    'overflowY',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'pageBreakAfter',
    'pageBreakBefore',
    'pageBreakInside',
    'paintOrder',
    'perspective',
    'perspectiveOrigin',
    'placeContent',
    'placeItems',
    'placeSelf',
    'pointerEvents',
    'position',
    'resize',
    'right',
    'rotate',
    'rowGap',
    'scrollBehavior',
    'scrollPadding',
    'scrollSnapAlign',
    'scrollSnapType',
    'scrollbarColor',
    'scrollbarWidth',
    'shapeImageThreshold',
    'shapeMargin',
    'shapeOutside',
    'tabSize',
    'tableLayout',
    'textAlign',
    'textAlignLast',
    'textDecoration',
    'textDecorationColor',
    'textDecorationLine',
    'textDecorationSkipInk',
    'textDecorationStyle',
    'textDecorationThickness',
    'textIndent',
    'textOverflow',
    'textShadow',
    'textTransform',
    'textUnderlineOffset',
    'top',
    'transform',
    'transformOrigin',
    'transformStyle',
    'transition',
    'transitionDelay',
    'transitionDuration',
    'transitionProperty',
    'transitionTimingFunction',
    'translate',
    'translateX',
    'translateY',
    'translateZ',
    'unicodeBidi',
    'userSelect',
    'verticalAlign',
    'visibility',
    'whiteSpace',
    'widows',
    'width',
    'willChange',
    'wordBreak',
    'wordSpacing',
    'wordWrap',
    'writingMode',
    'zIndex'
];


'use strict';
const $e0f37c1020a96688$export$2b5b252eb866c647 = (element, restProps = {})=>{
    const classCss = {};
    const { props: props, class: elementClass } = element;
    if (!(0, $EqHTq.isObject)(props)) return;
    // merge(elementClass, registry)
    // if (registry && Object.keys(registry)[0] !== Object.keys(CSS_PROPS_REGISTRY)[0]) {
    //   merge(elementClass, CSS_PROPS_REGISTRY)
    // }
    for(const key in props){
        const setter = (0, $bc85e892389de1ab$export$5c168558fab3755c)[key.slice(0, 1)];
        const hasCSS = elementClass[key];
        if (setter) setter(key, props[key], classCss, element, true);
        else if ((0, $EqHTq.isFunction)(hasCSS)) {
            // const stack = hasCSS(element)
            const stack = hasCSS(element, element.state, element.context);
            const exec = (0, $EqHTq.isArray)(stack) ? stack.reduce((a, c)=>{
                return (0, $8wu6n.merge)(a, c);
            }, {}) : stack;
            (0, $8wu6n.deepMerge)(classCss, exec);
        } else if (key === 'style') (0, $8wu6n.deepMerge)(classCss, props[key]);
        else restProps[key] = props[key];
    }
    return classCss;
};
const $e0f37c1020a96688$export$70a74cfeffe570f4 = (element)=>{
    const { props: defProps } = element;
    const css = {};
    const props = {};
    for(const key in defProps){
        const val = defProps[key];
        const mediaProp = (0, $bc85e892389de1ab$export$5c168558fab3755c)[key.slice(0, 1)];
        if (mediaProp) {
            mediaProp(key, defProps[key], css, element, true);
            continue;
        }
        const preprop = (0, $7b5e32a367d1defe$export$c6537d1a7d8e90af)[key];
        if (preprop) {
            // const stack = hasCSS(element)
            const stack = preprop(element, element.state, element.context);
            const exec = (0, $EqHTq.isArray)(stack) ? stack.reduce((a, c)=>{
                return (0, $8wu6n.merge)(a, c);
            }, {}) : stack;
            (0, $8wu6n.deepMerge)(css, exec);
            continue;
        }
        if (key === 'style') {
            (0, $8wu6n.deepMerge)(css, defProps[key]);
            continue;
        }
        if ((0, $963208d44dd1e716$export$33f20e95f48422c).includes(key)) {
            css[key] = val;
            continue;
        }
        props[key] = val;
    }
    return {
        css: css,
        props: props
    };
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

'use strict';
const { css: $a8eada0e0fa2abfb$var$css } = (0, $b3468425a35a59c8$export$51d693b3d243fd90);
const $a8eada0e0fa2abfb$export$a66cdfca4dd68910 = (props, callback)=>{
    return (0, $EqHTq.isFunction)(callback) ? callback(props) : $a8eada0e0fa2abfb$var$css(props);
};


'use strict';
const $a0e3532c8709a809$export$6241622f59b2c037 = (props, emotionCss)=>{
    const transform = (0, $e0f37c1020a96688$export$2b5b252eb866c647)(props);
    return (0, $a8eada0e0fa2abfb$export$a66cdfca4dd68910)(transform, emotionCss);
};





'use strict';
const $bf090872a82f6fe1$export$2d3867789701917d = (component, element)=>{
    const classObj = {};
    if (component.class) for(const classProp in component.class)classObj[classProp] = component.class[classProp](element);
    return classObj;
};








'use strict';
 // export * from '@symbo.ls/socket/client' // TODO: Check with @nikoloza
 // export * from '@symbo.ls/sync' // TODO: add it soon
$parcel$exportWildcard($5f26bd3c2a16a4d1$exports, $cBUNY);
$parcel$exportWildcard($5f26bd3c2a16a4d1$exports, $16baa215ff216ac9$exports);
$parcel$exportWildcard($5f26bd3c2a16a4d1$exports, $be006f1a0fabd945$exports);
$parcel$exportWildcard($5f26bd3c2a16a4d1$exports, $8319f99b46b296c9$exports);


var $04288ba364b453ff$exports = {};

$parcel$export($04288ba364b453ff$exports, "state", () => $9223f18bf47aaa7d$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "dependencies", () => $9d44a28624409bae$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "components", () => $6aaa67090b542dc0$exports);
$parcel$export($04288ba364b453ff$exports, "snippets", () => $1b6d556216bfb6d1$exports);
$parcel$export($04288ba364b453ff$exports, "pages", () => $2f93c2b81b587020$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "functions", () => $b1e5d99c521c823a$exports);
$parcel$export($04288ba364b453ff$exports, "methods", () => $c248cbc219519e34$exports);
$parcel$export($04288ba364b453ff$exports, "designSystem", () => $4390f92564b2bbc7$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "files", () => $efc11c9e2462386e$export$2e2bcd8739ae039);
var $9223f18bf47aaa7d$export$2e2bcd8739ae039 = {
    view: 'survey',
    phase: 1,
    isSubmitted: false,
    isSaving: false,
    showShareModal: false,
    // Phase 1 - Symbols
    symbolsPrompt: '',
    symbolsGithub: '',
    symbolsUrl: '',
    symbolsAccuracy: '',
    symbolsIterations: '',
    symbolsScreenshots: [],
    symbolsMetrics: '',
    symbolsMetricsScreenshots: [],
    // Comparison mode
    isComparison: false,
    comparisonFramework: '',
    comparisonFrameworkCustom: '',
    // Phase 2 - Other framework (only when isComparison)
    comparisonGithub: '',
    comparisonAccuracy: '',
    comparisonIterations: '',
    comparisonScreenshots: [],
    comparisonMetrics: '',
    comparisonMetricsScreenshots: [],
    // Phase 3 - Verdict
    preference: '',
    comparisonScore: 5,
    comparisonReason: '',
    // Dashboard
    submissions: []
};


var $9d44a28624409bae$export$2e2bcd8739ae039 = {};


var $6aaa67090b542dc0$exports = {};
var $6c8214b869e744e4$exports = {};

$parcel$export($6c8214b869e744e4$exports, "AppHeader", () => $6c8214b869e744e4$export$9bd256435c34a030);
const $6c8214b869e744e4$export$9bd256435c34a030 = {
    extends: 'Flex',
    justifyContent: 'space-between',
    flexAlign: 'center center',
    flexWrap: 'wrap',
    gap: 'A',
    marginBottom: 'C',
    Logo: {
        extends: 'Flex',
        flexAlign: 'center center',
        gap: 'Z2',
        Icon: {
            extends: 'Flex',
            flexAlign: 'center center',
            background: 'indigo600',
            round: 'X',
            padding: 'X',
            Svg: {
                viewBox: '0 0 24 24',
                width: '24',
                height: '24',
                html: '<rect x="2" y="3" width="20" height="14" rx="2" fill="none" stroke="white" stroke-width="2"/><path d="M8 21h8M12 17v4" stroke="white" stroke-width="2" stroke-linecap="round"/>'
            }
        },
        Title: {
            extends: 'Flex',
            tag: 'h1',
            text: 'SYMBOLS BENCHMARK',
            fontSize: 'B',
            fontWeight: '900',
            letterSpacing: '0.05em',
            color: 'slate900'
        }
    },
    Nav: {
        extends: 'Flex',
        flexAlign: 'center center',
        background: 'white',
        padding: 'X',
        round: 'B',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'slate200',
        gap: 'X',
        overflowX: 'auto',
        PhaseTabs: {
            extends: 'Flex',
            gap: 'X',
            onRender: (el, s)=>{
                if (el.__init) return;
                el.__init = true;
                var node = el.node;
                [
                    1,
                    2,
                    3
                ].forEach(function(p) {
                    var btn = document.createElement('button');
                    btn.type = 'button';
                    btn.textContent = 'PHASE ' + p;
                    btn.setAttribute('data-phase', p);
                    var isActive = s.phase === p;
                    btn.style.cssText = 'padding:6px 14px;border-radius:8px;font-size:11px;font-weight:700;letter-spacing:0.05em;cursor:pointer;border:none;transition:all 0.15s;' + (isActive ? 'background:#4f46e5;color:white;box-shadow:0 1px 4px rgba(79,70,229,0.3)' : 'background:transparent;color:#64748b');
                    if (p === 2) {
                        btn.style.opacity = s.isComparison ? '1' : '0.3';
                        btn.style.pointerEvents = s.isComparison ? 'auto' : 'none';
                    }
                    btn.addEventListener('click', function() {
                        el.call('switchPhase', s, p);
                    });
                    node.appendChild(btn);
                });
            },
            onStateUpdate: (el, s)=>{
                var btns = el.node.querySelectorAll('button[data-phase]');
                btns.forEach(function(btn) {
                    var p = parseInt(btn.getAttribute('data-phase'));
                    var isActive = s.view === 'survey' && s.phase === p;
                    btn.style.background = isActive ? '#4f46e5' : 'transparent';
                    btn.style.color = isActive ? 'white' : '#64748b';
                    btn.style.boxShadow = isActive ? '0 1px 4px rgba(79,70,229,0.3)' : '';
                    if (p === 2) {
                        btn.style.opacity = s.isComparison ? '1' : '0.3';
                        btn.style.pointerEvents = s.isComparison ? 'auto' : 'none';
                    }
                });
                el.node.style.display = s.view === 'survey' && !s.isSubmitted ? 'flex' : 'none';
            }
        },
        Divider: {
            extends: 'Flex',
            width: '1px',
            height: 'A',
            background: 'slate200'
        },
        ResultsBtn: {
            extends: 'Flex',
            tag: 'button',
            type: 'button',
            flexAlign: 'center center',
            gap: 'X',
            padding: 'X A',
            round: 'X',
            cursor: 'pointer',
            borderWidth: '0',
            fontWeight: '700',
            fontSize: '11px',
            letterSpacing: '0.05em',
            text: 'RESULTS',
            onRender: (el, s)=>{
                el.node.setAttribute('data-results-btn', '1');
                el.node.style.background = s.view === 'dashboard' ? '#4f46e5' : 'transparent';
                el.node.style.color = s.view === 'dashboard' ? 'white' : '#4f46e5';
            },
            onStateUpdate: (el, s)=>{
                el.node.style.background = s.view === 'dashboard' ? '#4f46e5' : 'transparent';
                el.node.style.color = s.view === 'dashboard' ? 'white' : '#4f46e5';
            },
            onClick: (e, el, s)=>{
                el.call('switchView', s, 'dashboard');
            }
        }
    }
};


var $ec05b790232eadbd$exports = {};

$parcel$export($ec05b790232eadbd$exports, "SurveyPhase1", () => $ec05b790232eadbd$export$99f79e5da5fa5c15);
const $ec05b790232eadbd$export$99f79e5da5fa5c15 = {
    extends: 'Flex',
    flow: 'y',
    gap: 'B2',
    scope: {
        buildSection: function(label) {
            var div = document.createElement('div');
            div.style.cssText = 'display:flex;flex-direction:column;gap:12px';
            var lbl = document.createElement('label');
            lbl.textContent = label;
            lbl.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
            div.appendChild(lbl);
            return div;
        },
        buildInput: function(s, placeholder, stateKey, icon) {
            var wrap = document.createElement('div');
            wrap.style.cssText = 'position:relative';
            if (icon) wrap.innerHTML = icon;
            var input = document.createElement('input');
            input.type = 'text';
            input.placeholder = placeholder;
            input.style.cssText = 'width:100%;padding:14px 14px 14px ' + (icon ? '44px' : '14px') + ';border-radius:14px;border:2px solid #f1f5f9;font-size:14px;color:#334155;box-sizing:border-box;outline:none;transition:border 0.15s;font-family:inherit';
            input.value = s[stateKey] || '';
            input.addEventListener('input', function(e) {
                var u = {};
                u[stateKey] = e.target.value;
                s.update(u);
            });
            input.addEventListener('focus', function() {
                input.style.borderColor = '#4f46e5';
            });
            input.addEventListener('blur', function() {
                input.style.borderColor = '#f1f5f9';
            });
            wrap.appendChild(input);
            return wrap;
        },
        buildOptionButtons: function(s, node, fieldName, options) {
            var grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:10px';
            options.forEach(function(opt) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.textContent = opt;
                btn.setAttribute('data-field', fieldName);
                btn.setAttribute('data-val', opt);
                var isActive = s[fieldName] === opt;
                btn.style.cssText = 'padding:10px 12px;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;text-align:left;transition:all 0.15s;' + (isActive ? 'background:#eef2ff;border:2px solid #4f46e5;color:#4f46e5' : 'background:white;border:2px solid #e2e8f0;color:#475569');
                btn.addEventListener('click', function() {
                    grid.querySelectorAll('button').forEach(function(b) {
                        var a = b === btn;
                        b.style.background = a ? '#eef2ff' : 'white';
                        b.style.borderColor = a ? '#4f46e5' : '#e2e8f0';
                        b.style.color = a ? '#4f46e5' : '#475569';
                    });
                    var u = {};
                    u[fieldName] = opt;
                    s.update(u);
                });
                grid.appendChild(btn);
            });
            node.appendChild(grid);
        },
        buildUploadArea: function(s, node, fieldName, label) {
            var preview = document.createElement('div');
            preview.setAttribute('data-preview', fieldName);
            preview.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin-top:4px';
            var wrapper = document.createElement('div');
            wrapper.style.cssText = 'position:relative;border:2px dashed #e2e8f0;border-radius:20px;padding:36px 20px;text-align:center;cursor:pointer;transition:border 0.15s';
            var txt = document.createElement('div');
            txt.textContent = label || 'Click to upload screenshots';
            txt.style.cssText = 'font-size:13px;font-weight:700;color:#64748b;pointer-events:none';
            wrapper.appendChild(txt);
            var input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.accept = 'image/*';
            input.style.cssText = 'position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%';
            input.addEventListener('change', function(e) {
                Array.from(e.target.files).forEach(function(file) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var img = document.createElement('img');
                        img.src = reader.result;
                        img.style.cssText = 'width:64px;height:64px;object-fit:cover;border-radius:10px;border:1px solid #e2e8f0';
                        preview.appendChild(img);
                        var current = s[fieldName] || [];
                        var u = {};
                        u[fieldName] = current.concat([
                            reader.result
                        ]);
                        s.update(u);
                    };
                    reader.readAsDataURL(file);
                });
                input.value = '';
            });
            wrapper.appendChild(input);
            node.appendChild(wrapper);
            node.appendChild(preview);
        },
        buildMetricsRow: function(s, node, metricsKey, screenshotsKey) {
            var grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:16px;padding:20px;background:#f8fafc;border-radius:16px;border:1px solid #f1f5f9';
            var left = document.createElement('div');
            left.style.cssText = 'display:flex;flex-direction:column;gap:8px';
            var leftLbl = document.createElement('label');
            leftLbl.textContent = 'PERFORMANCE DATA';
            leftLbl.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;letter-spacing:0.05em';
            var textarea = document.createElement('textarea');
            textarea.placeholder = 'Lighthouse score, bundle size, custom KPIs...';
            textarea.style.cssText = 'width:100%;height:90px;padding:12px;border-radius:10px;border:1px solid #e2e8f0;font-size:12px;font-family:monospace;color:#334155;resize:vertical;box-sizing:border-box;outline:none;background:white';
            textarea.value = s[metricsKey] || '';
            textarea.addEventListener('input', function(e) {
                var u = {};
                u[metricsKey] = e.target.value;
                s.update(u);
            });
            left.appendChild(leftLbl);
            left.appendChild(textarea);
            var right = document.createElement('div');
            right.style.cssText = 'display:flex;flex-direction:column;gap:8px';
            var rightLbl = document.createElement('label');
            rightLbl.textContent = 'METRICS SCREENSHOT';
            rightLbl.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;letter-spacing:0.05em';
            right.appendChild(rightLbl);
            // small upload area inline
            var preview = document.createElement('div');
            preview.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;margin-top:4px';
            var uploadWrap = document.createElement('div');
            uploadWrap.style.cssText = 'position:relative;border:2px dashed #e2e8f0;border-radius:12px;padding:20px 10px;text-align:center;cursor:pointer;background:white;flex:1';
            var uploadTxt = document.createElement('div');
            uploadTxt.textContent = 'Add chart / viz';
            uploadTxt.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;pointer-events:none';
            uploadWrap.appendChild(uploadTxt);
            var uploadInput = document.createElement('input');
            uploadInput.type = 'file';
            uploadInput.multiple = true;
            uploadInput.accept = 'image/*';
            uploadInput.style.cssText = 'position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%';
            uploadInput.addEventListener('change', function(e) {
                Array.from(e.target.files).forEach(function(file) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var img = document.createElement('img');
                        img.src = reader.result;
                        img.style.cssText = 'width:40px;height:40px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0';
                        preview.appendChild(img);
                        var current = s[screenshotsKey] || [];
                        var u = {};
                        u[screenshotsKey] = current.concat([
                            reader.result
                        ]);
                        s.update(u);
                    };
                    reader.readAsDataURL(file);
                });
                uploadInput.value = '';
            });
            uploadWrap.appendChild(uploadInput);
            right.appendChild(uploadWrap);
            right.appendChild(preview);
            grid.appendChild(left);
            grid.appendChild(right);
            node.appendChild(grid);
        }
    },
    onRender: (el, s)=>{
        if (el.__init) return;
        el.__init = true;
        var node = el.node;
        node.style.cssText = 'display:flex;flex-direction:column;gap:24px;padding:32px 40px';
        // Title
        var titleRow = document.createElement('div');
        titleRow.style.cssText = 'display:flex;align-items:center;gap:14px;padding-bottom:20px;border-bottom:1px solid #f1f5f9';
        titleRow.innerHTML = '<div style="padding:10px;background:#fef3c7;border-radius:14px"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#b45309" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div><div><h2 style="font-size:22px;font-weight:900;color:#0f172a;margin:0">1. Symbols AI Native</h2><p style="font-size:13px;color:#64748b;margin:4px 0 0;font-weight:500">Testing the direct generation experience.</p></div>';
        node.appendChild(titleRow);
        // Prompt
        var promptSection = el.scope.buildSection('The Exact Prompt Used');
        var textarea = document.createElement('textarea');
        textarea.placeholder = "e.g., 'Build a complex dashboard with React and Tailwind...'";
        textarea.style.cssText = 'width:100%;height:112px;padding:16px;border-radius:14px;border:2px solid #f1f5f9;font-size:14px;font-weight:500;color:#334155;resize:vertical;font-family:inherit;box-sizing:border-box;outline:none;transition:border 0.15s';
        textarea.value = s.symbolsPrompt || '';
        textarea.addEventListener('input', function(e) {
            s.update({
                symbolsPrompt: e.target.value
            });
        });
        textarea.addEventListener('focus', function() {
            textarea.style.borderColor = '#4f46e5';
        });
        textarea.addEventListener('blur', function() {
            textarea.style.borderColor = '#f1f5f9';
        });
        promptSection.appendChild(textarea);
        node.appendChild(promptSection);
        // GitHub URL
        var githubSection = el.scope.buildSection('GitHub Repo / Sandbox URL');
        var githubIcon = '<svg style="position:absolute;left:14px;top:14px;color:#94a3b8" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/></svg>';
        githubSection.appendChild(el.scope.buildInput(s, 'https://github.com/your-repo', 'symbolsGithub', githubIcon));
        node.appendChild(githubSection);
        // Symbols Live URL
        var urlSection = el.scope.buildSection('Symbols Live Preview URL');
        var linkIcon = '<svg style="position:absolute;left:14px;top:14px;color:#94a3b8" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>';
        urlSection.appendChild(el.scope.buildInput(s, 'https://your-symbols-app.pages.dev', 'symbolsUrl', linkIcon));
        node.appendChild(urlSection);
        // Screenshot upload
        var uploadSection = el.scope.buildSection('Attach Results Screenshots');
        el.scope.buildUploadArea(s, uploadSection, 'symbolsScreenshots', 'Click to upload screenshots');
        node.appendChild(uploadSection);
        // Accuracy options
        var accSection = el.scope.buildSection('Symbols initial accuracy?');
        el.scope.buildOptionButtons(s, accSection, 'symbolsAccuracy', [
            'Fully correct',
            'Mostly correct',
            'Partially correct',
            'Incorrect'
        ]);
        node.appendChild(accSection);
        // Iterations options
        var iterSection = el.scope.buildSection('Manual fixes required?');
        el.scope.buildOptionButtons(s, iterSection, 'symbolsIterations', [
            '0',
            '1-2',
            '3-5',
            '6+'
        ]);
        node.appendChild(iterSection);
        // Comparison checkbox
        var sep = document.createElement('div');
        sep.style.cssText = 'height:1px;background:#f1f5f9;margin:4px 0';
        node.appendChild(sep);
        var checkRow = document.createElement('label');
        checkRow.style.cssText = 'display:flex;align-items:center;gap:14px;padding:20px 24px;background:#f8fafc;border-radius:16px;border:2px solid ' + (s.isComparison ? '#4f46e5' : '#e2e8f0') + ';cursor:pointer;transition:all 0.15s;user-select:none';
        checkRow.setAttribute('data-comparison-row', '1');
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = s.isComparison || false;
        checkbox.style.cssText = 'width:20px;height:20px;accent-color:#4f46e5;cursor:pointer;flex-shrink:0';
        checkbox.setAttribute('data-comparison-cb', '1');
        var checkText = document.createElement('div');
        checkText.innerHTML = '<div style="font-size:15px;font-weight:700;color:#0f172a">Compare against another framework</div><div style="font-size:13px;color:#64748b;margin-top:2px">Enable Phase 2 to benchmark Symbols against React, Angular, Vue, etc.</div>';
        checkRow.appendChild(checkbox);
        checkRow.appendChild(checkText);
        node.appendChild(checkRow);
        // Metrics row (only shown when comparison is enabled)
        var metricsWrap = document.createElement('div');
        metricsWrap.setAttribute('data-p1-metrics', '1');
        metricsWrap.style.display = s.isComparison ? 'block' : 'none';
        var metricsSection = el.scope.buildSection('Performance Metrics');
        el.scope.buildMetricsRow(s, metricsSection, 'symbolsMetrics', 'symbolsMetricsScreenshots');
        metricsWrap.appendChild(metricsSection);
        node.appendChild(metricsWrap);
        checkbox.addEventListener('change', function() {
            var enabled = checkbox.checked;
            s.update({
                isComparison: enabled
            });
            // Update row border
            checkRow.style.borderColor = enabled ? '#4f46e5' : '#e2e8f0';
            checkRow.style.background = enabled ? '#eef2ff' : '#f8fafc';
            // Show/hide metrics section
            var p1metrics = document.querySelector('[data-p1-metrics]');
            if (p1metrics) p1metrics.style.display = enabled ? 'block' : 'none';
            // Show/hide Phase 2 tab directly
            var phase2tab = document.querySelector('button[data-phase="2"]');
            if (phase2tab) {
                phase2tab.style.opacity = enabled ? '1' : '0.3';
                phase2tab.style.pointerEvents = enabled ? 'auto' : 'none';
            }
            // Directly update Phase 3 DOM (onStateUpdate is unreliable)
            var p3title = document.querySelector('[data-p3-title]');
            if (p3title) p3title.textContent = enabled ? '3. Final Verdict' : '3. Final Notes';
            var p3desc = document.querySelector('[data-p3-desc]');
            if (p3desc) p3desc.textContent = enabled ? 'Data-backed head-to-head comparison.' : 'Your overall experience with Symbols AI.';
            var p3comp = document.querySelector('[data-p3-comparison]');
            if (p3comp) p3comp.style.display = enabled ? 'contents' : 'none';
            var p3reasonLbl = document.querySelector('[data-p3-reason-label]');
            if (p3reasonLbl) p3reasonLbl.textContent = enabled ? 'TECHNICAL REASONING' : 'OVERALL EXPERIENCE & NOTES';
            var p3reasonTa = document.querySelector('[data-p3-reason-ta]');
            if (p3reasonTa) p3reasonTa.placeholder = enabled ? 'Explain the specific technical differences, bugs encountered, or productivity boosts...' : "Describe your experience with Symbols AI generation \u2014 accuracy, ease of use, notable wins or issues...";
        });
        // Set initial Phase 2 tab state
        requestAnimationFrame(function() {
            var phase2tab = document.querySelector('button[data-phase="2"]');
            if (phase2tab) {
                phase2tab.style.opacity = s.isComparison ? '1' : '0.3';
                phase2tab.style.pointerEvents = s.isComparison ? 'auto' : 'none';
            }
        });
    }
};


var $b7aac82da1ef6d88$exports = {};

$parcel$export($b7aac82da1ef6d88$exports, "SurveyPhase2", () => $b7aac82da1ef6d88$export$544fe35cf93f4d76);
var $b7aac82da1ef6d88$var$FRAMEWORKS = [
    {
        id: 'react',
        label: 'React',
        color: '#61dafb',
        bg: '#e6f9ff'
    },
    {
        id: 'angular',
        label: 'Angular',
        color: '#dd0031',
        bg: '#ffe6eb'
    },
    {
        id: 'vue',
        label: 'Vue',
        color: '#42b883',
        bg: '#e6f7f1'
    },
    {
        id: 'svelte',
        label: 'Svelte',
        color: '#ff3e00',
        bg: '#fff0eb'
    },
    {
        id: 'html',
        label: 'HTML + CSS',
        color: '#e44d26',
        bg: '#fff3ee'
    },
    {
        id: 'other',
        label: 'Other',
        color: '#64748b',
        bg: '#f1f5f9'
    }
];
const $b7aac82da1ef6d88$export$544fe35cf93f4d76 = {
    extends: 'Flex',
    flow: 'y',
    gap: 'B2',
    scope: {
        buildSection: function(label) {
            var div = document.createElement('div');
            div.style.cssText = 'display:flex;flex-direction:column;gap:12px';
            var lbl = document.createElement('label');
            lbl.textContent = label;
            lbl.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
            div.appendChild(lbl);
            return div;
        },
        buildOptionButtons: function(s, node, fieldName, options) {
            var grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:10px';
            options.forEach(function(opt) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.textContent = opt;
                btn.setAttribute('data-field', fieldName);
                btn.setAttribute('data-val', opt);
                var isActive = s[fieldName] === opt;
                btn.style.cssText = 'padding:10px 12px;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;text-align:left;transition:all 0.15s;' + (isActive ? 'background:#eef2ff;border:2px solid #4f46e5;color:#4f46e5' : 'background:white;border:2px solid #e2e8f0;color:#475569');
                btn.addEventListener('click', function() {
                    grid.querySelectorAll('button').forEach(function(b) {
                        var a = b === btn;
                        b.style.background = a ? '#eef2ff' : 'white';
                        b.style.borderColor = a ? '#4f46e5' : '#e2e8f0';
                        b.style.color = a ? '#4f46e5' : '#475569';
                    });
                    var u = {};
                    u[fieldName] = opt;
                    s.update(u);
                });
                grid.appendChild(btn);
            });
            node.appendChild(grid);
        },
        buildUploadArea: function(s, node, fieldName, label) {
            var preview = document.createElement('div');
            preview.setAttribute('data-preview', fieldName);
            preview.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin-top:4px';
            var wrapper = document.createElement('div');
            wrapper.style.cssText = 'position:relative;border:2px dashed #e2e8f0;border-radius:20px;padding:36px 20px;text-align:center;cursor:pointer;transition:border 0.15s';
            var txt = document.createElement('div');
            txt.textContent = label || 'Click to upload screenshots';
            txt.style.cssText = 'font-size:13px;font-weight:700;color:#64748b;pointer-events:none';
            wrapper.appendChild(txt);
            var input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.accept = 'image/*';
            input.style.cssText = 'position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%';
            input.addEventListener('change', function(e) {
                Array.from(e.target.files).forEach(function(file) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var img = document.createElement('img');
                        img.src = reader.result;
                        img.style.cssText = 'width:64px;height:64px;object-fit:cover;border-radius:10px;border:1px solid #e2e8f0';
                        preview.appendChild(img);
                        var current = s[fieldName] || [];
                        var u = {};
                        u[fieldName] = current.concat([
                            reader.result
                        ]);
                        s.update(u);
                    };
                    reader.readAsDataURL(file);
                });
                input.value = '';
            });
            wrapper.appendChild(input);
            node.appendChild(wrapper);
            node.appendChild(preview);
        },
        buildMetricsRow: function(s, node, metricsKey, screenshotsKey) {
            var grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:16px;padding:20px;background:#f8fafc;border-radius:16px;border:1px solid #f1f5f9';
            var left = document.createElement('div');
            left.style.cssText = 'display:flex;flex-direction:column;gap:8px';
            var leftLbl = document.createElement('label');
            leftLbl.textContent = 'PERFORMANCE DATA';
            leftLbl.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;letter-spacing:0.05em';
            var textarea = document.createElement('textarea');
            textarea.placeholder = 'Lighthouse score, bundle size, custom KPIs...';
            textarea.style.cssText = 'width:100%;height:90px;padding:12px;border-radius:10px;border:1px solid #e2e8f0;font-size:12px;font-family:monospace;color:#334155;resize:vertical;box-sizing:border-box;outline:none;background:white';
            textarea.value = s[metricsKey] || '';
            textarea.addEventListener('input', function(e) {
                var u = {};
                u[metricsKey] = e.target.value;
                s.update(u);
            });
            left.appendChild(leftLbl);
            left.appendChild(textarea);
            var right = document.createElement('div');
            right.style.cssText = 'display:flex;flex-direction:column;gap:8px';
            var rightLbl = document.createElement('label');
            rightLbl.textContent = 'METRICS SCREENSHOT';
            rightLbl.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;letter-spacing:0.05em';
            right.appendChild(rightLbl);
            var preview = document.createElement('div');
            preview.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;margin-top:4px';
            var uploadWrap = document.createElement('div');
            uploadWrap.style.cssText = 'position:relative;border:2px dashed #e2e8f0;border-radius:12px;padding:20px 10px;text-align:center;cursor:pointer;background:white';
            var uploadTxt = document.createElement('div');
            uploadTxt.textContent = 'Add chart / viz';
            uploadTxt.style.cssText = 'font-size:11px;font-weight:700;color:#94a3b8;pointer-events:none';
            uploadWrap.appendChild(uploadTxt);
            var uploadInput = document.createElement('input');
            uploadInput.type = 'file';
            uploadInput.multiple = true;
            uploadInput.accept = 'image/*';
            uploadInput.style.cssText = 'position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%';
            uploadInput.addEventListener('change', function(e) {
                Array.from(e.target.files).forEach(function(file) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var img = document.createElement('img');
                        img.src = reader.result;
                        img.style.cssText = 'width:40px;height:40px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0';
                        preview.appendChild(img);
                        var current = s[screenshotsKey] || [];
                        var u = {};
                        u[screenshotsKey] = current.concat([
                            reader.result
                        ]);
                        s.update(u);
                    };
                    reader.readAsDataURL(file);
                });
                uploadInput.value = '';
            });
            uploadWrap.appendChild(uploadInput);
            right.appendChild(uploadWrap);
            right.appendChild(preview);
            grid.appendChild(left);
            grid.appendChild(right);
            node.appendChild(grid);
        }
    },
    onRender: (el, s)=>{
        if (el.__init) return;
        el.__init = true;
        var node = el.node;
        node.style.cssText = 'display:flex;flex-direction:column;gap:24px;padding:32px 40px';
        // Framework selector at the very top
        var fwSection = document.createElement('div');
        fwSection.style.cssText = 'display:flex;flex-direction:column;gap:14px;padding:20px 24px;background:#f8fafc;border-radius:20px;border:2px solid #e2e8f0';
        var fwLabel = document.createElement('div');
        fwLabel.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
        fwLabel.textContent = 'Which framework are you comparing against?';
        fwSection.appendChild(fwLabel);
        var fwGrid = document.createElement('div');
        fwGrid.style.cssText = 'display:grid;grid-template-columns:repeat(3,1fr);gap:8px';
        var customInput = document.createElement('input');
        customInput.type = 'text';
        customInput.placeholder = 'Specify framework...';
        customInput.style.cssText = 'display:none;width:100%;padding:10px 14px;border-radius:12px;border:2px solid #4f46e5;font-size:13px;color:#334155;box-sizing:border-box;outline:none;font-family:inherit;margin-top:4px';
        customInput.value = s.comparisonFrameworkCustom || '';
        customInput.addEventListener('input', function(e) {
            s.update({
                comparisonFrameworkCustom: e.target.value
            });
        });
        // Title el — dynamically updated by framework selection
        var titleEl = null;
        $b7aac82da1ef6d88$var$FRAMEWORKS.forEach(function(fw) {
            var btn = document.createElement('button');
            btn.type = 'button';
            var isActive = s.comparisonFramework === fw.id;
            btn.style.cssText = 'padding:10px 12px;border-radius:12px;font-size:13px;font-weight:700;cursor:pointer;transition:all 0.15s;border:2px solid;' + (isActive ? 'background:' + fw.bg + ';border-color:' + fw.color + ';color:' + fw.color : 'background:white;border-color:#e2e8f0;color:#475569');
            btn.textContent = fw.label;
            btn.addEventListener('click', function() {
                fwGrid.querySelectorAll('button').forEach(function(b, i) {
                    var f = $b7aac82da1ef6d88$var$FRAMEWORKS[i];
                    var a = b === btn;
                    b.style.background = a ? f.bg : 'white';
                    b.style.borderColor = a ? f.color : '#e2e8f0';
                    b.style.color = a ? f.color : '#475569';
                });
                s.update({
                    comparisonFramework: fw.id
                });
                // Show/hide custom input
                customInput.style.display = fw.id === 'other' ? 'block' : 'none';
                // Update section title
                if (titleEl) {
                    var name = fw.id === 'other' ? s.comparisonFrameworkCustom || 'Other Framework' : fw.label;
                    titleEl.textContent = '2. ' + name + ' Comparison';
                }
                // Update section border color
                fwSection.style.borderColor = fw.color;
            });
            fwGrid.appendChild(btn);
        });
        fwSection.appendChild(fwGrid);
        fwSection.appendChild(customInput);
        if (s.comparisonFramework === 'other') customInput.style.display = 'block';
        // Also update border if already selected
        var selectedFw = $b7aac82da1ef6d88$var$FRAMEWORKS.find(function(f) {
            return f.id === s.comparisonFramework;
        });
        if (selectedFw) fwSection.style.borderColor = selectedFw.color;
        node.appendChild(fwSection);
        // Title (updates based on framework selection)
        var titleRow = document.createElement('div');
        titleRow.style.cssText = 'display:flex;align-items:center;gap:14px;padding-bottom:20px;border-bottom:1px solid #f1f5f9';
        var fwName = s.comparisonFramework ? ($b7aac82da1ef6d88$var$FRAMEWORKS.find(function(f) {
            return f.id === s.comparisonFramework;
        }) || {}).label || 'Other' : 'Other Framework';
        titleRow.innerHTML = '<div style="padding:10px;background:#e0e7ff;border-radius:14px"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#4338ca" stroke-width="2"><rect x="2" y="2" width="8" height="8" rx="1"/><rect x="14" y="2" width="8" height="8" rx="1"/><rect x="2" y="14" width="8" height="8" rx="1"/><rect x="14" y="14" width="8" height="8" rx="1"/></svg></div><div><h2 data-phase2-title style="font-size:22px;font-weight:900;color:#0f172a;margin:0">2. ' + fwName + ' Comparison</h2><p style="font-size:13px;color:#64748b;margin:4px 0 0;font-weight:500">Benchmarking against the selected framework.</p></div>';
        titleEl = titleRow.querySelector('[data-phase2-title]');
        node.appendChild(titleRow);
        // GitHub URL
        var githubSection = el.scope.buildSection('GitHub Repo / Sandbox URL');
        var githubWrap = document.createElement('div');
        githubWrap.style.cssText = 'position:relative';
        githubWrap.innerHTML = '<svg style="position:absolute;left:14px;top:14px;color:#94a3b8" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/></svg>';
        var githubInput = document.createElement('input');
        githubInput.type = 'text';
        githubInput.placeholder = 'https://github.com/comparison-repo';
        githubInput.style.cssText = 'width:100%;padding:14px 14px 14px 44px;border-radius:14px;border:2px solid #f1f5f9;font-size:14px;color:#334155;box-sizing:border-box;outline:none;transition:border 0.15s;font-family:inherit';
        githubInput.value = s.comparisonGithub || '';
        githubInput.addEventListener('input', function(e) {
            s.update({
                comparisonGithub: e.target.value
            });
        });
        githubInput.addEventListener('focus', function() {
            githubInput.style.borderColor = '#4f46e5';
        });
        githubInput.addEventListener('blur', function() {
            githubInput.style.borderColor = '#f1f5f9';
        });
        githubWrap.appendChild(githubInput);
        githubSection.appendChild(githubWrap);
        node.appendChild(githubSection);
        // Screenshot upload
        var uploadSection = el.scope.buildSection('Attach Screenshots');
        el.scope.buildUploadArea(s, uploadSection, 'comparisonScreenshots', 'Click to upload output screenshots');
        node.appendChild(uploadSection);
        // Accuracy options
        var accSection = el.scope.buildSection('Initial accuracy?');
        el.scope.buildOptionButtons(s, accSection, 'comparisonAccuracy', [
            'Fully correct',
            'Mostly correct',
            'Partially correct',
            'Incorrect'
        ]);
        node.appendChild(accSection);
        // Iterations options
        var iterSection = el.scope.buildSection('Iterations to stabilize?');
        el.scope.buildOptionButtons(s, iterSection, 'comparisonIterations', [
            '0',
            '1-2',
            '3-5',
            '6+'
        ]);
        node.appendChild(iterSection);
        // Metrics row
        var metricsSection = el.scope.buildSection('Performance Metrics');
        el.scope.buildMetricsRow(s, metricsSection, 'comparisonMetrics', 'comparisonMetricsScreenshots');
        node.appendChild(metricsSection);
    }
};


var $1426954f6d11155b$exports = {};

$parcel$export($1426954f6d11155b$exports, "SurveyPhase3", () => $1426954f6d11155b$export$aa5a5f0e3c423339);
const $1426954f6d11155b$export$aa5a5f0e3c423339 = {
    extends: 'Flex',
    flow: 'y',
    gap: 'B2',
    scope: {
        buildOptionButtons: function(s, node, fieldName, options) {
            var grid = document.createElement('div');
            grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:10px';
            options.forEach(function(opt) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.textContent = opt;
                btn.setAttribute('data-field', fieldName);
                btn.setAttribute('data-val', opt);
                var isActive = s[fieldName] === opt;
                btn.style.cssText = 'padding:10px 12px;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;text-align:left;transition:all 0.15s;' + (isActive ? 'background:#eef2ff;border:2px solid #4f46e5;color:#4f46e5' : 'background:white;border:2px solid #e2e8f0;color:#475569');
                btn.addEventListener('click', function() {
                    grid.querySelectorAll('button').forEach(function(b) {
                        var a = b === btn;
                        b.style.background = a ? '#eef2ff' : 'white';
                        b.style.borderColor = a ? '#4f46e5' : '#e2e8f0';
                        b.style.color = a ? '#4f46e5' : '#475569';
                    });
                    var u = {};
                    u[fieldName] = opt;
                    s.update(u);
                });
                grid.appendChild(btn);
            });
            node.appendChild(grid);
        },
        buildRatingButtons: function(s, node, fieldName, minLabel, maxLabel) {
            var btnRow = document.createElement('div');
            btnRow.style.cssText = 'display:flex;gap:4px';
            for(var i = 1; i <= 10; i++){
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.textContent = i;
                btn.setAttribute('data-rfield', fieldName);
                btn.setAttribute('data-rval', i);
                var isActive = s[fieldName] === i;
                btn.style.cssText = 'flex:1;padding:10px 2px;border-radius:8px;font-size:12px;font-weight:700;cursor:pointer;border:2px solid;transition:all 0.15s;' + (isActive ? 'background:#4f46e5;border-color:#4f46e5;color:white;box-shadow:0 1px 3px rgba(79,70,229,0.3)' : 'background:white;border-color:#e2e8f0;color:#64748b');
                (function(val, b) {
                    b.addEventListener('click', function() {
                        btnRow.querySelectorAll('button').forEach(function(rb) {
                            var a = parseInt(rb.getAttribute('data-rval')) === val;
                            rb.style.background = a ? '#4f46e5' : 'white';
                            rb.style.borderColor = a ? '#4f46e5' : '#e2e8f0';
                            rb.style.color = a ? 'white' : '#64748b';
                            rb.style.boxShadow = a ? '0 1px 3px rgba(79,70,229,0.3)' : '';
                        });
                        var u = {};
                        u[fieldName] = val;
                        s.update(u);
                    });
                })(i, btn);
                btnRow.appendChild(btn);
            }
            node.appendChild(btnRow);
            var footer = document.createElement('div');
            footer.style.cssText = 'display:flex;justify-content:space-between;margin-top:4px';
            footer.innerHTML = '<span style="font-size:10px;color:#94a3b8;font-weight:700;text-transform:uppercase">' + (minLabel || 'Lower') + '</span>' + '<span style="font-size:10px;color:#94a3b8;font-weight:700;text-transform:uppercase">' + (maxLabel || 'Higher') + '</span>';
            node.appendChild(footer);
        },
        // Sync Phase 3 UI to current isComparison state — called from checkbox + onStateUpdate
        syncComparison: function(el, s) {
            var node = el.node;
            // Title
            var h2 = node.querySelector('[data-p3-title]');
            var desc = node.querySelector('[data-p3-desc]');
            if (h2) h2.textContent = s.isComparison ? '3. Final Verdict' : '3. Final Notes';
            if (desc) desc.textContent = s.isComparison ? 'Data-backed head-to-head comparison.' : 'Your overall experience with Symbols AI.';
            // Comparison-only block
            var compBlock = node.querySelector('[data-p3-comparison]');
            if (compBlock) compBlock.style.display = s.isComparison ? 'contents' : 'none';
            // Preference label update
            if (s.isComparison && s.comparisonFramework) {
                var fwMap = {
                    react: 'React',
                    angular: 'Angular',
                    vue: 'Vue',
                    svelte: 'Svelte',
                    html: 'HTML + CSS',
                    other: s.comparisonFrameworkCustom || 'Other'
                };
                var fwName = fwMap[s.comparisonFramework] || 'Other Framework';
                var prefLbl = node.querySelector('[data-p3-pref-label]');
                if (prefLbl) prefLbl.textContent = 'WHICH EXPERIENCE DO YOU PREFER?';
                var ratingLbl = node.querySelector('[data-p3-rating-label]');
                if (ratingLbl) ratingLbl.textContent = 'SYMBOLS AI ADVANTAGE OVER ' + fwName.toUpperCase() + ' (1-10)';
                // Update preference button labels
                var prefBtns = node.querySelectorAll('[data-p3-pref-btn]');
                if (prefBtns[1]) prefBtns[1].textContent = fwName;
            }
            // Reason label/placeholder
            var reasonLbl = node.querySelector('[data-p3-reason-label]');
            var reasonTA = node.querySelector('[data-p3-reason-ta]');
            if (reasonLbl) reasonLbl.textContent = s.isComparison ? 'TECHNICAL REASONING' : 'OVERALL EXPERIENCE & NOTES';
            if (reasonTA) reasonTA.placeholder = s.isComparison ? 'Explain the specific technical differences, bugs encountered, or productivity boosts...' : "Describe your experience with Symbols AI generation \u2014 accuracy, ease of use, notable wins or issues...";
        }
    },
    onRender: (el, s)=>{
        if (el.__init) return;
        el.__init = true;
        var node = el.node;
        node.style.cssText = 'display:flex;flex-direction:column;gap:24px;padding:32px 40px';
        // Title
        var titleRow = document.createElement('div');
        titleRow.style.cssText = 'display:flex;align-items:center;gap:14px;padding-bottom:20px;border-bottom:1px solid #f1f5f9';
        titleRow.innerHTML = '<div style="padding:10px;background:#d1fae5;border-radius:14px"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#047857" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></div><div><h2 data-p3-title style="font-size:22px;font-weight:900;color:#0f172a;margin:0">3. Final Notes</h2><p data-p3-desc style="font-size:13px;color:#64748b;margin:4px 0 0;font-weight:500">Your overall experience with Symbols AI.</p></div>';
        node.appendChild(titleRow);
        // Comparison-only block (preference + rating) — toggled via display
        var compBlock = document.createElement('div');
        compBlock.setAttribute('data-p3-comparison', '1');
        compBlock.style.cssText = 'display:' + (s.isComparison ? 'contents' : 'none');
        // Preference section
        var prefSection = document.createElement('div');
        prefSection.style.cssText = 'display:flex;flex-direction:column;gap:12px';
        var prefLbl = document.createElement('label');
        prefLbl.setAttribute('data-p3-pref-label', '1');
        prefLbl.textContent = 'WHICH EXPERIENCE DO YOU PREFER?';
        prefLbl.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
        prefSection.appendChild(prefLbl);
        var prefGrid = document.createElement('div');
        prefGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:10px';
        var fwMap = {
            react: 'React',
            angular: 'Angular',
            vue: 'Vue',
            svelte: 'Svelte',
            html: 'HTML + CSS',
            other: s.comparisonFrameworkCustom || 'Other'
        };
        var fwName = s.comparisonFramework ? fwMap[s.comparisonFramework] || 'Other Framework' : 'Other Framework';
        [
            'Symbols AI',
            fwName
        ].forEach(function(opt, idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = opt;
            btn.setAttribute('data-p3-pref-btn', idx);
            btn.setAttribute('data-field', 'preference');
            btn.setAttribute('data-val', opt);
            var isActive = s.preference === opt;
            btn.style.cssText = 'padding:10px 12px;border-radius:12px;font-size:13px;font-weight:600;cursor:pointer;text-align:left;transition:all 0.15s;' + (isActive ? 'background:#eef2ff;border:2px solid #4f46e5;color:#4f46e5' : 'background:white;border:2px solid #e2e8f0;color:#475569');
            btn.addEventListener('click', function() {
                prefGrid.querySelectorAll('button').forEach(function(b) {
                    var a = b === btn;
                    b.style.background = a ? '#eef2ff' : 'white';
                    b.style.borderColor = a ? '#4f46e5' : '#e2e8f0';
                    b.style.color = a ? '#4f46e5' : '#475569';
                });
                s.update({
                    preference: opt
                });
            });
            prefGrid.appendChild(btn);
        });
        prefSection.appendChild(prefGrid);
        compBlock.appendChild(prefSection);
        // Rating section
        var ratingSection = document.createElement('div');
        ratingSection.style.cssText = 'display:flex;flex-direction:column;gap:12px';
        var ratingLbl = document.createElement('label');
        ratingLbl.setAttribute('data-p3-rating-label', '1');
        ratingLbl.textContent = 'SYMBOLS AI ADVANTAGE OVER ' + fwName.toUpperCase() + ' (1-10)';
        ratingLbl.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
        ratingSection.appendChild(ratingLbl);
        el.scope.buildRatingButtons(s, ratingSection, 'comparisonScore', 'No advantage', 'Clear winner');
        compBlock.appendChild(ratingSection);
        node.appendChild(compBlock);
        // Reasoning (always shown)
        var reasonSection = document.createElement('div');
        reasonSection.style.cssText = 'display:flex;flex-direction:column;gap:12px';
        var reasonLbl = document.createElement('label');
        reasonLbl.setAttribute('data-p3-reason-label', '1');
        reasonLbl.textContent = s.isComparison ? 'TECHNICAL REASONING' : 'OVERALL EXPERIENCE & NOTES';
        reasonLbl.style.cssText = 'font-size:12px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em';
        var reasonTextarea = document.createElement('textarea');
        reasonTextarea.setAttribute('data-p3-reason-ta', '1');
        reasonTextarea.placeholder = s.isComparison ? 'Explain the specific technical differences, bugs encountered, or productivity boosts...' : "Describe your experience with Symbols AI generation \u2014 accuracy, ease of use, notable wins or issues...";
        reasonTextarea.style.cssText = 'width:100%;height:160px;padding:16px;border-radius:14px;border:2px solid #f1f5f9;font-size:14px;font-weight:500;color:#334155;resize:vertical;font-family:inherit;box-sizing:border-box;outline:none;transition:border 0.15s';
        reasonTextarea.value = s.comparisonReason || '';
        reasonTextarea.addEventListener('input', function(e) {
            s.update({
                comparisonReason: e.target.value
            });
        });
        reasonTextarea.addEventListener('focus', function() {
            reasonTextarea.style.borderColor = '#4f46e5';
        });
        reasonTextarea.addEventListener('blur', function() {
            reasonTextarea.style.borderColor = '#f1f5f9';
        });
        reasonSection.appendChild(reasonLbl);
        reasonSection.appendChild(reasonTextarea);
        node.appendChild(reasonSection);
    },
    onStateUpdate: (el, s)=>{
        el.scope.syncComparison(el, s);
    }
};


var $2715b7876f641fa7$exports = {};

$parcel$export($2715b7876f641fa7$exports, "DashboardView", () => $2715b7876f641fa7$export$33312d3da85d8994);
const $2715b7876f641fa7$export$33312d3da85d8994 = {
    extends: 'Flex',
    flow: 'y',
    gap: 'B',
    scope: {
        renderStats: function(el, s) {
            var statsEl = el.node.querySelector('[data-stats]');
            if (!statsEl) return;
            var total = (s.submissions || []).length;
            statsEl.innerHTML = '<div style="font-size:36px;font-weight:900;color:#4f46e5">' + total + '</div>' + '<div style="font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.1em">Total Reports</div>';
        },
        renderSubmissions: function(el, s) {
            var listEl = el.node.querySelector('[data-list]');
            if (!listEl) return;
            var subs = s.submissions || [];
            if (subs.length === 0) {
                listEl.innerHTML = '<div style="background:white;border-radius:20px;padding:80px 20px;text-align:center;border:2px dashed #e2e8f0"><div style="font-size:13px;color:#64748b;font-weight:500;margin-top:8px">Waiting for team to submit results...</div></div>';
                return;
            }
            listEl.innerHTML = '';
            subs.forEach(function(sub) {
                var card = document.createElement('div');
                card.style.cssText = 'background:white;border-radius:20px;border:1px solid #e2e8f0;padding:28px;margin-bottom:16px';
                var header = document.createElement('div');
                header.style.cssText = 'display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid #f1f5f9;gap:16px;flex-wrap:wrap';
                var leftSide = document.createElement('div');
                leftSide.style.cssText = 'flex:1';
                leftSide.innerHTML = '<div style="font-size:11px;font-weight:700;color:#4f46e5;background:#eef2ff;padding:2px 8px;border-radius:6px;display:inline-block;margin-bottom:6px">' + (sub.timestamp || '') + '</div>' + '<h3 style="font-size:18px;font-weight:900;color:#0f172a;margin:0">Prefers: <span style="color:#4f46e5">' + (sub.preference || "\u2014") + '</span></h3>';
                var rightSide = document.createElement('div');
                rightSide.style.cssText = 'text-align:center;padding:12px 20px;background:#4f46e5;border-radius:14px;min-width:90px';
                rightSide.innerHTML = '<div style="font-size:10px;font-weight:700;color:#a5b4fc;text-transform:uppercase;margin-bottom:4px">Impact</div><div style="font-size:24px;font-weight:900;color:white">' + (sub.comparisonScore || 5) + '/10</div>';
                header.appendChild(leftSide);
                header.appendChild(rightSide);
                card.appendChild(header);
                var metricsGrid = document.createElement('div');
                metricsGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:20px;font-size:13px;margin-bottom:20px';
                var symCol = document.createElement('div');
                symCol.innerHTML = '<div style="font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px">Symbols Performance</div><div style="display:grid;grid-template-columns:1fr 1fr;gap:10px"><div style="background:#f8fafc;padding:10px;border-radius:10px;border:1px solid #f1f5f9"><div style="font-size:9px;color:#94a3b8;font-weight:700;text-transform:uppercase;margin-bottom:4px">Accuracy</div><div style="font-weight:700;color:#334155">' + (sub.symbolsAccuracy || "\u2014") + '</div></div>' + '<div style="background:#f8fafc;padding:10px;border-radius:10px;border:1px solid #f1f5f9"><div style="font-size:9px;color:#94a3b8;font-weight:700;text-transform:uppercase;margin-bottom:4px">Iterations</div><div style="font-weight:700;color:#334155">' + (sub.symbolsIterations || "\u2014") + '</div></div>' + '</div>';
                var reactCol = document.createElement('div');
                reactCol.innerHTML = '<div style="font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px">React Performance</div><div style="display:grid;grid-template-columns:1fr 1fr;gap:10px"><div style="background:#f8fafc;padding:10px;border-radius:10px;border:1px solid #f1f5f9"><div style="font-size:9px;color:#94a3b8;font-weight:700;text-transform:uppercase;margin-bottom:4px">Accuracy</div><div style="font-weight:700;color:#334155">' + (sub.reactAccuracy || "\u2014") + '</div></div>' + '<div style="background:#f8fafc;padding:10px;border-radius:10px;border:1px solid #f1f5f9"><div style="font-size:9px;color:#94a3b8;font-weight:700;text-transform:uppercase;margin-bottom:4px">Iterations</div><div style="font-weight:700;color:#334155">' + (sub.reactIterations || "\u2014") + '</div></div>' + '</div>';
                metricsGrid.appendChild(symCol);
                metricsGrid.appendChild(reactCol);
                card.appendChild(metricsGrid);
                if (sub.rawMetricsData) {
                    var metricsBox = document.createElement('div');
                    metricsBox.style.cssText = 'background:#0f172a;color:#818cf8;padding:14px;border-radius:10px;font-family:monospace;font-size:11px;margin-bottom:16px;word-break:break-all';
                    metricsBox.innerHTML = '<div style="color:white;font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:0.1em;margin-bottom:8px;padding-bottom:8px;border-bottom:1px solid rgba(255,255,255,0.1)">Technical Metrics</div>' + sub.rawMetricsData;
                    card.appendChild(metricsBox);
                }
                if (sub.comparisonReason) {
                    var reasonBox = document.createElement('div');
                    reasonBox.style.cssText = 'margin-top:16px;padding-top:16px;border-top:1px solid #f1f5f9';
                    reasonBox.innerHTML = '<div style="font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:10px">Verdict Details</div><p style="font-size:13px;color:#475569;line-height:1.7;font-weight:500;background:#f8fafc;padding:14px;border-radius:14px;border:1px solid #f1f5f9;margin:0">' + sub.comparisonReason + '</p>';
                    card.appendChild(reasonBox);
                }
                listEl.appendChild(card);
            });
        }
    },
    onRender: (el, s)=>{
        if (el.__init) return;
        el.__init = true;
        var node = el.node;
        node.style.cssText = 'display:flex;flex-direction:column;gap:16px';
        // Stats header
        var statsCard = document.createElement('div');
        statsCard.style.cssText = 'background:white;border-radius:20px;border:1px solid #e2e8f0;padding:28px;display:flex;justify-content:space-between;align-items:center';
        var statsLeft = document.createElement('div');
        statsLeft.innerHTML = '<h2 style="font-size:22px;font-weight:900;color:#0f172a;margin:0 0 4px">Community Results</h2><p style="font-size:13px;color:#64748b;font-weight:500;margin:0">Saved to Local Storage</p>';
        var statsRight = document.createElement('div');
        statsRight.setAttribute('data-stats', '1');
        statsRight.style.cssText = 'text-align:right';
        statsCard.appendChild(statsLeft);
        statsCard.appendChild(statsRight);
        node.appendChild(statsCard);
        // Submissions list container
        var list = document.createElement('div');
        list.setAttribute('data-list', '1');
        node.appendChild(list);
        el.scope.renderStats(el, s);
        el.scope.renderSubmissions(el, s);
    },
    onStateUpdate: (el, s)=>{
        el.scope.renderStats(el, s);
        el.scope.renderSubmissions(el, s);
    }
};


var $26ef48098d79292b$exports = {};

$parcel$export($26ef48098d79292b$exports, "SuccessView", () => $26ef48098d79292b$export$be5117c66bf44cb9);
const $26ef48098d79292b$export$be5117c66bf44cb9 = {
    extends: 'Flex',
    flow: 'y',
    flexAlign: 'center center',
    gap: 'B2',
    padding: 'D2',
    background: 'white',
    round: 'C2',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'slate200',
    IconWrap: {
        extends: 'Flex',
        flexAlign: 'center center',
        boxSize: 'E',
        round: '100%',
        background: 'emerald100',
        Svg: {
            viewBox: '0 0 24 24',
            width: '48',
            height: '48',
            html: '<path d="M20 6L9 17l-5-5" stroke="#059669" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'
        }
    },
    Title: {
        extends: 'Flex',
        tag: 'h2',
        text: 'Report Synced!',
        fontSize: 'D',
        fontWeight: '900',
        color: 'slate900'
    },
    Subtitle: {
        extends: 'Flex',
        tag: 'p',
        text: 'Your data is now visible in the results dashboard.',
        fontSize: 'B',
        color: 'slate600',
        fontWeight: '500'
    },
    Actions: {
        extends: 'Flex',
        gap: 'A',
        marginTop: 'A',
        DashboardBtn: {
            extends: 'Flex',
            tag: 'button',
            type: 'button',
            text: 'View Dashboard',
            padding: 'A C',
            round: 'B',
            cursor: 'pointer',
            borderWidth: '0',
            background: 'indigo600',
            color: 'white',
            fontWeight: '700',
            fontSize: 'B',
            onClick: (e, el, s)=>{
                el.call('switchView', s, 'dashboard');
            }
        },
        NewEntryBtn: {
            extends: 'Flex',
            tag: 'button',
            type: 'button',
            text: 'New Entry',
            padding: 'A C',
            round: 'B',
            cursor: 'pointer',
            borderWidth: '0',
            background: 'slate100',
            color: 'slate700',
            fontWeight: '700',
            fontSize: 'B',
            onClick: (e, el, s)=>{
                s.update({
                    isSubmitted: false,
                    phase: 1
                });
                el.call('switchView', s, 'survey');
                el.call('switchPhase', s, 1);
            }
        }
    }
};


var $474fc4a155a919cf$exports = {};

$parcel$export($474fc4a155a919cf$exports, "ShareModal", () => $474fc4a155a919cf$export$3a7541004f18f50c);
const $474fc4a155a919cf$export$3a7541004f18f50c = {
    extends: 'Flex',
    id: 'share-modal',
    position: 'fixed',
    inset: '0',
    zIndex: '100',
    flexAlign: 'center center',
    padding: 'A',
    display: 'none',
    Backdrop: {
        extends: 'Flex',
        position: 'absolute',
        inset: '0',
        background: 'rgba(15,23,42,0.6)',
        onClick: (e, el, s)=>{
            var modal = document.getElementById('share-modal');
            if (modal) modal.style.display = 'none';
            s.update({
                showShareModal: false
            });
        }
    },
    Card: {
        extends: 'Flex',
        flow: 'y',
        position: 'relative',
        background: 'white',
        round: 'C2',
        width: '100%',
        maxWidth: '480px',
        zIndex: '1',
        Header: {
            extends: 'Flex',
            justifyContent: 'space-between',
            flexAlign: 'center center',
            padding: 'B C',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'slate100',
            Title: {
                extends: 'Flex',
                flexAlign: 'center center',
                gap: 'X',
                tag: 'h3',
                text: 'Sharing Instructions',
                fontSize: 'C',
                fontWeight: '900',
                color: 'slate900'
            },
            CloseBtn: {
                extends: 'Flex',
                tag: 'button',
                type: 'button',
                flexAlign: 'center center',
                padding: 'X',
                round: '100%',
                cursor: 'pointer',
                borderWidth: '0',
                background: 'none',
                Svg: {
                    viewBox: '0 0 24 24',
                    width: '20',
                    height: '20',
                    html: '<line x1="18" y1="6" x2="6" y2="18" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/>'
                },
                onClick: (e, el, s)=>{
                    var modal = document.getElementById('share-modal');
                    if (modal) modal.style.display = 'none';
                    s.update({
                        showShareModal: false
                    });
                }
            }
        },
        Body: {
            extends: 'Flex',
            flow: 'y',
            gap: 'B2',
            padding: 'C',
            InfoBox: {
                extends: 'Flex',
                gap: 'A',
                padding: 'A',
                background: 'indigo50',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'indigo100',
                round: 'B',
                P: {
                    extends: 'Flex',
                    tag: 'p',
                    fontSize: '13px',
                    color: 'indigo700',
                    lineHeight: '1.6',
                    text: 'Share the preview URL and tell users to look at the Preview panel.'
                }
            },
            Steps: {
                extends: 'Flex',
                flow: 'y',
                gap: 'A',
                StepsLabel: {
                    extends: 'Flex',
                    tag: 'p',
                    text: 'Steps for Teammates:',
                    fontWeight: '700',
                    fontSize: '13px',
                    color: 'slate700'
                },
                StepsList: {
                    extends: 'Flex',
                    flow: 'y',
                    gap: 'A',
                    onRender: (el)=>{
                        el.node.innerHTML = '<ol style="margin:0;padding-left:20px;display:flex;flex-direction:column;gap:10px"><li style="font-size:13px;color:#475569;font-weight:500;line-height:1.5">Send them the link from your browser address bar.</li><li style="font-size:13px;color:#475569;font-weight:500;line-height:1.5">They must <strong>Sign In</strong> if required by your deployment.</li><li style="font-size:13px;color:#475569;font-weight:500;line-height:1.5">The app is located in the <strong>Preview pane</strong>. They can scroll or interact with it directly.</li></ol>';
                    }
                }
            },
            GotItBtn: {
                extends: 'Flex',
                tag: 'button',
                type: 'button',
                flexAlign: 'center center',
                text: 'Got it',
                padding: 'A',
                round: 'B',
                cursor: 'pointer',
                borderWidth: '0',
                background: 'indigo600',
                color: 'white',
                fontWeight: '700',
                fontSize: 'B',
                onClick: (e, el, s)=>{
                    var modal = document.getElementById('share-modal');
                    if (modal) modal.style.display = 'none';
                    s.update({
                        showShareModal: false
                    });
                }
            }
        }
    }
};


$parcel$exportWildcard($6aaa67090b542dc0$exports, $6c8214b869e744e4$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $ec05b790232eadbd$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $b7aac82da1ef6d88$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $1426954f6d11155b$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $2715b7876f641fa7$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $26ef48098d79292b$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $474fc4a155a919cf$exports);


var $1b6d556216bfb6d1$exports = {};


const $382aee6e54bfb983$export$f22da7240b7add18 = {
    extends: 'Page',
    padding: 'B',
    '@mobile': {
        padding: 'A'
    },
    onRender: (el, s)=>{
        if (el.__init) return;
        el.__init = true;
        el.call('initApp', s);
    },
    Wrap: {
        extends: 'Flex',
        flow: 'y',
        gap: 'B',
        maxWidth: '900px',
        margin: '0 auto',
        width: '100%',
        AppHeader: {},
        // Survey view (default)
        SurveyView: {
            extends: 'Flex',
            id: 'view-survey',
            flow: 'y',
            width: '100%',
            FormCard: {
                extends: 'Flex',
                flow: 'y',
                width: '100%',
                background: 'white',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'slate200',
                round: 'C2',
                overflow: 'hidden',
                position: 'relative',
                SavingOverlay: {
                    extends: 'Flex',
                    id: 'saving-overlay',
                    position: 'absolute',
                    inset: '0',
                    background: 'rgba(255,255,255,0.9)',
                    zIndex: '50',
                    flexAlign: 'center center',
                    flow: 'y',
                    gap: 'A',
                    display: 'none',
                    onRender: (el)=>{
                        el.node.innerHTML = '<div style="font-size:13px;font-weight:700;color:#334155;text-transform:uppercase;letter-spacing:0.05em">UPLOADING REPORT...</div>';
                    },
                    onStateUpdate: (el, s)=>{
                        el.node.style.display = s.isSaving ? 'flex' : 'none';
                    }
                },
                Phase1: {
                    extends: 'Flex',
                    flow: 'y',
                    width: '100%',
                    id: 'phase-1',
                    SurveyPhase1: {}
                },
                Phase2: {
                    extends: 'Flex',
                    flow: 'y',
                    width: '100%',
                    id: 'phase-2',
                    display: 'none',
                    SurveyPhase2: {}
                },
                Phase3: {
                    extends: 'Flex',
                    flow: 'y',
                    width: '100%',
                    id: 'phase-3',
                    display: 'none',
                    SurveyPhase3: {}
                },
                FormFooter: {
                    extends: 'Flex',
                    justifyContent: 'space-between',
                    flexAlign: 'center center',
                    padding: 'A C',
                    background: 'slate50',
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: 'slate100',
                    PrevBtn: {
                        extends: 'Flex',
                        tag: 'button',
                        type: 'button',
                        text: 'Previous',
                        padding: 'A B2',
                        round: 'B',
                        cursor: 'pointer',
                        borderWidth: '0',
                        background: 'none',
                        color: 'slate400',
                        fontWeight: '700',
                        fontSize: 'B',
                        onRender: (el, s)=>{
                            el.node.setAttribute('data-prev-btn', '1');
                            el.node.style.opacity = s.phase === 1 ? '0' : '1';
                            el.node.style.pointerEvents = s.phase === 1 ? 'none' : 'auto';
                        },
                        onStateUpdate: (el, s)=>{
                            el.node.style.opacity = s.phase === 1 ? '0' : '1';
                            el.node.style.pointerEvents = s.phase === 1 ? 'none' : 'auto';
                        },
                        onClick: (e, el, s)=>{
                            if (s.phase > 1) el.call('switchPhase', s, s.phase - 1);
                        }
                    },
                    NextBtn: {
                        extends: 'Flex',
                        tag: 'button',
                        type: 'button',
                        padding: 'A C',
                        round: 'B',
                        cursor: 'pointer',
                        borderWidth: '0',
                        fontWeight: '700',
                        fontSize: 'B',
                        onRender: (el, s)=>{
                            el.node.setAttribute('data-next-btn', '1');
                            el.node.textContent = s.phase < 3 ? 'Continue \u2192' : 'Submit Final Report';
                            el.node.style.background = s.phase < 3 ? '#4f46e5' : '#059669';
                            el.node.style.color = 'white';
                        },
                        onStateUpdate: (el, s)=>{
                            el.node.textContent = s.phase < 3 ? 'Continue \u2192' : 'Submit Final Report';
                            el.node.style.background = s.phase < 3 ? '#4f46e5' : '#059669';
                        },
                        onClick: (e, el, s)=>{
                            if (s.phase < 3) el.call('switchPhase', s, s.phase + 1);
                            else el.call('submitForm', s);
                        }
                    }
                }
            }
        },
        SuccessViewWrap: {
            extends: 'Flex',
            flow: 'y',
            width: '100%',
            id: 'view-success',
            display: 'none',
            SuccessView: {}
        },
        DashboardWrap: {
            extends: 'Flex',
            flow: 'y',
            width: '100%',
            id: 'view-dashboard',
            display: 'none',
            DashboardView: {}
        },
        Footer: {
            extends: 'Flex',
            flow: 'y',
            flexAlign: 'center center',
            gap: 'X',
            paddingBottom: 'C',
            marginTop: 'A',
            Caption1: {
                extends: 'Flex',
                flexAlign: 'center center',
                gap: 'X',
                tag: 'div',
                text: 'Real-time Team Feedback Portal',
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                color: 'slate400'
            },
            Caption2: {
                extends: 'Flex',
                tag: 'div',
                text: '\u2728 Powered by Symbols / DOMQL v3',
                fontSize: '11px',
                color: 'indigo400',
                opacity: '0.6'
            }
        }
    }
};


var $2f93c2b81b587020$export$2e2bcd8739ae039 = {
    '/': (0, $382aee6e54bfb983$export$f22da7240b7add18)
};


var $b1e5d99c521c823a$exports = {};
var $cefac5f993ab5321$exports = {};

$parcel$export($cefac5f993ab5321$exports, "initApp", () => $cefac5f993ab5321$export$bec0ec21ab4579a);
// Supabase config — values injected from .env at build time by Parcel
const $7251206884b2317e$export$721045acb0bbe132 = "https://mmixjofiiqgeebsguyhx.supabase.co";
const $7251206884b2317e$export$b77c07a50a90ca85 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1taXhqb2ZpaXFnZWVic2d1eWh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIwNzE4MzMsImV4cCI6MjA4NzY0NzgzM30.cPQiLju_xyDYfn1m3t5qS99WZfSbgk2u2XC1x39AFKI";


const $cefac5f993ab5321$export$bec0ec21ab4579a = function initApp(s) {
    fetch((0, $7251206884b2317e$export$721045acb0bbe132) + '/rest/v1/survey_submissions?select=data,created_at&order=created_at.desc', {
        headers: {
            apikey: (0, $7251206884b2317e$export$b77c07a50a90ca85),
            Authorization: 'Bearer ' + (0, $7251206884b2317e$export$b77c07a50a90ca85)
        }
    }).then(function(r) {
        return r.json();
    }).then(function(rows) {
        var subs = Array.isArray(rows) ? rows.map(function(row) {
            return Object.assign({}, row.data, {
                createdAt: row.created_at
            });
        }) : [];
        s.update({
            submissions: subs
        });
    }).catch(function(err) {
        console.error('Failed to load submissions:', err);
        s.update({
            submissions: []
        });
    });
};


var $4d51347aa1000f3f$exports = {};

$parcel$export($4d51347aa1000f3f$exports, "switchView", () => $4d51347aa1000f3f$export$adaf8a367aa41030);
const $4d51347aa1000f3f$export$adaf8a367aa41030 = function switchView(s, view) {
    s.update({
        view: view
    });
    var views = [
        'survey',
        'dashboard',
        'success'
    ];
    views.forEach(function(v) {
        var el = document.getElementById('view-' + v);
        if (el) el.style.display = v === view ? 'block' : 'none';
    });
    // Deactivate phase tabs when leaving survey view
    document.querySelectorAll('button[data-phase]').forEach(function(btn) {
        var isActive = view === 'survey' && parseInt(btn.getAttribute('data-phase')) === s.phase;
        btn.style.background = isActive ? '#4f46e5' : 'transparent';
        btn.style.color = isActive ? 'white' : '#64748b';
        btn.style.boxShadow = isActive ? '0 1px 4px rgba(79,70,229,0.3)' : '';
    });
    // Update Results button
    var resultsBtn = document.querySelector('[data-results-btn]');
    if (resultsBtn) {
        resultsBtn.style.background = view === 'dashboard' ? '#4f46e5' : 'transparent';
        resultsBtn.style.color = view === 'dashboard' ? 'white' : '#4f46e5';
    }
};


var $e5c87af8493e8f9f$exports = {};

$parcel$export($e5c87af8493e8f9f$exports, "switchPhase", () => $e5c87af8493e8f9f$export$e8e66cd0d9267a6c);
const $e5c87af8493e8f9f$export$e8e66cd0d9267a6c = function switchPhase(s, phase) {
    // Skip phase 2 if comparison is disabled
    if (phase === 2 && !s.isComparison) phase = s.phase < 2 ? 3 : 1;
    s.update({
        phase: phase
    });
    // Always switch view back to survey (fixes: clicking phase tab from Results)
    var views = [
        'survey',
        'dashboard',
        'success'
    ];
    views.forEach(function(v) {
        var vel = document.getElementById('view-' + v);
        if (vel) vel.style.display = v === 'survey' ? 'block' : 'none';
    });
    [
        1,
        2,
        3
    ].forEach(function(p) {
        var el = document.getElementById('phase-' + p);
        if (el) el.style.display = p === phase ? 'block' : 'none';
    });
    // Update phase tab buttons
    document.querySelectorAll('button[data-phase]').forEach(function(btn) {
        var p = parseInt(btn.getAttribute('data-phase'));
        btn.style.background = p === phase ? '#4f46e5' : 'transparent';
        btn.style.color = p === phase ? 'white' : '#64748b';
        btn.style.boxShadow = p === phase ? '0 1px 4px rgba(79,70,229,0.3)' : '';
    });
    // Update next button text
    var nextBtn = document.querySelector('[data-next-btn]');
    if (nextBtn) {
        nextBtn.textContent = phase < 3 ? 'Continue \u2192' : 'Submit Final Report';
        nextBtn.style.background = phase < 3 ? '#4f46e5' : '#059669';
    }
    // Update prev button
    var prevBtn = document.querySelector('[data-prev-btn]');
    if (prevBtn) {
        prevBtn.style.opacity = phase === 1 ? '0' : '1';
        prevBtn.style.pointerEvents = phase === 1 ? 'none' : 'auto';
    }
};


var $e96d16ec228b6622$exports = {};

$parcel$export($e96d16ec228b6622$exports, "submitForm", () => $e96d16ec228b6622$export$e02251cfbe407ee6);

const $e96d16ec228b6622$export$e02251cfbe407ee6 = function submitForm(s) {
    if (s.isSaving) return;
    if (!s.symbolsPrompt || s.symbolsPrompt.trim() === '') {
        alert('Please fill in the prompt field in Phase 1');
        return;
    }
    if (!s.comparisonReason || s.comparisonReason.trim() === '') {
        alert('Please fill in the notes/reasoning field in Phase 3');
        return;
    }
    s.update({
        isSaving: true
    });
    var framework = s.comparisonFramework ? s.comparisonFramework === 'other' ? s.comparisonFrameworkCustom || 'Other' : s.comparisonFramework : '';
    var submission = {
        // Phase 1
        symbolsPrompt: s.symbolsPrompt || '',
        symbolsGithub: s.symbolsGithub || '',
        symbolsUrl: s.symbolsUrl || '',
        symbolsAccuracy: s.symbolsAccuracy || '',
        symbolsIterations: s.symbolsIterations || '',
        symbolsMetrics: s.symbolsMetrics || '',
        // Comparison
        isComparison: s.isComparison || false,
        comparisonFramework: framework,
        // Phase 2 (only relevant when isComparison)
        comparisonGithub: s.comparisonGithub || '',
        comparisonAccuracy: s.comparisonAccuracy || '',
        comparisonIterations: s.comparisonIterations || '',
        comparisonMetrics: s.comparisonMetrics || '',
        // Phase 3
        preference: s.preference || '',
        comparisonScore: s.comparisonScore || 5,
        comparisonReason: s.comparisonReason || '',
        // Meta
        userId: 'user_' + Math.random().toString(36).substr(2, 9),
        timestamp: new Date().toLocaleString()
    };
    fetch((0, $7251206884b2317e$export$721045acb0bbe132) + '/rest/v1/survey_submissions', {
        method: 'POST',
        headers: {
            apikey: (0, $7251206884b2317e$export$b77c07a50a90ca85),
            Authorization: 'Bearer ' + (0, $7251206884b2317e$export$b77c07a50a90ca85),
            'Content-Type': 'application/json',
            Prefer: 'return=minimal'
        },
        body: JSON.stringify({
            data: submission
        })
    }).then(function(r) {
        if (!r.ok) throw new Error('Save failed: ' + r.status);
        var newSubs = [
            submission
        ].concat(s.submissions || []);
        s.update({
            isSaving: false,
            isSubmitted: true,
            submissions: newSubs,
            symbolsPrompt: '',
            symbolsGithub: '',
            symbolsUrl: '',
            symbolsAccuracy: '',
            symbolsIterations: '',
            symbolsMetrics: '',
            isComparison: false,
            comparisonFramework: '',
            comparisonFrameworkCustom: '',
            comparisonGithub: '',
            comparisonAccuracy: '',
            comparisonIterations: '',
            comparisonMetrics: '',
            preference: '',
            comparisonScore: 5,
            comparisonReason: ''
        });
        var views = [
            'survey',
            'dashboard',
            'success'
        ];
        views.forEach(function(v) {
            var el = document.getElementById('view-' + v);
            if (el) el.style.display = v === 'success' ? 'block' : 'none';
        });
    }).catch(function(err) {
        console.error('Submit failed:', err);
        alert('Failed to save submission. Check your Supabase config in smbls/functions/config.js');
        s.update({
            isSaving: false
        });
    });
};


$parcel$exportWildcard($b1e5d99c521c823a$exports, $cefac5f993ab5321$exports);
$parcel$exportWildcard($b1e5d99c521c823a$exports, $4d51347aa1000f3f$exports);
$parcel$exportWildcard($b1e5d99c521c823a$exports, $e5c87af8493e8f9f$exports);
$parcel$exportWildcard($b1e5d99c521c823a$exports, $e96d16ec228b6622$exports);


var $c248cbc219519e34$exports = {};


var $dfcc5e70d6c08e3f$export$2e2bcd8739ae039 = {
    black: '#000',
    white: '#fff',
    // Slate
    slate50: '#f8fafc',
    slate100: '#f1f5f9',
    slate200: '#e2e8f0',
    slate300: '#cbd5e1',
    slate400: '#94a3b8',
    slate500: '#64748b',
    slate600: '#475569',
    slate700: '#334155',
    slate800: '#1e293b',
    slate900: '#0f172a',
    // Indigo
    indigo50: '#eef2ff',
    indigo100: '#e0e7ff',
    indigo400: '#818cf8',
    indigo600: '#4f46e5',
    indigo700: '#4338ca',
    // Emerald
    emerald50: '#ecfdf5',
    emerald100: '#d1fae5',
    emerald600: '#059669',
    emerald700: '#047857',
    // Amber
    amber100: '#fef3c7',
    amber700: '#b45309',
    // Rose
    rose50: '#fff1f2',
    rose600: '#e11d48'
};


var $e725aa6f4140cc0b$export$2e2bcd8739ae039 = {};


var $7c8733b00aa6d0aa$export$2e2bcd8739ae039 = {
    document: {
        '@light': {
            color: 'slate900',
            background: 'slate50'
        },
        '@dark': {
            color: 'white',
            background: 'slate900'
        }
    },
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    },
    primary: {
        color: 'white',
        background: 'indigo600',
        ':hover': {
            background: 'indigo700'
        }
    },
    success: {
        color: 'white',
        background: 'emerald600',
        ':hover': {
            background: 'emerald700'
        }
    },
    field: {
        color: 'slate700',
        background: 'white',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: 'slate200'
    },
    dialog: {
        color: 'slate600',
        background: 'slate100',
        ':hover': {
            background: 'slate200'
        }
    }
};


var $3236db8116cf7270$export$2e2bcd8739ae039 = {};


var $c35c84ccd945519f$export$2e2bcd8739ae039 = {};


var $11ec1402eb3e5297$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


var $963cab3f34249f12$export$2e2bcd8739ae039 = {
    base: 16,
    ratio: 1.618,
    subSequence: true
};


var $0edda29abbdf4dbd$export$2e2bcd8739ae039 = {};


var $a7aa3f03c4832ffc$export$2e2bcd8739ae039 = {};


var $346c4dccd7d5ec52$export$2e2bcd8739ae039 = {};


var $8d20f1e530a7800b$export$2e2bcd8739ae039 = {};


var $8cfe6affa863f726$export$2e2bcd8739ae039 = {};


var $eec83f27fc6eae19$export$2e2bcd8739ae039 = {};


var $48500ff8feea3cdf$export$2e2bcd8739ae039 = {};


var $d93332c5f155b477$export$2e2bcd8739ae039 = {};


var $10765305698c4491$export$2e2bcd8739ae039 = {};


var $4390f92564b2bbc7$export$2e2bcd8739ae039 = {
    COLOR: $dfcc5e70d6c08e3f$export$2e2bcd8739ae039,
    GRADIENT: $e725aa6f4140cc0b$export$2e2bcd8739ae039,
    THEME: $7c8733b00aa6d0aa$export$2e2bcd8739ae039,
    FONT: $3236db8116cf7270$export$2e2bcd8739ae039,
    FONT_FAMILY: $c35c84ccd945519f$export$2e2bcd8739ae039,
    TYPOGRAPHY: $11ec1402eb3e5297$export$2e2bcd8739ae039,
    SPACING: $963cab3f34249f12$export$2e2bcd8739ae039,
    TIMING: $0edda29abbdf4dbd$export$2e2bcd8739ae039,
    CLASS: $a7aa3f03c4832ffc$export$2e2bcd8739ae039,
    GRID: $346c4dccd7d5ec52$export$2e2bcd8739ae039,
    ICONS: $8d20f1e530a7800b$export$2e2bcd8739ae039,
    SHAPE: $8cfe6affa863f726$export$2e2bcd8739ae039,
    RESET: $eec83f27fc6eae19$export$2e2bcd8739ae039,
    ANIMATION: $48500ff8feea3cdf$export$2e2bcd8739ae039,
    MEDIA: $d93332c5f155b477$export$2e2bcd8739ae039,
    CASES: $10765305698c4491$export$2e2bcd8739ae039,
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false
};


var $efc11c9e2462386e$export$2e2bcd8739ae039 = {};




'use strict';
(0, $22cae8e82746fd5e$export$185802fd694ee1f5)({}, $04288ba364b453ff$exports);


//# sourceMappingURL=ai-survey.7165f9e7.js.map
